const labelToSkuPartMap = {
    "AIRDRIE": "ARDR-C",
    "BROOKS": "BRKS-C",
    "CALGARY": "CLGR-C",
    "CAMROSE": "CMR1-MD",
    "COLD LAKE": "CLDL-C",
    "EDMONTON": "EDMN-C",
    "FORT SASKATCHEWAN": "FRTS-C",
    "GRANDE PRAIRIE": "GRND-C",
    "LACOMBE": "LCM1-MD",
    "LEDUC": "LDC1-MD",
    "LETHBRIDGE": "LTH1-MD",
    "LLOYDMINSTER": "LLYD-C",
    "MEDICINE HAT": "MDCN-C",
    "RED DEER": "RDD1-MD",
    "SPRUCE GROVE": "SPRC-C",
    "ST ALBERT": "STLB-C",
    "WETASKIWIN": "WTSK-C",
    "COMMUNITY OF BELLEVUE": "BLLV-CO",
    "COMMUNITY OF BLAIRMORE": "BLRM-CO",
    "COMMUNITY OF COLEMAN": "CLMN-CO",
    "COMMUNITY OF FRANK": "FRNK-CO",
    "ATHABASCA": "ATH1-MD",
    "BANFF": "BNFF-T",
    "BARRHEAD": "BRRH-T",
    "BASHAW": "BSHW-T",
    "BASSANO": "BSSN-T",
    "BEAUMONT": "BMNT-M",
    "BEAVERLODGE": "BVRL-T",
    "BENTLEY": "BNTL-T",
    "BLACK DIAMOND": "BLCK-T",
    "BLACKFALDS": "BLC1-T",
    "BON ACCORD": "BNCC-T",
    "BONNYVILLE": "BNNY-T",
    "BOW ISLAND": "BWSL-T",
    "BOWDEN": "BWDN-T",
    "BRUDERHEIM": "BRDR-T",
    "CALMAR": "CLMR-T",
    "CANMORE": "CNMR-T",
    "CARDSTON": "CRD1-MD",
    "CARSTAIRS": "CRST-T",
    "CASTOR": "CSTR-T",
    "CHESTERMERE": "CHST-T",
    "CLARESHOLM": "CLRS-T",
    "COALDALE": "CLD1-T",
    "COALHURST": "CLHR-T",
    "COCHRANE": "CCHR-T",
    "CORONATION": "CRNT-T",
    "CROSSFIELD": "CRSS-T",
    "DAYSLAND": "DYSL-T",
    "DEVON": "DVN-T",
    "DIDSBURY": "DDSB-T",
    "DRAYTON VALLEY": "DRYT-T",
    "DRUMHELLER": "DRMH-T",
    "ECKVILLE": "ECKV-T",
    "EDSON": "EDSN-T",
    "ELK POINT": "SAS-ELKP",
    "FAIRVIEW": "FRVW-H",
    "FALHER": "FLHR-T",
    "FORT MACLEOD": "FRTM-T",
    "FOX CREEK": "FXCR-T",
    "GIBBONS": "GBBN-T",
    "GRANDE CACHE": "GRN3-H",
    "GRIMSHAW": "GRMS-T",
    "HANNA": "HNN-T",
    "HARDISTY": "HRDS-T",
    "HIGH LEVEL": "HGHL-T",
    "HIGH PRAIRIE": "HGHP-T",
    "HIGH RIVER": "HGHR-T",
    "HINTON": "HNTN-T",
    "INNISFAIL": "INNS-T",
    "IRRICANA": "IRRC-T",
    "KILLAM": "KLLM-T",
    "LAMONT": "LMN1-MD",
    "LEGAL": "LGL-T",
    "MAGRATH": "MGRT-T",
    "MANNING": "MNNN-T",
    "MAYERTHORPE": "MYRT-T",
    "MCLENNAN": "MCLN-T",
    "MILK RIVER": "MLKR-T",
    "MILLET": "MLLT-T",
    "MORINVILLE": "MRNV-T",
    "MUNDARE": "MNDR-T",
    "NANTON": "NNTN-T",
    "OKOTOKS": "OKTK-T",
    "OLDS": "OLDS-T",
    "ONOWAY": "ONWY-T",
    "OYEN": "OYN-T",
    "PEACE RIVER": "PCRV-T",
    "PENHOLD": "PNHL-T",
    "PICTURE BUTTE": "PCTR-T",
    "PINCHER CREEK": "PNCH-T",
    "PONOKA": "PNK1-MD",
    "PROVOST": "PRVS-T",
    "RAINBOW LAKE": "RNBW-T",
    "RAYMOND": "RYMN-T",
    "REDCLIFF": "RDCL-T",
    "REDWATER": "RDWT-T",
    "RIMBEY": "RMBY-T",
    "ROCKY MOUNTAIN HOUSE": "RCKY-T",
    "SEDGEWICK": "SDGW-T",
    "SEXSMITH": "SXSM-T",
    "SLAVE LAKE": "SLVL-T",
    "SMOKY LAKE": "SMK2-MD",
    "SPIRIT RIVER": "SPRT-T",
    "ST PAUL": "STPL-T",
    "STAVELY": "STVL-T",
    "STETTLER": "STTT-T",
    "STONY PLAIN": "STNY-T",
    "STRATHMORE": "STRT-T",
    "SUNDRE": "SNDR-T",
    "SWAN HILLS": "SWNH-T",
    "SYLVAN LAKE": "SYLV-T",
    "TABER": "TBR1-MD",
    "THREE HILLS": "THRH-T",
    "TOFIELD": "TFLD-T",
    "TROCHU": "TRCH-T",
    "TURNER VALLEY": "TRNR-T",
    "TWO HILLS": "TWHL-T",
    "VALLEYVIEW": "VLLY-T",
    "VAUXHALL": "VXHL-T",
    "VEGREVILLE": "VGRV-T",
    "VERMILION": "VRML-T",
    "VIKING": "VKNG-T",
    "VULCAN": "VLC1-MD",
    "WAINWRIGHT": "WNWR-T",
    "WEMBLEY": "WMBL-T",
    "WESTLOCK": "WST1-MD",
    "WHITECOURT": "WHTC-T",
    "ARGENTIA BEACH": "ARGN-V",
    "BETULA BEACH": "BTLB-V",
    "BIRCH COVE": "HAL-BRC1",
    "BIRCHCLIFF": "BRC1-V",
    "BONDISS": "BNDS-V",
    "BONNYVILLE BEACH": "BNN1-V",
    "BURNSTICK LAKE": "BRNS-V",
    "CASTLE ISLAND": "CSTL-V",
    "CRYSTAL SPRINGS": "CRY2-H",
    "GHOST LAKE": "GHST-V",
    "GOLDEN DAYS": "GLDN-V",
    "GRANDVIEW": "GRN2-M",
    "GULL LAKE": "GLLL-T",
    "HALF MOON BAY": "HLFM-V",
    "HORSESHOE BAY": "HRSS-H",
    "ISLAND LAKE": "ISLN-V",
    "ISLAND LAKE SOUTH": "ISL1-V",
    "ITASKA BEACH": "ITSK-V",
    "JARVIS BAY": "JRVS-V",
    "KAPASIWIN": "KPSW-V",
    "LAKEVIEW": "SAS-LKV2",
    "LARKSPUR": "LRKS-V",
    "MA-ME-O BEACH": "MMBC-V",
    "MEWATHA BEACH": "MWTH-V",
    "NAKAMUN PARK": "NKMN-V",
    "NORGLENWOLD": "NRGL-V",
    "NORRIS BEACH": "NRRS-V",
    "PARKLAND BEACH": "PRKL-H",
    "PELICAN NARROWS": "PLCN-V",
    "POINT ALISON": "PNTL-V",
    "POPLAR BAY": "PPLR-V",
    "ROCHON SANDS": "RCHN-V",
    "ROSS HAVEN": "RSSH-V",
    "SANDY BEACH": "SNDY-V",
    "SEBA BEACH": "SBBC-V",
    "SILVER BEACH": "SLVR-V",
    "SILVER SANDS": "SLV1-V",
    "SOUTH BAPTISTE": "STHB-V",
    "SOUTH VIEW": "STHV-V",
    "SUNBREAKER COVE": "SNBR-V",
    "SUNDANCE BEACH": "SNDN-V",
    "SUNRISE BEACH": "SNRS-V",
    "SUNSET BEACH": "SNST-H",
    "SUNSET POINT": "SNS1-V",
    "VAL QUENTIN": "VLQN-V",
    "WAIPAROUS": "WPRS-V",
    "WEST BAPTISTE": "WSTB-V",
    "WEST COVE": "WSTC-V",
    "WHISPERING HILLS": "WHSP-V",
    "WHITE SANDS": "WHTS-V",
    "YELLOWSTONE": "YLLW-V",
    "HEISLER": "HSLR-V",
    "HILL SPRING": "HLLS-V",
    "HINES CREEK": "HNSC-V",
    "HOLDEN": "HLDN-V",
    "HUGHENDEN": "HGHN-V",
    "HUSSAR": "HSSR-V",
    "INNISFREE": "INN1-V",
    "IRMA": "IRM-V",
    "KITSCOTY": "KTSC-V",
    "LINDEN": "LNDN-V",
    "LOMOND": "LMND-V",
    "LONGVIEW": "LNGV-V",
    "LOUGHEED": "LGHD-V",
    "MANNVILLE": "MNNV-V",
    "MARWAYNE": "MRWY-V",
    "MILO": "ML-V",
    "MORRIN": "MRRN-V",
    "MUNSON": "MNSN-V",
    "MYRNAM": "MYRN-V",
    "NAMPA": "NMP-V",
    "NOBLEFORD": "NBLF-V",
    "PARADISE VALLEY": "PRDS-V",
    "ROCKYFORD": "RCK1-V",
    "ROSALIND": "RSLN-V",
    "ROSEMARY": "RSMR-V",
    "RYCROFT": "RYCR-V",
    "RYLEY": "RYLY-V",
    "SPRING LAKE": "SPRN-V",
    "STANDARD": "STND-V",
    "STIRLING": "STRL-V",
    "THORSBY": "THRS-V",
    "VETERAN": "VTRN-V",
    "VILNA": "VLN-V",
    "WARBURG": "WRBR-V",
    "WARNER": "WRNR-V",
    "WASKATENAU": "WSKT-V",
    "YOUNGSTOWN": "YNGS-V",
    "ABEE": "ABEE-H",
    "ACADIA VALLEY": "ACDV-H",
    "AETNA": "ATN-H",
    "ALCOMDALE": "ALCM-H",
    "ALDER FLATS": "ALDR-H",
    "ALDERSYDE": "ALD1-H",
    "ALHAMBRA": "ALHM-H",
    "ALTARIO": "ALTR-H",
    "ANTLER LAKE": "ANTL-H",
    "ANZAC": "ANZC-H",
    "ARDENODE": "ARDN-H",
    "ARDLEY": "ARDL-H",
    "ARDMORE": "ARDM-H",
    "ARDROSSAN": "ARDR-H",
    "ARMENA": "ARMN-H",
    "ASHMONT": "ASHM-H",
    "ATMORE": "ATMR-H",
    "BALZAC": "BLZC-H",
    "BEAUVALLON": "BVLL-H",
    "BEAVER CROSSING": "BVRC-H",
    "BEAVER LAKE": "BVR1-H",
    "BEAVER MINES": "BVRM-H",
    "BEAVERDAM": "BVRD-H",
    "BEAZER": "BZR-H",
    "BELLIS": "BLLS-H",
    "BENALTO": "BNLT-H",
    "BENCHLANDS": "BNCH-H",
    "BENTON": "BNTN-H",
    "BEZANSON": "BZNS-H",
    "BINDLOSS": "BNDL-H",
    "BIRCHAM": "BRC2-H",
    "BLACKFOOT": "BLC2-H",
    "BLACKIE": "BLC3-H",
    "BLUE RIDGE": "BLRD-H",
    "BLUESKY": "BLSK-H",
    "BLUFFTON": "BLFF-H",
    "BODO": "BD-H",
    "BOTHA": "BTH-H",
    "BOTTREL": "BTTR-H",
    "BOW CITY": "BWCT-H",
    "BRAGG CREEK": "BRGG-H",
    "BRANT": "BUR-BRL7-N",
    "BREYNAT": "BRYN-H",
    "BROSSEAU": "BRSS-H",
    "BROWNFIELD": "BRWN-H",
    "BROWNVALE": "BRW1-H",
    "BRUCE": "BRC-H",
    "BRULE": "BRLE-H",
    "BUCK CREEK": "BCKC-H",
    "BUCK LAKE": "BCKL-H",
    "BUFFALO": "BFFL-H",
    "BUFFALO LAKES": "BFF1-H",
    "BUFORD": "BFRD-H",
    "BURDETT": "BRDT-H",
    "BUSBY": "BSBY-H",
    "BYEMOOR": "BYMR-H",
    "CADOGAN": "CDGN-H",
    "CADOMIN": "CDMN-H",
    "CADOTTE LAKE": "CDTT-H",
    "CALAHOO": "CLH-H",
    "CALLING LAKE": "CLLN-H",
    "CAMPSIE": "CMPS-H",
    "CANYON CREEK": "CNYN-H",
    "CARBONDALE": "CRBN-H",
    "CARDIFF": "CRDF-H",
    "CAROLSIDE": "CRLS-H",
    "CARSELAND": "CRSL-H",
    "CARVEL": "CRVL-H",
    "CARWAY": "CRWY-H",
    "CASLAN": "CSLN-H",
    "CASSILS": "CSSL-H",
    "CAVENDISH": "CVND-H",
    "CAYLEY": "CYLY-H",
    "CEREAL": "CRL-H",
    "CESSFORD": "CSSF-H",
    "CHANCELLOR": "CHNC-H",
    "CHEADLE": "CHDL-H",
    "CHERHILL": "CHRH-H",
    "CHERRY GROVE": "CHRR-H",
    "CHIN": "CHN-H",
    "CHINOOK": "CHNK-H",
    "CHISHOLM": "CHSH-TS",
    "CLAIRMONT": "CLRM-H",
    "CLANDONALD": "CLND-H",
    "CLEARDALE": "CLRD-H",
    "CLUNY": "CLNY-H",
    "COCHRANE LAKE": "CCH1-H",
    "COLINTON": "CLNT-H",
    "COLLINGWOOD COVE": "CLWC-H",
    "COMPEER": "CMPR-H",
    "CONDOR": "CNDR-H",
    "CONKLIN": "CNKL-H",
    "CONRICH": "CNRC-H",
    "CRAIGMYLE": "CRGM-H",
    "CYNTHIA": "CYNT-H",
    "DALEMEAD": "DLMD-H",
    "DALROY": "DLRY-H",
    "DALUM": "DALM-H",
    "DAPP": "DAPP-H",
    "DARWELL": "DRWL-H",
    "DE WINTON": "DWNT-H",
    "DEAD MAN'S FLATS": "DDMN-H",
    "DEADWOOD": "DDWD-H",
    "DEBOLT": "DBLT-H",
    "DEL BONITA": "DLBN-H",
    "DELACOUR": "DLCR-H",
    "DEMMITT": "DMMT-H",
    "DERWENT": "DRWN-H",
    "DESERT BLUME": "DSRT-H",
    "DEWBERRY": "DWBR-H",
    "DIAMOND CITY": "DMND-H",
    "DICKSON": "DCKS-H",
    "DIMSDALE": "DMSD-H",
    "DIXONVILLE": "DXNV-H",
    "DONATVILLE": "DNTV-H",
    "DOROTHY": "DRTH-H",
    "DUFFIELD": "DFFL-H",
    "DUHAMEL": "DHML-M",
    "DUNMORE": "DNMR-H",
    "DUVERNAY": "DVRN-H",
    "EAGLESHAM": "EGLS-H",
    "EDWAND": "EDWN-H",
    "EGREMONT": "EGRM-H",
    "ELLSCOTT": "ELLS-H",
    "ELMWORTH": "ELMW-H",
    "ENCHANT": "ENCH-H",
    "ENDIANG": "ENDN-H",
    "ENILDA": "ENLD-H",
    "ENSIGN": "ENSG-H",
    "ENTWISTLE": "ENTW-H",
    "ERSKINE": "ERSK-H",
    "ESTHER": "ESTH-H",
    "ETZIKOM": "ETZK-H",
    "EVANSBURG": "EVNS-H",
    "EXCEL": "EXCL-H",
    "EXSHAW": "EXSH-H",
    "FABYAN": "FBYN-H",
    "FALLIS": "FLLS-H",
    "FALUN": "FALN-H",
    "FAUST": "FAST-H",
    "FAWCETT": "FWCT-H",
    "FEDERAL": "FDRL-H",
    "FERINTOSH": "FRNT-H",
    "FLATBUSH": "FLTB-H",
    "FLEET": "FLET-H",
    "FORT ASSINIBOINE": "FRT1-H",
    "FORT CHIPEWYAN": "FRTC-H",
    "FORT KENT": "FRTK-H",
    "FORT MCKAY": "FRT2-H",
    "FORT MCMURRAY": "FRT3-H",
    "FORT VERMILION": "FRTV-H",
    "GADSBY": "GDSB-H",
    "GAINFORD": "GNFR-H",
    "GALAHAD": "GLHD-H",
    "GASOLINE ALLEY": "GSLN-H",
    "GEM": "GEM-H",
    "GLEICHEN": "GLCH-H",
    "GLENEVIS": "GLNV-H",
    "GOODFARE": "GDFR-H",
    "GOOSE LAKE": "GSLK-H",
    "GRANUM": "GRNM-H",
    "GRASSLAND": "GRSS-M",
    "GRASSY LAKE": "GRS1-H",
    "GREEN COURT": "GRNC-H",
    "GREENSHIELDS": "GRNS-H",
    "GREGOIRE LAKE ESTATES": "GRGR-H",
    "GROUARD": "GRRD-H",
    "GROVEDALE": "GRVD-H",
    "GUNN": "GNN-H",
    "GUY": "GUY-H",
    "GWYNNE": "GWYN-H",
    "HAIRY HILL": "HRYH-H",
    "HALF MOON LAKE": "HLF1-H",
    "HALCOURT": "HLCR-H",
    "HARMONY": "HRMN-H",
    "HARTELL": "HRTL-H",
    "HARVIE HEIGHTS": "HRVH-H",
    "HASTINGS LAKE": "HSTN-H",
    "HAYNES": "HYNS-H",
    "HAYS": "HAYS-H",
    "HAYTER": "HYTR-H",
    "HEINSBURG": "HNSB-H",
    "HEMARUKA": "HMRK-H",
    "HERITAGE POINTE": "HRTG-H",
    "HERRONTON": "HRRN-H",
    "HESKETH": "HSKT-H",
    "HILDA": "HLDA-H",
    "HILLIARD": "HLLR-TS",
    "HOADLEY": "HDLY-H",
    "HUALLEN": "HLLN-H",
    "HUXLEY": "HXLY-H",
    "HYLO": "HYLO-H",
    "HYTHE": "HYTH-H",
    "IDDESLEIGH": "IDDS-H",
    "INDUS": "INDS-H",
    "IRON RIVER": "IRNR-H",
    "IRON SPRINGS": "IRNS-H",
    "IRVINE": "IRVN-H",
    "ISLAY": "ISLY-H",
    "JANET": "JNET-H",
    "JANVIER SOUTH": "JNVR-H",
    "JARVIE": "JRVE-H",
    "JEAN COTE": "JNCT-H",
    "JENNER": "JNNR-H",
    "JOFFRE": "JFFR-H",
    "JOHNSON'S ADDITION": "JHNS-H",
    "JOSEPHBURG": "JSPH-H",
    "JOUSSARD": "JSSR-H",
    "KATHYRN": "KTHY-H",
    "KAVANAGH": "KVNG-H",
    "KEEPHILLS": "KPHL-H",
    "KELSEY": "KLSY-RM",
    "KEOMA": "KEOM-H",
    "KIMBALL": "KMBL-H",
    "KINGMAN": "KNGM-H",
    "KINSELLA": "KNSL-H",
    "KINUSO": "KNUS-H",
    "KIPP": "KIPP-H",
    "KIRKCALDY": "KRKC-H",
    "KIRRIEMUIR": "KRRM-H",
    "LA COREY": "LCRY-H",
    "LA CRETE": "LCRT-H",
    "LA GLACE": "LGLC-H",
    "LAC DES ARCS": "LCDS-H",
    "LAC LA BICHE": "LCL1-MD",
    "LAFOND": "LFND-H",
    "LAKE LOUISE": "LKLS-H",
    "LAKE NEWELL RESORT": "LKNW-H",
    "LAMOUREUX": "LMRX-H",
    "LANDRY HEIGHTS": "LNDR-H",
    "LANFINE": "LNFN-H",
    "LANGDON": "LNGD-H",
    "LAVOY": "LAVY-H",
    "LEAVITT": "LVTT-H",
    "LEEDALE": "LDL-H",
    "LESLIEVILLE": "LSLV-H",
    "LINDBERGH": "LNDB-H",
    "LINN VALLEY": "LNNV-H",
    "LITTLE BUFFALO": "LTTL-H",
    "LITTLE SMOKY": "LTT1-H",
    "LODGEPOLE": "LDGP-H",
    "LONG LAKE": "LNGL-H",
    "LOOMA": "LOOM-H",
    "LOTTIE LAKE": "LTLK-H",
    "LOUSANA": "LSNA-H",
    "LOWLAND HEIGHTS": "LWLN-H",
    "LOYALIST": "LYLS-TS",
    "LUNDBRECK": "LNBR-H",
    "LYALTA": "LYLT-H",
    "LYMBURN": "LYMB-H",
    "MADDEN": "MDDN-H",
    "MALLAIG": "MLLG-H",
    "MANOLA": "MNL-H",
    "MANYBERRIES": "MNYB-H",
    "MARIE REINE": "MRR1-H",
    "MARKERVILLE": "MRKR-H",
    "MARLBORO": "MRLB-H",
    "MARTEN BEACH": "MRTN-H",
    "MASKWACIS ": "MSKW-H",
    "MCLAUGHLIN": "MCLG-H",
    "MEANOOK": "MENK-H",
    "MEARNS": "MRNS-H",
    "MEETING CREEK": "MTNG-H",
    "METISKOW": "MTSK-H",
    "MICHICHI": "MCHC-H",
    "MILLARVILLE": "MLLR-H",
    "MINBURN": "MNBR-H",
    "MIRROR": "MRRR-H",
    "MITSUE LAKE INDUSTRIAL": "MTSL-H",
    "MONARCH": "MNRC-H",
    "MONITOR": "MNTR-H",
    "MOON RIVER ESTATES": "MNRV-H",
    "MORECAMBE": "MRCM-H",
    "MORNINGSIDE": "MRNN-H",
    "MOSSLEIGH": "MSSL-H",
    "MOUNTAIN VIEW": "MNT1-MD",
    "MULHURST BAY": "MLHR-H",
    "MUSIDORA": "MSDR-H",
    "NAMAKA": "NMK-H",
    "NAMAO": "NMAO-H",
    "NAPHTHA": "NPHT-H",
    "NEERLANDIA": "NRLN-H",
    "NESTOW": "NSTW-H",
    "NEVIS": "NEVS-H",
    "NEW BRIGDEN": "NWBR-H",
    "NEW DAYTON": "NWDY-H",
    "NEW NORWAY": "NWNR-H",
    "NEW SAREPTA": "NWSR-H",
    "NEWBROOK": "NWB1-H",
    "NIGHTINGALE": "NGHT-H",
    "NISKU": "NSKU-H",
    "NITON JUNCTION": "NTNJ-H",
    "NORDEGG": "NRDG-H",
    "NORTH COOKING LAKE": "NRTH-H",
    "NORTH STAR": "NRT1-H",
    "NOTIKEWIN": "NTKW-H",
    "OHATON": "OHTN-H",
    "OPAL": "OPAL-H",
    "ORION": "ORN-H",
    "ORTON": "ORTN-H",
    "PARKLAND": "PRK2-MD",
    "PATRICIA": "PTRC-H",
    "PEERS": "PRS-H",
    "PELICAN POINT": "PLC1-H",
    "PEORIA": "PEOR-H",
    "PERRYVALE": "PRRY-H",
    "PIBROCH": "PBRC-H",
    "PICKARDVILLE": "PCKR-H",
    "PINCHER STATION": "PNC1-H",
    "PINE SANDS": "PNSN-H",
    "PLAMONDON": "PLMN-H",
    "POPLAR RIDGE": "PPLR-H",
    "PRIDDIS": "PRDD-H",
    "PRIDDIS GREENS": "PRDG-H",
    "PURPLE SPRINGS": "PRPL-H",
    "QUEENSTOWN": "QNST-H",
    "RADWAY": "RDWY-H",
    "RAINIER": "RNR-H",
    "RANFURLY": "RNFR-H",
    "RED EARTH CREEK": "RDRT-H",
    "RED WILLOW": "RDWL-H",
    "REDLAND": "RDLN-H",
    "RENO": "RENO-H",
    "RICH VALLEY": "RCHV-H",
    "RICHDALE": "RCHD-H",
    "RIDGEVALLEY": "RDGV-H",
    "RIVERCOURSE": "RVRC-H",
    "RIVERVIEW": "RVRV-H",
    "RIVIÈRE QUI BARRE": "RVRQ-H",
    "ROBB": "RBB-H",
    "ROCHESTER": "RCHS-H",
    "ROCHFORT BRIDGE": "RCHF-H",
    "ROCKY RAPIDS": "RKYR-H",
    "ROLLING HILLS": "RLLN-H",
    "ROLLY VIEW": "RLLY-H",
    "ROSEBUD": "RSBD-H",
    "ROSELYNN": "RSLY-H",
    "ROUND HILL": "RNDH-H",
    "ROWLEY": "RWLY-H",
    "RUMSEY": "RMSY-H",
    "SANDY LAKE": "SND1-H",
    "SANGUDO": "SNGD-H",
    "SAPRAE CREEK": "SPRC-H",
    "SCANDIA": "SCND-H",
    "SCAPA": "SCP-H",
    "SCHULER": "SCHL-H",
    "SCOTFIELD": "SCTF-H",
    "SEDALIA": "SDLA-H",
    "SEVEN PERSONS": "SVNP-H",
    "SHAUGHNESSY": "SHGH-H",
    "SHEERNESS": "SHRN-H",
    "SHERWOOD PARK": "SHRW-H",
    "SHOULDICE": "SHLD-H",
    "SIBBALD": "SBBL-H",
    "SKIFF": "SKFF-H",
    "SMITH": "SMTH-H",
    "SOUTH COOKING LAKE": "STHC-H",
    "SPEDDEN": "SPDD-H",
    "SPRING COULEE": "SPR2-H",
    "SPRINGBROOK": "SPR3-H",
    "SPRUCE VIEW": "SPR4-H",
    "ST EDOUARD": "STDR-H",
    "ST FRANCIS": "STFR-H",
    "ST ISIDORE": "STSD-H",
    "ST LINA": "STLN-H",
    "ST MICHAEL": "STMC-H",
    "ST VINCENT": "STVN-H",
    "STANMORE": "STNM-H",
    "STAR": "STR-H",
    "STREAMSTOWN": "STRM-H",
    "STROME": "STR1-H",
    "SUFFIELD": "SFFL-H",
    "SUNNYBROOK": "SNNY-H",
    "SUNNYNOOK": "SNN1-H",
    "SUNNYSLOPE": "SNN2-H",
    "SWALWELL": "SWLW-H",
    "TANGENT": "TNGN-H",
    "TAWATINAW": "TWTN-H",
    "TEEPEE CREEK": "TPCR-H",
    "TEES": "TEES-H",
    "TELFORDVILLE": "TLFR-H",
    "THERIEN": "THRN-H",
    "THORHILD": "TRHD-H",
    "THRONE": "TRNE-H",
    "THUNDER LAKE": "THND-H",
    "TILLEY": "TLLY-H",
    "TILLICUM BEACH": "TLLC-H",
    "TOMAHAWK": "TMHW-H",
    "TORRINGTON": "TRRN-H",
    "TRAVERS": "TRVR-H",
    "TULLIBY LAKE": "TLLB-H",
    "TURIN": "TRN-H",
    "TWIN BUTTE": "TWNB-H",
    "VALHALLA CENTRE": "VLHL-H",
    "VEINERVILLE": "VNRV-H",
    "VENICE": "VNC-H",
    "VILLAGE AT PIGEON LAKE": "VPGL-V",
    "VILLENEUVE": "VLLN-H",
    "VIMY": "VMY-H",
    "VIOLET GROVE": "VLTG-H",
    "WABAMUN": "WBMN-H",
    "WABASCA": "WBSC-H",
    "WAGNER": "WGNR-H",
    "WALSH": "WLSH-H",
    "WANDERING RIVER": "WNDR-H",
    "WANHAM": "WNHM-H",
    "WARDLOW": "WRDL-H",
    "WARSPITE": "WRSP-H",
    "WATERTON PARK": "WTRT-H",
    "WATINO": "WTN-H",
    "WATTS": "WTTS-H",
    "WEDGEWOOD": "WDGW-H",
    "WELLING": "WLLN-H",
    "WELLING STATION": "WLLS-H",
    "WESTEROSE": "WSTR-H",
    "WHITELAW": "WHTL-H",
    "WHITFORD": "WHTF-H",
    "WHITLA": "WHT1-H",
    "WIDEWATER": "WDWT-H",
    "WILDWOOD": "SAS-WIDW",
    "WILLINGDON": "WLLD-H",
    "WIMBORNE": "WMBR-H",
    "WINFIELD": "WNFL-H",
    "WINNIFRED": "WNNF-H",
    "WITHROW": "WTHR-H",
    "WOKING": "WKNG-H",
    "WOODHOUSE": "WDHS-H",
    "WOOLFORD": "WLFR-H",
    "WORSLEY": "WRSL-H",
    "WOSTOK": "WSTK-H",
    "WRENTHAM": "WRNT-H",
    "ZAMA CITY": "ZMCT-H",
    "BEAVER": "BVR-MD",
    "BIRCH HILLS": "BRCH-T",
    "BRAZEAU": "BRZ-MD",
    "CLEAR HILLS": "CLRH-MD",
    "CLEARWATER": "CLRW-D",
    "BARRHEAD NO. 11": "BRR1-MD",
    "FORTY MILE NO. 8": "FRTY-MD",
    "GRANDE PRAIRIE NO. 1": "GRN4-MD",
    "MINBURN NO. 27": "MNB1-MD",
    "NEWELL NO. 4": "NWLL-MD",
    "NORTHERN LIGHTS": "NRT2-MD",
    "PAINTEARTH NO. 18": "PNTR-MD",
    "ST PAUL NO. 19": "STP1-MD",
    "STETTLER NO. 6": "STT1-MD",
    "THORHILD NO. 7": "THR3-MD",
    "TWO HILLS NO. 21": "TWH1-MD",
    "VERMILION RIVER": "VRM1-MD",
    "WARNER NO. 5": "WRN1-MD",
    "WETASKIWIN NO. 10": "WTS1-MD",
    "CYPRESS": "CYPR-MD",
    "FLAGSTAFF": "FLGS-MD",
    "KNEEHILL": "KNHL-MD",
    "LAC STE ANNE": "LCST-MD",
    "ACADIA NO. 34": "ACDN-MD",
    "BIG LAKES": "BGLK-MD",
    "BIGHORN NO. 8": "BGHR-MD",
    "BONNYVILLE NO. 87": "BNN2-MD",
    "FAIRVIEW NO. 136": "FRV2-MD",
    "FOOTHILLS NO. 31": "FTHL-MD",
    "GREENVIEW NO. 16": "GRNV-MD",
    "LESSER SLAVE RIVER NO. 124": "LSSR-MD",
    "OPPORTUNITY NO. 17": "OPPR-MD",
    "PEACE NO. 135": "PCN-MD",
    "PINCHER CREEK NO. 9": "PNC2-MD",
    "PROVOST NO. 52": "PRV1-MD",
    "RANCHLAND NO. 66": "RNCH-MD",
    "SMOKY RIVER NO. 130": "SMK1-MD",
    "SPIRIT RIVER NO. 133": "SPR5-MD",
    "WAINWRIGHT NO. 61": "WNW1-MD",
    "WILLOW CREEK NO. 26": "WLLW-MD",
    "NORTHERN SUNRISE": "NRT3-MD",
    "ROCKY VIEW": "RCK3-MD",
    "SADDLE HILLS": "SDDL-MD",
    "STARLAND": "STR2-MD",
    "STURGEON": "STRG-MD",
    "WHEATLAND": "WHT2-MD",
    "WOODLANDS": "WDLN-RM",
    "YELLOWHEAD": "YLL1-RM",
    "ABBEYDALE, CALGARY": "CAL-ABBY",
    "ACADIA, CALGARY": "CAL-ACAD",
    "ALBERT PARK - RADISSON HEIGHTS, CALGARY": "CAL-ALBR",
    "ALTADORE, CALGARY": "CAL-ALTD",
    "ALYTH - BONNYBROOK, CALGARY": "CAL-ALYT",
    "APPLEWOOD PARK, CALGARY": "CAL-APPL",
    "ARBOUR LAKE, CALGARY": "CAL-ARBR",
    "ASPEN WOODS, CALGARY": "CAL-ASPN",
    "AUBURN BAY, CALGARY": "CAL-ABRN",
    "AURORA BUSINESS PARK, CALGARY": "CAL-ARRB",
    "BANFF TRAIL, CALGARY": "CAL-BNFF",
    "BANKVIEW, CALGARY": "CAL-BNKV",
    "BAYVIEW, CALGARY": "CAL-BYVW",
    "BEDDINGTON HEIGHTS, CALGARY": "CAL-BDDN",
    "BEL-AIRE, CALGARY": "CAL-BLR",
    "BELTLINE, CALGARY": "CAL-BLTL",
    "BONAVISTA DOWNS, CALGARY": "CAL-BNVS",
    "BOWNESS, CALGARY": "CAL-BWNS",
    "BRAESIDE, CALGARY": "CAL-BRSD",
    "BRENTWOOD, CALGARY": "CAL-BRNT",
    "BRIDGELAND - RIVERSIDE, CALGARY": "CAL-BRDG",
    "BRIDLEWOOD, CALGARY": "CAL-BRDL",
    "BRITANNIA, CALGARY": "CAL-BRTN",
    "BURNS INDUSTRIAL, CALGARY": "CAL-BRNS",
    "CALGARY INTERNATIONAL AIRPORT, CALGARY": "CAL-CLGR",
    "CAMBRIAN HEIGHTS, CALGARY": "CAL-CMBR",
    "CANADA OLYMPIC PARK, CALGARY": "CAL-CNDL",
    "CANYON MEADOWS, CALGARY": "CAL-CNYN",
    "CAPITOL HILL, CALGARY": "CAL-CPTL",
    "CASTLERIDGE, CALGARY": "CAL-CSTL",
    "CEDARBRAE, CALGARY": "CAL-CDRB",
    "CFB CURRIE, CALGARY": "CAL-CFBC",
    "CFB LINCOLN PARK PMQ, CALGARY": "CAL-CFBL",
    "CHAPARRAL, CALGARY": "CAL-CHPR",
    "CHARLESWOOD, CALGARY": "CAL-CHRL",
    "CHINATOWN, CALGARY": "CAL-CHNT",
    "CHINOOK PARK, CALGARY": "CAL-CHNK",
    "CHRISTIE PARK, CALGARY": "CAL-CHRS",
    "CITADEL, CALGARY": "CAL-CTDL",
    "CITYSCAPE, CALGARY": "CAL-CTYS",
    "CLIFF BUNGALOW, CALGARY": "CAL-CLFF",
    "COACH HILL, CALGARY": "CAL-CCHH",
    "COLLINGWOOD, CALGARY": "CAL-CLLN",
    "COPPERFIELD, CALGARY": "CAL-CPPR",
    "CORAL SPRINGS, CALGARY": "CAL-CRLS",
    "COUGAR RIDGE, CALGARY": "CAL-CGRR",
    "COUNTRY HILLS, CALGARY": "CAL-CNTR",
    "COUNTRY HILLS VILLAGE, CALGARY": "CAL-CNT1",
    "COVENTRY HILLS, CALGARY": "CAL-CVNT",
    "CRANSTON, CALGARY": "CAL-CRNS",
    "CRESCENT HEIGHTS, CALGARY": "CAL-CRSC",
    "CRESTMONT, CALGARY": "CAL-CRST",
    "DALHOUSIE, CALGARY": "CAL-DLHS",
    "DEER RIDGE, CALGARY": "CAL-DRRD",
    "DEER RUN, CALGARY": "CAL-DRRN",
    "DEERFOOT BUSINESS CENTRE, CALGARY": "CAL-DRFT",
    "DIAMOND COVE, CALGARY": "CAL-DMND",
    "DISCOVERY RIDGE, CALGARY": "CAL-DSCV",
    "DOUGLASDALE - GLEN, CALGARY": "CAL-DGLS",
    "DOVER, CALGARY": "CAL-DVR",
    "DOWNTOWN COMMERCIAL CORE, CALGARY": "CAL-DWNT",
    "DOWNTOWN EAST VILLAGE, CALGARY": "CAL-DWN1",
    "DOWNTOWN WEST END, CALGARY": "CAL-DWN2",
    "EAGLE RIDGE, CALGARY": "CAL-EGLR",
    "EAST FAIRVIEW INDUSTRIAL, CALGARY": "CAL-ESTF",
    "EAST SHEPARD INDUSTRIAL, CALGARY": "CAL-ESTS",
    "EASTFIELD, CALGARY": "CAL-EST1",
    "EAU CLAIRE, CALGARY": "CAL-ECLR",
    "EDGEMONT, CALGARY": "CAL-EDGM",
    "ELBOW PARK, CALGARY": "CAL-ELBW",
    "ELBOYA, CALGARY": "CAL-ELBY",
    "ERIN WOODS, CALGARY": "CAL-ERNW",
    "ERLTON, CALGARY": "CAL-ERLT",
    "EVANSTON, CALGARY": "CAL-EVNS",
    "EVERGREEN, CALGARY": "CAL-EVRG",
    "FAIRVIEW, CALGARY": "CAL-FRVW",
    "FAIRVIEW INDUSTRIAL, CALGARY": "CAL-FRV1",
    "FALCONRIDGE, CALGARY": "CAL-FLCN",
    "FISH CREEK PARK, CALGARY": "CAL-FSHC",
    "FOOTHILLS, CALGARY": "CAL-FTHL",
    "FOREST HEIGHTS, CALGARY": "CAL-FRST",
    "FOREST LAWN, CALGARY": "CAL-FRS1",
    "FOREST LAWN INDUSTRIAL, CALGARY": "CAL-FRS2",
    "FRANKLIN, CALGARY": "CAL-FRNK",
    "GLAMORGAN, CALGARY": "CAL-GLMR",
    "GLENBROOK, CALGARY": "CAL-GLNB",
    "GLENDALE, CALGARY": "CAL-GLND",
    "GLENDEER BUSINESS PARK, CALGARY": "CAL-GLN1",
    "GLENMORE PARK, CALGARY": "CAL-GLNM",
    "GOLDEN TRIANGLE, CALGARY": "CAL-GLDN",
    "GREAT PLAINS, CALGARY": "CAL-GRTP",
    "GREENVIEW, CALGARY": "CAL-GRNV",
    "GREENVIEW INDUSTRIAL PARK, CALGARY": "CAL-GRN1",
    "GREENWOOD - GREENBRIAR, CALGARY": "CAL-GRNW",
    "HAMPTONS, CALGARY": "CAL-HMPT",
    "HARVEST HILLS, CALGARY": "CAL-HRVS",
    "HAWKWOOD, CALGARY": "CAL-HWKW",
    "HAYSBORO, CALGARY": "CAL-HYSB",
    "HIDDEN VALLEY, CALGARY": "CAL-HDDN",
    "HIGHFIELD, CALGARY": "CAL-HGHF",
    "HIGHLAND PARK, CALGARY": "CAL-HGHL",
    "HIGHWOOD, CALGARY": "CAL-HGHW",
    "HILLHURST, CALGARY": "CAL-HLLH",
    "HORIZON, CALGARY": "CAL-HRZN",
    "HOTCHKISS, CALGARY": "CAL-HTCH",
    "HOUNSFIELD HEIGHTS - BRIAR HILL, CALGARY": "CAL-HNSF",
    "HUNTINGTON HILLS, CALGARY": "CAL-HNTN",
    "INGLEWOOD, CALGARY": "CAL-INGL",
    "KELVIN GROVE, CALGARY": "CAL-KLVN",
    "KILLARNEY - GLENGARRY, CALGARY": "CAL-KLLR",
    "KINCORA, CALGARY": "CAL-KNCR",
    "KINGSLAND, CALGARY": "CAL-KNGS",
    "LAKE BONAVISTA, CALGARY": "CAL-LKBN",
    "LAKEVIEW, CALGARY": "CAL-LKVW",
    "LEGACY, CALGARY": "CAL-LGCY",
    "LINCOLN PARK, CALGARY": "CAL-LNCL",
    "LOWER MOUNT ROYAL, CALGARY": "CAL-LWRM",
    "MACEWAN GLEN, CALGARY": "CAL-MCWN",
    "MAHOGANY, CALGARY": "CAL-MHGN",
    "MANCHESTER, CALGARY": "CAL-MNCH",
    "MANCHESTER INDUSTRIAL, CALGARY": "CAL-MNC1",
    "MAPLE RIDGE, CALGARY": "CAL-MPLR",
    "MARLBOROUGH, CALGARY": "CAL-MRLB",
    "MARLBOROUGH PARK, CALGARY": "CAL-MRL1",
    "MARTINDALE, CALGARY": "CAL-MRTN",
    "MAYFAIR, CALGARY": "CAL-MYFR",
    "MAYLAND, CALGARY": "CAL-MYLN",
    "MAYLAND HEIGHTS, CALGARY": "CAL-MYL1",
    "MCCALL, CALGARY": "CAL-MCCL",
    "MCKENZIE LAKE, CALGARY": "CAL-MCKN",
    "MCKENZIE TOWNE, CALGARY": "CAL-MCK1",
    "MEADOWLARK PARK, CALGARY": "CAL-MDWL",
    "MERIDIAN, CALGARY": "CAL-MRDN",
    "MIDNAPORE, CALGARY": "CAL-MDNP",
    "MILLRISE, CALGARY": "CAL-MLLR",
    "MISSION, CALGARY": "CAL-MSSN",
    "MONTEREY PARK, CALGARY": "CAL-MNTR",
    "MONTGOMERY, CALGARY": "CAL-MNTG",
    "MOUNT PLEASANT, CALGARY": "CAL-MNTP",
    "NEW BRIGHTON, CALGARY": "CAL-NWBR",
    "NOLAN HILL, CALGARY": "CAL-NLNH",
    "NORTH AIRWAYS, CALGARY": "CAL-NRTH",
    "NORTH GLENMORE PARK, CALGARY": "CAL-NRT1",
    "NORTH HAVEN, CALGARY": "CAL-NRT2",
    "NORTH HAVEN UPPER, CALGARY": "CAL-NRT3",
    "NOSE HILL PARK, CALGARY": "CAL-NSHL",
    "OAKRIDGE, CALGARY": "CAL-OKRD",
    "OGDEN, CALGARY": "CAL-OGDN",
    "PALLISER, CALGARY": "CAL-PLLS",
    "PANORAMA HILLS, CALGARY": "CAL-PNRM",
    "PARKDALE, CALGARY": "CAL-PRKD",
    "PARKHILL, CALGARY": "CAL-PRKH",
    "PARKLAND, CALGARY": "CAL-PRKL",
    "PATTERSON, CALGARY": "CAL-PTTR",
    "PEGASUS, CALGARY": "CAL-PGSS",
    "PENBROOKE MEADOWS, CALGARY": "CAL-PNBR",
    "PINERIDGE, CALGARY": "CAL-PNRD",
    "POINT MCKAY, CALGARY": "CAL-PNTM",
    "PUMP HILL, CALGARY": "CAL-PMPH",
    "QUEENS PARK VILLAGE, CALGARY": "CAL-QNSP",
    "QUEENSLAND, CALGARY": "CAL-QNSL",
    "RAMSAY, CALGARY": "CAL-RMSY",
    "RANCHLANDS, CALGARY": "CAL-RNCH",
    "RED CARPET, CALGARY": "CAL-RDCR",
    "REDSTONE, CALGARY": "CAL-RDST",
    "RENFREW, CALGARY": "CAL-RNFR",
    "RICHMOND, CALGARY": "CAL-RCHM",
    "RIDEAU PARK, CALGARY": "CAL-RDPR",
    "RIVERBEND, CALGARY": "CAL-RVRB",
    "ROCKY RIDGE, CALGARY": "CAL-RCKY",
    "ROSEDALE, CALGARY": "CAL-RSDL",
    "ROSEMONT, CALGARY": "CAL-RSMN",
    "ROSSCARROCK, CALGARY": "CAL-RSSC",
    "ROXBORO, CALGARY": "CAL-RXBR",
    "ROYAL OAK, CALGARY": "CAL-RYLK",
    "ROYAL VISTA, CALGARY": "CAL-RYLV",
    "RUNDLE, CALGARY": "CAL-RNDL",
    "RUTLAND PARK, CALGARY": "CAL-RTLN",
    "SADDLE RIDGE, CALGARY": "CAL-SDDL",
    "SADDLE RIDGE INDUSTRIAL, CALGARY": "CAL-SDD1",
    "SAGE HILL, CALGARY": "CAL-SGHL",
    "SANDSTONE VALLEY, CALGARY": "CAL-SNDS",
    "SCARBORO, CALGARY": "CAL-SCRB",
    "SCARBORO - SUNALTA WEST, CALGARY": "CAL-SCR1",
    "SCENIC ACRES, CALGARY": "CAL-SCNC",
    "SETON, CALGARY": "CAL-STN",
    "SHAGANAPPI, CALGARY": "CAL-SHGN",
    "SHAWNEE SLOPES, CALGARY": "CAL-SHWN",
    "SHAWNESSY, CALGARY": "CAL-SHW1",
    "SHEPARD INDUSTRIAL, CALGARY": "CAL-SHPR",
    "SHERWOOD, CALGARY": "CAL-SHRW",
    "SIGNAL HILL, CALGARY": "CAL-SGNL",
    "SILVER SPRINGS, CALGARY": "CAL-SLVR",
    "SILVERADO, CALGARY": "CAL-SLV1",
    "SKYLINE EAST, CALGARY": "CAL-SKYL",
    "SKYLINE WEST, CALGARY": "CAL-SKY1",
    "SKYVIEW RANCH, CALGARY": "CAL-SKYV",
    "SOMERSET, CALGARY": "CAL-SMRS",
    "SOUTH AIRWAYS, CALGARY": "CAL-STHR",
    "SOUTH CALGARY, CALGARY": "CAL-STHC",
    "SOUTH FOOTHILLS, CALGARY": "CAL-STHF",
    "SOUTHVIEW, CALGARY": "CAL-STHV",
    "SOUTHWOOD, CALGARY": "CAL-STHW",
    "SPRINGBANK HILL, CALGARY": "CAL-SPRN",
    "SPRUCE CLIFF, CALGARY": "CAL-SPRC",
    "ST ANDREWS HEIGHTS, CALGARY": "CAL-STND",
    "STARFIELD, CALGARY": "CAL-STRF",
    "STONEGATE LANDING, CALGARY": "CAL-STNG",
    "STRATHCONA PARK, CALGARY": "CAL-STRT",
    "SUNALTA, CALGARY": "CAL-SNLT",
    "SUNDANCE, CALGARY": "CAL-SNDN",
    "SUNNYSIDE, CALGARY": "CAL-SNNY",
    "SUNRIDGE, CALGARY": "CAL-SNRD",
    "TARADALE, CALGARY": "CAL-TRDL",
    "TEMPLE, CALGARY": "CAL-TMPL",
    "THORNCLIFFE, CALGARY": "CAL-THRN",
    "TUSCANY, CALGARY": "CAL-TSCN",
    "TUXEDO PARK, CALGARY": "CAL-TXDP",
    "UNIVERSITY HEIGHTS, CALGARY": "CAL-UNVR",
    "UNIVERSITY OF CALGARY, CALGARY": "CAL-UNV1",
    "UPPER MOUNT ROYAL, CALGARY": "CAL-UPPR",
    "VALLEY RIDGE, CALGARY": "CAL-VLLY",
    "VALLEYFIELD, CALGARY": "CAL-VLL1",
    "VARSITY, CALGARY": "CAL-VRST",
    "VISTA HEIGHTS, CALGARY": "CAL-VSTH",
    "WALDEN, CALGARY": "CAL-WLDN",
    "WEST HILLHURST, CALGARY": "CAL-WSTH",
    "WEST SPRINGS, CALGARY": "CAL-WSTS",
    "WESTGATE, CALGARY": "CAL-WSTG",
    "WESTWINDS, CALGARY": "CAL-WSTW",
    "WHITEHORN, CALGARY": "CAL-WHTH",
    "WILDWOOD, CALGARY": "CAL-WLDW",
    "WILLOW PARK, CALGARY": "CAL-WLLW",
    "WINDSOR PARK, CALGARY": "CAL-WNDS",
    "WINSTON HEIGHTS - MOUNTVIEW, CALGARY": "CAL-WNST",
    "WOODBINE, CALGARY": "CAL-WDBN",
    "WOODLANDS, CALGARY": "CAL-WDLN",
    "ABBOTTSFIELD, EDMONTON": "EDM-ABBT",
    "ALBANY, EDMONTON": "EDM-ALBN",
    "ALBERTA AVENUE, EDMONTON": "EDM-ALB1",
    "ALDERGROVE, EDMONTON": "EDM-ALDR",
    "ALLARD, EDMONTON": "EDM-ALLR",
    "ALLENDALE, EDMONTON": "EDM-ALLN",
    "AMBLESIDE, EDMONTON": "EDM-AMBL",
    "ANTHONY HENDAY, EDMONTON": "EDM-ANTH",
    "ANTHONY HENDAY CASTLE DOWNS, EDMONTON": "EDM-ANT1",
    "ANTHONY HENDAY MISTATIM, EDMONTON": "EDM-ANT2",
    "ARGYLL, EDMONTON": "EDM-ARGY",
    "ASPEN GARDENS, EDMONTON": "EDM-ASP1",
    "ASTER, EDMONTON": "EDM-ASTR",
    "ATHLONE, EDMONTON": "EDM-ATHL",
    "AVONMORE, EDMONTON": "EDM-AVNM",
    "BALWIN, EDMONTON": "EDM-BLWN",
    "BANNERMAN, EDMONTON": "EDM-BNNR",
    "BARANOW, EDMONTON": "EDM-BRNW",
    "BATURYN, EDMONTON": "EDM-BTRY",
    "BEACON HEIGHTS, EDMONTON": "EDM-BCNH",
    "BEARSPAW, EDMONTON": "EDM-BRSP",
    "BEAUMARIS, EDMONTON": "EDM-BMRS",
    "BELGRAVIA, EDMONTON": "EDM-BLGR",
    "BELLE RIVE, EDMONTON": "EDM-BLLR",
    "BELLEVUE, EDMONTON": "EDM-BLLV",
    "BELMEAD, EDMONTON": "EDM-BLMD",
    "BELMONT, EDMONTON": "EDM-BLMN",
    "BELVEDERE, EDMONTON": "EDM-BLVD",
    "BERGMAN, EDMONTON": "EDM-BRGM",
    "BEVERLY HEIGHTS, EDMONTON": "EDM-BVRL",
    "BISSET, EDMONTON": "EDM-BSST",
    "BLACKBURNE, EDMONTON": "EDM-BLCK",
    "BLACKMUD CREEK, EDMONTON": "EDM-BLC1",
    "BLATCHFORD AREA, EDMONTON": "EDM-BLTC",
    "BLUE QUILL, EDMONTON": "EDM-BLQL",
    "BLUE QUILL ESTATES, EDMONTON": "EDM-BLQ1",
    "BONNIE DOON, EDMONTON": "EDM-BNND",
    "BOYLE STREET, EDMONTON": "EDM-BYLS",
    "BRANDER GARDENS, EDMONTON": "EDM-BRND",
    "BRECKENRIDGE GREENS, EDMONTON": "EDM-BRCK",
    "BRINTNELL, EDMONTON": "EDM-BRN1",
    "BRITANNIA YOUNGSTOWN, EDMONTON": "EDM-BRT1",
    "BROOKSIDE, EDMONTON": "EDM-BRKS",
    "BULYEA HEIGHTS, EDMONTON": "EDM-BLYH",
    "CAERNARVON, EDMONTON": "EDM-CRNR",
    "CALDER, EDMONTON": "EDM-CLDR",
    "CALGARY TRAIL NORTH, EDMONTON": "EDM-CLG1",
    "CALGARY TRAIL SOUTH, EDMONTON": "EDM-CLG2",
    "CALLAGHAN, EDMONTON": "EDM-CLLG",
    "CALLINGWOOD NORTH, EDMONTON": "EDM-CLL1",
    "CALLINGWOOD SOUTH, EDMONTON": "EDM-CLL2",
    "CAMERON HEIGHTS, EDMONTON": "EDM-CMRN",
    "CANON RIDGE, EDMONTON": "EDM-CNNR",
    "CANORA, EDMONTON": "EDM-CNR",
    "CANOSSA, EDMONTON": "EDM-CNSS",
    "CAPILANO, EDMONTON": "EDM-CPLN",
    "CARLISLE, EDMONTON": "EDM-CRL1",
    "CARLTON, EDMONTON": "EDM-CRLT",
    "CARTER CREST, EDMONTON": "EDM-CRTR",
    "CASSELMAN, EDMONTON": "EDM-CSSL",
    "CAVANAGH, EDMONTON": "EDM-CVNG",
    "CENTRAL MCDOUGALL, EDMONTON": "EDM-CNT2",
    "CHAMBERY, EDMONTON": "EDM-CHMB",
    "CHAPPELLE AREA, EDMONTON": "EDM-CHPP",
    "CHARLESWORTH, EDMONTON": "EDM-CHR1",
    "CLAREVIEW TOWN CENTRE, EDMONTON": "EDM-CLRV",
    "CLOVER BAR AREA, EDMONTON": "EDM-CLVR",
    "CLOVERDALE, EDMONTON": "EDM-CLV1",
    "CRAWFORD PLAINS, EDMONTON": "EDM-CRWF",
    "CRESTWOOD, EDMONTON": "EDM-CRS1",
    "CROMDALE, EDMONTON": "EDM-CRMD",
    "CRYSTALLINA NERA, EDMONTON": "EDM-CRYS",
    "CRYSTALLINA NERA EAST, EDMONTON": "EDM-CRY1",
    "CRYSTALLINA NERA WEST, EDMONTON": "EDM-CRY2",
    "CUMBERLAND, EDMONTON": "EDM-CMB1",
    "CY BECKER, EDMONTON": "EDM-CYBC",
    "DALY GROVE, EDMONTON": "EDM-DLYG",
    "DECHENE, EDMONTON": "EDM-DCHN",
    "DECOTEAU, EDMONTON": "EDM-DCT",
    "DELTON, EDMONTON": "EDM-DLTN",
    "DELWOOD, EDMONTON": "EDM-DLWD",
    "DESROCHERS AREA, EDMONTON": "EDM-DSRC",
    "DONSDALE, EDMONTON": "EDM-DNSD",
    "DOVERCOURT, EDMONTON": "EDM-DVRC",
    "DOWNTOWN, EDMONTON": "EDM-DWN3",
    "DUGGAN, EDMONTON": "EDM-DGGN",
    "DUNLUCE, EDMONTON": "EDM-DNLC",
    "EASTGATE BUSINESS PARK, EDMONTON": "EDM-ESTG",
    "EASTWOOD, EDMONTON": "EDM-ESTW",
    "EAUX CLAIRES, EDMONTON": "EDM-EXCL",
    "EBBERS, EDMONTON": "EDM-EBBR",
    "EDGEMONT, EDMONTON": "EDM-EDG1",
    "EDMONTON SOUTH CENTRAL EAST, EDMONTON": "EDM-EDMN",
    "EDMONTON SOUTH EAST, EDMONTON": "EDM-EDM1",
    "EKOTA, EDMONTON": "EDM-EKT",
    "ELLERSLIE, EDMONTON": "EDM-ELLR",
    "ELMWOOD, EDMONTON": "EDM-ELMW",
    "ELMWOOD PARK, EDMONTON": "EDM-ELM1",
    "ELSINORE, EDMONTON": "EDM-ELSN",
    "EMPIRE PARK, EDMONTON": "EDM-EMPR",
    "ERMINESKIN, EDMONTON": "EDM-ERMN",
    "EVANSDALE, EDMONTON": "EDM-EVN1",
    "EVERGREEN, EDMONTON": "EDM-EVR1",
    "FALCONER HEIGHTS, EDMONTON": "EDM-FLC1",
    "FOREST HEIGHTS, EDMONTON": "EDM-FRS3",
    "FRASER, EDMONTON": "EDM-FRSR",
    "FULTON PLACE, EDMONTON": "EDM-FLTN",
    "GARIEPY, EDMONTON": "EDM-GRPY",
    "GARNEAU, EDMONTON": "EDM-GRN",
    "GLASTONBURY, EDMONTON": "EDM-GLST",
    "GLENGARRY, EDMONTON": "EDM-GLNG",
    "GLENORA, EDMONTON": "EDM-GLNR",
    "GLENRIDDING AREA, EDMONTON": "EDM-GLN2",
    "GLENRIDDING HEIGHTS, EDMONTON": "EDM-GLN3",
    "GLENRIDDING RAVINE, EDMONTON": "EDM-GLN4",
    "GLENWOOD, EDMONTON": "EDM-GLNW",
    "GOLD BAR, EDMONTON": "EDM-GLDB",
    "GORMAN, EDMONTON": "EDM-GRMN",
    "GRANDVIEW HEIGHTS, EDMONTON": "EDM-GRND",
    "GRANVILLE, EDMONTON": "EDM-GRN2",
    "GRAYDON HILL, EDMONTON": "EDM-GRYD",
    "GREENFIELD, EDMONTON": "EDM-GRNF",
    "GREENVIEW, EDMONTON": "EDM-GRN3",
    "GRIESBACH, EDMONTON": "EDM-GRSB",
    "GROVENOR, EDMONTON": "EDM-GRVN",
    "HADDOW, EDMONTON": "EDM-HDDW",
    "HAIRSINE, EDMONTON": "EDM-HRSN",
    "HAMPTONS, EDMONTON": "EDM-HMP1",
    "HAWKS RIDGE, EDMONTON": "EDM-HWKS",
    "HAYS RIDGE AREA, EDMONTON": "EDM-HYSR",
    "HAZELDEAN, EDMONTON": "EDM-HZLD",
    "HENDERSON ESTATES, EDMONTON": "EDM-HNDR",
    "HERITAGE VALLEY TOWN CENTRE AREA, EDMONTON": "EDM-HRTG",
    "HIGH PARK, EDMONTON": "EDM-HGHP",
    "HIGHFIELD, EDMONTON": "EDM-HGH1",
    "HIGHLANDS, EDMONTON": "EDM-HGH2",
    "HILLVIEW, EDMONTON": "EDM-HLLV",
    "HODGSON, EDMONTON": "EDM-HDGS",
    "HOLLICK-KENYON, EDMONTON": "EDM-HLLC",
    "HOLYROOD, EDMONTON": "EDM-HLYR",
    "HOMESTEADER, EDMONTON": "EDM-HMST",
    "HUDSON, EDMONTON": "EDM-HDSN",
    "IDYLWYLDE, EDMONTON": "EDM-IDYL",
    "INGLEWOOD, EDMONTON": "EDM-ING1",
    "JACKSON HEIGHTS, EDMONTON": "EDM-JCKS",
    "JAMIESON PLACE, EDMONTON": "EDM-JMSN",
    "JASPER PARK, EDMONTON": "EDM-JSPR",
    "KAMEYOSEK, EDMONTON": "EDM-KMYS",
    "KEHEEWIN, EDMONTON": "EDM-KHWN",
    "KENILWORTH, EDMONTON": "EDM-KNLW",
    "KENSINGTON, EDMONTON": "EDM-KNSN",
    "KERNOHAN, EDMONTON": "EDM-KRNH",
    "KESWICK AREA, EDMONTON": "EDM-KSWC",
    "KILDARE, EDMONTON": "EDM-KLDR",
    "KILKENNY, EDMONTON": "EDM-KLKN",
    "KILLARNEY, EDMONTON": "EDM-KLL1",
    "KING EDWARD PARK, EDMONTON": "EDM-KNGD",
    "KINGLET GARDENS, EDMONTON": "EDM-KNGL",
    "KINISKI GARDENS, EDMONTON": "EDM-KNSK",
    "KIRKNESS, EDMONTON": "EDM-KRKN",
    "KLARVATTEN, EDMONTON": "EDM-KLRV",
    "LA PERLE, EDMONTON": "EDM-LPRL",
    "LAGO LINDO, EDMONTON": "EDM-LGLN",
    "LANSDOWNE, EDMONTON": "EDM-LNSD",
    "LARKSPUR, EDMONTON": "EDM-LRKS",
    "LAUDERDALE, EDMONTON": "EDM-LDRD",
    "LAUREL, EDMONTON": "EDM-LRL",
    "LAURIER HEIGHTS, EDMONTON": "EDM-LRRH",
    "LEE RIDGE, EDMONTON": "EDM-LRDG",
    "LEGER, EDMONTON": "EDM-LGR",
    "LENDRUM PLACE, EDMONTON": "EDM-LNDR",
    "LORELEI, EDMONTON": "EDM-LRL1",
    "LYMBURN, EDMONTON": "EDM-LYMB",
    "LYNNWOOD, EDMONTON": "EDM-LYNN",
    "MACEWAN, EDMONTON": "EDM-MCW1",
    "MACTAGGART, EDMONTON": "EDM-MCTG",
    "MAGRATH HEIGHTS, EDMONTON": "EDM-MGRT",
    "MALMO PLAINS, EDMONTON": "EDM-MLMP",
    "MAPLE, EDMONTON": "EDM-MPL",
    "MAPLE RIDGE, EDMONTON": "EDM-MPL1",
    "MATT BERRY, EDMONTON": "EDM-MTTB",
    "MAYFIELD, EDMONTON": "EDM-MYFL",
    "MAYLIEWAN, EDMONTON": "EDM-MYLW",
    "MCCAULEY, EDMONTON": "EDM-MCC1",
    "MCCONACHIE AREA, EDMONTON": "EDM-MCCN",
    "MCKERNAN, EDMONTON": "EDM-MCKR",
    "MCLEOD, EDMONTON": "EDM-MCLD",
    "MCQUEEN, EDMONTON": "EDM-MCQN",
    "MEADOWLARK PARK, EDMONTON": "EDM-MDW1",
    "MENISA, EDMONTON": "EDM-MNS",
    "MEYOKUMIN, EDMONTON": "EDM-MYKM",
    "MEYONOHK, EDMONTON": "EDM-MYNH",
    "MICHAELS PARK, EDMONTON": "EDM-MCHL",
    "MILL CREEK RAVINE NORTH, EDMONTON": "EDM-MLLC",
    "MILL WOODS TOWN CENTRE, EDMONTON": "EDM-MLLW",
    "MILLER, EDMONTON": "EDM-MLL1",
    "MINCHAU, EDMONTON": "EDM-MNC2",
    "MONTROSE, EDMONTON": "EDM-MNT1",
    "NEWTON, EDMONTON": "EDM-NWTN",
    "NORTH GLENORA, EDMONTON": "EDM-NRT4",
    "NORTHMOUNT, EDMONTON": "EDM-NRT5",
    "OGILVIE RIDGE, EDMONTON": "EDM-OGLV",
    "OLESKIW, EDMONTON": "EDM-OLSK",
    "OLIVER, EDMONTON": "EDM-OLVR",
    "ORCHARDS AT ELLERSLIE, EDMONTON": "EDM-ORCH",
    "ORMSBY PLACE, EDMONTON": "EDM-ORMS",
    "OTTEWELL, EDMONTON": "EDM-OTTW",
    "OVERLANDERS, EDMONTON": "EDM-OVRL",
    "OXFORD, EDMONTON": "EDM-OXFR",
    "OZERNA, EDMONTON": "EDM-OZRN",
    "PAISLEY, EDMONTON": "EDM-PSLY",
    "PARKALLEN, EDMONTON": "EDM-PRK1",
    "PARKDALE, EDMONTON": "EDM-PRK2",
    "PARKVIEW, EDMONTON": "EDM-PRKV",
    "PATRICIA HEIGHTS, EDMONTON": "EDM-PTRC",
    "PEMBINA, EDMONTON": "EDM-PMBN",
    "PINTAIL LANDING, EDMONTON": "EDM-PNTL",
    "PLACE LA RUE, EDMONTON": "EDM-PLCL",
    "PLEASANTVIEW, EDMONTON": "EDM-PLSN",
    "POLLARD MEADOWS, EDMONTON": "EDM-PLLR",
    "POTTER GREENS, EDMONTON": "EDM-PTT1",
    "PRINCE CHARLES, EDMONTON": "EDM-PRNC",
    "PRINCE RUPERT, EDMONTON": "EDM-PRN1",
    "QUEEN ALEXANDRA, EDMONTON": "EDM-QNLX",
    "QUEEN MARY PARK, EDMONTON": "EDM-QNMR",
    "QUESNELL HEIGHTS, EDMONTON": "EDM-QSNL",
    "RAMSAY HEIGHTS, EDMONTON": "EDM-RMS1",
    "RAPPERSWILL, EDMONTON": "EDM-RPPR",
    "RHATIGAN RIDGE, EDMONTON": "EDM-RHTG",
    "RICHFIELD, EDMONTON": "EDM-RCHF",
    "RICHFORD, EDMONTON": "EDM-RCH1",
    "RIDEAU PARK, EDMONTON": "EDM-RDP1",
    "RIO TERRACE, EDMONTON": "EDM-RTRR",
    "RITCHIE, EDMONTON": "EDM-RTCH",
    "RIVER VALLEY WINDEMERE, EDMONTON": "EDM-RVRV",
    "RIVER’S EDGE, EDMONTON": "EDM-RVRS",
    "RIVERDALE, EDMONTON": "EDM-RVRD",
    "RIVERVIEW AREA, EDMONTON": "EDM-RVR1",
    "ROSENTHAL, EDMONTON": "EDM-RSNT",
    "ROSSDALE, EDMONTON": "EDM-RSSD",
    "ROSSLYN, EDMONTON": "EDM-RSSL",
    "ROYAL GARDENS, EDMONTON": "EDM-RYLG",
    "RUNDLE HEIGHTS, EDMONTON": "EDM-RND1",
    "RUTHERFORD, EDMONTON": "EDM-RTHR",
    "SAKAW, EDMONTON": "EDM-SKW",
    "SATOO, EDMONTON": "EDM-ST",
    "SCHONSEE, EDMONTON": "EDM-SCHN",
    "SECORD, EDMONTON": "EDM-SCRD",
    "SHERBROOKE, EDMONTON": "EDM-SHRB",
    "SHERWOOD, EDMONTON": "EDM-SHR1",
    "SIFTON PARK, EDMONTON": "EDM-SFTN",
    "SILVER BERRY, EDMONTON": "EDM-SLV2",
    "SKYRATTLER, EDMONTON": "EDM-SKYR",
    "SOUTH EDMONTON COMMON, EDMONTON": "EDM-STHD",
    "SOUTH TERWILLEGAR, EDMONTON": "EDM-STHT",
    "SPRUCE AVENUE, EDMONTON": "EDM-SPR1",
    "STARLING, EDMONTON": "EDM-STRL",
    "STEINHAUER, EDMONTON": "EDM-STNH",
    "STEWART GREENS, EDMONTON": "EDM-STWR",
    "STILLWATER, EDMONTON": "EDM-STLL",
    "STRATHCONA, EDMONTON": "EDM-STR1",
    "STRATHCONA JUNCTION, EDMONTON": "EDM-STR2",
    "STRATHEARN, EDMONTON": "EDM-STR3",
    "SUDER GREENS, EDMONTON": "EDM-SDRG",
    "SUMMERLEA, EDMONTON": "EDM-SMMR",
    "SUMMERSIDE, EDMONTON": "EDM-SMM1",
    "SWEET GRASS, EDMONTON": "EDM-SWTG",
    "TAMARACK, EDMONTON": "EDM-TMRC",
    "TAWA, EDMONTON": "EDM-TW",
    "TERRA LOSA, EDMONTON": "EDM-TRRL",
    "TERRACE HEIGHTS, EDMONTON": "EDM-TRRC",
    "TERWILLEGAR TOWNE, EDMONTON": "EDM-TRWL",
    "THE HAMPTONS, EDMONTON": "EDM-THHM",
    "THE ORCHARDS AT ELLERSLIE, EDMONTON": "EDM-THRC",
    "THE UPLANDS, EDMONTON": "EDM-THPL",
    "THORNCLIFFE, EDMONTON": "EDM-THR1",
    "TIPASKAN, EDMONTON": "EDM-TPSK",
    "TRUMPETER AREA, EDMONTON": "EDM-TRMP",
    "TWEDDLE PLACE, EDMONTON": "EDM-TWDD",
    "TWIN BROOKS, EDMONTON": "EDM-TWNB",
    "UPLANDS, EDMONTON": "EDM-UPLN",
    "VIRGINIA PARK, EDMONTON": "EDM-VRGN",
    "WALKER, EDMONTON": "EDM-WLKR",
    "WEBBER GREENS, EDMONTON": "EDM-WBBR",
    "WEDGEWOOD HEIGHTS, EDMONTON": "EDM-WDGW",
    "WEINLOS, EDMONTON": "EDM-WNLS",
    "WELLINGTON, EDMONTON": "EDM-WLLN",
    "WEST JASPER PLACE, EDMONTON": "EDM-WSTJ",
    "WEST MEADOWLARK PARK, EDMONTON": "EDM-WSTM",
    "WESTBROOK ESTATE, EDMONTON": "EDM-WSTB",
    "WESTMOUNT, EDMONTON": "EDM-WST1",
    "WESTRIDGE, EDMONTON": "EDM-WSTR",
    "WESTVIEW VILLAGE, EDMONTON": "EDM-WSTV",
    "WESTWOOD, EDMONTON": "EDM-WST2",
    "WILD ROSE, EDMONTON": "EDM-WLDR",
    "WINDERMERE, EDMONTON": "EDM-WNDR",
    "WINDSOR PARK, EDMONTON": "EDM-WND1",
    "WOODCROFT, EDMONTON": "EDM-WDCR",
    "YORK, EDMONTON": "EDM-YRK",
    "HARDIEVILLE, LETHBRIDGE": "LET-HRDV",
    "BLACKWOLF, LETHBRIDGE": "LET-BLC2",
    "LEGACY RIDGE, LETHBRIDGE": "LET-LGC1",
    "PARK MEADOWS, LETHBRIDGE": "LET-PRKM",
    "SENATOR BUCHANAN, LETHBRIDGE": "LET-SNTR",
    "ST EDWARDS, LETHBRIDGE": "LET-STDW",
    "STAFFORDVILLE, LETHBRIDGE": "LET-STFF",
    "WESTMINSTER, LETHBRIDGE": "LET-WST3",
    "WINSTON CHURCHILL, LETHBRIDGE": "LET-WNS1",
    "UPLANDS, LETHBRIDGE": "LET-UPL1",
    "BENTON CROSSING, LETHBRIDGE": "LET-BNTN",
    "COPPERWOOD, LETHBRIDGE": "LET-CPP1",
    "HERITAGE HEIGHTS, LETHBRIDGE": "LET-HRT1",
    "GARRY STATION, LETHBRIDGE": "LET-GRRY",
    "INDIAN BATTLE HEIGHTS, LETHBRIDGE": "LET-INDN",
    "MOUNTAIN HEIGHTS, LETHBRIDGE": "LET-MNTN",
    "PARADISE CANYON, LETHBRIDGE": "LET-PRDS",
    "RIDGEWOOD HEIGHTS, LETHBRIDGE": "LET-RDGW",
    "RIVERSTONE, LETHBRIDGE": "LET-RVR2",
    "SUNRIDGE, LETHBRIDGE": "LET-SNR1",
    "VARSITY VILLAGE, LETHBRIDGE": "LET-VRS1",
    "WEST HIGHLANDS, LETHBRIDGE": "LET-WST4",
    "CHINOOK HEIGHTS, LETHBRIDGE": "LET-CHN1",
    "FAIRMONT PARK, LETHBRIDGE": "LET-FRMN",
    "FLEETWOOD, LETHBRIDGE": "LET-FLTW",
    "GLENDALE, LETHBRIDGE": "LET-GLN5",
    "HAMILTON, LETHBRIDGE": "LET-HMLT",
    "HENDERSON LAKE, LETHBRIDGE": "LET-HND1",
    "LAKEVIEW, LETHBRIDGE": "LET-LKV1",
    "LONDON ROAD, LETHBRIDGE": "LET-LNDN",
    "REDWOOD, LETHBRIDGE": "LET-RDWD",
    "SCENIC HEIGHTS, LETHBRIDGE": "LET-SCN1",
    "SOUTHGATE, LETHBRIDGE": "LET-STHG",
    "TUDOR ESTATES, LETHBRIDGE": "LET-TDRS",
    "VICTORIA PARK, LETHBRIDGE": "LET-VCTR",
    "ANDERS PARK, RED DEER": "RED-ANDR",
    "ASPEN RIDGE, RED DEER": "RED-ASP2",
    "BOWER, RED DEER": "RED-BWR",
    "CLEARVIEW MEADOWS, RED DEER": "RED-CLR1",
    "CLEARVIEW RIDGE, RED DEER": "RED-CLR2",
    "DEER PARK ESTATES, RED DEER": "RED-DRPR",
    "DEER PARK NORTHEAST, RED DEER": "RED-DRP1",
    "DEER PARK SOUTHEAST, RED DEER": "RED-DRP2",
    "DEER PARK VILLAGE, RED DEER": "RED-DRP3",
    "DOWNTOWN, RED DEER": "RED-DWN4",
    "EASTVIEW, RED DEER": "RED-ESTV",
    "FAIRVIEW, RED DEER": "RED-FRV2",
    "FORTH, RED DEER": "RED-FRTH",
    "GARDEN HEIGHTS, RED DEER": "RED-GRDN",
    "GLENDALE, RED DEER": "RED-GLN6",
    "GLENDALE PARK ESTATES, RED DEER": "RED-GLN7",
    "GRANDVIEW, RED DEER": "RED-GRN4",
    "HIGHLAND GREEN, RED DEER": "RED-HGH3",
    "HIGHLAND GREEN ESTATES, RED DEER": "RED-HGH4",
    "INGLEWOOD EAST, RED DEER": "RED-ING2",
    "INGLEWOOD WEST, RED DEER": "RED-ING3",
    "JOHNSTONE CROSSING, RED DEER": "RED-JHNS",
    "JOHNSTONE PARK, RED DEER": "RED-JHN1",
    "KENTWOOD EAST, RED DEER": "RED-KNTW",
    "KENTWOOD WEST, RED DEER": "RED-KNT1",
    "LANCASTER GREEN, RED DEER": "RED-LNCS",
    "LANCASTER MEADOWS, RED DEER": "RED-LNC1",
    "LONSDALE, RED DEER": "RED-LNS1",
    "MICHENER HILL, RED DEER": "RED-MCHN",
    "MORRISROE, RED DEER": "RED-MRRS",
    "MOUNTVIEW, RED DEER": "RED-MNTV",
    "NORMANDEAU, RED DEER": "RED-NRMN",
    "ORIOLE PARK, RED DEER": "RED-ORLP",
    "PARKVALE, RED DEER": "RED-PRK3",
    "PINES, RED DEER": "RED-PNS",
    "RIVERSIDE MEADOWS, RED DEER": "RED-RVR3",
    "ROSEDALE ESTATES, RED DEER": "RED-RSD1",
    "ROSEDALE MEADOWS, RED DEER": "RED-RSD2",
    "ROSSCARROCK, RED DEER": "RED-RSS1",
    "SOUTH HILL, RED DEER": "RED-STHH",
    "SUNNYBROOK, RED DEER": "RED-SNN1",
    "SUNNYBROOK SOUTH, RED DEER": "RED-SNN2",
    "TIMBERSTONE PARK, RED DEER": "RED-TMBR",
    "VANIER WOODS, RED DEER": "RED-VNRW",
    "WASKASOO, RED DEER": "RED-WSKS",
    "WEST PARK, RED DEER": "RED-WSTP",
    "WESTERNER PARK, RED DEER": "RED-WST5",
    "AIRDRIE MEADOWS, AIRDRIE": "AIR-ARDR",
    "BAYSIDE, AIRDRIE": "AIR-BYSD",
    "BAYSPRINGS, AIRDRIE": "AIR-BYSP",
    "BAYVIEW, AIRDRIE": "AIR-BYV1",
    "CANALS, AIRDRIE": "AIR-CNLS",
    "CHINOOK GATE, AIRDRIE": "AIR-CHN2",
    "COBBLESTONE CREEK, AIRDRIE": "AIR-CBBL",
    "COOPERS CROSSING, AIRDRIE": "AIR-CPRS",
    "DAVY CREEK, AIRDRIE": "AIR-DVYC",
    "DOWNTOWN, AIRDRIE": "AIR-DWN5",
    "EAST LAKE INDUSTRIAL, AIRDRIE": "AIR-ESTL",
    "EDGEWATER, AIRDRIE": "AIR-EDGW",
    "EDMONTON TRAIL, AIRDRIE": "AIR-EDM2",
    "FAIRWAYS, AIRDRIE": "AIR-FRWY",
    "GATEWAY COMMERCIAL, AIRDRIE": "AIR-GTWY",
    "HIGHLAND, AIRDRIE": "AIR-HGH5",
    "HILLCREST, AIRDRIE": "AIR-HLL1",
    "JENSEN, AIRDRIE": "AIR-JNSN",
    "KEY RANCH, AIRDRIE": "AIR-KYRN",
    "KING'S HEIGHTS, AIRDRIE": "AIR-KNG1",
    "LANARK, AIRDRIE": "AIR-LNRK",
    "LUXSTONE, AIRDRIE": "AIR-LXST",
    "MEADOWBROOK, AIRDRIE": "AIR-MDWB",
    "MIDTOWN, AIRDRIE": "AIR-MDTW",
    "MORNINGSIDE, AIRDRIE": "AIR-MRNN",
    "OLD TOWN, AIRDRIE": "AIR-OLDT",
    "PRAIRIE SPRINGS, AIRDRIE": "AIR-PRRS",
    "RAVENSWOOD, AIRDRIE": "AIR-RVNS",
    "REUNION, AIRDRIE": "AIR-RNN",
    "REYNOLDS, AIRDRIE": "AIR-RYNL",
    "RIDGEGATE, AIRDRIE": "AIR-RDGG",
    "SAGEWOOD, AIRDRIE": "AIR-SGWD",
    "SIERRA SPRINGS COMMERCIAL, AIRDRIE": "AIR-SRRS",
    "SILVER CREEK, AIRDRIE": "AIR-SLV3",
    "SOUTH POINTE COMMERCIAL, AIRDRIE": "AIR-STHP",
    "SOUTHWINDS, AIRDRIE": "AIR-STH1",
    "STONEGATE, AIRDRIE": "AIR-STN1",
    "SUMMERHILL, AIRDRIE": "AIR-SMM2",
    "SUN RIDGE, AIRDRIE": "AIR-SNR2",
    "THE VILLAGE, AIRDRIE": "AIR-THVL",
    "THORBURN, AIRDRIE": "AIR-THRB",
    "VANTAGE RISE, AIRDRIE": "AIR-VNTG",
    "WATERSTONE, AIRDRIE": "AIR-WTRS",
    "WILDFLOWER, AIRDRIE": "AIR-WLDF",
    "WILLIAMSTOWN, AIRDRIE": "AIR-WLLM",
    "WILLOW BROOK, AIRDRIE": "AIR-WLL1",
    "WINDSONG, AIRDRIE": "AIR-WND2",
    "WOODSIDE, AIRDRIE": "AIR-WDSD",
    "YANKEE VALLEY CROSSING, AIRDRIE": "AIR-YNKV",
    "YANKEE VALLEY ESTATES, AIRDRIE": "AIR-YNK1",
    "ABBOTSFORD": "ABBT-C",
    "ARMSTRONG": "ARMS-TS",
    "BURNABY": "BRNB-C",
    "CAMPBELL RIVER": "CMPB-C",
    "CASTLEGAR": "CSTL-C",
    "CHILLIWACK": "CHLL-C",
    "COLWOOD": "CLWD-C",
    "COQUITLAM": "CQTL-C",
    "COURTENAY": "CRTN-C",
    "CRANBROOK": "CRNB-C",
    "DAWSON CREEK": "DWSN-C",
    "DUNCAN": "DNCN-C",
    "ENDERBY": "ENDR-C",
    "FERNIE": "FRN-C",
    "FORT ST JOHN": "FRTS-C",
    "GRAND FORKS": "GRND-C",
    "GREENWOOD": "GRN6-V",
    "KAMLOOPS": "KMLP-C",
    "KELOWNA": "KLWN-C",
    "KIMBERLEY": "KMBR-C",
    "LANGFORD": "LNGF-RM",
    "LANGLEY": "LNG1-TS",
    "MAPLE RIDGE": "BAR-BRR29-N",
    "MERRITT": "MRRT-C",
    "NANAIMO": "NNM-C",
    "NELSON": "NLSN-C",
    "NEW WESTMINSTER": "NWWS-C",
    "NORTH VANCOUVER": "NRT3-D",
    "PARKSVILLE": "PRKS-C",
    "PENTICTON": "PNTC-C",
    "PITT MEADOWS": "PTTM-C",
    "PORT ALBERNI": "PRTL-C",
    "PORT COQUITLAM": "PRTC-C",
    "PORT MOODY": "PRTM-C",
    "POWELL RIVER": "PWLL-C",
    "PRINCE GEORGE": "PRNC-C",
    "PRINCE RUPERT": "PRN1-C",
    "QUESNEL": "QSNL-C",
    "REVELSTOKE": "RVLS-C",
    "RICHMOND BC": "RCHM-C",
    "VICTORIA BC": "VCTR-C",
    "WINDSOR ON": "WNDS-C",
    "KINGSTON ON": "KNGS-C",
    "WATERLOO ON": "WTRL-C",
    "STRATFORD ON": "STRT-C",
    "BURLINGTON ON": "BRLN-C",
    "WOODSTOCK ON": "WDST-C",
    "AMHERST NS": "AMHR-T",
    "CORNWALL ON": "CRNW-C",
    "RICHMOND AB": "CAL-RCHM",
    "RICHMOND ON": "RCHM-T",
    "RICHMOND QB": "RCHM-T",
    "RICHMOND HEIGHTS SK": "SAS-RCHM",
    "RICHMOND NS": "HAL-RCHM",
    "VICTORIA MB": "VCTR-RM",
    "VICTORIA NL": "VCTR-T",
    "VICTORIA PE": "VCTR-RM",
    "WINDSOR NS": "WND1-T",
    "WINDSOR QB": "WNDS-T",
    "KINGSTON NS": "KNGS-V",
    "KINGSTON PE": "KNGS-RM",
    "WATERLOO QB": "WTRL-T",
    "STRATFORD PE": "STRT-T",
    "STRATFORD QB": "STRT-TS",
    "BURLINGTON NL": "BRLN-T",
    "TOWN OF BURLINGTON NL": "BRLN-T",
    "WOODSTOCK NL": "WDST-T",
    "AMHERST QB": "AMHR-TS",
    "AMHERSTBURG ON": "AMHR-T",
    "CORNWALL PE": "CRNW-T",
    "RICHMOND": "RCHM-T",
    "ROSSLAND": "RSSL-C",
    "SALMON ARM": "SLMN-C",
    "SURREY": "SRRY-C",
    "TERRACE": "TRRC-C",
    
    // Direct city mappings to ensure robust parent-city resolution
    // Quebec City (parent city fragment used in neighbourhood SKUs as QUE-...)
    "QUEBEC CITY": "QUE",
    
    // Trois-Rivieres (spelled without diacritics in some inputs)
    "TROIS-RIVIERES": "TRO",
    "TROIS-RIVIERES": "TRO",
    "TROY-RIVIERES": "TRO",
    "TRAIL": "TRL-C",
    "VANCOUVER": "VNCV-C",
    "VERNON": "VRNN-C",
    "VICTORIA": "VCTR-RM",
    "WEST KELOWNA": "WSTK-C",
    "WHITE ROCK": "WHTR-C",
    "WILLIAMS LAKE": "WLLM-C",
    "COMOX": "CMX-T",
    "CRESTON": "CRST-T",
    "GIBSONS": "GBSN-T",
    "GOLDEN": "GLDN-T",
    "LADYSMITH": "LDYS-T",
    "LAKE COWICHAN": "LKCW-T",
    "OLIVER": "OLVR-T",
    "OSOYOOS": "OSYS-T",
    "PORT MCNEILL": "PRT1-T",
    "PRINCETON": "PRN2-T",
    "QUALICUM BEACH": "QLCM-T",
    "SIDNEY": "SDNY-T",
    "SMITHERS": "SMTH-T",
    "VIEW ROYAL": "VWRY-T",
    "ESQUIMALT": "ESQM-TS",
    "SPALLUMCHEEN": "SPLL-TS",
    "ALERT BAY": "ALRT-V",
    "ANMORE": "ANMR-V",
    "ASHCROFT": "ASHC-V",
    "BELCARRA": "BLCR-V",
    "BURNS LAKE": "BRNS-V",
    "CACHE CREEK": "CCHC-V",
    "CANAL FLATS": "CNLF-V",
    "CHASE": "CHS-V",
    "CLINTON": "CLNT-V",
    "CUMBERLAND": "CMBR-RM",
    "FRASER LAKE": "FRSR-V",
    "FRUITVALE": "FRTV-V",
    "GOLD RIVER": "GLDR-V",
    "GRANISLE": "GRNS-V",
    "HARRISON HOT SPRINGS": "HRRS-V",
    "HAZELTON": "HZLT-V",
    "KASLO": "KSL-V",
    "KEREMEOS": "KRMS-V",
    "LIONS BAY": "LNSB-V",
    "LUMBY": "LMBY-V",
    "LYTTON": "LYTT-V",
    "MASSET": "MSST-V",
    "MCBRIDE": "MCBR-V",
    "MIDWAY": "MDWY-V",
    "MONTROSE": "MNTR-V",
    "NAKUSP": "NKSP-V",
    "NEW DENVER": "NWDN-V",
    "PEMBERTON": "PMBR-V",
    "PORT ALICE": "PRT2-V",
    "PORT CLEMENTS": "PRT3-V",
    "POUCE COUPE": "PCCP-V",
    "QUEEN CHARLOTTE": "QNCH-V",
    "RADIUM HOT SPRINGS": "RDMH-V",
    "SALMO": "SLM-V",
    "SAYWARD": "SYWR-V",
    "SILVERTON": "SLVR-V",
    "SLOCAN": "SLCN-V",
    "TAHSIS": "THSS-V",
    "TELKWA": "TLKW-V",
    "VALEMOUNT": "VLMN-V",
    "WARFIELD": "WRFL-V",
    "ZEBALLOS": "ZBLL-V",
    "100 MILE HOUSE": "MLHS-D",
    "BARRIERE": "BRRR-D",
    "CENTRAL SAANICH": "CNTR-D",
    "CHETWYND": "CHTW-D",
    "COLDSTREAM": "CLDS-D",
    "DELTA": "DLT-D",
    "ELKFORD": "ELKF-D",
    "FORT ST JAMES": "FRT1-D",
    "HIGHLANDS": "HGHL-D",
    "HOPE": "HP-TS",
    "HOUSTON": "HSTN-D",
    "HUDSON'S HOPE": "HDSN-D",
    "INVERMERE": "INVR-D",
    "KENT": "KENT-D",
    "KITIMAT": "KTMT-D",
    "LAKE COUNTRY": "LKCN-D",
    "LANTZVILLE": "LNTZ-D",
    "LILLOOET": "LLLT-D",
    "LOGAN LAKE": "LGNL-D",
    "MACKENZIE": "MCKN-D",
    "METCHOSIN": "MTCH-D",
    "MISSION": "MSSN-D",
    "NEW HAZELTON": "NWHZ-D",
    "NORTH COWICHAN": "NRT1-D",
    "NORTH SAANICH": "NRT2-D",
    "OAK BAY": "OKBY-D",
    "PEACHLAND": "PCHL-D",
    "PORT EDWARD": "PRTD-D",
    "PORT HARDY": "PRTH-D",
    "SAANICH": "SNCH-D",
    "SECHELT": "SCHL-D",
    "SICAMOUS": "SCMS-D",
    "SOOKE": "SOOK-D",
    "SPARWOOD": "SPRW-D",
    "SQUAMISH": "SQMS-D",
    "STEWART": "STWR-D",
    "SUMMERLAND": "SMMR-D",
    "TAYLOR": "TYLR-D",
    "TOFINO": "TFNO-D",
    "TUMBLER RIDGE": "TMBL-D",
    "UCLUELET": "UCLL-D",
    "VANDERHOOF": "VNDR-D",
    "WELLS": "WLLS-D",
    "WEST VANCOUVER": "WSTV-D",
    "ALBERNI-CLAYOQUOT REGIONAL DISTRICT": "ALBR-RG",
    "BULKLEY-NECHAKO REGIONAL DISTRICT": "BKNC-RG",
    "CAPITAL REGIONAL DISTRICT": "CPTL-RG",
    "CARIBOO REGIONAL DISTRICT": "CRBO-RG",
    "CENTRAL COAST REGIONAL DISTRICT": "CCST-RG",
    "CENTRAL KOOTENAY REGIONAL DISTRICT": "CKTN-RG",
    "CENTRAL OKANAGAN REGIONAL DISTRICT": "COKN-RG",
    "COLUMBIA SHUSWAP REGIONAL DISTRICT": "CSWP-RG",
    "COMOX VALLEY REGIONAL DISTRICT": "COMO-RG",
    "COWICHAN VALLEY REGIONAL DISTRICT": "CWCV-RG",
    "EAST KOOTENAY REGIONAL DISTRICT": "EKTN-RG",
    "FRASER VALLEY REGIONAL DISTRICT": "FRVL-RG",
    "FRASER-FORT GEORGE REGIONAL DISTRICT": "FFG-RG",
    "GREATER VANCOUVER REGIONAL DISTRICT": "GRVC-RG",
    "KITIMAT-STIKINE REGIONAL DISTRICT": "KMSK-RG",
    "KOOTENAY BOUNDARY REGIONAL DISTRICT": "KTBD-RG",
    "MOUNT WADDINGTON REGIONAL DISTRICT": "MWDG-RG",
    "NANAIMO REGIONAL DISTRICT": "NNMO-RG",
    "NORTH COAST REGIONAL DISTRICT": "NRCS-RG",
    "NORTH OKANAGAN REGIONAL DISTRICT": "NOKN-RG",
    "OKANAGAN-SIMILKAMEEN REGIONAL DISTRICT": "OKSM-RG",
    "PEACE RIVER REGIONAL DISTRICT": "PRVR-RG",
    "QATHET REGIONAL DISTRICT": "QTHT-RG",
    "SQUAMISH-LILLOOET REGIONAL DISTRICT": "SQLL-RG",
    "STRATHCONA REGIONAL DISTRICT": "STCN-RG",
    "SUNSHINE COAST REGIONAL DISTRICT": "SSNC-RG",
    "THOMPSON-NICOLA REGIONAL DISTRICT": "TPSN-RG",
    "RESORT MUNICIPALITY OF WHISTLER": "WHST-RM",
    "ARBUTUS RIDGE, VANCOUVER": "VAN-ARBT",
    "DOWNTOWN, VANCOUVER": "VAN-DWNT",
    "DUNBAR-SOUTHLANDS, VANCOUVER": "VAN-DNBR",
    "FAIRVIEW, VANCOUVER": "VAN-FRVW",
    "GRANDVIEW-WOODLAND, VANCOUVER": "VAN-GRND",
    "HASTINGS-SUNRISE, VANCOUVER": "VAN-HSTN",
    "KENSINGTON-CEDAR COTTAGE, VANCOUVER": "VAN-KNSN",
    "KERRISDALE, VANCOUVER": "VAN-KRRS",
    "KILLARNEY, VANCOUVER": "VAN-KLLR",
    "KITSILANO, VANCOUVER": "VAN-KTSL",
    "MARPOLE, VANCOUVER": "VAN-MRPL",
    "MOUNT PLEASANT, VANCOUVER": "VAN-MNTP",
    "OAKRIDGE, VANCOUVER": "VAN-OKRD",
    "RENFREW-COLLINGWOOD, VANCOUVER": "VAN-RNFR",
    "RILEY PARK, VANCOUVER": "VAN-RLYP",
    "SHAUGHNESSY, VANCOUVER": "VAN-SHGH",
    "SOUTH CAMBIE, VANCOUVER": "VAN-STHC",
    "STRATHCONA, VANCOUVER": "VAN-STRT",
    "SUNSET, VANCOUVER": "VAN-SNST",
    "VICTORIA-FRASERVIEW, VANCOUVER": "VAN-VCTR",
    "WEST END, VANCOUVER": "VAN-WSTN",
    "WEST POINT GREY, VANCOUVER": "VAN-WSTP",
    "BURNSIDE, VICTORIA": "VIC-BRNS",
    "DOWNTOWN, VICTORIA": "VIC-DWN1",
    "FAIRFIELD, VICTORIA": "VIC-FRFL",
    "FERNWOOD, VICTORIA": "VIC-FRNW",
    "GONZALES, VICTORIA": "VIC-GNZL",
    "HILLSIDE QUADRA, VICTORIA": "VIC-HLLS",
    "JAMES BAY, VICTORIA": "VIC-JMSB",
    "JUBILEE, VICTORIA": "VIC-JBL",
    "NORTH PARK, VICTORIA": "VIC-NRTH",
    "OAKLANDS, VICTORIA": "VIC-OKLN",
    "ROCKLAND, VICTORIA": "VIC-RCKL",
    "VICTORIA WEST, VICTORIA": "VIC-VCT1",
    "CLOVERDALE, SURREY": "SUR-CLVR",
    "FLEETWOOD, SURREY": "SUR-FLTW",
    "GUILDFORD, SURREY": "SUR-GLDF",
    "NEWTON, SURREY": "SUR-NWTN",
    "SOUTH SURREY, SURREY": "SUR-STHS",
    "WHALLEY, SURREY": "SUR-WHLL",
    "BURNABY HEIGHTS , BURNABY HEIGHTS": "BUR-BRNB",
    "WILLINGDON HEIGHTS, BURNABY HEIGHTS": "BUR-WLLN",
    "WEST CENTRAL VALLEY, BURNABY HEIGHTS": "BUR-WSTC",
    "DAWSON-DELTA, BURNABY HEIGHTS": "BUR-DWSN",
    "BRENTWOOD, BURNABY HEIGHTS": "BUR-BRNT",
    "CAPITOL HILL, BURNABY HEIGHTS": "BUR-CPTL",
    "PARKCREST-AUBREY, BURNABY HEIGHTS": "BUR-PRKC",
    "ARDINGLEY-SPROTT, BURNABY HEIGHTS": "BUR-ARDN",
    "BURNABY LAKE, BURNABY HEIGHTS": "BUR-BRN1",
    "GOVERNMENT ROAD, BURNABY HEIGHTS": "BUR-GVRN",
    "SPERLING-BROADWAY, BURNABY HEIGHTS": "BUR-SPRL",
    "LOCHDALE, BURNABY HEIGHTS": "BUR-LCHD",
    "WESTRIDGE, BURNABY HEIGHTS": "BUR-WSTR",
    "BURNABY MOUNTAIN , BURNABY HEIGHTS": "BUR-BRN2",
    "LAKE CITY, BURNABY HEIGHTS": "BUR-LKCT",
    "LYNDHURST, BURNABY HEIGHTS": "BUR-LYND",
    "CAMERON, BURNABY HEIGHTS": "BUR-CMRN",
    "CARIBOO-ARMSTRONG, BURNABY HEIGHTS": "BUR-CRBR",
    "SECOND STREET, BURNABY HEIGHTS": "BUR-SCND",
    "EDMONDS, BURNABY HEIGHTS": "BUR-EDMN",
    "STRIDE AVENUE, BURNABY HEIGHTS": "BUR-STRD",
    "STRIDE HILL, BURNABY HEIGHTS": "BUR-STR1",
    "BIG BEND, BURNABY HEIGHTS": "BUR-BGBN",
    "CLINTON-GLENWOOD, BURNABY HEIGHTS": "BUR-CLNT",
    "SUSSEX-NELSON, BURNABY HEIGHTS": "BUR-SSSX",
    "SUNCREST, BURNABY HEIGHTS": "BUR-SNCR",
    "MAYWOOD, BURNABY HEIGHTS": "BUR-MYWD",
    "GARDEN VILLAGE, BURNABY HEIGHTS": "BUR-GRDN",
    "CASCADE-SCHOU, BURNABY HEIGHTS": "BUR-CSCD",
    "DOUGLAS-GILPIN, BURNABY HEIGHTS": "BUR-DGLS",
    "MARLBOROUGH, BURNABY HEIGHTS": "BUR-MRLB",
    "WINDSOR, BURNABY HEIGHTS": "BUR-WNDS",
    "KINGSWAY-BERESFORD, BURNABY HEIGHTS": "BUR-KNGS",
    "RICHMOND PARK, BURNABY HEIGHTS": "BUR-RCHM",
    "MORLEY-BUCKINGHAM, BURNABY HEIGHTS": "BUR-MRLY",
    "LAKEVIEW-MAYFIELD, BURNABY HEIGHTS": "BUR-LKVW",
    "BOYD PARK, RICHMOND": "RIC-BYDP",
    "BRIDGEPORT, RICHMOND": "RIC-BRDG",
    "BRIGHOUSE, RICHMOND": "RIC-BRGH",
    "BRIGHOUSE SOUTH, RICHMOND": "RIC-BRG1",
    "BROADMOOR, RICHMOND": "RIC-BRDM",
    "EAST CAMBIE, RICHMOND": "RIC-ESTC",
    "EAST RICHMOND, RICHMOND": "RIC-ESTR",
    "GARDEN CITY, RICHMOND": "RIC-GRD1",
    "GILMORE, RICHMOND": "RIC-GLMR",
    "GRANVILLE, RICHMOND": "RIC-GRNV",
    "HAMILTON, RICHMOND": "RIC-HMLT",
    "IRONWOOD, RICHMOND": "RIC-IRNW",
    "LACKNER, RICHMOND": "RIC-LCKN",
    "MCLENNAN, RICHMOND": "RIC-MCLN",
    "MCLENNAN NORTH, RICHMOND": "RIC-MCL1",
    "MCNAIR, RICHMOND": "RIC-MCNR",
    "QUILCHENA, RICHMOND": "RIC-QLCH",
    "RIVERDALE, RICHMOND": "RIC-RVRD",
    "SAUNDERS, RICHMOND": "RIC-SNDR",
    "SEA ISLAND, RICHMOND": "RIC-SSLN",
    "SEAFAIR, RICHMOND": "RIC-SFR",
    "SOUTH ARM, RICHMOND": "RIC-STHR",
    "STEVESTON NORTH, RICHMOND": "RIC-STVS",
    "STEVESTON SOUTH, RICHMOND": "RIC-STV1",
    "STEVESTON VILLAGE, RICHMOND": "RIC-STV2",
    "TERRA NOVA, RICHMOND": "RIC-TRRN",
    "WEST CAMBIE, RICHMOND": "RIC-WST1",
    "WESTWIND, RICHMOND": "RIC-WSTW",
    "WOODWARDS, RICHMOND": "RIC-WDWR",
    "AUSTIN HEIGHTS, COQUITLAM": "COQ-ASTN",
    "CAPE HORN, COQUITLAM": "COQ-CPHR",
    "CARIBOO, COQUITLAM": "COQ-CRB",
    "BURQUITLAM, COQUITLAM": "COQ-BRQT",
    "CENTRAL COQUITLAM, COQUITLAM": "COQ-CNTR",
    "EAGLE RIDGE, COQUITLAM": "COQ-EGLR",
    "HOCKADAY NESTOR, COQUITLAM": "COQ-HCKD",
    "MAILLARDVILLE, COQUITLAM": "COQ-MLLR",
    "MAYFAIR, COQUITLAM": "COQ-MYFR",
    "PACIFIC REACH, COQUITLAM": "COQ-PCFC",
    "NORTHEAST COQUITLAM, COQUITLAM": "COQ-NRT1",
    "RANCH PARK, COQUITLAM": "COQ-RNCH",
    "RIVER HEIGHTS, COQUITLAM": "COQ-RVRH",
    "TOWN CENTRE, COQUITLAM": "COQ-TWNC",
    "WESTWOOD PLATEAU, COQUITLAM": "COQ-WST2",
    "ABERDEEN, ABBOTSFORD": "ABB-ABRD",
    "ARNOLD, ABBOTSFORD": "ABB-ARNL",
    "AUGUSTON, ABBOTSFORD": "ABB-AGST",
    "BLUERIDGE, ABBOTSFORD": "ABB-BLRD",
    "BRADNER, ABBOTSFORD": "ABB-BRDN",
    "CLAYBURN, ABBOTSFORD": "ABB-CLYB",
    "CLEARBROOK, ABBOTSFORD": "ABB-CLRB",
    "DOWNTOWN, ABBOTSFORD": "ABB-DWN2",
    "EAGLE MOUNTAIN, ABBOTSFORD": "ABB-EGLM",
    "GIFFORD, ABBOTSFORD": "ABB-GFFR",
    "GLEN MOUNTAIN, ABBOTSFORD": "ABB-GLNM",
    "HUNTINGDON, ABBOTSFORD": "ABB-HNTN",
    "KILGARD, ABBOTSFORD": "ABB-KLGR",
    "MATSQUI, ABBOTSFORD": "ABB-MTSQ",
    "MCKINLEY HEIGHTS, ABBOTSFORD": "ABB-MCKN",
    "MILL LAKE, ABBOTSFORD": "ABB-MLLL",
    "MOUNT LEHMAN, ABBOTSFORD": "ABB-MNTL",
    "NORTH POPLAR, ABBOTSFORD": "ABB-NRT2",
    "PEARDONVILLE, ABBOTSFORD": "ABB-PRDN",
    "PEPIN BROOK, ABBOTSFORD": "ABB-PPNB",
    "SANDY HILL, ABBOTSFORD": "ABB-SNDY",
    "SOUTH POPLAR, ABBOTSFORD": "ABB-STHP",
    "STRAITON, ABBOTSFORD": "ABB-STR2",
    "TOWNLINE, ABBOTSFORD": "ABB-TWNL",
    "BLACK MOUNTAIN, KELOWNA": "KEL-BLCK",
    "CRAWFORD ESTATES, KELOWNA": "KEL-CRWF",
    "DILWORTH MOUNTAIN, KELOWNA": "KEL-DLWR",
    "ELLISON, KELOWNA": "KEL-ELLS",
    "GLENMORE, KELOWNA": "KEL-GLN1",
    "JOE RICHE, KELOWNA": "KEL-JRCH",
    "KELOWNA NORTH, KELOWNA": "KEL-KLWN",
    "KELOWNA SOUTH, KELOWNA": "KEL-KLW1",
    "KETTLE VALLEY, KELOWNA": "KEL-KTTL",
    "LOWER MISSION, KELOWNA": "KEL-LWRM",
    "MCKINLEY LANDING, KELOWNA": "KEL-MCK1",
    "NORTH GLENMORE, KELOWNA": "KEL-NRT3",
    "RUTLAND SOUTH, KELOWNA": "KEL-RTLN",
    "SOUTH EAST KELOWNA, KELOWNA": "KEL-STH1",
    "SPRINGFIELD/SPALL, KELOWNA": "KEL-SPRN",
    "SOUTHRIDGE, KELOWNA": "KEL-STH2",
    "UNIVERSITY DISTRICT, KELOWNA": "KEL-UNVR",
    "UPPER MISSION, KELOWNA": "KEL-UPPR",
    "WILDEN, KELOWNA": "KEL-WLDN",
    "ALDERGROVE, LANGLEY": "LAN-ALDR",
    "BROOKSWOOD, LANGLEY": "LAN-BRKS",
    "FERNRIDGE, LANGLEY": "LAN-FRNR",
    "FORT LANGLEY, LANGLEY": "LAN-FRTL",
    "MILNER, LANGLEY": "LAN-MLNR",
    "MURRAYVILLE, LANGLEY": "LAN-MRRY",
    "WILLOUGHBY, LANGLEY": "LAN-WLLG",
    "WALNUT GROVE, LANGLEY": "LAN-WLNT",
    "BLENKINSOP, SAANICH": "SAA-BLNK",
    "CADBORO BAY, SAANICH": "SAA-CDBR",
    "CAREY, SAANICH": "SAA-CRY",
    "BROADMEAD, SAANICH": "SAA-BRD1",
    "CORDOVA BAY, SAANICH": "SAA-CRDV",
    "GORDON HEAD, SAANICH": "SAA-GRD2",
    "NORTH QUADRA, SAANICH": "SAA-NRT4",
    "QUADRA, SAANICH": "SAA-QDR",
    "ROYAL OAK, SAANICH": "SAA-RYLK",
    "RURAL SAANICH, SAANICH": "SAA-RRLS",
    "SAANICH CORE, SAANICH": "SAA-SNCH",
    "SHELBOURNE, SAANICH": "SAA-SHLB",
    "TILLICUM, SAANICH": "SAA-TLLC",
    "NORTH DELTA, DELTA": "DEL-NRT5",
    "LADNER, DELTA": "DEL-LDNR",
    "TSAWWASSEN, DELTA": "DEL-TSWW",
    "LANTZVILLE, NANAIMO": "NAN-LNTZ",
    "QUALICUM BEACH, NANAIMO": "NAN-QLCM",
    "PARKSVILLE, NANAIMO": "NAN-PRKS",
    "BRANDON": "BRND-C",
    "DAUPHIN": "DPH1-RM",
    "FLIN FLON": "FLNF-C",
    "MORDEN": "MRDN-C",
    "PORTAGE LA PRAIRIE": "PRT1-RM",
    "SELKIRK": "SLKR-C",
    "STEINBACH": "STNB-C",
    "THOMPSON": "THM1-RM",
    "WINKLER": "WNKL-C",
    "WINNIPEG": "WNNP-C",
    "ALTONA": "ALTN-T",
    "ARBORG": "ARBR-T",
    "BEAUSEJOUR": "BSJR-T",
    "BIRTLE": "BRT1-RM",
    "BOISSEVAIN": "BSSV-T",
    "CARBERRY": "CRBR-T",
    "CARMAN": "CRMN-T",
    "CHURCHILL": "CHRC-T",
    "DELORAINE": "DLRN-T",
    "EMERSON": "EMRS-T",
    "ERICKSON": "ERCK-T",
    "GILBERT PLAINS": "GLB1-RM",
    "GILLAM": "GLLM-T",
    "GLADSTONE": "GLDS-T",
    "GRAND RAPIDS": "GRND-T",
    "GRETNA": "GRTN-T",
    "HARTNEY": "HRTN-T",
    "LAC DU BONNET": "LCD1-RM",
    "LEAF RAPIDS": "LFRP-T",
    "LYNN LAKE": "LYNN-T",
    "MACGREGOR": "MCGR-T",
    "MANITOU": "MNT-T",
    "MELITA": "MLT-T",
    "MINITONAS": "MNT3-RM",
    "MINNEDOSA": "MNND-T",
    "MORRIS": "MRR1-RM",
    "NEEPAWA": "NPW-T",
    "NIVERVILLE": "NVRV-T",
    "OAK LAKE": "OKLK-T",
    "PILOT MOUND": "PLTM-T",
    "PLUM COULEE": "PLMC-T",
    "POWERVIEW-PINE FALLS": "PWRV-T",
    "RAPID CITY": "RPDC-T",
    "RIVERS": "RVRS-T",
    "ROBLIN": "RBL2-RM",
    "ROSSBURN": "RSS3-RM",
    "RUSSELL": "RSSL-TS",
    "SNOW LAKE": "SNWL-T",
    "SOURIS": "SRS-T",
    "STE ANNE": "STN1-RM",
    "STE ROSE DU LAC": "STRS-T",
    "STONEWALL": "STNW-T",
    "SWAN RIVER": "SWN1-RM",
    "TEULON": "TLN-T",
    "THE PAS": "THPS-T",
    "TREHERNE": "TRHR-T",
    "VIRDEN": "VRDN-T",
    "WINNIPEG BEACH": "WNN1-T",
    "BENITO": "BNT-V",
    "BINSCARTH": "BNSC-V",
    "BOWSMAN": "BWSM-V",
    "CARTWRIGHT": "CRTW-T",
    "CRYSTAL CITY": "CRYS-V",
    "DUNNOTAR": "DNNT-V",
    "ELKHORN": "ELKH-V",
    "ETHELBERT": "ETH1-RM",
    "GLENBORO": "GLNB-V",
    "MCCREARY": "MCC2-RM",
    "NOTRE DAME DE LOURDES": "NTRD-V",
    "RIVERTON": "RVRT-V",
    "SOMERSET": "SMRS-V",
    "ST CLAUDE": "STCL-V",
    "ST LAZARE": "STLZ-V",
    "ST PIERRE-JOLYS": "STPR-V",
    "WASKADA": "WSKD-V",
    "WAWANESA": "WWNS-V",
    "WINNIPEGOSIS": "WNN2-V",
    "BIFROST-RIVERTON": "BFRS-M",
    "BOISSEVAIN-MORTON": "BSS1-M",
    "BRENDA-WASKADA": "BRN1-M",
    "CARTWRIGHT-ROBLIN": "CRT1-M",
    "CLANWILLIAM-ERICKSON": "CLNW-M",
    "DELORAINE-WINCHESTER": "DLR1-M",
    "ELLICE-ARCHIE": "ELLC-M",
    "EMERSON-FRANKLIN": "EMR1-M",
    "GLENBORO-SOUTH CYPRESS": "GLN1-M",
    "GLENELLA-LANSDOWNE": "GLNL-M",
    "HARRISON PARK": "HRRS-M",
    "KILLARNY-TURTLE MOUNTAIN": "KLLR-M",
    "MINITONAS-BOWSMAN": "MNT1-M",
    "MOSSEY RIVER": "MSS1-RM",
    "NORFOLK TREHERNE": "NRFL-M",
    "NORTH CYPRESS-LANGFORD": "NRTH-M",
    "NORTH NORFOLK": "NRT3-RM",
    "OAKLAND-WAWANESA": "OKLN-M",
    "OAKVIEW": "OKV1-RM",
    "PEMBINA": "PMB1-RM",
    "PRAIRIE LAKES": "PRR1-RM",
    "PRAIRIE VIEW": "PRRV-M",
    "RHINELAND": "RHN1-RM",
    "RIDING MOUNTAIN WEST": "RDN1-RM",
    "RIVERDALE": "RVRD-M",
    "ROSSBURN MUNICIPALITY": "RSS1-M",
    "RUSSELL-BINSCARTH": "RSS2-M",
    "SHOAL LAKE": "SHLL-M",
    "SOURIS-GLENWOOD": "SRSG-M",
    "SWAN VALLEY WEST": "SWNV-M",
    "TWO BORDERS": "TWBR-M",
    "WALLACE-WOODWORTH": "WLL2-RM",
    "WEST INTERLAKE": "WST1-RM",
    "WESTLAKE-GLADSTONE": "WSTL-M",
    "HAMIOTA": "HMT-M",
    "ALBERT": "ALBR-RM",
    "ALEXANDER": "ALXN-RM",
    "ALONSA": "ALNS-RM",
    "ARCHIE": "ARCH-RM",
    "ARGYLE": "ARGY-RM",
    "ARTHUR": "ARTH-RM",
    "BIFROST": "BFR1-RM",
    "BLANSHARD": "BLNS-RM",
    "BRENDA": "BRN2-RM",
    "BROKENHEAD": "BRKN-RM",
    "CAMERON": "CMRN-RM",
    "CARTIER": "CRTR-RM",
    "CLANWILLIAM": "CLN1-RM",
    "COLDWELL": "CLDW-RM",
    "CORNWALLIS": "CRNW-RM",
    "DALY": "DLY-RM",
    "DE SALABERRY": "DSLB-RM",
    "DUFFERIN": "DFFR-RM",
    "EAST ST PAUL": "ESTS-RM",
    "EDWARD": "EDWR-RM",
    "ELLICE": "ELL1-RM",
    "ELTON": "ELTN-RM",
    "ERIKSDALE": "ERKS-RM",
    "FISHER": "FSHR-RM",
    "FRANKLIN": "FRNK-M",
    "GIMLI": "GML-RM",
    "GLENELLA": "GLN2-RM",
    "GLENWOOD": "GLNW-T",
    "GRAHAMDALE": "GRHM-RM",
    "GREY": "GRY-RM",
    "HANOVER": "HNVR-T",
    "HARRISON": "HRR1-RM",
    "HEADINGLEY": "HDNG-RM",
    "HILLSBURG": "HLLS-RM",
    "LA BROQUERIE": "LBRQ-RM",
    "LAKESHORE": "BAR-BRR22-N",
    "LANSDOWNE": "LNSD-RM",
    "LAWRENCE": "LWRN-RM",
    "LORNE": "LRN-RM",
    "LOUISE": "LOUS-RM",
    "MACDONALD": "MCDN-TS",
    "MINIOTA": "MNT2-RM",
    "MINTO": "MNT-T",
    "MINTO-ODANAH": "MNTD-RM",
    "MONTCALM": "MNT2-M",
    "MORTON": "MRTN-RM",
    "MOUNTAIN": "MNT5-RM",
    "NORTH CYPRESS": "NRT2-RM",
    "OAKLAND": "OKL1-RM",
    "OCHRE RIVER": "OCHR-RM",
    "ODANAH": "ODNH-RM",
    "PARK": "PRK-RM",
    "PINEY": "PNY-RM",
    "PIPESTONE": "PPST-RM",
    "REYNOLDS": "RYNL-RM",
    "RITCHOT": "RTCH-RM",
    "RIVERSIDE": "RVR1-RM",
    "ROCKWOOD": "RCKW-RM",
    "ROLAND": "RLND-RM",
    "ROSEDALE": "RSDL-RM",
    "ROSSER": "RSSR-RM",
    "SASKATCHEWAN": "SSKT-RM",
    "SHELL RIVER": "SHL1-RM",
    "SHELLMOUTH-BOULTON": "SHL2-RM",
    "SIFTON": "SFTN-RM",
    "SIGLUNES": "SGLN-RM",
    "SILVER CREEK": "SLVR-RM",
    "SOUTH CYPRESS": "STHC-RM",
    "SOUTH NORFOLK": "STHN-RM",
    "SPRINGFIELD": "SPRN-RM",
    "ST ANDREWS": "STND-RM",
    "ST CLEMENTS": "STC1-RM",
    "ST FRANCOIS XAVIER": "STFR-RM",
    "ST LAURENT": "STLR-RM",
    "STANLEY": "STNL-RM",
    "STE ROSE": "STR1-RM",
    "STRATHCLAIR": "STRT-RM",
    "STRATHCONA": "STR2-RM",
    "STUARTBURN": "STR3-RM",
    "TACHE": "TCH-RM",
    "VICTORIA BEACH": "VCT1-RM",
    "WALLACE": "WLL1-RM",
    "WEST ST PAUL": "WSTS-RM",
    "WESTBOURNE": "WSTB-RM",
    "WHITEHEAD": "WHTH-RM",
    "WHITEMOUTH": "WHTM-RM",
    "WHITEWATER": "WHTW-RM",
    "WINCHESTER": "WNCH-RM",
    "WOODWORTH": "WDWR-RM",
    "ASSINIBOINE, WINNIPEG": "WIN-ASBN",
    "FORT GARRY, WINNIPEG": "WIN-FRTG",
    "INSKER, WINNIPEG": "WIN-INSK",
    "POINT DOUGLAS, WINNIPEG": "WIN-PNTD",
    "RIVER EAST, WINNIPEG": "WIN-RVRS",
    "RIVER HEIGHTS, WINNIPEG": "WIN-RVRH",
    "SEVEN OAKS, WINNIPEG": "WIN-SVNK",
    "ST BONIFACE, WINNIPEG": "WIN-STBN",
    "ST JAMES, WINNIPEG": "WIN-STJM",
    "ST VITAL, WINNIPEG": "WIN-STVT",
    "TRANSCONA, WINNIPEG": "WIN-TRNS",
    "AGASSIZ, WINNIPEG": "WIN-AGSS",
    "ALPINE PLACE, WINNIPEG": "WIN-ALPN",
    "AMBER TRAILS, WINNIPEG": "WIN-AMBR",
    "ARCHWOOD, WINNIPEG": "WIN-ARCH",
    "ARMSTRONG POINT, WINNIPEG": "WIN-ARMS",
    "ASSINIBOIA DOWNS, WINNIPEG": "WIN-ASSN",
    "ASSINIBOINE PARK, WINNIPEG": "WIN-ASS1",
    "BEAUMONT, WINNIPEG": "WIN-BMNT",
    "BETSWORTH, WINNIPEG": "WIN-BTSW",
    "BIRCHWOOD, WINNIPEG": "WIN-BRCH",
    "BOOTH, WINNIPEG": "WIN-BTH",
    "BRIDGEWATER CENTRE, WINNIPEG": "WIN-BRDG",
    "BRIDGEWATER FOREST, WINNIPEG": "WIN-BRDC",
    "BRIDGEWATER LAKES, WINNIPEG": "WIN-BRDF",
    "BRIDGEWATER TRAILS, WINNIPEG": "WIN-BRDL",
    "BROADWAY - ASSINIBOINE, WINNIPEG": "WIN-BRDW",
    "BROCKVILLE, WINNIPEG": "WIN-BRCK",
    "BROOKLANDS, WINNIPEG": "WIN-BRKL",
    "BRUCE PARK, WINNIPEG": "WIN-BRCP",
    "BUCHANAN, WINNIPEG": "WIN-BCHN",
    "BUFFALO, WINNIPEG": "WIN-BFFL",
    "BURROWS - KEEWATIN, WINNIPEG": "WIN-BRRW",
    "BURROWS CENTRAL, WINNIPEG": "WIN-BRR1",
    "CANTERBURY PARK, WINNIPEG": "WIN-CNTR",
    "CENTENNIAL, WINNIPEG": "WIN-CNTN",
    "CENTRAL PARK, WINNIPEG": "WIN-CNTP",
    "CENTRAL RIVER HEIGHTS, WINNIPEG": "WIN-CTRH",
    "CENTRAL ST BONIFACE, WINNIPEG": "WIN-CNTS",
    "CHALMERS, WINNIPEG": "WIN-CHLM",
    "CHEVRIER, WINNIPEG": "WIN-CHVR",
    "CHINA TOWN, WINNIPEG": "WIN-CHNT",
    "CIVIC CENTRE, WINNIPEG": "WIN-CVCC",
    "CLOUTIER DRIVE, WINNIPEG": "WIN-CLTR",
    "COLONY, WINNIPEG": "WIN-CLNY",
    "CRESCENT PARK, WINNIPEG": "WIN-CRSC",
    "CRESCENTWOOD, WINNIPEG": "WIN-CRSW",
    "CRESTVIEW, WINNIPEG": "WIN-CRST",
    "DAKOTA CROSSING, WINNIPEG": "WIN-DKTC",
    "DANIEL MCINTYRE, WINNIPEG": "WIN-DNLM",
    "DEER LODGE, WINNIPEG": "WIN-DRLD",
    "DOWNTOWN WINNIPEG, WINNIPEG": "WIN-DWNT",
    "DUFFERIN, WINNIPEG": "WIN-DFFR",
    "DUFFERIN INDUSTRIAL, WINNIPEG": "WIN-DFFI",
    "DUFRESNE, WINNIPEG": "WIN-DFRS",
    "DUGALD, WINNIPEG": "WIN-DGLD",
    "EAGLEMERE, WINNIPEG": "WIN-EGLM",
    "EARL GREY, WINNIPEG": "WIN-ERLG",
    "EAST ELMWOOD, WINNIPEG": "WIN-ESTL",
    "BATHURST": "BATH-C",
    "CAMPBELLTON": "CMPB-T",
    "DIEPPE": "DIEP-C",
    "EDMUNDSTON": "EDMS-C",
    "FREDERICTON": "FRDR-C",
    "MIRAMICHI": "MRMC-C",
    "MONCTON": "MNCT-C",
    "SAINT JOHN": "STJN-C",
    "RURAL COMMUNITY OF ST STEPHEN": "STST-RC",
    "RURAL COMMUNITY OF TRACADIE": "TRCD-RC",
    "RURAL COMMUNITY OF ALNWICK": "ALNW-RC",
    "RURAL COMMUNITY OF BEAUSOLEIL": "BSLL-RC",
    "RURAL COMMUNITY OF BUTTERNUT VALLEY": "BTTR-RC",
    "RURAL COMMUNITY OF CAMPOBELLO ISLAND": "CMPB-RC",
    "RURAL COMMUNITY OF CENTRAL YORK": "CNTR-RC",
    "RURAL COMMUNITY OF EASTERN CHARLOTTE": "ESTR-RC",
    "RURAL COMMUNITY OF FUNDY SHORES": "FNDY-RC",
    "RURAL COMMUNITY OF HANWELL": "HNWL-RC",
    "RURAL COMMUNITY OF HARVEY": "HRVY-RC",
    "RURAL COMMUNITY OF KEDGWICK": "KDGW-RC",
    "RURAL COMMUNITY OF MAPLE HILLS": "MPLH-RC",
    "RURAL COMMUNITY OF MIRAMICHI RIVER VALLEY": "MRMC-RC",
    "RURAL COMMUNITY OF NACKAWIC-MILLVILLE": "NCKW-RC",
    "RURAL COMMUNITY OF NASHWAAK": "NSHW-RC",
    "RURAL COMMUNITY OF STRAIT SHORES": "STRT-RC",
    "RURAL COMMUNITY OF SUNBURY-YORK SOUTH": "SNBR-RC",
    "RURAL COMMUNITY OF UPPER MIRAMICHI": "UPPR-RC",
    "GRAND MANAN": "GRND-V",
    "HARVEY": "HRV1-V",
    "HILLSBOROUGH": "HLLS-V",
    "LAC-BAKER": "LCBK-V",
    "LAKELAND RIDGES": "LKLN-V",
    "MCADAM": "MCDM-V",
    "MEMRAMCOOK": "MMRM-V",
    "MUNICIPALITY OF GRAND LAKE": "GRLK-VM",
    "NEGUAC": "NGC-V",
    "NEW MARYLAND": "NWMR-V",
    "NOUVELLE-ARCADIE": "NVLL-V",
    "SOUTHERN VICTORIA": "STHR-V",
    "THE COUNTY OF PICTOU": "CTPC-M",
    "TOBIQUE VALLEY": "TBQV-V",
    "TRACY": "TRCY-V",
    "VALLEY WATERS": "VLLY-V",
    "CORNER BROOK": "CRNR-C",
    "MOUNT PEARL": "MNTP-C",
    "ST. JOHN'S": "STJH-C",
    "ADMIRALS BEACH": "ADMR-T",
    "ANCHOR POINT": "ANCH-T",
    "APPLETON": "APPL-T",
    "AQUAFORTE": "AQFR-T",
    "ARNOLD'S COVE": "ARNL-T",
    "AVONDALE": "AVND-T",
    "BADGER": "BDGR-T",
    "BAIE VERTE": "BVRT-T",
    "BAINE HARBOUR": "BNHR-T",
    "BAULINE": "BLN-T",
    "BAY BULLS": "BYBL-T",
    "BAY L'ARGENT": "BYLR-T",
    "BAY ROBERTS": "BYRB-T",
    "BAY DE VERDE": "BYDV-T",
    "BAYTONA": "BYTN-T",
    "BEACHSIDE": "BCHS-T",
    "BELLBURNS": "BLLB-T",
    "BELLEORAM": "BLLR-T",
    "BIRCHY BAY": "BRCH-T",
    "BIRD COVE": "BRDC-T",
    "BISHOP'S COVE": "BSHP-T",
    "BISHOP'S FALLS": "BSH1-T",
    "BONAVISTA": "BNVS-T",
    "BOTWOOD": "BTWD-T",
    "BRANCH": "BRNC-T",
    "BRENT'S COVE": "BRNT-T",
    "BRIGHTON": "SAS-BRGH",
    "BRIGUS": "BRGS-T",
    "BRYANT'S COVE": "BRYN-T",
    "BUCHANS": "BCHN-T",
    "BURGEO": "BRG-T",
    "BURIN": "BRN-T",
    "BURLINGTON": "BRLN-C",
    "CITY OF BURLINGTON": "BRLN-C",
    "BURNT ISLANDS": "BRN1-T",
    "CAPE BROYLE": "CPBR-T",
    "CAPE ST. GEORGE": "CPST-T",
    "CARBONEAR": "CRBN-T",
    "CARMANVILLE": "CRMN-T",
    "CENTREVILLE-WAREHAM-TRINITY": "CNTR-T",
    "CHANCE COVE": "CHNC-T",
    "CHANGE ISLANDS": "CHNG-T",
    "CHANNEL-PORT AUX BASQUES": "CHNN-T",
    "CHAPEL ARM": "CHPL-T",
    "CHARLOTTETOWN": "CHRL-C",
    "CLARENVILLE": "CLRN-T",
    "CLARKE'S BEACH": "CLRK-T",
    "COACHMAN'S COVE": "CCHM-T",
    "COLINET": "CLNT-T",
    "COLLIERS": "CLLR-T",
    "COME BY CHANCE": "CMBY-T",
    "COMFORT COVE-NEWSTEAD": "CMFR-T",
    "CONCEPTION BAY SOUTH": "CNCP-T",
    "CONCEPTION HARBOUR": "CNC1-T",
    "CONCHE": "CNCH-T",
    "COOK'S HARBOUR": "CKSH-T",
    "CORMACK": "CRMC-T",
    "COTTLESVILLE": "CTTL-T",
    "COW HEAD": "CWHD-T",
    "COX'S COVE": "CXSC-T",
    "CROW HEAD": "CRWH-T",
    "CUPIDS": "CPDS-T",
    "DANIEL'S HARBOUR": "DNLS-T",
    "DEER LAKE": "DRLK-T",
    "DOVER": "DVR-V",
    "DUNTARA": "DNTR-T",
    "EASTPORT": "ESTP-T",
    "ELLISTON": "ELLS-T",
    "EMBREE": "EMBR-T",
    "ENGLEE": "ENGL-T",
    "ENGLISH HARBOUR EAST": "ENG1-T",
    "FERMEUSE": "FRMS-T",
    "FERRYLAND": "FRRY-T",
    "FLATROCK": "FLTR-T",
    "FLEUR DE LYS": "FLRD-T",
    "FLOWER'S COVE": "FLWR-T",
    "FOGO ISLAND": "FGSL-T",
    "FORTEAU": "FRT-T",
    "FORTUNE": "FRTN-T",
    "FOX COVE-MORTIER": "FXCV-T",
    "FOX HARBOUR": "FXHR-T",
    "FRENCHMAN'S COVE": "FRNC-T",
    "GALLANTS": "GLLN-T",
    "GAMBO": "GMB-T",
    "GANDER": "GNDR-T",
    "GARNISH": "GRNS-T",
    "GASKIERS-POINT LA HAYE": "GSKR-T",
    "GAULTOIS": "GLTS-T",
    "GILLAMS": "GLLM-T",
    "GLENBURNIE-BIRCHY HEAD-SHOAL BROOK": "GLNB-T",
    "GLOVERTOWN": "GLVR-T",
    "GOOSE COVE EAST": "GSCV-T",
    "GRAND BANK": "GRND-T",
    "GRAND FALLS-WINDSOR": "GRN1-T",
    "GRAND LE PIERRE": "GRN2-T",
    "GREENSPOND": "GRN3-T",
    "HAMPDEN": "HMPD-TS",
    "HANT'S HARBOUR": "HNTS-T",
    "HAPPY ADVENTURE": "HPPY-T",
    "HAPPY VALLEY-GOOSE BAY": "HPP1-T",
    "HARBOUR BRETON": "HRBR-T",
    "HARBOUR GRACE": "HRB1-T",
    "HARBOUR MAIN-CHAPEL'S COVE-LAKEVIEW": "HRB2-T",
    "HARE BAY": "HRBY-T",
    "HAWKE'S BAY": "HWKS-T",
    "HEART'S CONTENT": "HRTS-T",
    "HEART'S DELIGHT-ISLINGTON": "HRT1-T",
    "HEART'S DESIRE": "HRT2-T",
    "HERMITAGE-SANDYVILLE": "HRMT-T",
    "HOLYROOD": "HLYR-T",
    "HOWLEY": "HWLY-T",
    "HUGHES BROOK": "HGHS-T",
    "HUMBER ARM SOUTH": "HMBR-T",
    "INDIAN BAY": "INDN-T",
    "IRISHTOWN-SUMMERSIDE": "IRSH-T",
    "ISLE AUX MORTS": "ISLX-T",
    "JACKSON'S ARM": "JCKS-T",
    "KEELS": "KLS-T",
    "KING'S COVE": "KNGS-T",
    "KING'S POINT": "KNG1-T",
    "KIPPENS": "KPPN-T",
    "L'ANSE AU CLAIR": "LNSC-T",
    "L'ANSE AU LOUP": "LNSL-T",
    "LA SCIE": "LSC-T",
    "LABRADOR CITY": "LBRD-T",
    "LAMALINE": "LMLN-T",
    "LARK HARBOUR": "LRKH-T",
    "LAWN": "LWN-T",
    "LEADING TICKLES": "LDNG-T",
    "LEWIN'S COVE": "LWNS-T",
    "LEWISPORTE": "LWSP-T",
    "LITTLE BAY": "LTTL-T",
    "LITTLE BAY EAST": "LTT1-T",
    "LITTLE BAY ISLANDS": "LTT2-T",
    "LITTLE BURNT BAY": "LTT3-T",
    "LOGY BAY-MIDDLE COVE-OUTER COVE": "LGYB-T",
    "LONG HARBOUR-MOUNT ARLINGTON HEIGHTS": "LNGH-T",
    "LORD'S COVE": "LRDS-T",
    "LOURDES": "LRD1-T",
    "LUMSDEN": "LMSD-T",
    "LUSHES BIGHT-BEAUMONT-BEAUMONT NORTH": "LSHS-T",
    "MAIN BROOK": "MNBR-T",
    "MARY'S HARBOUR": "MRYS-T",
    "MARYSTOWN": "MRY1-T",
    "MASSEY DRIVE": "MSSY-T",
    "MCIVERS": "MCVR-T",
    "MEADOWS": "MDWS-T",
    "MIDDLE ARM": "MDDL-T",
    "MILES COVE": "MLSC-T",
    "MILLERTOWN": "MLLR-T",
    "MILLTOWN-HEAD OF BAY D'ESPOIR": "MHBE-T",
    "MING'S BIGHT": "MNGS-T",
    "MORRISVILLE": "MRRS-T",
    "MOUNT CARMEL-MITCHELLS BROOK-ST. CATHERINE'S": "MNTC-T",
    "MOUNT MORIAH": "MNTM-T",
    "MUSGRAVE HARBOUR": "MSGR-T",
    "MUSGRAVETOWN": "MSG1-T",
    "NEW PERLICAN": "NWPR-T",
    "NEW-WES-VALLEY": "NWWS-T",
    "NIPPERS HARBOUR": "NPPR-T",
    "NORMAN'S COVE-LONG COVE": "NRMN-T",
    "NORRIS ARM": "NRRS-T",
    "NORRIS POINT": "NRR1-T",
    "NORTH RIVER": "NRTH-T",
    "NORTH WEST RIVER": "NRT1-T",
    "NORTHERN ARM": "NRT2-T",
    "OLD PERLICAN": "OLDP-T",
    "PACQUET": "PCQT-T",
    "PARADISE": "PRDS-T",
    "PARKER'S COVE": "PRKR-T",
    "PARSON'S POND": "PRSN-T",
    "PASADENA": "PSDN-T",
    "PETERVIEW": "PTRV-T",
    "PETTY HARBOUR-MADDOX COVE": "PTTY-T",
    "PILLEY'S ISLAND": "PLLY-T",
    "PINWARE": "PNWR-T",
    "PLACENTIA": "PLCN-T",
    "POINT LANCE": "PNTL-T",
    "POINT LEAMINGTON": "PNT1-T",
    "POINT MAY": "PNTM-T",
    "POINT AU GAUL": "PNTG-T",
    "POINT OF BAY": "PTBY-T",
    "POOL'S COVE": "PLSC-T",
    "PORT ANSON": "PRTN-T",
    "PORT BLANDFORD": "PRTB-T",
    "PORT HOPE SIMPSON": "PRTH-T",
    "PORT KIRWAN": "PRTK-T",
    "PORT REXTON": "PRTR-T",
    "PORT SAUNDERS": "PRTS-T",
    "PORT AU CHOIX": "PRTC-T",
    "PORT AU PORT EAST": "PRTP-T",
    "PORT AU PORT WEST-AGUATHUNA-FELIX COVE": "PRT1-T",
    "PORTUGAL COVE SOUTH": "PRTG-T",
    "PORTUGAL COVE-ST. PHILIP'S": "PRT2-T",
    "POUCH COVE": "PCHC-T",
    "RALEIGH": "RLGH-T",
    "RAMEA": "RAME-T",
    "RED BAY": "RDBY-T",
    "RED HARBOUR": "RDHR-T",
    "REIDVILLE": "RDVL-T",
    "RENCONTRE EAST": "RNCN-T",
    "RENEWS-CAPPAHAYDEN": "RNWS-T",
    "RIVER OF PONDS": "RVPD-T",
    "RIVERHEAD": "RVRH-T",
    "ROBERT'S ARM": "RBRT-T",
    "ROCKY HARBOUR": "RCKY-T",
    "RODDICKTON-BIDE ARM": "RDDC-T",
    "ROSE BLANCHE-HARBOUR LE COU": "RSBL-T",
    "RUSHOON": "RSHN-T",
    "SALMON COVE": "SLMN-T",
    "SALVAGE": "SLVG-T",
    "SANDRINGHAM": "SNDR-T",
    "SANDY COVE": "SNDY-T",
    "SEAL COVE (FORTUNE BAY)": "SLCV-T",
    "SEAL COVE (WHITE BAY)": "SLC1-T",
    "SMALL POINT–ADAM'S COVE–BLACKHEAD–BROAD COVE": "SMLL-T",
    "SOUTH BROOK": "STHB-T",
    "SOUTH RIVER": "STHR-V",
    "SOUTHERN HARBOUR": "STH1-T",
    "SPANIARD'S BAY": "SPNR-T",
    "SPRINGDALE": "SPRN-T",
    "ST. ALBAN'S": "STLB-T",
    "ST. ANTHONY": "STNT-T",
    "ST. BERNARD'S-JACQUES FONTAINE": "STBR-T",
    "ST. BRENDAN'S": "STB1-T",
    "ST. BRIDE'S": "STB2-T",
    "ST. GEORGE'S": "STGR-T",
    "ST. JACQUES-COOMB'S COVE": "STJC-T",
    "ST. JOSEPH'S": "STJS-T",
    "ST. LAWRENCE": "STLW-T",
    "ST. LEWIS": "STL1-T",
    "ST. LUNAIRE-GRIQUET": "STLN-T",
    "ST. MARY'S": "STMR-T",
    "ST. PAUL'S": "STPL-T",
    "ST. SHOTT'S": "STSH-T",
    "ST. VINCENT'S-ST. STEPHEN'S-PETER'S RIVER": "STVN-T",
    "STEADY BROOK": "STDY-T",
    "STEPHENVILLE": "STPH-T",
    "STEPHENVILLE CROSSING": "STP1-T",
    "SUMMERFORD": "SMMR-T",
    "SUNNYSIDE (TRINITY BAY)": "SNNY-T",
    "TERRA NOVA": "TRRN-T",
    "TERRENCEVILLE": "TRR1-T",
    "TILT COVE": "TLTC-T",
    "TORBAY": "TRBY-T",
    "TRAYTOWN": "TRYT-T",
    "TREPASSEY": "TRPS-T",
    "TRINITY": "TRNT-T",
    "TRINITY BAY NORTH": "TRN1-T",
    "TRITON": "TRTN-T",
    "TROUT RIVER": "TRTR-T",
    "TWILLINGATE": "TWLL-T",
    "UPPER ISLAND COVE": "UPPR-T",
    "WABANA": "WBN-T",
    "WABUSH": "WBSH-T",
    "WEST ST. MODESTE": "WSTS-T",
    "WESTPORT": "WSTP-V",
    "WHITBOURNE": "WHTB-T",
    "WHITEWAY": "WHTW-T",
    "WINTERLAND": "WNTR-T",
    "WINTERTON": "WNT1-T",
    "WITLESS BAY": "WTLS-T",
    "WOODSTOCK": "WDST-C",
    "WOODY POINT": "WDYP-T",
    "YORK HARBOUR": "YRKH-T",
    "FORT SMITH": "FRTS-T",
    "HAY RIVER": "HYRV-T",
    "INUVIK": "INVK-T",
    "NORMAN WELLS": "NRMN-T",
    "FORT SIMPSON": "FRT1-V",
    "AKLAVIK": "AKLV-H",
    "ENTERPRISE": "ENTR-H",
    "FORT LIARD": "FRTL-H",
    "FORT MCPHERSON": "FRTM-H",
    "COMMUNITY OF FORT MCPHERSON": "FRTM-CO",
    "FORT PROVIDENCE": "FRTP-H",
    "FORT RESOLUTION": "FRTR-H",
    "PAULATUK": "PLTK-H",
    "SACHS HARBOUR": "SCHS-H",
    "TUKTOYAKTUK": "TKTY-H",
    "TULITA": "TLTA-H",
    "ULUKHAKTOK": "ULKH-H",
    "COMMUNITY OF TSIIGEHTCHIC": "TSGH-CO",
    "COMMUNITY OF FORT GOOD HOPE": "FRTG-CO",
    "COMMUNITY OF YELLOWKNIFE": "YLLW-CO",
    "COMMUNITY OF BEHCHOKÖ": "BHCH-CO",
    "COMMUNITY OF BEHCHOKO": "BHCH-CO",
    "COMMUNITY OF DELINE": "DLN-CO",
    "COMMUNITY OF GAMETI": "GMT-CO",
    "COMMUNITY OF GAMÈTÌ": "GMT-CO",
    "COMMUNITY OF WEKWEÈTÌ": "WKWT-CO",
    "COMMUNITY OF WEKWEETI": "WKWT-CO",
    "COMMUNITY OF WHATÌ": "WHTI-CO",
    "COMMUNITY OF WHATI": "WHTI-CO",
    "COMMUNITY OF WEKWEÈTÌ": "WKWT-CO",
    "COMMUNITY OF WEKWEETI": "WKWT-CO",
    "HALIFAX": "HLFX-C",
    "COMMUNITIES OF BEAVER BANK": "BVRB-CM",
    "COMMUNITIES OF BEDFORD": "BDFR-CM",
    "COMMUNITIES OF BEECHVILLE": "BCHV-CM",
    "COMMUNITIES OF CLAYTON PARK": "CLYT-CM",
    "COMMUNITIES OF CLAYTON PARK WEST": "CLY1-CM",
    "COMMUNITIES OF COLE HARBOUR": "CLHR-CM",
    "COMMUNITIES OF COW BAY": "CWBY-CM",
    "COMMUNITIES OF DARTMOUTH": "DRTM-CM",
    "COMMUNITIES OF EASTERN PASSAGE": "ESTR-CM",
    "COMMUNITIES OF FAIRVIEW": "FRVW-CM",
    "COMMUNITIES OF FALL RIVER": "FLLR-CM",
    "COMMUNITIES OF FLETCHERS LAKE": "FLTC-CM",
    "COMMUNITIES OF HAMMONDS PLAINS": "HMMN-CM",
    "COMMUNITIES OF UPPER HAMMONDS PLAINS": "UPPR-CM",
    "COMMUNITIES OF KINSAC": "KNSC-CM",
    "COMMUNITIES OF LAKE ECHO": "LKCH-CM",
    "COMMUNITIES OF LAKESIDE": "LKSD-CM",
    "COMMUNITIES OF LAKEVIEW": "LKVW-CM",
    "COMMUNITIES OF LUCASVILLE": "LCSV-CM",
    "COMMUNITIES OF EAST PRESTON": "ESTP-CM",
    "COMMUNITIES OF NORTH PRESTON": "NRTH-CM",
    "COMMUNITIES OF LOWER SACKVILLE": "LWRS-CM",
    "COMMUNITIES OF MIDDLE SACKVILLE": "MDDL-CM",
    "COMMUNITIES OF UPPER SACKVILLE": "UPP1-CM",
    "COMMUNITIES OF SHEARWATER": "SHRW-CM",
    "COMMUNITIES OF SPRYFIELD": "SPRY-CM",
    "COMMUNITIES OF STILL WATER LAKE": "STLL-CM",
    "COMMUNITIES OF TANTALLON": "TNTL-CM",
    "COMMUNITIES OF UPPER TANTALLON": "UPP2-CM",
    "COMMUNITIES OF TIMBERLEA": "TMBR-CM",
    "COMMUNITIES OF WAVERLEY": "WVRL-CM",
    "COMMUNITIES OF WELLINGTON": "WLL1-CM",
    "COMMUNITIES OF WINDSOR JUNCTION": "WNDS-CM",
    "COMMUNITIES OF WOODSIDE": "WDSD-CM",
    "COMMUNITIES OF ANTRIM": "ANTR-CM",
    "COMMUNITIES OF BALD ROCK": "BLDR-CM",
    "COMMUNITIES OF BEAR COVE": "BRCV-CM",
    "COMMUNITIES OF BARKHOUSE SETTLEMENT": "BRKH-CM",
    "COMMUNITIES OF BAYSIDE": "BYSD-CM",
    "COMMUNITIES OF BEAVER DAM": "BVRD-CM",
    "COMMUNITIES OF BEAVER HARBOUR": "BVRH-CM",
    "COMMUNITIES OF BEAVER ISLAND": "BVRS-CM",
    "COMMUNITIES OF BEECH HILL": "BCHH-CM",
    "COMMUNITIES OF BIG LAKE": "BGLK-CM",
    "COMMUNITIES OF BLACK POINT": "BLCK-CM",
    "COMMUNITIES OF BLIND BAY": "BLND-CM",
    "COMMUNITIES OF BOUTILIERS POINT": "BTLR-CM",
    "COMMUNITIES OF BROOKSIDE": "BRKS-CM",
    "COMMUNITIES OF BROOKVALE": "BRKV-CM",
    "COMMUNITIES OF CARIBOU MINES": "CRBM-CM",
    "COMMUNITIES OF CARROLL'S CORNER": "CRRL-CM",
    "COMMUNITIES OF CENTRE MUSQUODOBOIT": "CNTR-CM",
    "COMMUNITIES OF CHAPLIN": "CHPL-CM",
    "COMMUNITIES OF CHASWOOD": "CHSW-CM",
    "COMMUNITIES OF CLAM BAY": "CLMB-CM",
    "COMMUNITIES OF CLAM HARBOUR": "CLMH-CM",
    "COMMUNITIES OF COLLEGE LAKE": "CLLG-CM",
    "COMMUNITIES OF CONROD SETTLEMENT": "CNRD-CM",
    "COMMUNITIES OF CROOKS BROOK": "CRKS-CM",
    "COMMUNITIES OF DEAN": "DEAN-CM",
    "COMMUNITIES OF DEBAIES COVE": "DBSC-CM",
    "COMMUNITIES OF DEVON": "DVN-CM",
    "COMMUNITIES OF DEVILS ISLAND": "DVLS-CM",
    "COMMUNITIES OF DUNCAN'S COVE": "DNCN-CM",
    "COMMUNITIES OF DUTCH SETTLEMENT": "DTCH-CM",
    "COMMUNITIES OF EAST CHEZZETCOOK": "ESTC-CM",
    "COMMUNITIES OF EAST DOVER": "ESTD-CM",
    "COMMUNITIES OF EAST JEDDORE": "ESTJ-CM",
    "COMMUNITIES OF EAST LAWRENCETOWN": "ESTL-CM",
    "COMMUNITIES OF EAST LOON LAKE VILLAGE": "EST1-CM",
    "COMMUNITIES OF EAST PENNANT": "EST2-CM",
    "COMMUNITIES OF EAST PETPESWICK": "EST3-CM",
    "COMMUNITIES OF EAST QUODDY": "ESTQ-CM",
    "COMMUNITIES OF EAST SHIP HARBOUR": "ESTS-CM",
    "COMMUNITIES OF ECUM SECUM": "ECMS-CM",
    "COMMUNITIES OF ECUM SECUM WEST": "ECM1-CM",
    "COMMUNITIES OF ELDERBANK": "ELDR-CM",
    "COMMUNITIES OF ELMSDALE": "ELMS-CM",
    "COMMUNITIES OF ELMSVALE": "ELM1-CM",
    "COMMUNITIES OF ENFIELD": "ENFL-CM",
    "COMMUNITIES OF FALKLAND": "FLKL-CM",
    "COMMUNITIES OF FERGUSON'S COVE": "FRGS-CM",
    "COMMUNITIES OF FRENCH VILLAGE": "FRNC-CM",
    "COMMUNITIES OF GAETZ BROOK": "GTZB-CM",
    "COMMUNITIES OF GLEN HAVEN": "GLNH-CM",
    "COMMUNITIES OF GLEN MARGARET": "GLNM-CM",
    "COMMUNITIES OF GLENMORE": "GLN1-CM",
    "COMMUNITIES OF GOFFS": "GFFS-CM",
    "COMMUNITIES OF GOODWOOD": "GDWD-CM",
    "COMMUNITIES OF GOVERNOR LAKE": "GVRN-CM",
    "COMMUNITIES OF GRAND DESERT": "GRND-CM",
    "COMMUNITIES OF GRAND LAKE": "GRN1-CM",
    "COMMUNITIES OF GREENWOOD": "GRNW-CM",
    "COMMUNITIES OF HACKETT'S COVE": "HCKT-CM",
    "COMMUNITIES OF HALIBUT BAY": "HLBT-CM",
    "COMMUNITIES OF HARRIETSFIELD": "HRRT-CM",
    "COMMUNITIES OF HATCHET LAKE": "HTCH-CM",
    "COMMUNITIES OF HEAD OF CHEZZETCOOK": "HCZC-CM",
    "COMMUNITIES OF HEAD OF JEDDORE": "HJDD-CM",
    "COMMUNITIES OF HEAD OF SAINT MARGARETS BAY": "HSMB-CM",
    "COMMUNITIES OF HERRING COVE": "HRRN-CM",
    "COMMUNITIES OF HUBBARDS": "HBBR-CM",
    "COMMUNITIES OF HIGGINSVILLE": "HGGN-CM",
    "COMMUNITIES OF HUBLEY": "HBLY-CM",
    "COMMUNITIES OF INDIAN HARBOUR": "INDN-CM",
    "COMMUNITIES OF INGRAMPORT": "INGR-CM",
    "COMMUNITIES OF JACKET LAKE": "JCKT-CM",
    "COMMUNITIES OF JEDDORE OYSTER POND": "JDDR-CM",
    "COMMUNITIES OF KETCH HARBOUR": "KTCH-CM",
    "COMMUNITIES OF LAKE CHARLOTTE": "LKC1-CM",
    "COMMUNITIES OF LAKE EGMONT": "LKGM-CM",
    "COMMUNITIES OF LAKE MAJOR": "LKMJ-CM",
    "COMMUNITIES OF LAWRENCETOWN": "LWRN-CM",
    "COMMUNITIES OF LEWIS LAKE": "LWSL-CM",
    "COMMUNITIES OF LINDSEY LAKE": "LNDS-CM",
    "COMMUNITIES OF LISCOMB SANCTUARY": "LSCM-CM",
    "COMMUNITIES OF LITTLE HARBOUR": "LTTL-CM",
    "COMMUNITIES OF LOCHABER MINES": "LCHB-CM",
    "COMMUNITIES OF LONG LAKE": "LNGL-CM",
    "COMMUNITIES OF LOON LAKE": "LNLK-CM",
    "COMMUNITIES OF LOWER EAST CHEZZETCOOK": "LWR1-CM",
    "COMMUNITIES OF LOWER LAWRENCETOWN": "LWRL-CM",
    "COMMUNITIES OF LOWER PROSPECT": "LWRP-CM",
    "COMMUNITIES OF LOWER SHIP HARBOUR": "LWR2-CM",
    "COMMUNITIES OF LOWER THREE FATHOM HARBOUR": "LWRT-CM",
    "COMMUNITIES OF MCGRATHS COVE": "MCGR-CM",
    "COMMUNITIES OF MCNABS ISLAND": "MCNB-CM",
    "COMMUNITIES OF MALAY FALLS": "MLYF-CM",
    "COMMUNITIES OF MARINETTE": "MRNT-CM",
    "COMMUNITIES OF MEAGHERS GRANT": "MGHR-CM",
    "COMMUNITIES OF MIDDLE MUSQUODOBOIT": "MDD1-CM",
    "COMMUNITIES OF MIDDLE PORTERS LAKE": "MDD2-CM",
    "COMMUNITIES OF MILL LAKE": "MLLL-CM",
    "COMMUNITIES OF MINEVILLE": "MNVL-CM",
    "COMMUNITIES OF MITCHELL BAY": "MTCH-CM",
    "COMMUNITIES OF MONTAGUE GOLD MINES": "MNTG-CM",
    "COMMUNITIES OF MOOSEHEAD": "MSHD-CM",
    "COMMUNITIES OF MOOSE RIVER GOLD MINES": "MSRV-CM",
    "COMMUNITIES OF MOSER RIVER": "MSRR-CM",
    "COMMUNITIES OF MURPHY COVE": "MRPH-CM",
    "COMMUNITIES OF MURCHYVILLE": "MRCH-CM",
    "COMMUNITIES OF MUSHABOOM": "MSHB-CM",
    "COMMUNITIES OF MUSQUODOBOIT HARBOUR": "MSQD-CM",
    "COMMUNITIES OF MYERS POINT": "MYRS-CM",
    "COMMUNITIES OF NECUM TEUCH": "NCMT-CM",
    "COMMUNITIES OF NEWCOMB CORNER": "NWCM-CM",
    "COMMUNITIES OF NORTH BEAVER BANK": "NRT1-CM",
    "COMMUNITIES OF OAKFIELD": "OKFL-CM",
    "COMMUNITIES OF OLDHAM": "OLDH-CM",
    "COMMUNITIES OF OSTREA LAKE": "OSTR-CM",
    "COMMUNITIES OF OTTER LAKE": "OTTR-CM",
    "COMMUNITIES OF OWLS HEAD": "OWLS-CM",
    "COMMUNITIES OF OYSTER POND": "OYST-CM",
    "COMMUNITIES OF PACE SETTLEMENT": "PCST-CM",
    "COMMUNITIES OF PEGGYS COVE": "PGGY-CM",
    "COMMUNITIES OF PEGGYS COVE PRESERVATION AREA": "PGG1-CM",
    "COMMUNITIES OF PLEASANT HARBOUR": "PLSN-CM",
    "COMMUNITIES OF PLEASANT VALLEY": "PLS1-CM",
    "COMMUNITIES OF PENNANT POINT": "PNNN-CM",
    "COMMUNITIES OF PLEASANT POINT": "PLS2-CM",
    "COMMUNITIES OF POPES HARBOUR": "PPSH-CM",
    "COMMUNITIES OF PORT DUFFERIN": "PRTD-CM",
    "COMMUNITIES OF PORTERS LAKE": "PRTR-CM",
    "COMMUNITIES OF PORTUGUESE COVE": "PRTG-CM",
    "COMMUNITIES OF PROSPECT": "PRSP-CM",
    "COMMUNITIES OF PROSPECT BAY": "PRS1-CM",
    "COMMUNITIES OF PURCELL'S COVE": "PRCL-CM",
    "COMMUNITIES OF QUEENSLAND": "QNSL-CM",
    "COMMUNITIES OF RIVER LAKE": "RVRL-CM",
    "COMMUNITIES OF SABLE ISLAND": "SBLS-CM",
    "COMMUNITIES OF SAINT MARGARETS BAY": "SNTM-CM",
    "COMMUNITIES OF SALMON RIVER BRIDGE": "SLMN-CM",
    "COMMUNITIES OF SAMBRO": "SMBR-CM",
    "COMMUNITIES OF SAMBRO CREEK": "SMB1-CM",
    "COMMUNITIES OF SAMBRO HEAD": "SMB2-CM",
    "COMMUNITIES OF SANDY COVE": "SNDY-CM",
    "COMMUNITIES OF SEABRIGHT": "SBRG-CM",
    "COMMUNITIES OF SEAFORTH": "SFRT-CM",
    "COMMUNITIES OF SHAD BAY": "SHDB-CM",
    "COMMUNITIES OF SHEET HARBOUR": "SHTH-CM",
    "COMMUNITIES OF SHEET HARBOUR PASSAGE": "SHT1-CM",
    "COMMUNITIES OF SHIP HARBOUR": "SHPH-CM",
    "COMMUNITIES OF SIMMS SETTLEMENT": "SMMS-CM",
    "COMMUNITIES OF SMITHS SETTLEMENT": "SMTH-CM",
    "COMMUNITIES OF SOBER ISLAND": "SBRS-CM",
    "COMMUNITIES OF SOUTH SECTION": "STHS-CM",
    "COMMUNITIES OF SPRY BAY": "SPR1-CM",
    "COMMUNITIES OF SPRY HARBOUR": "SPR2-CM",
    "COMMUNITIES OF TANGIER": "TNGR-CM",
    "COMMUNITIES OF TAYLORS HEAD": "TYLR-CM",
    "COMMUNITIES OF TEN MILE LAKE": "TNML-CM",
    "COMMUNITIES OF TERENCE BAY": "TRNC-CM",
    "COMMUNITIES OF THREE FATHOM HARBOUR": "THRF-CM",
    "COMMUNITIES OF THIRD LAKE": "THRD-CM",
    "COMMUNITIES OF TRAFALGAR": "TRFL-CM",
    "COMMUNITIES OF UPPER LAKEVILLE": "UPP3-CM",
    "COMMUNITIES OF UPPER LAWRENCETOWN": "UPP4-CM",
    "COMMUNITIES OF UPPER MUSQUODOBOIT": "UPP5-CM",
    "COMMUNITIES OF WATT SECTION": "WTTS-CM",
    "COMMUNITIES OF WEST CHEZZETCOOK": "WSTC-CM",
    "COMMUNITIES OF WEST DOVER": "WSTD-CM",
    "COMMUNITIES OF WEST JEDDORE": "WSTJ-CM",
    "COMMUNITIES OF WEST LAWRENCETOWN": "WSTL-CM",
    "COMMUNITIES OF WEST PENNANT": "WSTP-CM",
    "COMMUNITIES OF WEST PETPESWICK": "WST1-CM",
    "COMMUNITIES OF WEST PORTERS LAKE": "WST2-CM",
    "COMMUNITIES OF WEST QUODDY": "WSTQ-CM",
    "COMMUNITIES OF WHITES LAKE": "WHTS-CM",
    "COMMUNITIES OF WILLIAMSWOOD": "WLLM-CM",
    "COMMUNITIES OF WYSES CORNER": "WYSS-CM",
    "COMMUNITIES OF YANKEETOWN": "YNKT-CM",
    "COMMUNITIES OF ALBERT BRIDGE": "ALBR-CM",
    "COMMUNITIES OF ALDER POINT": "ALDR-CM",
    "COMMUNITIES OF BALEINE": "BLN-CM",
    "COMMUNITIES OF BALLS CREEK": "BLLS-CM",
    "COMMUNITIES OF BARACHOIS HARBOUR": "BRCH-CM",
    "COMMUNITIES OF BARRACHOIS": "BRRC-CM",
    "COMMUNITIES OF BATESTON": "BTST-CM",
    "COMMUNITIES OF BEAVER COVE": "BVRC-CM",
    "COMMUNITIES OF BEECHMONT": "BCHM-CM",
    "COMMUNITIES OF BEN EOIN": "BNN-CM",
    "COMMUNITIES OF BENACADIE": "BNCD-CM",
    "COMMUNITIES OF BIG BEACH": "BGBC-CM",
    "COMMUNITIES OF BIG POND CENTRE": "BGPN-CM",
    "COMMUNITIES OF BIG POND": "BGP1-CM",
    "COMMUNITIES OF BIG RIDGE": "BGRD-CM",
    "COMMUNITIES OF BIRCH GROVE": "BRC1-CM",
    "COMMUNITIES OF BLACK BROOK": "BLC1-CM",
    "COMMUNITIES OF BLACKETTS LAKE": "BLC2-CM",
    "COMMUNITIES OF BOISDALE": "BSDL-CM",
    "COMMUNITIES OF BRAS D'OR": "BRSD-CM",
    "COMMUNITIES OF BRIDGEPORT": "BRDG-CM",
    "COMMUNITIES OF BROUGHTON": "BRGH-CM",
    "COMMUNITIES OF CARIBOU MARSH": "CRB1-CM",
    "COMMUNITIES OF CASTLE BAY": "CSTL-CM",
    "COMMUNITIES OF CATALONE": "CTLN-CM",
    "COMMUNITIES OF CATALONE GUT": "CTL1-CM",
    "COMMUNITIES OF CHRISTMAS ISLAND": "CHRS-CM",
    "COMMUNITIES OF COXHEATH": "CXHT-CM",
    "COMMUNITIES OF DALEM LAKE": "DLML-CM",
    "COMMUNITIES OF DOMINION": "DMNN-CM",
    "COMMUNITIES OF DONKIN": "DNKN-CM",
    "COMMUNITIES OF DUTCH BROOK": "DTC1-CM",
    "COMMUNITIES OF EAST BAY": "ESTB-CM",
    "COMMUNITIES OF EDWARDSVILLE": "EDWR-CM",
    "COMMUNITIES OF ENON": "ENN-CM",
    "COMMUNITIES OF ESKASONI": "ESKS-CM",
    "COMMUNITIES OF FLORENCE": "FLRN-CM",
    "COMMUNITIES OF FRENCH ROAD": "FRN1-CM",
    "COMMUNITIES OF FRENCHVALE": "FRN2-CM",
    "COMMUNITIES OF GABARUS": "GBRS-CM",
    "COMMUNITIES OF GABARUS LAKE": "GBR1-CM",
    "COMMUNITIES OF GARDINER MINES": "GRDN-CM",
    "COMMUNITIES OF GEORGES RIVER": "GRGS-CM",
    "COMMUNITIES OF GILLIS LAKE": "GLLS-CM",
    "COMMUNITIES OF GLACE BAY": "GLCB-CM",
    "COMMUNITIES OF GRAND LAKE ROAD": "GRN2-CM",
    "COMMUNITIES OF GRAND MIRA NORTH": "GRN3-CM",
    "COMMUNITIES OF GRAND MIRA SOUTH": "GRN4-CM",
    "COMMUNITIES OF GRAND NARROWS": "GRN5-CM",
    "COMMUNITIES OF GROVES POINT": "GRVS-CM",
    "COMMUNITIES OF HILLSIDE BOULARDERIE": "HLLS-CM",
    "COMMUNITIES OF HOMEVILLE": "HMVL-CM",
    "COMMUNITIES OF HORNES ROAD": "HRNS-CM",
    "COMMUNITIES OF HOWIE CENTRE": "HWCN-CM",
    "COMMUNITIES OF HUNTINGTON": "HNTN-CM",
    "COMMUNITIES OF IRISH COVE": "IRSH-CM",
    "COMMUNITIES OF IRISHVALE": "IRS1-CM",
    "COMMUNITIES OF IRONVILLE": "IRNV-CM",
    "COMMUNITIES OF ISLAND VIEW": "ISLN-CM",
    "COMMUNITIES OF JUNIPER MOUNTAIN": "JNPR-CM",
    "COMMUNITIES OF LEITCHES CREEK": "LTCH-CM",
    "COMMUNITIES OF LEITCHES CREEK STATION": "LTC1-CM",
    "COMMUNITIES OF LINGAN": "LNGN-CM",
    "COMMUNITIES OF LINGAN ROAD": "LNG1-CM",
    "COMMUNITIES OF LITTLE BRAS D'OR": "LTT1-CM",
    "COMMUNITIES OF LITTLE LORRAINE": "LTT2-CM",
    "COMMUNITIES OF LITTLE POND": "LTT3-CM",
    "COMMUNITIES OF LONG ISLAND MAIN": "LNGS-CM",
    "COMMUNITIES OF LOUISBOURG": "LSBR-CM",
    "COMMUNITIES OF MCADAMS LAKE": "MCDM-CM",
    "COMMUNITIES OF MAIN-A-DIEU": "MND-CM",
    "COMMUNITIES OF MARION BRIDGE": "MRNB-CM",
    "COMMUNITIES OF MIDDLE CAPE": "MDD3-CM",
    "COMMUNITIES OF MILL CREEK": "MLLC-CM",
    "COMMUNITIES OF MILLVILLE BOULARDERIE": "MLLV-CM",
    "COMMUNITIES OF MIRA GUT": "MRGT-CM",
    "COMMUNITIES OF MIRA ROAD": "MRRD-CM",
    "COMMUNITIES OF NEW ABERDEEN": "NWBR-CM",
    "COMMUNITIES OF NEW VICTORIA": "NWVC-CM",
    "COMMUNITIES OF NEW WATERFORD": "NWWT-CM",
    "COMMUNITIES OF NORTH SYDNEY": "NRT2-CM",
    "COMMUNITIES OF NORTH WEST ARM": "NRT3-CM",
    "COMMUNITIES OF NORTHSIDE EAST BAY": "NRT4-CM",
    "COMMUNITIES OF PIPERS COVE": "PPRS-CM",
    "COMMUNITIES OF POINT ACONI": "PNTC-CM",
    "COMMUNITIES OF POINT EDWARD": "PNTD-CM",
    "COMMUNITIES OF PORTAGE": "PRT1-CM",
    "COMMUNITIES OF PORT CALEDONIA": "PRTC-CM",
    "COMMUNITIES OF PORT MORIEN": "PRTM-CM",
    "COMMUNITIES OF PRIME BROOK": "PRMB-CM",
    "COMMUNITIES OF RESERVE MINES": "RSRV-CM",
    "COMMUNITIES OF RIVER RYAN": "RVRR-CM",
    "COMMUNITIES OF ROCK ELM": "RCKL-CM",
    "COMMUNITIES OF ROUND ISLAND": "RNDS-CM",
    "COMMUNITIES OF SALEM ROAD": "SLMR-CM",
    "COMMUNITIES OF SALMON RIVER ROAD": "SLM1-CM",
    "COMMUNITIES OF SANDFIELD": "SNDF-CM",
    "COMMUNITIES OF SCOTCH LAKE": "SCTC-CM",
    "COMMUNITIES OF SCOTCHTOWN": "SCT1-CM",
    "COMMUNITIES OF SHUNACADIE": "SHNC-CM",
    "COMMUNITIES OF SOUTH BAR": "STHB-CM",
    "COMMUNITIES OF SOUTH SIDE OF BOULARDERIE": "SSBL-CM",
    "COMMUNITIES OF ST ANDREW'S CHANNEL": "STND-CM",
    "COMMUNITIES OF SYDNEY": "SYDN-CM",
    "COMMUNITIES OF SYDNEY FORKS": "SYD1-CM",
    "COMMUNITIES OF SYDNEY MINES": "SYD2-CM",
    "COMMUNITIES OF SYDNEY RIVER": "SYD3-CM",
    "COMMUNITIES OF UPPER GRAND MIRA": "UPP6-CM",
    "COMMUNITIES OF UPPER LEITCHES CREEK": "UPP7-CM",
    "COMMUNITIES OF UPPER NORTH SYDNEY": "UPP8-CM",
    "COMMUNITIES OF VICTORIA MINES": "VCTR-CM",
    "COMMUNITIES OF WESTMOUNT": "WSTM-CM",
    "COMMUNITIES OF TROUT BROOK": "TRTB-CM",
    "COMMUNITIES OF BANG'S FALLS": "BNGS-CM",
    "COMMUNITIES OF BEACH MEADOWS": "BCH1-CM",
    "COMMUNITIES OF BRISTOL": "BRST-CM",
    "COMMUNITIES OF BROOKFIELD MINES": "BRKF-CM",
    "COMMUNITIES OF BROOKLYN, QUEENS": "BRKL-CM",
    "COMMUNITIES OF BUCKFIELD": "BCKF-CM",
    "COMMUNITIES OF CALEDONIA": "CLDN-CM",
    "COMMUNITIES OF CHARLESTON": "CHRL-CM",
    "COMMUNITIES OF CHELSEA": "CHLS-CM",
    "COMMUNITIES OF EAGLE HEAD": "EGLH-CM",
    "COMMUNITIES OF EAST BERLIN": "EST4-CM",
    "COMMUNITIES OF EAST PORT MEDWAY": "EST5-CM",
    "COMMUNITIES OF EAST SIDE PORT L'HÉBERT": "EST6-CM",
    "COMMUNITIES OF GREENFIELD": "GRNF-CM",
    "COMMUNITIES OF HARMONY MILLS": "HRMN-CM",
    "COMMUNITIES OF HIBERNIA": "HBRN-CM",
    "COMMUNITIES OF HUNTS POINT": "HNTS-CM",
    "COMMUNITIES OF KEMPT": "KMPT-CM",
    "COMMUNITIES OF LABELLE": "LBLL-CM",
    "COMMUNITIES OF LIVERPOOL": "LVRP-CM",
    "COMMUNITIES OF LOW LANDING": "LWLN-CM",
    "COMMUNITIES OF MEDWAY": "MDWY-CM",
    "COMMUNITIES OF MIDDLEFIELD": "MDD4-CM",
    "COMMUNITIES OF MILL VILLAGE": "MLL1-CM",
    "COMMUNITIES OF MILTON": "MLTN-CM",
    "COMMUNITIES OF MOLEGA": "MLG-CM",
    "COMMUNITIES OF MOUNT PLEASANT": "MNTP-CM",
    "COMMUNITIES OF NEW GRAFTON": "NWGR-CM",
    "COMMUNITIES OF NORTH BROOKFIELD": "NRT5-CM",
    "COMMUNITIES OF NORTHFIELD, QUEENS": "NRT6-CM",
    "COMMUNITIES OF PLEASANTFIELD": "PLS3-CM",
    "COMMUNITIES OF PORT JOLI": "PRTJ-CM",
    "COMMUNITIES OF PORT MEDWAY": "PRT2-CM",
    "COMMUNITIES OF PORT MOUTON": "PRT3-CM",
    "COMMUNITIES OF RIVERSDALE": "RVRS-CM",
    "COMMUNITIES OF SOUTH BROOKFIELD": "STH1-CM",
    "COMMUNITIES OF SOUTH WEST PORT MOUTON": "STHW-CM",
    "COMMUNITIES OF SUMMERVILLE BEACH": "SMMR-CM",
    "COMMUNITIES OF SUMMERVILLE CENTRE": "SMM1-CM",
    "COMMUNITIES OF WEST BERLIN": "WSTB-CM",
    "COMMUNITIES OF WESTERN HEAD": "WSTR-CM",
    "COMMUNITIES OF WESTFIELD": "WSTF-CM",
    "COMMUNITIES OF WHITEBURN MINES": "WHTB-CM",
    "AMHERST": "AMHR-TS",
    "ANNAPOLIS ROYAL": "ANNP-T",
    "ANTIGONISH": "ANT1-RM",
    "BERWICK": "BRWC-T",
    "BRIDGEWATER": "BRD1-T",
    "CLARK'S HARBOUR": "CLRK-T",
    "DIGBY": "DGB1-RM",
    "HANTSPORT": "HNT1-T",
    "KENTVILLE": "KNTV-T",
    "LOCKEPORT": "LCKP-T",
    "LUNENBURG": "LNN1-RM",
    "MAHONE BAY": "MHNB-T",
    "MIDDLETON": "MDD5-T",
    "MULGRAVE": "MLGR-T",
    "NEW GLASGOW": "NWGL-T",
    "OXFORD": "OXFR-T",
    "PARRSBORO": "PRRS-T",
    "PICTOU": "PCT1-RM",
    "PORT HAWKESBURY": "PRTH-T",
    "SHELBURNE": "SHLB-T",
    "STELLARTON": "STL1-T",
    "STEWIACKE": "STWC-T",
    "TRENTON": "TRNT-T",
    "TRURO": "TRR-T",
    "WESTVILLE": "WSTV-T",
    "WINDSOR": "WNDS-T",
    "WOLFVILLE": "WLFV-T",
    "YARMOUTH": "YRM1-RM",
    "AYLESFORD": "AYLS-V",
    "BADDECK": "BDDC-V",
    "BIBLE HILL": "BBLH-V",
    "CANNING": "CNNN-V",
    "CHESTER": "CHS1-RM",
    "CORNWALLIS SQUARE": "CRNW-V",
    "FREEPORT": "FRPR-V",
    "HEBBVILLE": "HBBV-V",
    "KINGSTON": "KNGS-RM",
    "LAWRENCETOWN": "LWR3-V",
    "NEW MINAS": "NWMN-V",
    "PORT WILLIAMS": "PRTW-V",
    "PUGWASH": "PGWS-V",
    "RIVER HEBERT": "RVRH-V",
    "ST PETER’S": "STPT-V",
    "ST PETER'S": "STP1-V",
    "TATAMAGOUCHE": "TTMG-V",
    "TIVERTON": "TVRT-V",
    "WEYMOUTH": "WYMT-V",
    "ANNAPOLIS": "ANN1-RM",
    "BARRINGTON": "BRRN-RM",
    "CLARE": "CLR-RM",
    "COLCHESTER": "CLCH-RM",
    "EAST HANTS": "ESTH-RM",
    "GUYSBOROUGH": "GYSB-RM",
    "INVERNESS": "INVR-M",
    "KINGS": "KNG1-RM",
    "ST MARY'S": "STMR-RM",
    "WEST HANTS": "WSTH-RM",
    "ADMIRAL'S COVE": "HAL-ADM1",
    "ALBRO LAKE": "HAL-ALB1",
    "ARMDALE": "HAL-ARM1",
    "ARMCREST": "HAL-ARM2",
    "ATLANTIC ACRES INDUSTRIAL PARK": "HAL-ATL1",
    "AUSTENVILLE": "HAL-AST1",
    "DOWNTOWN BEDFORD": "HAL-DWN3",
    "NORTH BEDFORD": "HAL-NRT2",
    "BEECHWOOD PARK": "HAL-BCH1",
    "BOULDERWOOD": "HAL-BLD1",
    "BRIGHTWOOD": "HAL-BRG1",
    "BROOKVIEW": "HAL-BRK1",
    "BURNSIDE": "HAL-BRN1",
    "CRICHTON PARK": "HAL-CRC1",
    "COLBY VILLAGE": "HAL-CLB1",
    "CRYSTAL HEIGHTS": "HAL-CRY1",
    "DOWNTOWN DARTMOUTH": "HAL-DWN4",
    "DUTCH VILLAGE": "HAL-DTC1",
    "ELLENVALE": "HAL-ELL1",
    "FAIRMOUNT": "HAL-FRM1",
    "FIRST LAKE": "HAL-FRS2",
    "FOREST HILLS": "HAL-FRS3",
    "GLENBOURNE": "HAL-GLN1",
    "GLEN MOIR": "HAL-GLN2",
    "GRAHAM'S CORNER": "HAL-GRH1",
    "GREEN ACRES": "HAL-GRN1",
    "GREENWOOD HEIGHTS": "HAL-GRN2",
    "DOWNTOWN HALIFAX": "HAL-DWN5",
    "HARBOURVIEW": "HAL-HRB1",
    "HAWTHORNE": "HAL-HWT1",
    "HIGHFIELD PARK": "HAL-HGH1",
    "HUMBER PARK": "HAL-HMB1",
    "HYDROSTONE": "HAL-HYD1",
    "IMPEROYAL": "HAL-IMP1",
    "JOLLIMORE": "HAL-JLL1",
    "LAKEFRONT": "HAL-LKF1",
    "LAKESIDE INDUSTRIAL PARK": "HAL-LKS1",
    "LEIBLIN PARK": "HAL-LBL1",
    "LINDWOOD": "HAL-LND1",
    "SOUTH LOWER SACKVILLE": "HAL-STH1",
    "MANOR PARK": "HAL-MNR1",
    "MEADOWLANDS": "HAL-MDW1",
    "MELVILLE COVE": "HAL-MLV1",
    "MILLVIEW": "HAL-MLL1",
    "EAST MILLWOOD": "HAL-EST1",
    "MILLWOOD": "HAL-MLL2",
    "MOUNT ROYAL": "SAS-MNTR",
    "NANTUCKET": "HAL-NNT1",
    "NORTH END": "HAL-NRT3",
    "PARK AVENUE": "HAL-PRK1",
    "PORTLAND ESTATES": "HAL-PRT2",
    "PORTLAND HILLS": "HAL-PRT3",
    "PORTOBELLO": "HAL-PRT4",
    "PORT WALLACE": "HAL-PRT5",
    "PRINCE'S LODGE": "HAL-PRN1",
    "QUINPOOL": "HAL-QNP1",
    "REGENCY PARK": "HAL-RGN1",
    "ROCKINGHAM": "HAL-RCK1",
    "ROCKY LAKE": "HAL-RCK2",
    "RUSSELL LAKE WEST": "HAL-RSS1",
    "SACKVILLE BUSINESS PARK": "HAL-SCK2",
    "SACKVILLE MANOR": "HAL-SCK3",
    "OLD SACKVILLE ROAD": "HAL-OLD1",
    "SHANNON PARK": "HAL-SHN1",
    "SHERWOOD HEIGHTS": "HAL-SHR1",
    "SILVER'S HILL": "HAL-SLV1",
    "SOUTH END": "HAL-STH2",
    "SPRING GARDEN": "HAL-SPR1",
    "STONEMOUNT": "HAL-STN1",
    "THORNHILL": "HAL-THR1",
    "TUFT'S COVE": "HAL-TFT1",
    "THE VILLAGE": "HAL-THV1",
    "WALLACE HEIGHTS": "HAL-WLL1",
    "WEST END": "HAL-WST1",
    "WESTPHAL": "HAL-WST2",
    "WOODLAWN": "HAL-WDL1",
    "COMMUNITY OF ARCTIC BAY": "ARCT-CO",
    "COMMUNITY OF ARVIAT": "ARVT-CO",
    "COMMUNITY OF BAKER LAKE": "BKRL-CO",
    "COMMUNITY OF CAMBRIDGE BAY": "CMBR-CO",
    "COMMUNITY OF CAPE DORSET": "CPDR-CO",
    "COMMUNITY OF CHESTERFIELD INLET": "CHST-CO",
    "COMMUNITY OF CLYDE RIVER": "CLYD-CO",
    "COMMUNITY OF CORAL HARBOUR": "CRLH-CO",
    "COMMUNITY OF GJOA HAVEN": "GJHV-CO",
    "COMMUNITY OF GRISE FIORD": "GRSF-CO",
    "COMMUNITY OF HALL BEACH": "HLLB-CO",
    "COMMUNITY OF IGLOOLIK": "IGLL-CO",
    "COMMUNITY OF IQALUIT": "IQLT-CO",
    "COMMUNITY OF KIMMIRUT": "KMMR-CO",
    "COMMUNITY OF KUGAARUK": "KGRK-CO",
    "COMMUNITY OF KUGLUKTUK": "KGLK-CO",
    "COMMUNITY OF NAUJAAT": "NJT-CO",
    "COMMUNITY OF PANGNIRTUNG": "PNGN-CO",
    "COMMUNITY OF POND INLET": "PNDN-CO",
    "COMMUNITY OF QIKIQTARJUAQ": "QKQT-CO",
    "COMMUNITY OF RANKIN INLET": "RNKN-CO",
    "COMMUNITY OF RESOLUTE BAY": "RSLT-CO",
    "COMMUNITY OF SANIKILUAQ": "SNKL-CO",
    "COMMUNITY OF TALOYOAK": "TLYK-CO",
    "COMMUNITY OF WHALE COVE": "WHLC-CO",
    "BRAMPTON": "BRMP-C",
    "CAMBRIDGE": "CMBR-C",
    "CLARENCE-ROCKLAND": "CLR1-TS",
    "KITCHENER": "KTCH-C",
    "MARKHAM": "MRKH-C",
    "MISSISSAUGA": "MSSS-C",
    "NIAGARA FALLS": "NGRF-C",
    "OSHAWA": "OSHW-C",
    "OWEN SOUND": "OWNS-C",
    "PICKERING": "PCKR-C",
    "PORT COLBORNE": "PRTC-C",
    "SARNIA": "SRN-C",
    "ST CATHERINES": "STCT-C",
    "THOROLD": "THRL-C",
    "VAUGHAN": "VGHN-C",
    "WATERLOO": "WTRL-T",
    "WELLAND": "WLLN-C",
    "BARRIE": "BRR-C",
    "BELLEVILLE": "BLLV-C",
    "BRANTFORD": "BRNT-C",
    "BROCKVILLE": "BRCK-C",
    "CORNWALL": "CRNW-T",
    "DRYDEN": "DRYD-C",
    "ELLIOT LAKE": "ELLT-C",
    "GREATER SUDBURY": "GRTR-C",
    "GUELPH": "GLPH-C",
    "HAMILTON": "HMLT-C",
    "KAWARTHA LAKES": "KWRT-C",
    "KENORA": "KNR-C",
    "LONDON": "LNDN-C",
    "ORILLIA, CITY OF": "ORLL-C",
    "OTTAWA, CITY OF": "OTTW-C",
    "PEMBROKE, CITY OF": "PMBR-C",
    "PETERBOROUGH, CITY OF": "PTRB-C",
    "NORTH BAY, CITY OF": "NRTH-C",
    "TEMISKAMING SHORES": "TMSK-C",
    "THUNDER BAY": "THND-C",
    "TIMMINS": "TMMN-C",
    "TORONTO": "TORO-C",
    "QUINTE WEST": "QNTW-C",
    "SAULT STE MARIE": "SLTS-C",
    "ST THOMAS": "STTH-C",
    "STRATFORD": "STRT-TS",
    "AJAX": "AJX-T",
    "AMHERSTBURG": "AMHR-T",
    "ARNPRIOR": "ARN1-TS",
    "AURORA": "ARR-T",
    "AYLMER": "AYLM-T",
    "BANCROFT": "BNCR-T",
    "BAYHAM": "BYHM-T",
    "BRACEBRIDGE": "BRCB-T",
    "BRADFORD WEST GWILLIMBURY": "BRDF-T",
    "CALEDON": "CLDN-T",
    "CARLETON PLACE": "CRLT-T",
    "COBOURG": "CBRG-T",
    "COLLINGWOOD": "CLLN-T",
    "DEEP RIVER": "DPRV-T",
    "DESERONTO": "DSRN-T",
    "EAST GWILLIMBURY": "ESTG-T",
    "ERIN": "ERN-T",
    "ESSEX": "ESSX-T",
    "FORT ERIE": "FRTR-T",
    "GEORGINA": "GRGN-T",
    "GODERICH": "GDRC-T",
    "GRAND VALLEY": "GRND-T",
    "GRAVENHURST": "GRVN-T",
    "GREATER NAPANEE": "GRT1-T",
    "GRIMSBY": "GRMS-T",
    "HALTON HILLS": "HLTN-T",
    "HAWKESBURY": "HWKS-T",
    "HUNTSVILLE": "HNTS-T",
    "INGERSOLL": "INGR-T",
    "INNISFIL": "INNS-T",
    "KINGSVILLE": "KNG1-T",
    "LASALLE": "BUR-BRL15-N",
    "LAURENTIAN HILLS": "KIT-LRN2-N",
    "LINCOLN": "LNCL-T",
    "NEW TECUMSETH": "NWTC-T",
    "MIDLAND": "MDLN-T",
    "MILTON": "MLTN-T",
    "MISSISSIPPI MILLS": "MSS1-T",
    "MONO": "MN-T",
    "NEWMARKET": "NWMR-T",
    "OAKVILLE": "OKVL-T",
    "ORANGEVILLE": "ORNG-T",
    "PELHAM": "PLHM-T",
    "PERTH": "PRTH-T",
    "PETAWAWA": "PTWW-T",
    "PETROLIA": "PTRL-T",
    "PLYMPTON-WYOMING": "PLYM-T",
    "RENFREW": "RNFR-T",
    "SAUGEEN SHORES": "SGNS-T",
    "SOUTH BRUCE PENINSULA": "STHB-T",
    "RICHMOND HILL": "RCHM-T",
    "TECUMSEH": "TCMS-T",
    "THE BLUE MOUNTAINS": "THBL-T",
    "TILLSONBURG": "TLLS-T",
    "WASAGA BEACH": "WSGB-T",
    "WHITBY": "WHTB-T",
    "WHITCHURCH-STOUFFVILLE": "WHTC-T",
    "ATIKOKAN": "ATKK-T",
    "BLIND RIVER": "BLND-T",
    "BRUCE MINES": "BRCM-T",
    "COBALT": "CBLT-T",
    "ENGLEHART": "ENGL-T",
    "ESPANOLA": "ESPN-T",
    "FORT FRANCES": "FRTF-T",
    "GORE BAY": "GRBY-T",
    "HEARST": "HRST-T",
    "IROQUOIS FALLS": "IRQS-T",
    "KAPUSKASING": "KPSK-T",
    "KEARNEY": "KRNY-T",
    "MATTAWA": "MTTW-T",
    "KIRKLAND LAKE": "KRKL-T",
    "LATCHFORD": "LTCH-T",
    "MARATHON": "MRTH-T",
    "PARRY SOUND": "PRRY-T",
    "MOOSONEE": "MSN-T",
    "NORTHEASTERN MANITOULIN AND THE ISLANDS": "NRT1-T",
    "PRESCOTT": "PRSC-T",
    "RAINY RIVER": "RNYR-T",
    "SMITHS FALLS": "SMTH-T",
    "SMOOTH ROCK FALLS": "SMT1-T",
    "SPANISH": "SPNS-T",
    "ST MARYS": "STMR-T",
    "THESSALON": "THSS-T",
    "GANANOQUE": "GNNQ-T",
    "ADDINGTON HIGHLANDS": "ADDN-TS",
    "ADELAIDE-METCALFE": "ADLD-TS",
    "ADJALA-TOSORONTIO": "ADJL-TS",
    "ADMASTON/BROMLEY": "ADMS-TS",
    "ALFRED AND PLANTAGENET": "ALFR-TS",
    "ALGONQUIN HIGHLANDS": "ALGN-TS",
    "ALNWICK/HALDIMAND": "ALNW-TS",
    "AMARANTH": "AMRN-TS",
    "ASHFIELD-COLBORNE-WAWANOSH": "ASHF-TS",
    "ASPHODEL-NORWOOD": "ASPH-TS",
    "ATHENS": "ATHN-TS",
    "AUGUSTA": "AGST-TS",
    "BECKWITH": "BCKW-TS",
    "BLANDFORD-BLENHEIM": "BLN1-TS",
    "BONNECHERE VALLEY": "BNNC-TS",
    "BROCK": "BRC1-V",
    "BRUDENELL, LYNDOCH AND RAGLAN": "BRDN-TS",
    "CARLOW/MAYO": "CRLW-TS",
    "CAVAN-MONAGHAN": "CVNM-TS",
    "CENTRAL FRONTENA": "CNTR-TS",
    "CENTRE WELLINGTON": "CNT1-TS",
    "CHAMPLAIN": "CHMP-M",
    "CHATSWORTH": "CHTS-TS",
    "CLARINGTON": "CLR3-M",
    "CLEARVIEW": "CLRV-TS",
    "CRAMAHE": "CRMH-TS",
    "DAWN-EUPHEMIA": "DWNP-TS",
    "DOURO-DUMMER": "DRDM-TS",
    "DRUMMOND/NORTH ELMSLEY": "DRMM-TS",
    "DYSART": "DYSR-V",
    "DUDLEY": "DDLY-TS",
    "HARCOURT": "HRCR-TS",
    "GUILFORD": "GLFR-TS",
    "HARBURN": "HRBR-TS",
    "BRUTON": "BRTN-TS",
    "HAVELOCK": "HVLC-TS",
    "EYRE": "EYR-TS",
    "CLYDE": "CLYD-TS",
    "EAST GARAFRAXA": "EST1-TS",
    "EAST HAWKESBURY": "ESTH-TS",
    "EAST ZORRA-TAVISTOCK": "ESTZ-TS",
    "EDWARDSBURGH/CARDINAL": "EDWR-TS",
    "ELIZABETHTOWN-KITLEY": "ELZB-TS",
    "ENNISKILLEN": "ENNS-TS",
    "ESSA": "ESS-TS",
    "FARADAY": "FRDY-TS",
    "FRONT OF YONGE": "FRYG-TS",
    "FRONTENAC ISLANDS": "FRNT-TS",
    "GEORGIAN BAY": "GRG1-TS",
    "GEORGIAN BLUFFS": "GRG2-TS",
    "GREATER MADAWASKA": "GRT2-TS",
    "GUELPH/ERAMOSA": "GLP1-TS",
    "HAVELOCK-BELMONT-METHUEN": "HVL1-TS",
    "HEAD, CLARA AND MARIA": "HDCL-TS",
    "HORTON": "HRTN-TS",
    "HOWICK": "HWCK-M",
    "HURON-KINLOSS": "HRNK-TS",
    "KILLALOE, HAGARTY AND RICHARDS": "KLLL-TS",
    "KING": "KNG-TS",
    "LAKE OF BAYS": "LKBY-TS",
    "LANARK HIGHLANDS": "LNRK-TS",
    "LAURENTIAN VALLEY": "LRN1-TS",
    "LEEDS AND THE THOUSAND ISLANDS": "LDSN-TS",
    "LIMERICK": "LMRC-V",
    "LUCAN BIDDULPH": "LCNB-TS",
    "MADAWASKA VALLEY": "MDWS-TS",
    "MADOC": "MDC-TS",
    "MALAHIDE": "MLHD-TS",
    "MAPLETON": "MPLT-TS",
    "MCNAB - BRAESIDE": "MCNB-TS",
    "MELANCTHON": "MLNC-TS",
    "MINDEN HILLS": "MNDN-TS",
    "MONTAGUE": "MNTG-TS",
    "MULMUR": "MLMR-TS",
    "MUSKOKA LAKES": "MSKK-TS",
    "NORTH ALGONA WILBERFORCE": "NRT2-TS",
    "NORTH DUMFRIES": "NRT3-TS",
    "NORTH DUNDAS": "NRT4-TS",
    "NORTH FRONTENAC": "NRT5-TS",
    "NORTH GLENGARRY": "NRT6-TS",
    "NORTH HURON": "NRT7-TS",
    "NORTH KAWARTHA": "NRT8-TS",
    "NORTH STORMONT": "NRT9-TS",
    "NORWICH": "NRWC-TS",
    "ORO-MEDONTE": "ORMD-TS",
    "OTONABEE-SOUTH MONAGHAN": "OTNB-TS",
    "PERTH EAST": "PRT1-TS",
    "PERTH SOUTH": "PRT2-TS",
    "PUSLINCH": "PSLN-TS",
    "RAMARA": "RMR-TS",
    "RIDEAU LAKES": "RDLK-TS",
    "SCUGOG": "SCGG-TS",
    "SELWYN": "SLWY-TS",
    "SEVERN": "SVRN-TS",
    "SOUTH FRONTENAC": "STHF-TS",
    "SOUTH GLENGARRY": "STHG-TS",
    "SOUTH STORMONT": "STHS-TS",
    "SOUTH-WEST OXFORD": "STHW-TS",
    "SOUTHGATE": "STH1-TS",
    "SOUTHWOLD": "STH2-TS",
    "SPRINGWATER": "SPRN-TS",
    "ST CLAIR": "STCL-TS",
    "STIRLING-RAWDON": "STRL-TS",
    "STONE MILLS": "STNM-TS",
    "STRATHROY-CARADOC": "STR1-TS",
    "TAY VALLEY": "TYVL-TS",
    "TAY": "TY-TS",
    "TINY": "TNY-TS",
    "TUDOR AND CASHEL": "TDRN-TS",
    "TYENDINAGA": "TYND-TS",
    "UXBRIDGE": "UXBR-TS",
    "WAINFLEET": "WNFL-TS",
    "WARWICK": "WRWC-T",
    "WELLESLEY": "WLLS-TS",
    "WELLINGTON NORTH": "WLL1-TS",
    "WEST LINCOLN": "WSTL-TS",
    "WHITEWATER REGION": "WHTW-TS",
    "WILMOT": "WLMT-TS",
    "WOLLASTON": "WLL2-TS",
    "WOOLWICH": "WLWC-TS",
    "ZORRA": "ZRR-TS",
    "ALBERTON": "ALBR-T",
    "ARMOUR": "ARMR-TS",
    "ASSIGINACK": "ASSG-TS",
    "BALDWIN": "BLDW-TS",
    "BILLINGS": "BLLN-TS",
    "BLACK RIVER-MATHESON": "BLCK-TS",
    "BONFIELD": "BNFL-TS",
    "BRETHOUR": "BRTH-TS",
    "BURPEE AND MILLS": "BRPN-TS",
    "CARLING": "CRLN-TS",
    "CASEY": "CSY-TS",
    "CHAMBERLAIN": "CHMB-V",
    "CHAPLEAU": "CHPL-TS",
    "CHAPPLE": "CHPP-TS",
    "COCKBURN ISLAND": "CCKB-TS",
    "COLEMAN": "CLMN-TS",
    "CONMEE": "CNM-TS",
    "DAWSON": "DWSN-TS",
    "DORION": "DRN-TS",
    "DUBREUILVILLE": "DBRL-TS",
    "EAR FALLS": "ERFL-TS",
    "EAST FERRIS": "ESTF-TS",
    "EMO": "EM-TS",
    "EVANTUREL": "EVNT-TS",
    "FAUQUIER-STRICKLAND": "FQRS-TS",
    "GAUTHIER": "GTHR-TS",
    "GILLIES": "GLLS-TS",
    "HARLEY": "HRLY-TS",
    "HARRIS": "HRRS-TS",
    "HILTON": "HLT1-TS",
    "HORNEPAYNE": "HRNP-TS",
    "HUDSON": "HDSN-T",
    "IGNACE": "IGNC-TS",
    "JAMES": "JMS-TS",
    "JOCELYN": "JCLY-TS",
    "JOHNSON": "JHNS-TS",
    "JOLY": "JLY-TS",
    "KERNS": "KRNS-TS",
    "LA VALLEE": "LVLL-TS",
    "LAIRD": "LRD-V",
    "LAKE OF THE WOODS": "LKWD-TS",
    "LARDER LAKE": "LRDR-TS",
    "MACHAR": "MCHR-TS",
    "MACHIN": "MCHN-TS",
    "MANITOUWADGE": "MNTW-TS",
    "MATACHEWAN": "MTCH-TS",
    "MATTAWAN": "MTT1-TS",
    "MATTICE-VAL CÔTÉ": "MTTC-TS",
    "MCDOUGALL": "MCDG-TS",
    "MCGARRY": "MCGR-TS",
    "MCKELLAR": "MCKL-TS",
    "MCMURRICH/MONTEITH": "MCMR-TS",
    "MOONBEAM": "MNBM-TS",
    "MORLEY": "MRLY-TS",
    "NAIRN AND HYMAN": "NRNN-TS",
    "NIPIGON": "NPGN-TS",
    "NIPISSING": "NPSS-TS",
    "O'CONNOR": "OCNN-TS",
    "OPASATIKA": "OPST-TS",
    "PAPINEAU-CAMERON": "PPNC-TS",
    "PELEE": "PELE-TS",
    "PERRY": "PRR1-TS",
    "PICKLE LAKE": "PCKL-TS",
    "PLUMMER ADDITIONAL": "PLMM-TS",
    "PRINCE": "PRN1-H",
    "RED ROCK": "RDRC-TS",
    "RYERSON": "RYRS-TS",
    "SABLES-SPANISH RIVERS": "SBLS-TS",
    "SCHREIBER": "SCHR-TS",
    "SEGUIN": "SGN-TS",
    "SIOUX NARROWS-NESTOR FALLS": "SXNR-TS",
    "SOUTH ALGONQUIN": "STHL-TS",
    "ST JOSEPH": "STJS-TS",
    "STRONG": "STRN-TS",
    "TARBUTT": "TRBT-TS",
    "TEHKUMMAH": "THKM-TS",
    "TERRACE BAY": "TRRC-TS",
    "THE ARCHIPELAGO": "THRC-TS",
    "THE NORTH SHORE": "THNR-TS",
    "VAL RITA-HARTY": "VLRT-TS",
    "WHITE RIVER": "WHTR-TS",
    "CASSELMAN": "CSSL-V",
    "MERRICKVILLE-WOLFORD": "MRRC-V",
    "NEWBURY": "NWBR-V",
    "OIL SPRINGS": "OLSP-V",
    "POINT EDWARD": "PNTD-V",
    "BURK'S FALLS": "BRKS-V",
    "HILTON BEACH": "HLT2-V",
    "SUNDRIDGE": "SNDR-V",
    "THORNLOE": "THRN-V",
    "ARRAN-ELDERSLIE": "ARRN-M",
    "BLUEWATER": "BLWT-M",
    "BROCKTON": "BRC2-M",
    "BROOKE-ALVINSTON": "BRKL-M",
    "CENTRAL ELGIN": "CNT2-M",
    "CENTRAL HURON": "CNT3-M",
    "CENTRE HASTINGS": "CNT4-M",
    "DUTTON": "DTTN-M",
    "DUNWICH": "DNWC-M",
    "GREY HIGHLANDS": "GRYH-M",
    "HASTINGS HIGHLANDS": "HSTN-M",
    "HIGHLANDS EAST": "HGHL-M",
    "HURON EAST": "HRNS-M",
    "KINCARDINE": "KNCR-M",
    "LAMBTON SHORES": "LMBT-M",
    "LEAMINGTON": "LMNG-M",
    "MEAFORD": "MFRD-M",
    "MIDDLESEX CENTRE": "MDDL-M",
    "MORRIS-TURNBERRY": "MRRS-M",
    "NORTH GRENVILLE": "NRT10-M",
    "NORTH MIDDLESEX": "NRT11-M",
    "NORTH PERTH": "NRT12-M",
    "NORTHERN BRUCE PENINSULA": "NRT13-M",
    "PORT HOPE": "PRT3-M",
    "RED LAKE": "RDL1-M",
    "SOUTH BRUCE": "STH3-M",
    "SOUTH DUNDAS": "STHD-M",
    "SOUTH HURON": "STHH-M",
    "SOUTHWEST MIDDLESEX": "STH4-M",
    "THAMES CENTRE": "THMS-M",
    "THE NATION MUNICIPALITY": "THNT-M",
    "TRENT HILLS": "TRNT-M",
    "TRENT LAKES": "TRN1-M",
    "TWEED": "TWD-M",
    "WEST ELGIN": "WST1-M",
    "WEST GREY": "WSTG-M",
    "WEST PERTH": "WST2-M",
    "MARMORA AND LAKE": "MRMR-M",
    "CALLANDER": "CLL1-M",
    "CALVIN": "CLVN-M",
    "CENTRAL MANITOULIN": "CNT5-M",
    "CHARLTON AND DACK": "CHRL-M",
    "CHATHAM-KENT": "CHTH-M",
    "FRENCH RIVER": "FRNC-M",
    "GORDON/BARRIE ISLAND": "GRDN-M",
    "GREENSTONE": "GRNS-M",
    "HURON SHORES": "HRN1-M",
    "KILLARNEY": "KLLR-M",
    "MAGNETAWAN": "MGNT-M",
    "OLIVER PAIPOONGE": "OLVR-M",
    "MARKSTAY-WARREN": "MRKS-M",
    "NEEBING": "NBNG-M",
    "POWASSAN": "PWSS-M",
    "SHUNIAH": "SHNH-M",
    "SIOUX LOOKOUT": "SXLK-M",
    "ST CHARLES": "STCH-M",
    "TEMAGAMI": "TMGM-M",
    "WAWA": "WW-M",
    "WEST NIPISSING": "WSTN-M",
    "WHITESTONE": "WHTS-M",
    "DURHAM": "DRHM-M",
    "HALTON": "HLT3-M",
    "MUSKOKA": "MSK1-M",
    "NIAGARA": "NGR-M",
    "PEEL": "PL1-M",
    "YORK": "YRK-M",
    "COUNTY OF BRANT": "BRN1-CT",
    "COUNTY OF HALDIMAND": "HLDM-CT",
    "COUNTY OF NORFOLK": "NRFL-CT",
    "PRINCE EDWARD COUNTY": "PRED-CT",
    "BRUCE COUNTY": "BRCE-CT",
    "DUFFERIN COUNTY": "DFFR-CT",
    "ELGIN COUNTY": "ELGI-CT",
    "ESSEX COUNTY": "ESSX-CT",
    "FRONTENAC COUNTY": "FRTN-CT",
    "GREY COUNTY": "GREY-CT",
    "HALIBURTON COUNTY": "HLBR-CT",
    "HASTINGS COUNTY": "HSTN-CT",
    "HURON COUNTY": "HURO-CT",
    "LAMBTON COUNTY": "LMBT-CT",
    "LANARK COUNTY": "LNRK-CT",
    "LENNOX AND ADDINGTON COUNTY": "LNNX-CT",
    "MIDDLESEX COUNTY": "MDLS-CT",
    "NORTHUMBERLAND COUNTY": "NTBL-CT",
    "OXFORD COUNTY": "OXFD-CT",
    "PERTH COUNTY": "PRTH-CT",
    "PETERBOROUGH COUNTY": "PTBR-CT",
    "RENFREW COUNTY": "RNFR-CT",
    "SIMCOE COUNTY": "SMCO-CT",
    "WELLINGTON COUNTY": "WLGT-CT",
    "UNITED COUNTIES OF LEEDS AND GRENVILLE": "LDS1-UC",
    "UNITED COUNTIES OF STORMONT, DUNDAS AND GLENGARRY": "STRM-UC",
    "UNITED COUNTIES OF PRESCOTT AND RUSSELL": "PRS1-UC",
    "WEST HUMBER-CLAIRVILLE, TORONTO": "TOR-WSTH-N",
    "MOUNT OLIVE-SILVERSTONE-JAMESTOWN, TORONTO": "TOR-MNTL-N",
    "THISTLETOWN-BEAUMOND HEIGHTS, TORONTO": "TOR-THST-N",
    "REXDALE-KIPLING, TORONTO": "TOR-RXDL-N",
    "ELMS-OLD REXDALE, TORONTO": "TOR-ELMS-N",
    "KINGSVIEW VILLAGE-THE WESTWAY, TORONTO": "TOR-KNGS-N",
    "WILLOWRIDGE-MARTINGROVE-RICHVIEW, TORONTO": "TOR-WLLW-N",
    "HUMBER HEIGHTS-WESTMOUNT, TORONTO": "TOR-HMBR-N",
    "EDENBRIDGE-HUMBER VALLEY, TORONTO": "TOR-EDNB-N",
    "PRINCESS-ROSETHORN, TORONTO": "TOR-PRNC-N",
    "ERINGATE-CENTENNIAL-WEST DEANE, TORONTO": "TOR-ERNG-N",
    "MARKLAND WOOD, TORONTO": "TOR-MRKL-N",
    "ETOBICOKE WEST MALL, TORONTO": "TOR-ETBC-N",
    "KINGSWAY SOUTH, TORONTO": "TOR-KNG1-N",
    "STONEGATE-QUEENSWAY, TORONTO": "TOR-STNG-N",
    "NEW TORONTO, TORONTO": "TOR-NWTR-N",
    "LONG BRANCH, TORONTO": "TOR-LNGB-N",
    "ALDERWOOD, TORONTO": "TOR-ALDR-N",
    "HUMBER SUMMIT, TORONTO": "TOR-HMB1-N",
    "HUMBERMEDE, TORONTO": "TOR-HMB2-N",
    "PELMO PARK-HUMBERLEA, TORONTO": "TOR-PLMP-N",
    "BLACK CREEK, TORONTO": "TOR-BLCK-N",
    "GLENFIELD-JANE HEIGHTS, TORONTO": "TOR-GLNF-N",
    "YORK UNIVERSITY HEIGHTS, TORONTO": "TOR-YRKN-N",
    "RUSTIC, TORONTO": "TOR-RSTC-N",
    "MAPLE LEAF, TORONTO": "TOR-MPLL-N",
    "BROOKHAVEN-AMESBURY, TORONTO": "TOR-BRKH-N",
    "YORKDALE-GLEN PARK, TORONTO": "TOR-YRKD-N",
    "ENGLEMOUNT-LAWRENCE, TORONTO": "TOR-ENGL-N",
    "CLANTON PARK, TORONTO": "TOR-CLNT-N",
    "BATHURST MANOR, TORONTO": "TOR-BTHR-N",
    "WESTMINSTER-BRANSON, TORONTO": "TOR-WSTM-N",
    "NEWTONBROOK WEST, TORONTO": "TOR-NWTN-N",
    "WILLOWDALE WEST, TORONTO": "TOR-WLL1-N",
    "LANSING-WESTGATE, TORONTO": "TOR-LNSN-N",
    "BEDFORD PARK-NORTOWN, TORONTO": "TOR-BDFR-N",
    "STANDREW-WINDFIELDS, TORONTO": "TOR-STND-N",
    "BRIDLE PATH-SUNNYBROOK-YORK MILLS, TORONTO": "TOR-BRDL-N",
    "BANBURY-DON MILLS, TORONTO": "TOR-BNBR-N",
    "VICTORIA VILLAGE, TORONTO": "TOR-VCTR-N",
    "FLEMINGDON PARK, TORONTO": "TOR-FLMN-N",
    "PLEASANT VIEW, TORONTO": "TOR-PLSN-N",
    "DON VALLEY VILLAGE, TORONTO": "TOR-DNVL-N",
    "HILLCREST VILLAGE, TORONTO": "TOR-HLLC-N",
    "BAYVIEW WOODS-STEELES, TORONTO": "TOR-BYVW-N",
    "NEWTONBROOK EAST, TORONTO": "TOR-NWT1-N",
    "BAYVIEW VILLAGE, TORONTO": "TOR-BYV1-N",
    "HENRY FARM, TORONTO": "TOR-HNRY-N",
    "O`CONNOR PARKVIEW, TORONTO": "TOR-OCNN-N",
    "THORNCLIFFE PARK, TORONTO": "TOR-THRN-N",
    "LEASIDE-BENNINGTON, TORONTO": "TOR-LSDB-N",
    "BROADVIEW NORTH, TORONTO": "TOR-BRDV-N",
    "OLD EAST YORK, TORONTO": "TOR-OLDS-N",
    "DANFORTH-EAST YORK, TORONTO": "TOR-DNFR-N",
    "WOODBINE-LUMSDEN, TORONTO": "TOR-WDBN-N",
    "TAYLOR MASSEY, TORONTO": "TOR-TYLR-N",
    "EAST END DANFORTH, TORONTO": "TOR-ESTN-N",
    "THE BEACHES, TORONTO": "TOR-THBC-N",
    "WOODBINE CORRIDOR, TORONTO": "TOR-WDB1-N",
    "GREENWOOD-COXWELL, TORONTO": "TOR-GRNW-N",
    "DANFORTH, TORONTO": "TOR-DNF1-N",
    "PLAYTER ESTATES-DANFORTH, TORONTO": "TOR-PLYT-N",
    "NORTH RIVERDALE, TORONTO": "TOR-NRTH-N",
    "BLAKE-JONES, TORONTO": "TOR-BLKJ-N",
    "SOUTH RIVERDALE, TORONTO": "TOR-STHR-N",
    "CABBAGETOWN-SOUTH ST JAMES TOWN, TORONTO": "TOR-CBBG-N",
    "REGENT PARK, TORONTO": "TOR-RGNT-N",
    "MOSS PARK, TORONTO": "TOR-MSSP-N",
    "NORTH ST JAMES TOWN, TORONTO": "TOR-NRT1-N",
    "KENSINGTON-CHINATOWN, TORONTO": "TOR-KNSN-N",
    "UNIVERSITY, TORONTO": "TOR-UNVR-N",
    "PALMERSTON-LITTLE ITALY, TORONTO": "TOR-PLMR-N",
    "TRINITY-BELLWOODS, TORONTO": "TOR-TRNT-N",
    "DUFFERIN GROVE, TORONTO": "TOR-DFFR-N",
    "LITTLE PORTUGAL, TORONTO": "TOR-LTTL-N",
    "SOUTH PARKDALE, TORONTO": "TOR-STHP-N",
    "RONCESVALLES, TORONTO": "TOR-RNCS-N",
    "HIGH PARK-SWANSEA, TORONTO": "TOR-HGHP-N",
    "HIGH PARK NORTH, TORONTO": "TOR-HGH1-N",
    "RUNNYMEDE-BLOOR WEST VILLAGE, TORONTO": "TOR-RNNY-N",
    "JUNCTION AREA, TORONTO": "TOR-JNCT-N",
    "WESTON-PELHAM PARK, TORONTO": "TOR-WSTN-N",
    "CORSO ITALIA-DAVENPORT, TORONTO": "TOR-CRST-N",
    "WYCHWOOD, TORONTO": "TOR-WYCH-N",
    "ANNEX, TORONTO": "TOR-ANNX-N",
    "CASA LOMA, TORONTO": "TOR-CSLM-N",
    "YONGE-ST CLAIR, TORONTO": "TOR-YNGS-N",
    "ROSEDALE-MOORE PARK, TORONTO": "TOR-RSDL-N",
    "MOUNT PLEASANT EAST, TORONTO": "TOR-MNTP-N",
    "YONGE-EGLINTON, TORONTO": "TOR-YNGG-N",
    "FOREST HILL SOUTH, TORONTO": "TOR-FRST-N",
    "FOREST HILL NORTH, TORONTO": "TOR-FRS1-N",
    "LAWRENCE PARK SOUTH, TORONTO": "TOR-LWRN-N",
    "LAWRENCE PARK NORTH, TORONTO": "TOR-LWR1-N",
    "HUMEWOOD-CEDARVALE, TORONTO": "TOR-HMWD-N",
    "OAKWOOD VILLAGE, TORONTO": "TOR-OKWD-N",
    "BRIAR HILL-BELGRAVIA, TORONTO": "TOR-BRRH-N",
    "CALEDONIA-FAIRBANK, TORONTO": "TOR-CLDN-N",
    "KEELESDALE-EGLINTON WEST, TORONTO": "TOR-KLSD-N",
    "ROCKCLIFFE-SMYTHE, TORONTO": "TOR-RCKC-N",
    "BEECHBOROUGH-GREENBROOK, TORONTO": "TOR-BCHB-N",
    "WESTON, TORONTO": "TOR-WST1-N",
    "LAMBTON BABY POINT, TORONTO": "TOR-LMBT-N",
    "MOUNT DENNIS, TORONTO": "TOR-MNTD-N",
    "STEELES, TORONTO": "TOR-STLS-N",
    "TAM O’SHANTER-SULLIVAN, TORONTO": "TOR-TMSH-N",
    "WEXFORD/MARYVALE, TORONTO": "TOR-WXFR-N",
    "CLAIRLEA-BIRCHMOUNT, TORONTO": "TOR-CLRL-N",
    "OAKRIDGE, TORONTO": "TOR-OKRD-N",
    "BIRCHCLIFFE-CLIFFSIDE, TORONTO": "TOR-BRCH-N",
    "CLIFFCREST, TORONTO": "TOR-CLFF-N",
    "KENNEDY PARK, TORONTO": "TOR-KNND-N",
    "IONVIEW, TORONTO": "TOR-INVW-N",
    "DORSET PARK, TORONTO": "TOR-DRST-N",
    "AGINCOURT SOUTH-MALVERN WEST, TORONTO": "TOR-AGNC-N",
    "AGINCOURT NORTH, TORONTO": "TOR-AGN1-N",
    "MILLIKEN, TORONTO": "TOR-MLLK-N",
    "CENTENNIAL SCARBOROUGH, TORONTO": "TOR-CNTN-N",
    "HIGHLAND CREEK, TORONTO": "TOR-HGHL-N",
    "MORNINGSIDE, TORONTO": "TOR-MRNN-N",
    "WEST HILL, TORONTO": "TOR-WST2-N",
    "EGLINTON EAST, TORONTO": "TOR-EGLN-N",
    "SCARBOROUGH VILLAGE, TORONTO": "TOR-SCRB-N",
    "GUILDWOOD, TORONTO": "TOR-GLDW-N",
    "GOLFDALE-CEDARBRAE-WOBURN, TORONTO": "TOR-GLFD-N",
    "WOBURN NORTH, TORONTO": "TOR-WBRN-N",
    "WEST ROUGE, TORONTO": "TOR-WSTR-N",
    "MORNINGSIDE HEIGHTS, TORONTO": "TOR-MRN1-N",
    "MALVERN WEST, TORONTO": "TOR-MLVR-N",
    "MALVERN EAST, TORONTO": "TOR-MLV1-N",
    "L’AMOREAUX WEST, TORONTO": "TOR-LMRX-N",
    "EAST L’AMOREAUX, TORONTO": "TOR-ESTL-N",
    "PARKWOODS-O’CONNOR HILLS, TORONTO": "TOR-PRKW-N",
    "FENSIDE-PARKWOODS, TORONTO": "TOR-FNSD-N",
    "YONGE-DORIS, TORONTO": "TOR-YNGD-N",
    "EAST WILLOWDALE, TORONTO": "TOR-ESTW-N",
    "AVONDALE, TORONTO": "TOR-AVND-N",
    "OAKDALE-BEVERLEY HEIGHTS, TORONTO": "TOR-OKDL-N",
    "DOWNSVIEW, TORONTO": "TOR-DWNS-N",
    "BENDALE-GLEN ANDREW, TORONTO": "TOR-BNDL-N",
    "BENDALE SOUTH, TORONTO": "TOR-BND1-N",
    "ISLINGTON, TORONTO": "TOR-ISLN-N",
    "ETOBICOKE CITY CENTRE, TORONTO": "TOR-ETB1-N",
    "MIMICO-QUEENSWAY, TORONTO": "TOR-MMCQ-N",
    "HUMBER BAY SHORES, TORONTO": "TOR-HMB3-N",
    "WEST QUEEN WEST, TORONTO": "TOR-WSTQ-N",
    "FORT YORK-LIBERTY VILLAGE, TORONTO": "TOR-FRTY-N",
    "WELLINGTON PLACE, TORONTO": "TOR-WLLN-N",
    "HARBOURFRONT-CITYPLACE, TORONTO": "TOR-HRBR-N",
    "ST LAWRENCE-EAST BAYFRONT-THE ISLANDS, TORONTO": "TOR-STLW-N",
    "CHURCH-WELLESLEY, TORONTO": "TOR-CHRC-N",
    "DOWNTOWN YONGE EAST, TORONTO": "TOR-DWNT-N",
    "BAY-CLOVERHILL, TORONTO": "TOR-BYCL-N",
    "YONGE-BAY CORRIDOR, TORONTO": "TOR-YNGB-N",
    "JUNCTION-WALLACE EMERSON, TORONTO": "TOR-JNC1-N",
    "DOVERCOURT VILLAGE, TORONTO": "TOR-DVRC-N",
    "NORTH TORONTO, TORONTO": "TOR-NRT2-N",
    "SOUTH EGLINTON-DAVISVILLE, TORONTO": "TOR-STHG-N",
    "BYWARD MARKET, OTTAWA": "OTT-BYWR-N",
    "CENTRETOWN, OTTAWA": "OTT-CNTR-N",
    "DOWNTOWN, OTTAWA": "OTT-DWN1-N",
    "THE GLEBE, OTTAWA": "OTT-THGL-N",
    "GOLDEN TRIANGLE, OTTAWA": "OTT-GLDN-N",
    "LEBRETON FLATS, OTTAWA": "OTT-LBRT-N",
    "LOWER TOWN, OTTAWA": "OTT-LWRT-N",
    "OLD OTTAWA , OTTAWA": "OTT-OLDT-N",
    "SANDY HILL, OTTAWA": "OTT-SNDY-N",
    "CARSON MEADOWS, OTTAWA": "OTT-CRSN-N",
    "CASTLE HEIGHTS, OTTAWA": "OTT-CSTL-N",
    "FORBES, OTTAWA": "OTT-FRBS-N",
    "LEES AVENUE, OTTAWA": "OTT-LSVN-N",
    "LINDENLEA, OTTAWA": "OTT-LNDN-N",
    "MANOR PARK, OTTAWA": "OTT-MNRP-N",
    "NEW EDINBURGH, OTTAWA": "OTT-NWDN-N",
    "OVERBROOK, OTTAWA": "OTT-OVRB-N",
    "ROCKCLIFFE PARK, OTTAWA": "OTT-RCK1-N",
    "VANIER, OTTAWA": "OTT-VNRT-N",
    "VISCOUNT ALEXANDER PARK, OTTAWA": "OTT-VSCN-N",
    "AIRPORT-UPLANDS, OTTAWA": "OTT-ARPR-N",
    "ALTA VISTA, OTTAWA": "OTT-ALTV-N",
    "BILLINGS BRIDGE, OTTAWA": "OTT-BLLN-N",
    "CONFEDERATION HEIGHTS, OTTAWA": "OTT-CNFD-N",
    "ELLWOOD, OTTAWA": "OTT-ELLW-N",
    "ELMVALE ACRES, OTTAWA": "OTT-ELMV-N",
    "GREENBORO, OTTAWA": "OTT-GRNB-N",
    "HAWTHORNE MEADOWS, OTTAWA": "OTT-HWTH-N",
    "HERON GATE, OTTAWA": "OTT-HRNG-N",
    "HERON PARK, OTTAWA": "OTT-HRNP-N",
    "HUNT CLUB, OTTAWA": "OTT-HNTC-N",
    "HUNT CLUB PARK, OTTAWA": "OTT-HNT1-N",
    "RIVERSIDE PARK, OTTAWA": "OTT-RVRS-N",
    "RIVERVIEW, OTTAWA": "OTT-RVRV-N",
    "MOONEY'S BAY PARK, OTTAWA": "OTT-MNYS-N",
    "SHEFFIELD GLEN, OTTAWA": "OTT-SHFF-N",
    "SOUTH KEYS, OTTAWA": "OTT-STHK-N",
    "URBANDALE, OTTAWA": "OTT-URBN-N",
    "AMBLESIDE, OTTAWA": "OTT-AMBL-N",
    "BEL-AIR HEIGHTS, OTTAWA": "OTT-BLRH-N",
    "BEL-AIR PARK, OTTAWA": "OTT-BLRP-N",
    "BELLTOWN, OTTAWA": "OTT-BLLT-N",
    "BRAEMAR PARK, OTTAWA": "OTT-BRMR-N",
    "BRITANNIA, OTTAWA": "OTT-BRTN-N",
    "BRITANNIA HEIGHTS, OTTAWA": "OTT-BRT1-N",
    "BRITANNIA VILLAGE, OTTAWA": "OTT-BRT2-N",
    "CARLETON HEIGHTS, OTTAWA": "OTT-CRLT-N",
    "CARLINGTON, OTTAWA": "OTT-CRLN-N",
    "CARLINGWOOD, OTTAWA": "OTT-CRL1-N",
    "CENTRAL PARK, OTTAWA": "OTT-CNT1-N",
    "CHAMPLAIN PARK, OTTAWA": "OTT-CHMP-N",
    "CIVIC HOSPITAL, OTTAWA": "OTT-CVCH-N",
    "COPELAND PARK, OTTAWA": "OTT-CPLN-N",
    "COURTLAND PARK, OTTAWA": "OTT-CRTL-N",
    "GLABAR PARK, OTTAWA": "OTT-GLBR-N",
    "HAMPTON PARK, OTTAWA": "OTT-HMPT-N",
    "HIGHLAND PARK, OTTAWA": "OTT-HGH2-N",
    "HINTONBURG, OTTAWA": "OTT-HNTN-N",
    "KENSON PARK, OTTAWA": "OTT-KNS1-N",
    "LINCOLN HEIGHTS, OTTAWA": "OTT-LNCL-N",
    "MCKELLAR HEIGHTS, OTTAWA": "OTT-MCKL-N",
    "MCKELLAR PARK, OTTAWA": "OTT-MCK1-N",
    "MECHANICSVILLE, OTTAWA": "OTT-MCHN-N",
    "MICHELE HEIGHTS, OTTAWA": "OTT-MCHL-N",
    "QUALICUM, OTTAWA": "OTT-QLCM-N",
    "QUEENSWAY TERRACE NORTH, OTTAWA": "OTT-QNSW-N",
    "REDWOOD, OTTAWA": "OTT-RDWD-N",
    "RIDEAU VIEW, OTTAWA": "OTT-RDVW-N",
    "TUNNEY'S PASTURE, OTTAWA": "OTT-TNNY-N",
    "WELLINGTON VILLAGE, OTTAWA": "OTT-WLL2-N",
    "WESTBORO, OTTAWA": "OTT-WSTB-N",
    "WHITEHAVEN, OTTAWA": "OTT-WHTH-N",
    "WOODPARK, OTTAWA": "OTT-WDPR-N",
    "WOODROFFE NORTH, OTTAWA": "OTT-WDRF-N",
    "BEACON HILL, OTTAWA": "OTT-BCNH-N",
    "BLACKBURN HAMLET, OTTAWA": "OTT-BLC1-N",
    "BLOSSOM PARK, OTTAWA": "OTT-BLSS-N",
    "CARLSBAD SPRINGS, OTTAWA": "OTT-CRLS-N",
    "CARSON GROVE, OTTAWA": "OTT-CRS1-N",
    "CEDARDALE, OTTAWA": "OTT-CDRD-N",
    "CHAPEL HILL, OTTAWA": "OTT-CHPL-N",
    "CHATEAU NEUF, OTTAWA": "OTT-CHTN-N",
    "CONVENT GLEN, OTTAWA": "OTT-CNVN-N",
    "CYRVILLE, OTTAWA": "OTT-CYRV-N",
    "EDWARDS, OTTAWA": "OTT-EDWR-N",
    "ELIZABETH PARK, OTTAWA": "OTT-ELZB-N",
    "FICKO, OTTAWA": "OTT-FCKT-N",
    "FINDLAY CREEK, OTTAWA": "OTT-FNDL-N",
    "GLOUCESTER GLEN, OTTAWA": "OTT-GLCS-N",
    "HIAWATHA PARK, OTTAWA": "OTT-HWT1-N",
    "HONEY GABLES, OTTAWA": "OTT-HNYG-N",
    "JOHNSTON CORNERS, OTTAWA": "OTT-JHNS-N",
    "KEMPARK, OTTAWA": "OTT-KMPR-N",
    "LEITRIM, OTTAWA": "OTT-LTRM-N",
    "LIMEBANK, OTTAWA": "OTT-LMBN-N",
    "MANOTICK STATION, OTTAWA": "OTT-MNTC-N",
    "ORLEANS, OTTAWA": "OTT-ORLN-N",
    "ORLÉANS VILLAGE, OTTAWA": "OTT-ORL1-N",
    "ORLÉANS WOOD, OTTAWA": "OTT-ORL2-N",
    "PINEVIEW, OTTAWA": "OTT-PNVW-N",
    "PIPERVILLE, OTTAWA": "OTT-PPRV-N",
    "RAMSAYVILLE, OTTAWA": "OTT-RMSY-N",
    "RIVERSIDE SOUTH, OTTAWA": "OTT-RVR1-N",
    "ROTHWELL HEIGHTS, OTTAWA": "OTT-RTHW-N",
    "SOUTH GLOUCESTER, OTTAWA": "OTT-STH1-N",
    "VICTORY HILL, OTTAWA": "OTT-VCT1-N",
    "WINDSOR PARK VILLAGE, OTTAWA": "OTT-WNDS-N",
    "BEAVERBROOK, OTTAWA": "OTT-BVRB-N",
    "BRIDLEWOOD, OTTAWA": "OTT-BRD1-N",
    "GLEN CAIRN, OTTAWA": "OTT-GLNC-N",
    "HARWOOD PLAINS, OTTAWA": "OTT-HRWD-N",
    "KANATA, OTTAWA": "OTT-KNTT-N",
    "KATIMAVIK-HAZELDEAN, OTTAWA": "OTT-KTMV-N",
    "LAKESIDE, OTTAWA": "OTT-LKSD-N",
    "MALWOOD, OTTAWA": "OTT-MLWD-N",
    "MARCHHURST, OTTAWA": "OTT-MRCH-N",
    "MARCHWOOD, OTTAWA": "OTT-MRC1-N",
    "MORGAN'S GRANT, OTTAWA": "OTT-MRGN-N",
    "SOUTH MARCH, OTTAWA": "OTT-STHM-N",
    "STRATHEARN, OTTAWA": "OTT-STRT-N",
    "ARBEATHA PARK, OTTAWA": "OTT-ARBT-N",
    "ARLINGTON WOODS, OTTAWA": "OTT-ARLN-N",
    "BARRHAVEN, OTTAWA": "OTT-BRR1-N",
    "BAYSHORE, OTTAWA": "OTT-BYSH-N",
    "BELLS CORNERS, OTTAWA": "OTT-BLLS-N",
    "BORDEN FARM, OTTAWA": "OTT-BRDN-N",
    "BOYCE, OTTAWA": "OTT-BYCT-N",
    "BRIARGREEN, OTTAWA": "OTT-BRRG-N",
    "CEDARHILL ESTATE, OTTAWA": "OTT-CDRH-N",
    "CENTREPOINTE, OTTAWA": "OTT-CNT2-N",
    "CITY VIEW, OTTAWA": "OTT-CTYV-N",
    "CLEARVIEW, OTTAWA": "OTT-CLRV-N",
    "COUNTRY PLACE, OTTAWA": "OTT-CNT3-N",
    "CRAIG HENRY, OTTAWA": "OTT-CRGH-N",
    "CRESTVIEW, OTTAWA": "OTT-CRS2-N",
    "CRYSTAL BAY, OTTAWA": "OTT-CRYS-N",
    "CRYSTAL BEACH, OTTAWA": "OTT-CRY1-N",
    "DAVIDSON HEIGHTS, OTTAWA": "OTT-DVDS-N",
    "FALLOWFIELD, OTTAWA": "OTT-FLLW-N",
    "FISHER GLEN, OTTAWA": "OTT-FSHR-N",
    "FISHER HEIGHTS, OTTAWA": "OTT-FSH1-N",
    "FRASERVALE, OTTAWA": "OTT-FRSR-N",
    "GRAHAM PARK, OTTAWA": "OTT-GRHM-N",
    "GRENFELL GLEN, OTTAWA": "OTT-GRNF-N",
    "HEARTS DESIRE, OTTAWA": "OTT-HRTS-N",
    "HILLSDALE, OTTAWA": "OTT-HLLS-N",
    "JOCKVALE, OTTAWA": "OTT-JCKV-N",
    "KNOLLSBROOK, OTTAWA": "OTT-KNLL-N",
    "LESLIE PARK, OTTAWA": "OTT-LSLP-N",
    "LONGFIELDS, OTTAWA": "OTT-LNGF-N",
    "LYNWOOD VILLAGE, OTTAWA": "OTT-LYNW-N",
    "MANORDALE, OTTAWA": "OTT-MNRD-N",
    "MEADOWLANDS, OTTAWA": "OTT-MDWL-N",
    "THE MEADOWS, OTTAWA": "OTT-THMD-N",
    "MERIVALE GARDENS, OTTAWA": "OTT-MRVL-N",
    "NAVAHO, OTTAWA": "OTT-NVHT-N",
    "ORCHARD ESTATES, OTTAWA": "OTT-ORCH-N",
    "PARKWOOD HILLS, OTTAWA": "OTT-PRK1-N",
    "PHEASANT RUN, OTTAWA": "OTT-PHSN-N",
    "PINEGLEN, OTTAWA": "OTT-PNGL-N",
    "RIDEAU GLEN, OTTAWA": "OTT-RDGL-N",
    "ROCKY POINT, OTTAWA": "OTT-RCKY-N",
    "RYAN FARM, OTTAWA": "OTT-RYNF-N",
    "SHIRLEYS BAY, OTTAWA": "OTT-SHRL-N",
    "SKYLINE, OTTAWA": "OTT-SKYL-N",
    "STONEHEDGE, OTTAWA": "OTT-STNH-N",
    "TANGLEWOOD, OTTAWA": "OTT-TNGL-N",
    "TREND VILLAGE, OTTAWA": "OTT-TRND-N",
    "TWIN ELM, OTTAWA": "OTT-TWNL-N",
    "VALLEY STREAM, OTTAWA": "OTT-VLLY-N",
    "WESTCLIFFE ESTATES, OTTAWA": "OTT-WSTC-N",
    "NEPEAN, OTTAWA": "OTT-NPNT-N",
    "GLOUCESTER, OTTAWA": "OTT-GLC1-N",
    "CUMBERLAND, OTTAWA": "OTT-CMBR-N",
    "AVALON, OTTAWA": "OTT-AVLN-N",
    "BEARBROOK, OTTAWA": "OTT-BRBR-N",
    "BECKETT CREEK, OTTAWA": "OTT-BCKT-N",
    "BELLA VISTA, OTTAWA": "OTT-BLLV-N",
    "BURROMEE, OTTAWA": "OTT-BRRM-N",
    "CANAAN, OTTAWA": "OTT-CNNT-N",
    "CHAPERAL, OTTAWA": "OTT-CHPR-N",
    "CHARTRAND, OTTAWA": "OTT-CHRT-N",
    "CHATELAINE VILLAGE, OTTAWA": "OTT-CHTL-N",
    "CUMBERLAND VILLAGE, OTTAWA": "OTT-CMB1-N",
    "FALLINGBROOK, OTTAWA": "OTT-FLLN-N",
    "FRENCH HILL, OTTAWA": "OTT-FRNC-N",
    "LEONARD, OTTAWA": "OTT-LNRD-N",
    "MARTINS CORNERS, OTTAWA": "OTT-MRTN-N",
    "NOTRE-DAME-DES-CHAMPS, OTTAWA": "OTT-NTRD-N",
    "NAVAN, OTTAWA": "OTT-NVNT-N",
    "RIVER WALK, OTTAWA": "OTT-RVRW-N",
    "SARSFIELD, OTTAWA": "OTT-SRSF-N",
    "TOWN CENTRE (ORLEANS), OTTAWA": "OTT-TWNC-N",
    "QUEENSWOOD VILLAGE, OTTAWA": "OTT-QNS1-N",
    "VARS, OTTAWA": "OTT-VRST-N",
    "GOULBOURN, OTTAWA": "OTT-GLB1-N",
    "AMBERWOOD VILLAGE, OTTAWA": "OTT-AMBR-N",
    "ASHTON, OTTAWA": "OTT-ASHT-N",
    "BRYANSTON GATE, OTTAWA": "OTT-BRYN-N",
    "DWYER HILL, OTTAWA": "OTT-DWYR-N",
    "FRINGEWOOD, OTTAWA": "OTT-FRNG-N",
    "HEALEY'S HEATH, OTTAWA": "OTT-HLYS-N",
    "MANSFIELD, OTTAWA": "OTT-MNSF-N",
    "MUNSTER, OTTAWA": "OTT-MNST-N",
    "OLD STITTSVILLE, OTTAWA": "OTT-OLD1-N",
    "RED PINE ESTATES, OTTAWA": "OTT-RDPN-N",
    "RICHMOND, OTTAWA": "OTT-RCHM-N",
    "STANLEY CORNERS, OTTAWA": "OTT-STNL-N",
    "STAPLEDON, OTTAWA": "OTT-STPL-N",
    "STITTSVILLE, OTTAWA": "OTT-STTT-N",
    "WOODSIDE ACRES, OTTAWA": "OTT-WDSD-N",
    "OSGOODE TOWNSHIP, OTTAWA": "OTT-OSGD-N",
    "BELMEADE, OTTAWA": "OTT-BLMD-N",
    "DALMENY, OTTAWA": "OTT-DLMN-N",
    "GREELY, OTTAWA": "OTT-GRLY-N",
    "HERBERT CORNERS, OTTAWA": "OTT-HRB1-N",
    "KENMORE, OTTAWA": "OTT-KNMR-N",
    "MARIONVILLE, OTTAWA": "OTT-MRNV-N",
    "MARVELVILLE, OTTAWA": "OTT-MRV1-N",
    "METCALFE, OTTAWA": "OTT-MTCL-N",
    "OSGOODE, OTTAWA": "OTT-OSG1-N",
    "PANA, OTTAWA": "OTT-PNTT-N",
    "REIDS MILLS, OTTAWA": "OTT-RDSM-N",
    "SPRING HILL, OTTAWA": "OTT-SPRN-N",
    "VERNON, OTTAWA": "OTT-VRNN-N",
    "WEST OSGOODE, OTTAWA": "OTT-WSTS-N",
    "RIDEAU, OTTAWA": "OTT-RDTT-N",
    "MARLBOROUGH, OTTAWA": "OTT-MRLB-N",
    "BAXTERS CORNERS, OTTAWA": "OTT-BXTR-N",
    "BECKETTS LANDING, OTTAWA": "OTT-BCK1-N",
    "BURRITTS RAPIDS, OTTAWA": "OTT-BRRT-N",
    "GOODSTOWN, OTTAWA": "OTT-GDST-N",
    "MALAKOFF, OTTAWA": "OTT-MLKF-N",
    "MILLS CORNERS, OTTAWA": "OTT-MLLS-N",
    "MOORES CORNERS, OTTAWA": "OTT-MRSC-N",
    "PIERCES CORNERS, OTTAWA": "OTT-PRCS-N",
    "NORTH GOWER, OTTAWA": "OTT-NRT3-N",
    "CARSONBY, OTTAWA": "OTT-CRS3-N",
    "KARS, OTTAWA": "OTT-KRST-N",
    "MANOTICK, OTTAWA": "OTT-MNT1-N",
    "REEVECRAIG, OTTAWA": "OTT-RVCR-N",
    "WATTERSON CORNERS, OTTAWA": "OTT-WTTR-N",
    "WEST CARLETON, OTTAWA": "OTT-WST3-N",
    "ANTRIM, OTTAWA": "OTT-ANTR-N",
    "FITZROY HARBOUR, OTTAWA": "OTT-FTZR-N",
    "GALETTA, OTTAWA": "OTT-GLTT-N",
    "KINBURN, OTTAWA": "OTT-KNBR-N",
    "MARATHON, OTTAWA": "OTT-MRTH-N",
    "MARATHON VILLAGE, OTTAWA": "OTT-MRT1-N",
    "MARSHALL BAY, OTTAWA": "OTT-MRSH-N",
    "MOHR CORNERS, OTTAWA": "OTT-MHRC-N",
    "PANMURE, OTTAWA": "OTT-PNMR-N",
    "QUYON FERRY LANDING, OTTAWA": "OTT-QYNF-N",
    "SMITH'S CORNERS, OTTAWA": "OTT-SMTH-N",
    "VYDON ACRES, OTTAWA": "OTT-VYDN-N",
    "WILLOLA BEACH, OTTAWA": "OTT-WLLL-N",
    "WOODRIDGE, OTTAWA": "OTT-WDRD-N",
    "FITZROY, OTTAWA": "OTT-FTZ1-N",
    "HUNTLEY, OTTAWA": "OTT-HNTL-N",
    "CARP, OTTAWA": "OTT-CRPT-N",
    "CORKERY, OTTAWA": "OTT-CRKR-N",
    "HUNTLEY MANOR ESTATES, OTTAWA": "OTT-HNT2-N",
    "MANION CORNERS, OTTAWA": "OTT-MNNC-N",
    "WESTMONT ESTATES, OTTAWA": "OTT-WST4-N",
    "WESTWOOD, OTTAWA": "OTT-WSTW-N",
    "TORBOLTON, OTTAWA": "OTT-TRBL-N",
    "BASKIN'S BEACH, OTTAWA": "OTT-BSKN-N",
    "BUCKHAMS BAY, OTTAWA": "OTT-BCKH-N",
    "CONSTANCE BAY, OTTAWA": "OTT-CNST-N",
    "CROWN POINT, OTTAWA": "OTT-CRWN-N",
    "DIRLETON, OTTAWA": "OTT-DRLT-N",
    "DUNROBIN, OTTAWA": "OTT-DNRB-N",
    "KILMAURS, OTTAWA": "OTT-KLMR-N",
    "MACLARENS, OTTAWA": "OTT-MCLR-N",
    "MCKAY'S WATERFRONT, OTTAWA": "OTT-MCKY-N",
    "TORWOOD ESTATES, OTTAWA": "OTT-TRWD-N",
    "WOODLAWN, OTTAWA": "OTT-WDLW-N",
    "AMBERWOOD, OTTAWA": "OTT-AMB1-N",
    "APPLEWOOD ACRES, OTTAWA": "OTT-APPL-N",
    "ATHANS PARK, OTTAWA": "OTT-ATHN-N",
    "BARRHAVEN MEWS, OTTAWA": "OTT-BRR2-N",
    "BARRHAVEN ON THE GREEN, OTTAWA": "OTT-BRR3-N",
    "BEACON HEIGHTS, OTTAWA": "OTT-BCN1-N",
    "BEACON HILL NORTH, OTTAWA": "OTT-BCN2-N",
    "BEACON HILL SOUTH, OTTAWA": "OTT-BCN3-N",
    "BEACONWOOD VILLAGE, OTTAWA": "OTT-BCNW-N",
    "BEL AIR HEIGHTS, OTTAWA": "OTT-BLR1-N",
    "BEL AIR PARK, OTTAWA": "OTT-BLR2-N",
    "BELL'S CORNER, OTTAWA": "OTT-BLL1-N",
    "BLAIR COURT, OTTAWA": "OTT-BLRC-N",
    "BORDEN FARM PARK, OTTAWA": "OTT-BRD2-N",
    "BRADLEY ESTATES, OTTAWA": "OTT-BRD3-N",
    "BRAEMER PARK, OTTAWA": "OTT-BRM1-N",
    "BRIAR GREEN, OTTAWA": "OTT-BRR4-N",
    "BRITANNIA BAY, OTTAWA": "OTT-BRT3-N",
    "BROOKSIDE, OTTAWA": "OTT-BRKS-N",
    "CANADIAN NATIONAL RESOURCE COUNCIL, OTTAWA": "OTT-CNDN-N",
    "CARDINAL CREEK, OTTAWA": "OTT-CRDN-N",
    "CARDINAL HEIGHTS, OTTAWA": "OTT-CRD1-N",
    "CARELTON SQUARE, OTTAWA": "MIS-CRL2-N",
    "ABSOLUTE CONDOMINIUMS, MISSISSAUGA": "MIS-ABSL-N",
    "APPLEWOOD, MISSISSAUGA": "MIS-APP1-N",
    "CENTRAL ERIN MILLS, MISSISSAUGA": "MIS-CNT4-N",
    "CHELSEA TOWERS, MISSISSAUGA": "MIS-CHLS-N",
    "CHURCHILL MEADOWS, MISSISSAUGA": "MIS-CHR1-N",
    "CITY CENTRE, MISSISSAUGA": "MIS-CTYC-N",
    "CLARKSON, MISSISSAUGA": "MIS-CLRK-N",
    "COOKSVILLE, MISSISSAUGA": "MIS-CKSV-N",
    "CREDITVIEW, MISSISSAUGA": "MIS-CRDT-N",
    "DIXIE, MISSISSAUGA": "MIS-DXMS-N",
    "EAST CREDIT, MISSISSAUGA": "MIS-ESTC-N",
    "ERIN MILLS, MISSISSAUGA": "MIS-ERNM-N",
    "ERINDALE, MISSISSAUGA": "MIS-ERND-N",
    "FAIRVIEW, MISSISSAUGA": "MIS-FRVW-N",
    "GATEWAY, MISSISSAUGA": "MIS-GTWY-N",
    "HURONTARIO, MISSISSAUGA": "MIS-HRNT-N",
    "KANEFF CRESCENT, MISSISSAUGA": "MIS-KNFF-N",
    "LAKEVIEW, MISSISSAUGA": "MIS-LKVW-N",
    "LISGAR, MISSISSAUGA": "MIS-LSGR-N",
    "LORNE PARK, MISSISSAUGA": "MIS-LRNP-N",
    "LORNE PARK ESTATES, MISSISSAUGA": "MIS-LRN1-N",
    "MALTON, MISSISSAUGA": "MIS-MLTN-N",
    "MAVIS-ERINDALE, MISSISSAUGA": "MIS-MVSR-N",
    "MEADOWVALE, MISSISSAUGA": "MIS-MDWV-N",
    "MEADOWVALE BUSINESS PARK, MISSISSAUGA": "MIS-MDW1-N",
    "MEADOWVALE NORTH BUSINESS PARK, MISSISSAUGA": "MIS-MDW2-N",
    "MEADOWVALE VILLAGE, MISSISSAUGA": "MIS-MDW3-N",
    "MINEOLA, MISSISSAUGA": "MIS-MNLM-N",
    "MISSISSAUGA VALLEYS, MISSISSAUGA": "MIS-MSSS-N",
    "NORTHEAST MISSISSAUGA, MISSISSAUGA": "MIS-NRT4-N",
    "OVATION AT CITY CENTRE, MISSISSAUGA": "MIS-OVTN-N",
    "PORT CREDIT, MISSISSAUGA": "MIS-PRTC-N",
    "RATHWOOD, MISSISSAUGA": "MIS-RTH1-N",
    "SHERIDAN, MISSISSAUGA": "MIS-SHRD-N",
    "SOUTHDOWN, MISSISSAUGA": "MIS-STHD-N",
    "STREETSVILLE, MISSISSAUGA": "MIS-STR1-N",
    "THE CAPITAL CONDOMINIUMS, MISSISSAUGA": "MIS-THCP-N",
    "UNIVERSITY OF TORONTO AT MISSISSAUGA, MISSISSAUGA": "MIS-UNV1-N",
    "VILLAGE CENTRE, MISSISSAUGA": "MIS-VLLG-N",
    "WESTERN BUSINESS PARK, MISSISSAUGA": "BRA-WST5-N",
    "AVONDALE, BRAMPTON": "BRA-AVN1-N",
    "BRAM EAST, BRAMPTON": "BRA-BRMS-N",
    "BRAMALEA NORTH INDUSTRIAL, BRAMPTON": "BRA-BRML-N",
    "BRAMALEA SOUTH INDUSTRIAL, BRAMPTON": "BRA-BRM2-N",
    "BRAMPTON 407 CORRIDOR, BRAMPTON": "BRA-BRMP-N",
    "BRAMPTON EAST, BRAMPTON": "BRA-BRM3-N",
    "BRAMPTON EAST INDUSTRIAL, BRAMPTON": "BRA-BRM4-N",
    "BRAMPTON NORTH, BRAMPTON": "BRA-BRM5-N",
    "BRAMPTON SOUTH, BRAMPTON": "BRA-BRM6-N",
    "BRAMPTON WEST, BRAMPTON": "BRA-BRM7-N",
    "BRAMPTON WEST INDUSTIRAL, BRAMPTON": "BRA-BRM8-N",
    "CASTLEMORE CROSSING, BRAMPTON": "BRA-CST1-N",
    "CENTRAL PARK, BRAMPTON": "BRA-CNT5-N",
    "CREDIT VALLEY, BRAMPTON": "BRA-CRD2-N",
    "DOWNTOWN BRAMPTON, BRAMPTON": "BRA-DWN2-N",
    "FLETCHER'S MEADOW, BRAMPTON": "BRA-FLTC-N",
    "FLETCHERS CREEK SOUTH, BRAMPTON": "BRA-FLT1-N",
    "FLETCHERS CREEK VILLAGE, BRAMPTON": "BRA-FLT2-N",
    "FLETCHERS WEST, BRAMPTON": "BRA-FLT3-N",
    "GORE INDUSTRIAL NORTH, BRAMPTON": "BRA-GRND-N",
    "HEART LAKE EAST, BRAMPTON": "BRA-HRTL-N",
    "HEAT LAKE WEST, BRAMPTON": "BRA-HTLK-N",
    "HIGHWAY 427, BRAMPTON": "BRA-HGHW-N",
    "HUTTONVILLE, BRAMPTON": "BRA-HTTN-N",
    "MADOC, BRAMPTON": "BRA-MDCB-N",
    "NORTHGATE, BRAMPTON": "BRA-NRT5-N",
    "NORTHWEST BRAMPTON, BRAMPTON": "BRA-NRT6-N",
    "NORTHWEST SANDALWOOD PARKWAY, BRAMPTON": "BRA-NRT7-N",
    "NORWOOD PARK, BRAMPTON": "BRA-NRWD-N",
    "PARKWAY BELT INDUSTRIAL AREA, BRAMPTON": "BRA-PRK2-N",
    "QUEEN STREET CORRIDOR, BRAMPTON": "BRA-QNST-N",
    "SANDRINGHAM-WELLINGTON, BRAMPTON": "BRA-SNDR-N",
    "SANDRINGHAM-WELLINGTON NORTH, BRAMPTON": "BRA-SND1-N",
    "SNELGROVE, BRAMPTON": "BRA-SNLG-N",
    "SOUTHGATE, BRAMPTON": "BRA-STH2-N",
    "STEELES INDUSTRIAL, BRAMPTON": "BRA-STL1-N",
    "TORONTO GORE RURAL ESTATE, BRAMPTON": "BRA-TRN1-N",
    "VALES OF CASTLEMORE, BRAMPTON": "BRA-VLSF-N",
    "VALES OF CASTLEMORE NORTH, BRAMPTON": "BRA-VLS1-N",
    "WESTGATE, BRAMPTON": "HAM-WSTG-N",
    "AINSLIE WOOD, HAMILTON": "HAM-ANSL-N",
    "AINSLIE WOOD EAST, HAMILTON": "HAM-ANS1-N",
    "AINSLIE WOOD NORTH, HAMILTON": "HAM-ANS2-N",
    "AINSLIE WOOD WEST, HAMILTON": "HAM-ANS3-N",
    "ALBERTON, HAMILTON": "HAM-ALBR-N",
    "ALBION, HAMILTON": "HAM-ALBN-N",
    "ALBION FALLS, HAMILTON": "HAM-ALB1-N",
    "ALLISON, HAMILTON": "HAM-ALLS-N",
    "BAKELEY, HAMILTON": "HAM-BKLY-N",
    "BALFOUR, HAMILTON": "HAM-BLFR-N",
    "BALTIMORE, HAMILTON": "HAM-BLTM-N",
    "BARNSTOWN, HAMILTON": "HAM-BRNS-N",
    "BARTONVILLE, HAMILTON": "HAM-BRT4-N",
    "BATTLEFIELD, HAMILTON": "HAM-BTTL-N",
    "BAYVIEW, HAMILTON": "HAM-BYV2-N",
    "BEASLEY, HAMILTON": "HAM-BSLY-N",
    "BERRISFIELD, HAMILTON": "HAM-BRRS-N",
    "BEWDLEY, HAMILTON": "HAM-BWDL-N",
    "BINBROOK, HAMILTON": "HAM-BNB1-N",
    "BONNINGTON, HAMILTON": "HAM-BNNN-N",
    "BOOK, HAMILTON": "HAM-BKHM-N",
    "BOWMAN, HAMILTON": "HAM-BWMN-N",
    "BROUGHTON EAST, HAMILTON": "HAM-BRGH-N",
    "BROUGHTON WEST, HAMILTON": "HAM-BRG1-N",
    "BRULEVILLE, HAMILTON": "HAM-BRLV-N",
    "BUCHANAN, HAMILTON": "HAM-BCHN-N",
    "BURKHOLME, HAMILTON": "HAM-BRK1-N",
    "BUTLER, HAMILTON": "HAM-BTLR-N",
    "CARLISLE, HAMILTON": "HAM-CRL3-N",
    "CARLUKE, HAMILTON": "HAM-CRLK-N",
    "CARPENTER, HAMILTON": "HAM-CRPN-N",
    "CENTRAL HAMILTON, HAMILTON": "HAM-CNT6-N",
    "CENTREMOUNT, HAMILTON": "HAM-CNT7-N",
    "CHAPPEL EAST, HAMILTON": "HAM-CHPP-N",
    "CHAPPEL WEST, HAMILTON": "HAM-CHP1-N",
    "CHEDOKE PARK, HAMILTON": "HAM-CHDK-N",
    "CLEARVIEW, HAMILTON": "HAM-CLR1-N",
    "COLBORNE, HAMILTON": "HAM-CLBR-N",
    "CONFEDERATION PARK, HAMILTON": "HAM-CNF1-N",
    "COPETOWN, HAMILTON": "HAM-CPTW-N",
    "CORKTOWN, HAMILTON": "HAM-CRKT-N",
    "CORMAN, HAMILTON": "HAM-CRMN-N",
    "CREIGHTON EAST, HAMILTON": "HAM-CRG1-N",
    "CREIGHTON WEST, HAMILTON": "HAM-CRG2-N",
    "CRERAR, HAMILTON": "HAM-CRRR-N",
    "CROWN POINT EAST, HAMILTON": "HAM-CRW1-N",
    "CROWN POINT WEST, HAMILTON": "HAM-CRW2-N",
    "DELTA EAST, HAMILTON": "LON-DLTS-N",
    "ANDOVER TRAILS, LONDON": "LON-ANDV-N",
    "ARGYLE, LONDON": "LON-ARGY-N",
    "ARGYLE PARK, LONDON": "LON-ARG1-N",
    "BALLYMOTE WOODS, LONDON": "LON-BLLY-N",
    "BELLWOOD PARK, LONDON": "LON-BLLW-N",
    "BERKSHIRE VILLAGE, LONDON": "LON-BRK2-N",
    "BISHOP HELLMUTH HERITAGE DISTRICT, LONDON": "LON-BSHP-N",
    "BLACKFRIARS-PETERSVILLE HERITAGE DISTRICT, LONDON": "LON-BLC2-N",
    "BONAVENTURE MEADOWS, LONDON": "LON-BNVN-N",
    "BOSTWICK, LONDON": "LON-BSTW-N",
    "BRADLEY, LONDON": "LON-BRD4-N",
    "BROCKLEY, LONDON": "LON-BRCK-N",
    "BROUGHDALE, LONDON": "LON-BRG2-N",
    "BYRON, LONDON": "LON-BYRN-N",
    "CARLING, LONDON": "LON-CRL4-N",
    "CARLING HEIGHTS, LONDON": "LON-CRL5-N",
    "CEDAR HOLLOW, LONDON": "LON-CDR1-N",
    "CHELSEA GREEN, LONDON": "LON-CHL1-N",
    "CHELSEA HEIGHTS, LONDON": "LON-CHL2-N",
    "CHERRYHILL, LONDON": "LON-CHRR-N",
    "CHESHAM ESTATES, LONDON": "LON-CHSH-N",
    "CLEARDALE, LONDON": "LON-CLRD-N",
    "COBBLESTONE GATE, LONDON": "LON-CBBL-N",
    "COPPERFIELD, LONDON": "LON-CPPR-N",
    "CRUMLIN, LONDON": "LON-CRML-N",
    "DEER RIDGE, LONDON": "LON-DRRD-N",
    "DEER RIDGE WEST, LONDON": "LON-DRR1-N",
    "DOWNTOWN LONDON, LONDON": "LON-DWN3-N",
    "DUNDAS STREET, LONDON": "LON-DNDS-N",
    "EAGLE RIDGE, LONDON": "LON-EGLR-N",
    "EALING, LONDON": "LON-ELNG-N",
    "EAST LONDON, LONDON": "LON-EST1-N",
    "FAIRMONT, LONDON": "LON-FRMN-N",
    "FANSHAWE, LONDON": "LON-FNSH-N",
    "FANSHAWE RIDGE, LONDON": "LON-FNS1-N",
    "FOREST HILL, LONDON": "LON-FRS2-N",
    "FOX FIELD, LONDON": "LON-FXFL-N",
    "FOX HOLLOW, LONDON": "LON-FXHL-N",
    "GLANWORTH, LONDON": "LON-GLNW-N",
    "GLEN CAIRN, LONDON": "LON-GLN1-N",
    "GRENFELL VILLAGE, LONDON": "LON-GRN1-N",
    "HALE STREET DISTRICT, LONDON": "LON-HLST-N",
    "HAMILTON ROAD, LONDON": "LON-HMLT-N",
    "HAZELDEN, LONDON": "LON-HZLD-N",
    "HAZELDEN NORTH, LONDON": "LON-HZL1-N",
    "HAZELDEN PARK, LONDON": "LON-HZL2-N",
    "HICKORY HEIGHTS, LONDON": "LON-HCKR-N",
    "HIGHBURY, LONDON": "MAR-HGHB-N",
    "AILEEN WILLOW BROOK, MARKHAM": "MAR-ALNW-N",
    "ANGUS GLEN, MARKHAM": "MAR-ANGS-N",
    "BAYVIEW FAIRWAY - BAYVIEW COUNTRY CLUB ESTATES, MARKHAM": "MAR-BYV3-N",
    "BAYVIEW GLEN, MARKHAM": "MAR-BYV4-N",
    "BERCZY, MARKHAM": "MAR-BRCZ-N",
    "BOX GROVE, MARKHAM": "MAR-BXGR-N",
    "BULLOCK, MARKHAM": "MAR-BLLC-N",
    "BUTTONVILLE, MARKHAM": "MAR-BTTN-N",
    "CACHET, MARKHAM": "MAR-CCHT-N",
    "CATHEDRALTOWN, MARKHAM": "MAR-CTHD-N",
    "CEDAR GROVE, MARKHAM": "MAR-CDRG-N",
    "CEDARWOOD, MARKHAM": "MAR-CDRW-N",
    "COMMERCE VALLEY, MARKHAM": "MAR-CMMR-N",
    "CORNELL, MARKHAM": "MAR-CRNL-N",
    "DEVIL'S ELBOW, MARKHAM": "MAR-DVLS-N",
    "GERMAN MILLS, MARKHAM": "MAR-GRMN-N",
    "GRANDVIEW, MARKHAM": "MAR-GRN2-N",
    "GREENSBOROUGH, MARKHAM": "MAR-GRNS-N",
    "LANGSTAFF SOUTH, MARKHAM": "MAR-LNGS-N",
    "LEGACY, MARKHAM": "MAR-LGCY-N",
    "MARKHAM VILLAGE, MARKHAM": "MAR-MRKH-N",
    "MARKVILLE, MARKHAM": "MAR-MRKV-N",
    "MIDDLEFIELD, MARKHAM": "MAR-MDDL-N",
    "MILLIKEN MILLS EAST, MARKHAM": "MAR-MLL1-N",
    "MILLIKEN MILLS WEST, MARKHAM": "MAR-MLL2-N",
    "OLD MARKHAM VILLAGE, MARKHAM": "MAR-OLDM-N",
    "RAYMERVILLE, MARKHAM": "MAR-RYMR-N",
    "ROUGE FAIRWAYS, MARKHAM": "MAR-RGFR-N",
    "ROUGE RIVER ESTATES, MARKHAM": "MAR-RGRV-N",
    "ROYAL ORCHARD, MARKHAM": "MAR-RYLR-N",
    "SHERWOOD - AMBERGLEN, MARKHAM": "MAR-SHRW-N",
    "THORNHILL, MARKHAM": "MAR-THR1-N",
    "THORNLEA, MARKHAM": "MAR-THR2-N",
    "UNIONVILLE, MARKHAM": "MAR-UNNV-N",
    "VICTORIA MANOR - JENNINGS GATE, MARKHAM": "MAR-VCT2-N",
    "VICTORIA SQUARE, MARKHAM": "MAR-VCT3-N",
    "VILLAGE GREEN - SOUTH UNIONVILLE, MARKHAM": "MAR-VLL1-N",
    "VINEGAR HILL, MARKHAM": "MAR-VNGR-N",
    "WISMER, MARKHAM": "VAU-WSMR-N",
    "BEVERLEY GLEN": "VAU-BVRL-N",
    "BROWNRIDGE": "VAU-BRWN-N",
    "CONCORD": "VAU-CNCR-N",
    "CRESTWOOD - SPRINGFARM - YORKHILL": "VAU-CRS4-N",
    "EAST WOODBRIDGE": "VAU-EST2-N",
    "ELDER MILLS": "VAU-ELDR-N",
    "GLEN SHIELDS": "VAU-GLNS-N",
    "ISLINGTON WOODS": "VAU-ISL1-N",
    "LAKEVIEW ESTATES": "VAU-LKV1-N",
    "MAPLE": "BUR-BRL17-N",
    "PATTERSON": "VAU-PTTR-N",
    "PINE VALLEY BUSINESS PARK": "VAU-PNVL-N",
    "SONOMA HEIGHTS": "VAU-SNMH-N",
    "STEELES WEST INDUSTRIAL": "VAU-STL2-N",
    "UPLANDS": "VAU-UPLN-N",
    "VAUGHAN CORPORATE CENTRE": "VAU-VGHN-N",
    "VAUGHAN GROVE": "VAU-VGH1-N",
    "VELLORE VILLAGE": "VAU-VLLR-N",
    "WEST WOODBRIDGE": "VAU-WST6-N",
    "WEST WOODBRIDGE INDUSTRIAL AREA": "KIT-WST7-N",
    "ALPINE": "KIT-ALPN-N",
    "BRIDGEPORT KIWANIS PARK": "KIT-BRDG-N",
    "BRIGADOON/HURON PARK": "KIT-BRGD-N",
    "CENTREVILLE/CHICOPEE": "KIT-CNT8-N",
    "AUDITORIUM": "KIT-ADTR-N",
    "BRIDGEPORT": "KIT-BRD5-N",
    "BRIDGEPORT EAST": "KIT-BRD6-N",
    "BRIDGEPORT NORTH": "KIT-BRD7-N",
    "BRIDGEPORT WEST": "KIT-BRD8-N",
    "BRIGADOON": "KIT-BRG3-N",
    "CARYNDALE": "KIT-CRYN-N",
    "CEDAR HILL": "KIT-CDR2-N",
    "CENTRAL FREDERICK": "KIT-CNT9-N",
    "CENTRE DISTRICT": "KIT-CNT10-N",
    "CENTREVILLE CHICOPEE": "KIT-CNT11-N",
    "CHANDLER - MOWAT": "KIT-CHND-N",
    "CHERRY HILL": "KIT-CHR2-N",
    "CITY COMMERCIAL CORE": "KIT-CTY1-N",
    "CIVIC CENTRE": "KIT-CVCC-N",
    "COUNTRY HILLS": "KIT-CNT12-N",
    "COUNTRY HILLS EAST": "KIT-CNT13-N",
    "COUNTRY HILLS WEST": "KIT-CNT14-N",
    "DEER RIDGE ESTATES": "KIT-DRR2-N",
    "DOON SOUTH": "KIT-DNST-N",
    "DUNDEE": "DND-TS",
    "EASTWOOD": "KIT-EST3-N",
    "FAIRFIELD": "KIT-FRFL-N",
    "FOREST HEIGHTS": "KIT-FRS3-N",
    "FOREST HILL": "KIT-FRS4-N",
    "GRAND HILL VILLAGE": "KIT-GRN3-N",
    "GRAND RIVER NORTH": "KIT-GRN4-N",
    "GRAND RIVER SOUTH": "KIT-GRN5-N",
    "GREENBELT": "KIT-GRN6-N",
    "HERITAGE PARK": "KIT-HRTG-N",
    "HIDDEN VALLEY": "KIT-HDDN-N",
    "HIGHLAND WEST": "KIT-HGH3-N",
    "HIGHLAND-STIRLING": "KIT-HGH4-N",
    "HURON PARK": "KIT-HRN1-N",
    "HURON SOUTH": "KIT-HRNS-N",
    "IDLEWOOD": "KIT-IDLW-N",
    "INNOVATION DISTRICT": "KIT-INNV-N",
    "KING EAST": "KIT-KNG2-N",
    "KW HOSPITAL": "KIT-KWHS-N",
    "LARENTIAN WEST": "KIT-LRNT-N",
    "LOWER DOON": "KIT-LWRD-N",
    "MARKET DISTRICT": "KIT-MRKT-N",
    "MEINZINGER": "KIT-MNZN-N",
    "MILL COURTLAND WOODSIDE PARK": "KIT-MLLC-N",
    "MOUNT HOPE HURON PARK": "KIT-MNTH-N",
    "NORTHWARD": "WIN-NRT8-N",
    "BRIDGEVIEW, WINDSOR": "WIN-BRD9-N",
    "CENTRAL WINDSOR, WINDSOR": "WIN-CNT15-N",
    "DEVONSHIRE, WINDSOR": "WIN-DVNS-N",
    "DOWNTOWN WINDSOR, WINDSOR": "WIN-DWN4-N",
    "EAST RIVERSIDE, WINDSOR": "WIN-ESTR-N",
    "EAST WINDSOR, WINDSOR": "WIN-EST4-N",
    "EASTGATE ESTATES, WINDSOR": "WIN-ESTG-N",
    "FONTAINBLEU, WINDSOR": "WIN-FNTN-N",
    "FORD CITY, WINDSOR": "WIN-FRDC-N",
    "FORD-FERNDALE, WINDSOR": "WIN-FRDF-N",
    "FOREST GLADE, WINDSOR": "WIN-FRS5-N",
    "HEART OF WINDSOR, WINDSOR": "WIN-HRTF-N",
    "HILLSIDE PARK, WINDSOR": "WIN-HLL1-N",
    "KENILWORTH GARDENS, WINDSOR": "WIN-KNLW-N",
    "LITTLE ITALY, WINDSOR": "WIN-LTT1-N",
    "LITTLE RIVER ACRES, WINDSOR": "WIN-LTT2-N",
    "MALDEN, WINDSOR": "WIN-MLDN-N",
    "MEADOWBROOK, WINDSOR": "WIN-MDWB-N",
    "MIDTOWN, WINDSOR": "WIN-MDTW-N",
    "OTTAWA STREET VILLAGE, WINDSOR": "WIN-OTTW-N",
    "PEACHTREE VILLAGE, WINDSOR": "WIN-PCHT-N",
    "PELTON, WINDSOR": "WIN-PLTN-N",
    "PILLETTE ROAD VILLAGE, WINDSOR": "WIN-PLLT-N",
    "POLONIA PARK, WINDSOR": "WIN-PLNP-N",
    "REMINGTON PARK, WINDSOR": "WIN-RMNG-N",
    "RENDEZVOUS SHORES, WINDSOR": "WIN-RNDZ-N",
    "RIVERSIDE, WINDSOR": "WIN-RVR2-N",
    "ROSELAND, WINDSOR": "WIN-RSLN-N",
    "ROSEVILLE GARDENS, WINDSOR": "WIN-RSVL-N",
    "SANDWICH, WINDSOR": "WIN-SNDW-N",
    "SANDWICH HERITAGE DISTRICT, WINDSOR": "WIN-SND2-N",
    "SANDWICH SOUTH, WINDSOR": "WIN-SND3-N",
    "SOUTH CAMERON, WINDSOR": "WIN-STHC-N",
    "SOUTH CENTRAL, WINDSOR": "WIN-STH3-N",
    "SOUTH WALKERVILLE, WINDSOR": "WIN-STHW-N",
    "SOUTH WINDSOR, WINDSOR": "WIN-STH4-N",
    "SOUTHWOOD LAKES, WINDSOR": "WIN-STH5-N",
    "SPRING GARDEN, WINDSOR": "WIN-SPR1-N",
    "WALKER FARM, WINDSOR": "WIN-WLKR-N",
    "WALKER GATES, WINDSOR": "WIN-WLK1-N",
    "WALKERVILLE, WINDSOR": "WIN-WLK2-N",
    "WEST WINDSOR, WINDSOR": "WIN-WST8-N",
    "WINDSOR UNIVERSITY DISTRICT, WINDSOR": "WIN-WND1-N",
    "WYANDOTTE TOWNE CENTRE, WINDSOR": "WIN-WYND-N",
    "YAWKEY, WINDSOR": "OAK-YWKY-N",
    "OAKVILLE, 407 NORTH": "OAK-OKVL-N",
    "OAKVILLE, 407 WEST": "OAK-OKV1-N",
    "OAKVILLE, BRONTE": "OAK-OKV2-N",
    "OAKVILLE, BRONTE CREEK": "OAK-OKV3-N",
    "OAKVILLE, BRONTE EAST": "OAK-OKV4-N",
    "OAKVILLE, BRONTE PARK": "OAK-OKV5-N",
    "OAKVILLE, BRONTE WEST": "OAK-OKV6-N",
    "OAKVILLE, CENTRAL OAKVILLE": "OAK-OKV7-N",
    "OAKVILLE, CHARTWELL DISTRICT": "OAK-OKV8-N",
    "OAKVILLE, CLEARVIEW": "OAK-OKV9-N",
    "OAKVILLE, COLLEGE PARK": "OAK-OKV10-N",
    "OAKVILLE, CORNWALL DISTRICT": "OAK-OKV11-N",
    "OAKVILLE, DOWNTOWN OAKVILLE": "OAK-OKV12-N",
    "OAKVILLE, EASTLAKE": "OAK-OKV13-N",
    "OAKVILLE, FALGARWOOD": "OAK-OKV14-N",
    "OAKVILLE, FORD": "OAK-OKV15-N",
    "OAKVILLE, GLEN ABBEY": "OAK-OKV16-N",
    "OAKVILLE, GLENORCHY": "OAK-OKV17-N",
    "OAKVILLE, IROQUOIS RIDGE NORTH": "OAK-OKV18-N",
    "OAKVILLE, JOSHUA CREEK": "OAK-OKV19-N",
    "OAKVILLE, JOSHUA'S MEADOWS": "OAK-OKV20-N",
    "OAKVILLE, LYONS DISTRICT": "OAK-OKV21-N",
    "OAKVILLE, MORRISON": "OAK-OKV22-N",
    "OAKVILLE, OLD OAKVILLE": "OAK-OKV23-N",
    "OAKVILLE, PALERMO WEST": "OAK-OKV24-N",
    "OAKVILLE, QUEEN ELIZABETH COMMERCIAL ZONE": "OAK-OKV25-N",
    "OAKVILLE, RIVER OAKS": "OAK-OKV26-N",
    "OAKVILLE, SIXTEEN HOLLOW": "OAK-OKV27-N",
    "OAKVILLE, SOUTHWEST OAKVILLE": "OAK-OKV28-N",
    "OAKVILLE, WEDGEWOOD CREEK": "OAK-OKV29-N",
    "OAKVILLE, WEST OAKVILLE": "OAK-OKV30-N",
    "OAKVILLE, WESTMOUNT": "OAK-OKV31-N",
    "OAKVILLE, WESTOAK TRAILS": "OAK-OKV32-N",
    "OAKVILLE, WINSTON PARK": "RIC-OKV33-N",
    "RICHMOND HILL, BAYVIEW HILL": "RIC-RCH1-N",
    "RICHMOND HILL, BEAVER CREEK BUSINESS PARK": "RIC-RCH2-N",
    "RICHMOND HILL, CROSBY": "RIC-RCH3-N",
    "RICHMOND HILL, DEVONSLEIGH": "RIC-RCH4-N",
    "RICHMOND HILL, DONCREST": "RIC-RCH5-N",
    "RICHMOND HILL, HARDING": "RIC-RCH6-N",
    "RICHMOND HILL, HEADFORD BUSINESS PARK": "RIC-RCH7-N",
    "RICHMOND HILL, JEFFERSON": "RIC-RCH8-N",
    "RICHMOND HILL, LANGSTAFF": "RIC-RCH9-N",
    "RICHMOND HILL, MILL POND": "RIC-RCH10-N",
    "RICHMOND HILL, NORTH RICHVALE": "RIC-RCH11-N",
    "RICHMOND HILL, OAK RIDGES": "RIC-RCH12-N",
    "RICHMOND HILL, OAK RIDGES LAKE WILCOX": "RIC-RCH13-N",
    "RICHMOND HILL, OBSERVATORY": "RIC-RCH14-N",
    "RICHMOND HILL, ROUGE WOODS": "RIC-RCH15-N",
    "RICHMOND HILL, RURAL RICHMOND HILL": "RIC-RCH16-N",
    "RICHMOND HILL, SOUTH RICHVALE": "RIC-RCH17-N",
    "RICHMOND HILL, WESTBROOK": "BUR-RCH18-N",
    "ALDERSHOT CENTRAL": "BUR-BRLN-N",
    "ALDERSHOT EAST": "BUR-BRL1-N",
    "ALDERSHOT SOUTH": "BUR-BRL2-N",
    "ALDERSHOT WEST": "BUR-BRL3-N",
    "ALTON VILLAGE": "BUR-BRL4-N",
    "APPLEBY": "BUR-BRL5-N",
    "BAYVIEW": "BUR-BRL6-N",
    "BRANT HILLS": "BUR-BRL8-N",
    "BURLINGTON INDUSTRIAL AREA": "BUR-BRL9-N",
    "CORPORATE": "BUR-BRL10-N",
    "DYNES": "BUR-BRL11-N",
    "ELIZABETH GARDENS": "BUR-BRL12-N",
    "FREEMAN": "BUR-BRL13-N",
    "HEADON FOREST": "BUR-BRL14-N",
    "LONGMOOR": "BUR-BRL16-N",
    "MILCROFT": "BUR-BRL18-N",
    "MOUNTAINSIDE": "BUR-BRL19-N",
    "PALMER": "BUR-BRL20-N",
    "ROSELAND": "BUR-BRL21-N",
    "SHELDON CREEK": "BUR-BRL22-N",
    "SHOREACRES": "BUR-BRL23-N",
    "TANSLEY WOODS": "BUR-BRL24-N",
    "THE ORCHARD": "BUR-BRL25-N",
    "TYANDAGA": "BUR-BRL26-N",
    "UPTOWN": "OSH-BRL27-N",
    "OSHAWA, BEATON": "OSH-OSHW-N",
    "OSHAWA, CENTENNIAL": "OSH-OSH1-N",
    "OSHAWA, CENTRAL OSHAWA": "OSH-OSH2-N",
    "OSHAWA, DONEVAN": "OSH-OSH3-N",
    "OSHAWA, DOWNTOWN OSHAWA": "OSH-OSH4-N",
    "OSHAWA, EASTDALE": "OSH-OSH5-N",
    "OSHAWA, FAREWELL": "OSH-OSH6-N",
    "OSHAWA, KEDRON": "OSH-OSH7-N",
    "OSHAWA, LAKEVIEW": "OSH-OSH8-N",
    "OSHAWA, MCLAUGHLIN": "OSH-OSH9-N",
    "OSHAWA, NORTHGLEN": "OSH-OSH10-N",
    "OSHAWA, NORTHWOOD": "OSH-OSH11-N",
    "OSHAWA, O'NEILL": "OSH-OSH12-N",
    "OSHAWA, PINECREST": "OSH-OSH13-N",
    "OSHAWA, RAGLAN": "OSH-OSH14-N",
    "OSHAWA, SAMAC": "OSH-OSH15-N",
    "OSHAWA, STEVENSON": "OSH-OSH16-N",
    "OSHAWA, TAUNTON": "OSH-OSH17-N",
    "OSHAWA, VANIER": "OSH-OSH18-N",
    "OSHAWA, WINDFIELDS": "MIL-OSH19-N",
    "MILTON, 401 BUSINESS PARK": "MIL-MLT1-N",
    "MILTON, BEATY": "MIL-MLT2-N",
    "MILTON, BOWES": "MIL-MLT3-N",
    "MILTON, BOWES WEST": "MIL-MLT4-N",
    "MILTON, BRONTE MEADOWS": "MIL-MLT5-N",
    "MILTON, BROOKVILLE": "MIL-MLT6-N",
    "MILTON, CAMPBELLVILLE": "MIL-MLT7-N",
    "MILTON, CLARKE": "MIL-MLT8-N",
    "MILTON, COATES": "MIL-MLT9-N",
    "MILTON, COBBAN": "MIL-MLT10-N",
    "MILTON, DEMPSEY": "MIL-MLT11-N",
    "MILTON, DORSET PARK": "MIL-MLT12-N",
    "MILTON, ESQUESING": "MIL-MLT13-N",
    "MILTON, FALLINGBROOK": "MIL-MLT14-N",
    "MILTON, FORD": "MIL-MLT15-N",
    "MILTON, FOREST GROVE": "MIL-MLT16-N",
    "MILTON, HARRISON": "MIL-MLT17-N",
    "MILTON, MILTON HEIGHTS": "MIL-MLT18-N",
    "MILTON, MOFFAT": "MIL-MLT19-N",
    "MILTON, MOUNTAIN VIEW": "MIL-MLT20-N",
    "MILTON, OLD MILTON": "MIL-MLT21-N",
    "MILTON, SCOTT": "MIL-MLT22-N",
    "MILTON, TIMBERLEA": "MIL-MLT23-N",
    "MILTON, VALLEY VIEW": "MIL-MLT24-N",
    "MILTON, WALKER": "MIL-MLT25-N",
    "MILTON, WILLMOTT": "GRE-MLT26-N",
    "GREATER SUDBURY, ADAMSDALE": "GRE-GRTR-N",
    "GREATER SUDBURY, ADANAC": "GRE-GRT1-N",
    "GREATER SUDBURY, ALGONQUIN": "GRE-GRT2-N",
    "GREATER SUDBURY, BELL GROVE": "GRE-GRT3-N",
    "GREATER SUDBURY, BELL PARK": "GRE-GRT4-N",
    "GREATER SUDBURY, BRODIE": "GRE-GRT5-N",
    "GREATER SUDBURY, CAMBRIAN": "GRE-GRT6-N",
    "GREATER SUDBURY, CONISTON": "GRE-GRT7-N",
    "GREATER SUDBURY, COPPER CLIFF": "GRE-GRT8-N",
    "GREATER SUDBURY, COPPER PARK": "GRE-GRT9-N",
    "GREATER SUDBURY, DON LITA": "GRE-GRT10-N",
    "GREATER SUDBURY, DONOVAN": "GRE-GRT11-N",
    "GREATER SUDBURY, ELM WEST": "GRE-GRT12-N",
    "GREATER SUDBURY, FLOUR MILL": "GRE-GRT13-N",
    "GREATER SUDBURY, GARSON": "GRE-GRT14-N",
    "GREATER SUDBURY, GATCHELL": "GRE-GRT15-N",
    "GREATER SUDBURY, HISTORIC DOWNTOWN SUDBURY": "GRE-GRT16-N",
    "GREATER SUDBURY, KINGSMOUNT": "GRE-GRT17-N",
    "GREATER SUDBURY, LEBEL": "GRE-GRT18-N",
    "GREATER SUDBURY, LITTLE BRITIAN": "GRE-GRT19-N",
    "GREATER SUDBURY, LIVELY": "GRE-GRT20-N",
    "GREATER SUDBURY, LO-ELLEN": "GRE-GRT21-N",
    "GREATER SUDBURY, LOCKERBY": "GRE-GRT22-N",
    "GREATER SUDBURY, MIKKOLA SUBDIVISION": "GRE-GRT23-N",
    "GREATER SUDBURY, MONTROSE": "GRE-GRT24-N",
    "GREATER SUDBURY, MOONGLOW": "GRE-GRT25-N",
    "GREATER SUDBURY, MOONLIGHT RIDGE": "GRE-GRT26-N",
    "GREATER SUDBURY, NICKEL CENTRE": "GRE-GRT27-N",
    "GREATER SUDBURY, NICKELDALE": "GRE-GRT28-N",
    "GREATER SUDBURY, NORTHERN HEIGHTS": "GRE-GRT29-N",
    "GREATER SUDBURY, PRIMEAUVILLE": "GRE-GRT30-N",
    "GREATER SUDBURY, ROBINSON SUBDIVISION": "GRE-GRT31-N",
    "GREATER SUDBURY, RURAL SUDBURY": "GRE-GRT32-N",
    "GREATER SUDBURY, SUNRISE RIDGE": "GRE-GRT33-N",
    "GREATER SUDBURY, WESTMOUNT": "GRE-GRT34-N",
    "GREATER SUDBURY, WOODBINE": "GRE-GRT35-N",
    "400 EAST": "BAR-BRR5-N",
    "400 NORTH": "BAR-BRRN-N",
    "400 WEST": "BAR-BRRW-N",
    "ALLANDALE": "BAR-BRRL-N",
    "ALLANDALE CENTRE": "BAR-BRR6-N",
    "ALLANDALE HEIGHTS": "BAR-BRR7-N",
    "ALLIANCE": "BAR-BRR8-N",
    "ARDAGH": "BAR-BRRR-N",
    "BAYFIELD": "BAR-BRRB-N",
    "BAYSHORE": "BAR-BRR9-N",
    "BAYSHORE ESTATES": "BAR-BRR10-N",
    "BROCK PARK HISTORIC DISTRICT": "BAR-BRR11-N",
    "CITY CENTER": "BAR-BRRC-N",
    "CODRINGTON": "BAR-BRR12-N",
    "COUNTRY CLUB ESTATES": "BAR-BRR13-N",
    "CUNDLES EAST": "BAR-BRR14-N",
    "EAST BAYFIELD": "BAR-BRR15-N",
    "EDGEHILL DRIVE": "BAR-BRRD-N",
    "FOREST HILL - ARDAGH BLUFFS": "BAR-BRRF-N",
    "FOREST HILL ESTATES": "BAR-BRR16-N",
    "GEORGIAN DRIVE": "BAR-BRR17-N",
    "GROVE EAST": "BAR-BRR18-N",
    "HEWITT'S": "BAR-BRR19-N",
    "HOLLY": "BAR-BRR20-N",
    "INNIS SHORE": "BAR-BRR21-N",
    "LAKEWYND INNIS SHORES": "BAR-BRR23-N",
    "LETITIA HEIGHTS": "BAR-BRR24-N",
    "LIONS GATE": "BAR-BRR25-N",
    "LITTLE LAKE": "BAR-BRR26-N",
    "LITTLE LAKE ESTATES": "BAR-BRR27-N",
    "LIVINGSTONE HEIGHTS": "BAR-BRR28-N",
    "MAPLE WOODLANDS": "BAR-BRR30-N",
    "MAPLECORT": "BAR-BRR31-N",
    "NORTHWEST BARRIE": "BAR-BRR32-N",
    "OSPREY RIDGE": "BAR-BRR33-N",
    "PAINSWICK NORTH": "BAR-BRRP-N",
    "PAINSWICK SOUTH": "BAR-BRR34-N",
    "PRINCE WILLIAM GATE": "BAR-BRR35-N",
    "PRINCETON WOODS": "BAR-BRR36-N",
    "QUEEN'S PARK": "BAR-BRRQ-N",
    "QUEENS PARK HISTORIC DISTRICT": "BAR-BRR37-N",
    "RIVERWOOD": "BAR-BRR38-N",
    "SAINT VINCENT ESTATES": "BAR-BRR39-N",
    "SALEM": "BAR-BRR40-N",
    "SANDY HOLLOW": "BAR-BRR41-N",
    "SANFORD": "BAR-BRR42-N",
    "GUELPH, ARBORETUM": "GUE-GLPH-N",
    "GUELPH, BRANT": "GUE-GLP1-N",
    "GUELPH, CLAIRFIELDS": "GUE-GLP2-N",
    "GUELPH, EDEN MILLS": "GUE-GLP3-N",
    "GUELPH, EXHIBITION PARK": "GUE-GLP4-N",
    "GUELPH, GRANGE HILL EAST": "GUE-GLP5-N",
    "GUELPH, GUELPH DOWNTOWN": "GUE-GLP6-N",
    "GUELPH, GUELPH SOUTH": "GUE-GLP7-N",
    "GUELPH, GUELPH VILLAGE": "GUE-GLP8-N",
    "GUELPH, HANLON CREEK": "GUE-GLP9-N",
    "GUELPH, HANLON INDUSTIRAL": "GUE-GLP10-N",
    "GUELPH, JUNE AVENUE": "GUE-GLP11-N",
    "GUELPH, KORTRIGHT HILLS": "GUE-GLP12-N",
    "GUELPH, MARKET SQUARE": "GUE-GLP13-N",
    "GUELPH, NORTHWEST INDUSTRIAL PARK": "GUE-GLP14-N",
    "GUELPH, OLD UNIVERSITY": "GUE-GLP15-N",
    "GUELPH, ONWARD WILLOW": "GUE-GLP16-N",
    "GUELPH, PARKWOOD GARDENS": "GUE-GLP17-N",
    "GUELPH, PRIORY PARK": "GUE-GLP18-N",
    "GUELPH, ROCKWOOD": "GUE-GLP19-N",
    "GUELPH, SAINT GEORGES": "GUE-GLP20-N",
    "GUELPH, ST GEORGE'S SQUARE": "GUE-GLP21-N",
    "GUELPH, THE JUNCTION": "GUE-GLP22-N",
    "GUELPH, TWO RIVERS": "GUE-GLP23-N",
    "GUELPH, WAVERLEY": "GUE-GLP24-N",
    "GUELPH, WEST WILLOW VILLAGE": "GUE-GLP25-N",
    "GUELPH, WEST WILLOW WOODS": "GUE-GLP26-N",
    "GUELPH, WESTMINSTER WOODS": "GUE-GLP27-N",
    "GUELPH, YORK": "WHI-GLP28-N",
    "WHITBY, BLUE GRASS MEADOWS": "WHI-WHTB-N",
    "WHITBY, BROOKLIN": "WHI-WHT1-N",
    "WHITBY, DOWNTOWN WHITBY": "WHI-WHT2-N",
    "WHITBY, LYNDE CREEK": "WHI-WHT3-N",
    "WHITBY, PORT WHITBY": "WHI-WHT4-N",
    "WHITBY, PRINGLE CREEK": "WHI-WHT5-N",
    "WHITBY, ROLLING ACRES": "WHI-WHT6-N",
    "WHITBY, TAUNTON NORTH": "WHI-WHT7-N",
    "WHITBY, WHITBY INDUSTRIAL": "WHI-WHT8-N",
    "WHITBY, WILLIAMSBURG": "AJA-WHT9-N",
    "AJAX, APPLECROFT": "AJA-AJXP-N",
    "AJAX, AUDLEY NORTH": "AJA-AJXD-N",
    "AJAX, AUDLEY SOUTH": "AJA-AJX1-N",
    "AJAX, CARRUTHERS CREEK": "AJA-AJXC-N",
    "AJAX, CARRUTHERS CREEK BUSINESS AREA": "AJA-AJX2-N",
    "AJAX, CENTRAL AJAX EMPLOYMENT AREA": "AJA-AJX3-N",
    "AJAX, CLOVER RIDGE": "AJA-AJX4-N",
    "AJAX, DEER CREEK": "AJA-AJX5-N",
    "AJAX, DISCOVERY BAY": "AJA-AJX6-N",
    "AJAX, DOWNTOWN AJAX": "AJA-AJX7-N",
    "AJAX, DUFFINS BAY": "AJA-AJX8-N",
    "AJAX, HERMITAGE": "AJA-AJXH-N",
    "AJAX, LAKE VISTA": "AJA-AJXL-N",
    "AJAX, LAKESIDE": "AJA-AJX9-N",
    "AJAX, MEADOW RIDGE": "AJA-AJXM-N",
    "AJAX, MEMORIAL VILLAGE": "AJA-AJX10-N",
    "AJAX, MIDTOWN": "AJA-AJX11-N",
    "AJAX, NOTTINGHAM": "AJA-AJXN-N",
    "AJAX, PICKERING BEACH": "AJA-AJX12-N",
    "AJAX, RIVERSIDE": "AJA-AJXR-N",
    "AJAX, SALEM HEIGHTS": "AJA-AJXS-N",
    "AJAX, SOUTH GREENWOOD": "AJA-AJX13-N",
    "AJAX, SOUTHWOOD": "AJA-AJX14-N",
    "AJAX, VILLAGE": "AJA-AJXV-N",
    "AJAX, WESTNEY HEIGHTS": "STC-AJXW-N",
    "ST CATHERINES, BARBICAN HEIGHTS": "STC-STCT-N",
    "ST CATHERINES, BUNTING": "STC-STC1-N",
    "ST CATHERINES, BURLEIGH HILL": "STC-STC2-N",
    "ST CATHERINES, CARLTON": "STC-STC3-N",
    "ST CATHERINES, DOWNTOWN ST CATHARINES": "STC-STC4-N",
    "ST CATHERINES, FACER": "STC-STC5-N",
    "ST CATHERINES, FAIRVIEW": "STC-STC6-N",
    "ST CATHERINES, FITZGERALD": "STC-STC7-N",
    "ST CATHERINES, FONTHILL": "STC-STC8-N",
    "ST CATHERINES, GLENRIDGE": "STC-STC9-N",
    "ST CATHERINES, GRANTHAM EAST": "STC-STC10-N",
    "ST CATHERINES, GRANTHAM WEST": "STC-STC11-N",
    "ST CATHERINES, KERNAHAN": "STC-STC12-N",
    "ST CATHERINES, LAKEPORT": "STC-STC13-N",
    "ST CATHERINES, LAKESHORE": "STC-STC14-N",
    "ST CATHERINES, LANCASTER": "STC-STC15-N",
    "ST CATHERINES, LOCK 3": "STC-STC16-N",
    "ST CATHERINES, MARSDALE": "STC-STC17-N",
    "ST CATHERINES, MARTINDALE": "STC-STC18-N",
    "ST CATHERINES, MERRITTON": "STC-STC19-N",
    "ST CATHERINES, MICHIGAN BEACH": "STC-STC20-N",
    "ST CATHERINES, OAKDALE": "STC-STC21-N",
    "ST CATHERINES, ORCHARD PARK": "STC-STC22-N",
    "ST CATHERINES, PORT DALHOUSIE": "STC-STC23-N",
    "ST CATHERINES, PORT WELLER": "STC-STC24-N",
    "ST CATHERINES, POWER GLEN": "STC-STC25-N",
    "ST CATHERINES, QUEENSTON": "STC-STC26-N",
    "ST CATHERINES, RIVERVIEW": "STC-STC27-N",
    "ST CATHERINES, SECORD WOODS": "STC-STC28-N",
    "ST CATHERINES, ST GEORGE'S POINT": "STC-STC29-N",
    "ST CATHERINES, THE HAIG": "STC-STC30-N",
    "ST CATHERINES, VANSICKLE": "STC-STC31-N",
    "ST CATHERINES, WESTERN HILL": "CAM-STC32-N",
    "CAMBRIDGE, ALISON": "CAM-CMB2-N",
    "CAMBRIDGE, BLAIR ROAD": "CAM-CMB3-N",
    "CAMBRIDGE, CHRISTOPHER-CHAMPLAIN": "CAM-CMB4-N",
    "CAMBRIDGE, DOWNTOWN CAMBRIDGE": "CAM-CMB5-N",
    "CAMBRIDGE, EAST GALT": "CAM-CMB6-N",
    "CAMBRIDGE, EAST HESPELER": "CAM-CMB7-N",
    "CAMBRIDGE, FIDDLESTICKS": "CAM-CMB8-N",
    "CAMBRIDGE, GALT CITY CENTRE": "CAM-CMB9-N",
    "CAMBRIDGE, GREENWAY-CHAPLIN": "CAM-CMB10-N",
    "CAMBRIDGE, HESPELER VILLAGE": "CAM-CMB11-N",
    "CAMBRIDGE, LANG'S FARM": "CAM-CMB12-N",
    "CAMBRIDGE, LITTLE'S CORNERS": "CAM-CMB13-N",
    "CAMBRIDGE, POPCORN HOUSE": "CAM-CMB14-N",
    "CAMBRIDGE, PRESTON CENTRE": "CAM-CMB15-N",
    "CAMBRIDGE, PRESTON HEIGHTS": "CAM-CMB16-N",
    "CAMBRIDGE, RIVERWALK": "CAM-CMB17-N",
    "CAMBRIDGE, SILVER HEIGHTS": "CAM-CMB18-N",
    "CAMBRIDGE, SOUTHWOOD": "CAM-CMB19-N",
    "CAMBRIDGE, ST ANDREWS ESTATES": "KIN-CMB20-N",
    "KINGSTON, ALWINGTON": "KIN-KNG3-N",
    "KINGSTON, ARBOUR RIDGE": "KIN-KNG4-N",
    "KINGSTON, AUDEN PARK": "KIN-KNG5-N",
    "KINGSTON, BARRIEFIELD VILLAGE HERITAGE DISTRICT": "KIN-KNG6-N",
    "KINGSTON, BAYRIDGE EAST": "KIN-KNG7-N",
    "KINGSTON, BAYRIDGE WEST": "KIN-KNG8-N",
    "KINGSTON, BAYSHORE ESTATES": "KIN-KNG9-N",
    "KINGSTON, CALVIN PARK": "KIN-KNG10-N",
    "KINGSTON, CATARAQUI NORTH": "KIN-KNG11-N",
    "KINGSTON, CATARAQUI RIVER EAST": "KIN-KNG12-N",
    "KINGSTON, CATARAQUI WESTBROOK": "KIN-KNG13-N",
    "KINGSTON, CATARAQUI WOODS": "KIN-KNG14-N",
    "KINGSTON, CFB KINGSTON": "KIN-KNG15-N",
    "KINGSTON, COLLINS BAY PENITENTIARY": "KIN-KNG16-N",
    "KINGSTON, COUNTRY CLUB ESTATES": "KIN-KNG17-N",
    "KINGSTON, DOWNTOWN KINGSTON": "KIN-KNG18-N",
    "KINGSTON, ELGINBURG - SILVER CORNERS - SHANNONS CORNERS": "KIN-KNG19-N",
    "KINGSTON, FAIRWAY HILLS": "KIN-KNG20-N",
    "KINGSTON, GARDINERS": "KIN-KNG21-N",
    "KINGSTON, GLENBURNIE": "KIN-KNG22-N",
    "KINGSTON, GREENWOOD": "KIN-KNG23-N",
    "KINGSTON, GRENVILLE PARK": "KIN-KNG24-N",
    "KINGSTON, HENDERSON": "KIN-KNG25-N",
    "KINGSTON, HILLENDALE": "KIN-KNG26-N",
    "KINGSTON, INNER HARBOUR": "KIN-KNG27-N",
    "KINGSTON, JOYCEVILLE": "KIN-KNG28-N",
    "KINGSTON, KINGS LANDING": "KIN-KNG29-N",
    "KINGSTON, KINGSCOURT": "KIN-KNG30-N",
    "KINGSTON, KINGSTON MILLS": "KIN-KNG31-N",
    "KINGSTON, LAWRENCE PARK": "KIN-KNG32-N",
    "KINGSTON, LEMOINE POINT": "KIN-KNG33-N",
    "KINGSTON, MACLEAN PARK - RIVERWALK": "KIN-KNG34-N",
    "KINGSTON, MARKERS ACRES": "KIN-KNG35-N",
    "KINGSTON, MARKET SQUARE HERITAGE DISTRICT": "KIN-KNG36-N",
    "KINGSTON, MEADOWBROOK": "KIN-KNG37-N",
    "KINGSTON, MIDLAND PARK": "KIN-KNG38-N",
    "KINGSTON, MILE SQUARE": "KIN-KNG39-N",
    "KINGSTON, NOVELIS": "KIN-KNG40-N",
    "KINGSTON, OLD SYDENHAM HERITAGE DISTRICT": "KIN-KNG41-N",
    "KINGSTON, POLSON PARK": "KIN-KNG42-N",
    "KINGSTON, PORTSMOUTH": "KIN-KNG43-N",
    "KINGSTON, QUEENS": "KIN-KNG44-N",
    "KINGSTON, RAVENSVIEW": "KIN-KNG45-N",
    "KINGSTON, REDDENDALE": "KIN-KNG46-N",
    "KINGSTON, RIDEAU HEIGHTS": "KIN-KNG47-N",
    "KINGSTON, RIDGEWOOD ESTATES": "KIN-KNG48-N",
    "KINGSTON, RIVER PARK": "KIN-KNG49-N",
    "KINGSTON, SAINT LAWRENCE NORTH": "KIN-KNG50-N",
    "WATERLOO, BEECHWOOD": "KIN-WTRL-N",
    "WATERLOO, BEECHWOOD NORTH": "KIN-WTR1-N",
    "WATERLOO, BEECHWOOD PARK": "KIN-WTR2-N",
    "WATERLOO, BEECHWOOD SOUTH": "KIN-WTR3-N",
    "WATERLOO, BEECHWOOD WEST": "KIN-WTR4-N",
    "WATERLOO, BRIDLEGATE": "KIN-WTR5-N",
    "WATERLOO, CLAIR HILLS": "KIN-WTR6-N",
    "WATERLOO, COLONIAL ACRES": "KIN-WTR7-N",
    "WATERLOO, COLUMBIA FOREST": "KIN-WTR8-N",
    "WATERLOO, CRAIGLEITH": "KIN-WTR9-N",
    "WATERLOO, DOWNTOWN WATERLOO": "KIN-WTR10-N",
    "WATERLOO, EASTBRIDGE": "KIN-WTR11-N",
    "WATERLOO, GLASGOW HEIGHTS 2": "KIN-WTR12-N",
    "WATERLOO, GLASGOW HEIGHTS I": "KIN-WTR13-N",
    "WATERLOO, KIWANIS PARK": "KIN-WTR14-N",
    "WATERLOO, LAKESHORE": "KIN-WTR15-N",
    "WATERLOO, LAKESHORE EAST": "KIN-WTR16-N",
    "WATERLOO, LAUREL CREEK": "KIN-WTR17-N",
    "WATERLOO, LAURELWOOD": "KIN-WTR18-N",
    "WATERLOO, LEXINGTON": "KIN-WTR19-N",
    "WATERLOO, LINCOLN HEIGHTS": "KIN-WTR20-N",
    "WATERLOO, LINCOLN VILLAGE": "KIN-WTR21-N",
    "WATERLOO, MAPLE HILLS": "KIN-WTR22-N",
    "WATERLOO, MARY ALLEN": "KIN-WTR23-N",
    "WATERLOO, NORTH LAKESHORE": "KIN-WTR24-N",
    "WATERLOO, RIM PARK": "KIN-WTR25-N",
    "WATERLOO, RUMMELHARDT": "KIN-WTR26-N",
    "WATERLOO, SUNNYDALE": "KIN-WTR27-N",
    "WATERLOO, UNIVERSITY DOWNS": "KIN-WTR28-N",
    "WATERLOO, UPPER BEECHWOOD": "KIN-WTR29-N",
    "WATERLOO, UPTOWN WATERLOO": "KIN-WTR30-N",
    "WATERLOO, UPTOWN WEST": "KIN-WTR31-N",
    "WATERLOO, VERMONT": "KIN-WTR32-N",
    "WATERLOO, CLAIR CREEK": "KIN-WTR33-N",
    "WATERLOO, VISTA HILLS": "KIN-WTR34-N",
    "WATERLOO, WESTVALE": "THU-WTR35-N",
    "THUNDER BAY, ACADEMY HEIGHTS": "FRI-THND-N",
    "THUNDER BAY, COLLEGE HEIGHTS": "SAT-THN1-N",
    "THUNDER BAY, COLLEGE PARK": "SUN-THN2-N",
    "THUNDER BAY, COUNTY PARK": "MON-THN3-N",
    "THUNDER BAY, COURT-CUMBERLAND": "TUE-THN4-N",
    "THUNDER BAY, CURRENT RIVER": "WED-THN5-N",
    "THUNDER BAY, DAWSON HEIGHTS": "THU-THN6-N",
    "THUNDER BAY, DOWNTOWN FORT WILLIAM": "FRI-THN7-N",
    "THUNDER BAY, DOWNTOWN PORT ARTHUR": "SAT-THN8-N",
    "THUNDER BAY, EAST END": "SUN-THN9-N",
    "THUNDER BAY, EDGEWATER PARK": "MON-THN10-N",
    "THUNDER BAY, FOREST PARK": "TUE-THN11-N",
    "THUNDER BAY, GREEN ACRES": "WED-THN12-N",
    "THUNDER BAY, INTERCITY": "THU-THN13-N",
    "THUNDER BAY, JUMBO GARDENS": "FRI-THN14-N",
    "THUNDER BAY, MCKELLAR PARK": "SAT-THN15-N",
    "THUNDER BAY, MCVICAR CREEK - HARRINGTON COURT": "SUN-THN16-N",
    "THUNDER BAY, MOUNT FOREST ESTATES": "MON-THN17-N",
    "THUNDER BAY, MOUNTVIEW": "TUE-THN18-N",
    "THUNDER BAY, NORTHWOOD": "WED-THN19-N",
    "THUNDER BAY, PARKDALE": "THU-THN20-N",
    "THUNDER BAY, PRINCE ARTHURS LANDING": "FRI-THN21-N",
    "THUNDER BAY, RIVER TERRACE": "SAT-THN22-N",
    "THUNDER BAY, RIVERVIEW TERRACE": "SUN-THN23-N",
    "THUNDER BAY, ROSSLYN": "MON-THN24-N",
    "THUNDER BAY, SHERWOOD ESTATES": "TUE-THN25-N",
    "THUNDER BAY, SHUNIAH": "WED-THN26-N",
    "THUNDER BAY, SIMPSON-OGDEN": "THU-THN27-N",
    "THUNDER BAY, VICKERS HEIGHTS": "FRI-THN28-N",
    "THUNDER BAY, VICKERS PARK": "SAT-THN29-N",
    "THUNDER BAY, WAVERLY PARK HERITAGE": "SUN-THN30-N",
    "THUNDER BAY, WEST END": "MON-THN31-N",
    "THUNDER BAY, WESTFORT": "TUE-THN32-N",
    "THUNDER BAY, WESTFORT VILLAGE": "CLA-THN33-N",
    "CLARINGTON, BOWMANVILLE": "CLA-CLRN-N",
    "CLARINGTON, COURTICE": "CLA-CLR2-N",
    "CLARINGTON, NEWCASTLE": "CLA-CLR3-N",
    "CLARINGTON, ORONO": "BRA-CLR4-N",
    "BRANTFORD, AVA HEIGHTS-GOLFDALE": "BRA-BRNT-N",
    "BRANTFORD, BRANEIDA INDUSTRIAL PARK": "BRA-BRN1-N",
    "BRANTFORD, BRANT'S CROSSING BUSINESS AREA": "BRA-BRN2-N",
    "BRANTFORD, BRIER PARK": "BRA-BRN3-N",
    "BRANTFORD, CITY CENTRE & ACADEMIC DISTRICT": "BRA-BRN4-N",
    "BRANTFORD, COLBORNE": "BRA-BRN5-N",
    "BRANTFORD, DOWNTOWN BRANTFORD": "BRA-BRN6-N",
    "BRANTFORD, EAGLE PLACE": "BRA-BRN7-N",
    "BRANTFORD, EAST WARD": "BRA-BRN8-N",
    "BRANTFORD, EASTWARD CREEK": "BRA-BRN9-N",
    "BRANTFORD, ECHO PLACE": "BRA-BRN10-N",
    "BRANTFORD, FAIRVIEW": "BRA-BRN11-N",
    "BRANTFORD, GREENBRIER": "BRA-BRN12-N",
    "BRANTFORD, HENDERSON-SKY ACRES": "BRA-BRN13-N",
    "BRANTFORD, HOLMESDALE-LANSDOWNE": "BRA-BRN14-N",
    "BRANTFORD, LYNDEN HILLS": "BRA-BRN15-N",
    "BRANTFORD, MARKET STREET VILLAGE": "BRA-BRN16-N",
    "BRANTFORD, MAYFAIR": "BRA-BRN17-N",
    "BRANTFORD, MOHAWK GREENWICH": "BRA-BRN18-N",
    "BRANTFORD, NORTH WARD": "BRA-BRN19-N",
    "BRANTFORD, SHELLARD LANE": "BRA-BRN20-N",
    "BRANTFORD, TERRACE HILL": "BRA-BRN21-N",
    "BRANTFORD, WEST BRANT": "BRA-BRN22-N",
    "SUMMERSIDE": "SMMR-C",
    "BORDEN-CARLETON": "BRDN-T",
    "KENSINGTON": "SAS-KNS1",
    "NORTH RUSTICO": "NRTH-T",
    "O'LEARY": "OLRY-T",
    "THREE RIVERS": "THRR-T",
    "TIGNISH": "TGNS-T",
    "TIGNISH SHORE": "TGN1-M",
    "RESORT MUNICIPALITY OF STANLEY BRIDGE": "STNL-RS",
    "RESORT MUNICIPALITY OF HOPE RIVER": "HPRV-RS",
    "RESORT MUNICIPALITY OF BAYVIEW": "BYVW-RS",
    "RESORT MUNICIPALITY OF CAVENDISH": "CVND-RS",
    "RESORT MUNICIPALITY OF NORTH RUSTICO": "NRT1-RS",
    "ABRAM-VILLAGE": "ABRM-RM",
    "ALEXANDRA": "ALXN-RM",
    "ANNANDALE-LITTLE POND-HOWE BAY": "ANNN-RM",
    "BEDEQUE & AREA": "BDQR-RM",
    "BELFAST": "BLFS-RM",
    "BREADALBANE": "BRDL-RM",
    "CENTRAL KINGS": "CNTR-RM",
    "CENTRAL PRINCE": "CNT1-RM",
    "CLYDE RIVER": "CLYD-RM",
    "CRAPAUD": "CRPD-RM",
    "EASTERN KINGS": "ESTR-RM",
    "GREENMOUNT-MONTROSE": "GRNM-RM",
    "HAMPSHIRE": "HMPS-RM",
    "HAZELBROOK": "HZLB-RM",
    "HUNTER RIVER": "HNTR-RM",
    "KINKORA": "KNKR-RM",
    "LINKLETTER": "LNKL-RM",
    "LOT 11 & AREA": "LTR-RM",
    "MALPEQUE BAY": "MLPQ-RM",
    "MILTONVALE PARK": "MLTN-RM",
    "MIMINEGASH": "MMNG-RM",
    "MISCOUCHE": "MSCC-RM",
    "MORELL": "MRLL-RM",
    "MOUNT STEWART": "MNTS-RM",
    "MURRAY HARBOUR": "MRRY-RM",
    "MURRAY RIVER": "MRR1-RM",
    "NORTH SHORE": "NRT2-RM",
    "NORTH WILTSHIRE": "NRT3-RM",
    "NORTHPORT": "NRT4-RM",
    "PLEASANT GROVE": "PLSN-RM",
    "SHERBROOKE": "SHRB-T",
    "SOURIS WEST": "SRSW-RM",
    "ST FELIX": "STFL-RM",
    "ST LOUIS": "STLS-V",
    "ST NICHOLAS": "STNC-RM",
    "ST PETERS": "STPT-RM",
    "TYNE VALLEY": "TYNV-RM",
    "UNION ROAD": "UNNR-RM",
    "WARREN GROVE": "WRRN-RM",
    "WELLINGTON": "WLLN-RM",
    "WEST RIVER": "WSTR-RM",
    "DOWNTOWN CHARLOTTETOWN, CHARLOTTETOWN": "CHA-DTCH-N",
    "BRIGHTON, CHARLOTTETOWN": "CHA-BRGT-N",
    "SPRING PARK, CHARLOTTETOWN": "CHA-SPPR-N",
    "PARKDALE, CHARLOTTETOWN": "CHA-PRKD-N",
    "SHERWOOD, CHARLOTTETOWN": "CHA-SHRW-N",
    "EAST ROYALTY, CHARLOTTETOWN": "CHA-ESTY-N",
    "HILLSBOROUGH PARK, CHARLOTTETOWN": "CHA-HLSB-N",
    "WEST ROYALTY, CHARLOTTETOWN": "CHA-WRYT-N",
    "WINSLOE, CHARLOTTETOWN": "CHA-WNSL-N",
    "LEWIS POINT, CHARLOTTETOWN": "CHA-LWPT-N",
    "BEACH GROVE, CHARLOTTETOWN": "CHA-BCGR-N",
    "LÉVIS": "LVS-C",
    "MONTREAL": "MNTR-C",
    "RIGAUD": "RGD-C",
    "CITY OF SAINT-HONORÉ": "SNTH-C",
    "CITY OF SAINT-HONORE": "SNTH-C",
    "SAINT-HONORÉ": "SNTH-C",
    "SAINT-PHILIPPE": "SNTP-C",
    "SAINTE-BRIGITTE-DE-LAVAL": "SNTB-C",
    "SHANNON": "SHNN-C",
    "ADSTOCK": "ADST-M",
    "AGUANISH": "AGNS-M",
    "ALBANEL": "ALBN-M",
    "ALBERTVILLE": "ALBR-V",
    "ALLEYN-ET-CAWOOD": "ALLY-M",
    "ANGE-GARDIEN": "ANGG-M",
    "ARMAGH": "ARMG-M",
    "ASCOT CORNER": "ASCT-M",
    "ASTON-JONCTION": "ASTN-M",
    "AUCLAIR": "ACLR-M",
    "AUDET": "ADT-M",
    "AUSTIN": "AST1-M",
    "AUTHIER": "ATHR-M",
    "AUTHIER-NORD": "ATH1-M",
    "BAIE-DES-SABLES": "BDSS-M",
    "BAIE-DU-FEBVRE": "BDFB-M",
    "BAIE-JOHAN-BEETZ": "BJHN-M",
    "BAIE-SAINTE-CATHERINE": "BSNT-M",
    "BARNSTON-OUEST": "BRNS-M",
    "BARRAUTE": "BRRT-M",
    "BATISCAN": "BTSC-M",
    "BÉARN": "BRN-M",
    "BEAULAC-GARTHBY": "BLCG-M",
    "BÉGIN": "BGN-M",
    "BELCOURT": "BLCR-M",
    "BERRY": "BRRY-M",
    "BERTHIER-SUR-MER": "BRTH-M",
    "BÉTHANIE": "BTHN-M",
    "BIENCOURT": "BNCR-M",
    "BLANC-SABLON": "BLNC-M",
    "BLUE SEA": "BLS-M",
    "BOILEAU": "BL-M",
    "BOIS-FRANC": "BSFR-M",
    "BOISCHATEL": "BSCH-M",
    "BOLTON-EST": "BLTN-M",
    "BOLTON-OUEST": "BLT1-M",
    "BONNE-ESPÉRANCE": "BNNS-M",
    "BONSECOURS": "BNSC-M",
    "BOUCHETTE": "BCHT-M",
    "BOWMAN": "BWMN-M",
    "BRIGHAM": "BRGH-M",
    "BRISTOL": "BRST-M",
    "BRYSON": "BRYS-M",
    "BURY": "BRY-M",
    "CACOUNA": "CCN-M",
    "CALIXA-LAVALLÉE": "CLXL-M",
    "CAMPBELL'S BAY": "CMPB-M",
    "CANTLEY": "CNTL-M",
    "CAP-SAINT-IGNACE": "CPSN-M",
    "CAPLAN": "CPLN-M",
    "CASCAPÉDIA--SAINT-JULES": "CSCP-M",
    "CAYAMANT": "CYMN-M",
    "CHAMBORD": "CHMB-M",
    "CHAMPNEUF": "CHM1-M",
    "CHARETTE": "CHRT-M",
    "CHARTIERVILLE": "CHR1-M",
    "CHAZEL": "CHZL-M",
    "CHELSEA": "CHLS-M",
    "CHÉNÉVILLE": "CHNV-M",
    "CHERTSEY": "CHR2-M",
    "CHESTERVILLE": "CHST-M",
    "CHUTE-SAINT-PHILIPPE": "CHTS-M",
    "CLARENDON": "CLRN-M",
    "CLERVAL": "CLRV-M",
    "COLOMBIER": "CLMB-M",
    "COMPTON": "CMPT-M",
    "CÔTE-NORD-DU-GOLFE-DU-SAINT-LAURENT": "CTNR-M",
    "COURCELLES": "CRCL-M",
    "CRABTREE": "CRBT-M",
    "DÉLÉAGE": "DLG-M",
    "DENHOLM": "DNHL-V",
    "DESCHAILLONS-SUR-SAINT-LAURENT": "DSCH-M",
    "DESCHAMBAULT-GRONDINES": "DSC1-M",
    "DIXVILLE": "DXVL-M",
    "DOSQUET": "DSQT-M",
    "DUDSWELL": "DDSW-M",
    "DUHAMEL-OUEST": "DHM1-M",
    "DUPUY": "DPY-M",
    "DURHAM-SUD": "DRHM-M",
    "EAST BROUGHTON": "ESTB-M",
    "EAST FARNHAM": "ESTF-M",
    "EAST HEREFORD": "ESTH-M",
    "EASTMAN": "ESTM-M",
    "EGAN-SUD": "EGNS-M",
    "ELGIN": "ELGN-M",
    "ENTRELACS": "ENTR-M",
    "ESCUMINAC": "ESCM-M",
    "ESPRIT-SAINT": "ESPR-M",
    "FASSETT": "FSST-M",
    "FERLAND-ET-BOILLEAU": "FRLN-M",
    "FERME-NEUVE": "FRMN-M",
    "FORTIERVILLE": "FRTR-M",
    "FRAMPTON": "FRMP-M",
    "FRANQUELIN": "FRNQ-M",
    "FRELIGHSBURG": "FRLG-M",
    "FRONTENAC": "FRNT-M",
    "FUGÈREVILLE": "FGRV-M",
    "GALLICHAN": "GLLC-M",
    "GIRARDVILLE": "GRRD-M",
    "GOUVERNEMENT RÉGIONAL D'EEYOU ISTCHEE BAIE-JAMES": "GVRN-M",
    "GRAND-MÉTIS": "GRND-M",
    "GRAND-REMOUS": "GRN1-M",
    "GRAND-SAINT-ESPRIT": "GRN2-M",
    "GRANDE-VALLÉE": "GRN3-M",
    "GRENVILLE-SUR-LA-ROUGE": "GRNV-M",
    "GROS-MÉCATINA": "GRSM-M",
    "GROSSE-ÎLE": "GRSS-M",
    "GROSSES-ROCHES": "GRS1-M",
    "HAM-SUD": "HMSD-M",
    "HATLEY": "HTL1-TS",
    "HAVRE-SAINT-PIERRE": "HVRS-M",
    "HÉBERTVILLE": "HBRT-M",
    "HENRYVILLE": "HNRY-M",
    "HINCHINBROOKE": "HNCH-M",
    "HONFLEUR": "HNFL-M",
    "HOPE TOWN": "HPTW-M",
    "HUBERDEAU": "HBRD-M",
    "IRLANDE": "IRLN-M",
    "IVRY-SUR-LE-LAC": "IVRY-M",
    "KAMOURASKA": "KMRS-M",
    "KAZABAZUA": "KZBZ-M",
    "KIAMIKA": "KMK-M",
    "KINNEAR'S MILLS": "KNNR-M",
    "KIPAWA": "KPW-M",
    "L'ANGE-GARDIEN": "LNGG-M",
    "L'ANSE-SAINT-JEAN": "LNSS-M",
    "L'ASCENSION": "LSCN-M",
    "L'ASCENSION-DE-PATAPÉDIA": "LSC1-M",
    "L'AVENIR": "LVNR-M",
    "L'ÎLE-D'ANTICOSTI": "LLDN-M",
    "L'ÎLE-DU-GRAND-CALUMET": "LLDG-M",
    "L'ISLE-AUX-ALLUMETTES": "LSLX-M",
    "L'ISLE-AUX-COUDRES": "LSL1-M",
    "L'ISLE-VERTE": "LSLV-M",
    "L'ISLET": "LSLT-M",
    "LA BOSTONNAIS": "LBST-M",
    "LA CONCEPTION": "LCNC-M",
    "LA CORNE": "LCRN-M",
    "LA MACAZA": "LMCZ-M",
    "LA MARTRE": "LMRT-M",
    "LA MINERVE": "LMNR-M",
    "LA MORANDIÈRE": "LMRN-M",
    "LA MOTTE": "LMTT-M",
    "LA PATRIE": "LPTR-M",
    "LA PÊCHE": "LPCH-M",
    "LA PRÉSENTATION": "LPRS-M",
    "LA REINE": "LRN-M",
    "LA VISITATION-DE-L'ÎLE-DUPAS": "LVST-M",
    "LA VISITATION-DE-YAMASKA": "LVS1-M",
    "LABELLE": "LBLL-M",
    "LABRECQUE": "LBRC-M",
    "LAC-AU-SAUMON": "LCSM-M",
    "LAC-BEAUPORT": "LCBP-M",
    "LAC-BOUCHETTE": "LCBC-M",
    "LAC-DES-AIGLES": "LCDS-M",
    "LAC-DES-ÉCORCES": "LCD1-M",
    "LAC-DES-PLAGES": "LCD2-M",
    "LAC-DES-SEIZE-ÎLES": "LCD3-M",
    "LAC-DROLET": "LCDR-M",
    "LAC-DU-CERF": "LCDC-M",
    "LAC-ÉDOUARD": "LCD4-M",
    "LAC-ETCHEMIN": "LCTC-M",
    "LAC-FRONTIÈRE": "LCFR-M",
    "LAC-SAINT-PAUL": "LCSN-M",
    "LAC-SAINTE-MARIE": "LCS1-M",
    "LAC-SIMON": "LCS2-M",
    "LAC-SUPÉRIEUR": "LCSP-M",
    "LAC-TREMBLANT-NORD": "LCTR-M",
    "LACOLLE": "LCLL-M",
    "LAFORCE": "LFRC-M",
    "LAMARCHE": "LMRC-M",
    "LAMBTON": "LMBT-M",
    "LANORAIE": "LNR-M",
    "LANTIER": "LNTR-M",
    "LAROUCHE": "LRCH-M",
    "LAURIERVILLE": "LRRV-M",
    "LAVERLOCHÈRE": "LVRL-M",
    "LAVERLOCHÈRE ANGLIERS": "LVR1-M",
    "LECLERCVILLE": "LCLR-M",
    "LEFEBVRE": "LFBV-M",
    "LEJEUNE": "LJN-M",
    "LEMIEUX": "LMX-M",
    "LES BERGERONNES": "LSBR-M",
    "LES CÈDRES": "LSCD-M",
    "LES COTEAUX": "LSCT-M",
    "LES ÉBOULEMENTS": "LSBL-M",
    "LES ESCOUMINS": "LSSC-M",
    "LES HAUTEURS": "LSHT-M",
    "LES ÎLES-DE-LA-MADELEINE": "LSLS-M",
    "LES MÉCHINS": "LSMC-M",
    "LITCHFIELD": "LTCH-M",
    "LONGUE-POINTE-DE-MINGAN": "LNGP-M",
    "LONGUE-RIVE": "LNGR-M",
    "LORRAINVILLE": "LRRN-M",
    "LOTBINIÈRE": "LTBN-M",
    "LYSTER": "LYST-M",
    "MADDINGTON FALLS": "MDDN-M",
    "MANDEVILLE": "MNDV-M",
    "MANSEAU": "MNS-M",
    "MANSFIELD-ET-PONTEFRACT": "MNSF-M",
    "MARIA": "MR-M",
    "MARICOURT": "MRCR-M",
    "MARTINVILLE": "MRTN-M",
    "MASKINONGÉ": "MSKN-M",
    "MATAPÉDIA": "MTPD-M",
    "MAYO": "SAS-MAYO-V",
    "MCMASTERVILLE": "MCMS-M",
    "MESSINES": "MSSN-M",
    "MILAN": "MLN-M",
    "MILLE-ISLES": "MLLS-M",
    "MOFFET": "MFFT-M",
    "MONT-CARMEL": "MNTC-M",
    "MONT-SAINT-GRÉGOIRE": "MNTS-M",
    "MONT-SAINT-MICHEL": "MNT1-M",
    "MONTCERF-LYTTON": "MNT3-M",
    "MONTEBELLO": "MNTB-M",
    "MONTPELLIER": "MNTP-M",
    "MONTRÉAL-EST": "MNT4-M",
    "MONTRÉAL-OUEST": "MNT5-M",
    "MORIN-HEIGHTS": "MRNH-M",
    "MULGRAVE-ET-DERRY": "MLGR-M",
    "NAMUR": "NMR-M",
    "NANTES": "NNTS-M",
    "NAPIERVILLE": "NPRV-M",
    "NATASHQUAN": "NTSH-M",
    "NEW CARLISLE": "NWCR-M",
    "NEWPORT": "NWPR-M",
    "NOMININGUE": "NMNN-M",
    "NORMÉTAL": "NRMT-M",
    "NOTRE-DAME-DE-BONSECOURS": "NTRD-M",
    "NOTRE-DAME-DE-HAM": "NTR1-M",
    "NOTRE-DAME-DE-LA-MERCI": "NTR2-M",
    "NOTRE-DAME-DE-LA-PAIX": "NTR3-M",
    "NOTRE-DAME-DE-LA-SALETTE": "NTR4-M",
    "NOTRE-DAME-DE-LORETTE": "NTR5-M",
    "NOTRE-DAME-DE-LOURDES": "NTR6-M",
    "NOTRE-DAME-DE-MONTAUBAN": "NTR7-M",
    "NOTRE-DAME-DE-PONTMAIN": "NTR8-M",
    "NOTRE-DAME-DE-STANBRIDGE": "NTR9-M",
    "NOTRE-DAME-DES-BOIS": "NTR10-M",
    "NOTRE-DAME-DES-MONTS": "NTR11-M",
    "NOTRE-DAME-DES-NEIGES": "NTR12-M",
    "NOTRE-DAME-DU-LAUS": "NTR13-M",
    "NOTRE-DAME-DU-NORD": "NTR14-M",
    "NOTRE-DAME-DU-PORTAGE": "NTR15-M",
    "NOTRE-DAME-DU-ROSAIRE": "NTR16-M",
    "NOUVELLE": "NVLL-M",
    "NOYAN": "NYN-M",
    "OGDEN": "OGDN-M",
    "OKA": "OK-M",
    "ORMSTOWN": "ORMS-M",
    "OTTER LAKE": "OTTR-M",
    "PADOUE": "PD-M",
    "PALMAROLLE": "PLMR-M",
    "PAPINEAUVILLE": "PPNV-M",
    "PÉRIBONKA": "PRBN-M",
    "PETIT-SAGUENAY": "PTTS-M",
    "PETITE-RIVIÈRE-SAINT-FRANÇOIS": "PTTR-M",
    "PETITE-VALLÉE": "PTTV-M",
    "PIEDMONT": "PDMN-M",
    "PIERREVILLE": "PRRV-M",
    "PIKE RIVER": "PKRV-M",
    "PIOPOLIS": "PPLS-M",
    "PLAISANCE": "PLSN-M",
    "POINTE-À-LA-CROIX": "PNTL-M",
    "POINTE-CALUMET": "PNTC-M",
    "PONTIAC": "PNT1-M",
    "PORT-DANIEL--GASCONS": "PRTD-M",
    "PORTNEUF-SUR-MER": "PRTN-M",
    "POULARIES": "PLRS-M",
    "PREISSAC": "PRSS-M",
    "RACINE": "RCN-M",
    "RAPIDE-DANSEUR": "RPDD-M",
    "RAPIDES-DES-JOACHIMS": "RPDS-M",
    "RAWDON": "RWDN-M",
    "RÉMIGNY": "RMGN-M",
    "RIPON": "RPN-M",
    "RIVIÈRE-À-CLAUDE": "RVRC-M",
    "RIVIÈRE-À-PIERRE": "RVRP-M",
    "RIVIÈRE-AU-TONNERRE": "RVRT-M",
    "RIVIÈRE-BEAUDETTE": "RVRB-M",
    "RIVIÈRE-BLEUE": "RVR1-M",
    "RIVIÈRE-ÉTERNITÉ": "RVR2-M",
    "RIVIÈRE-HÉVA": "RVRH-M",
    "RIVIÈRE-OUELLE": "RVRL-M",
    "RIVIÈRE-SAINT-JEAN": "RVRS-M",
    "ROCHEBAUCOURT": "RCHB-M",
    "ROQUEMAURE": "RQMR-M",
    "ROUGEMONT": "RGMN-M",
    "ROXTON POND": "RXTN-M",
    "SACRÉ-CŒUR": "SCRC-M",
    "SAINT-ADALBERT": "SNTD-M",
    "SAINT-ADOLPHE-D'HOWARD": "SNT1-M",
    "SAINT-ADRIEN": "SNT2-M",
    "SAINT-ADRIEN-D'IRLANDE": "SNT3-M",
    "SAINT-AGAPIT": "SNTG-M",
    "SAINT-AIMÉ": "SNTM-M",
    "SAINT-AIMÉ-DES-LACS": "SNT4-M",
    "SAINT-AIMÉ-DU-LAC-DES-ÎLES": "SNT5-M",
    "SAINT-ALBAN": "SNTL-M",
    "SAINT-ALBERT": "SNT6-M",
    "SAINT-ALEXANDRE": "SNT7-M",
    "SAINT-ALEXANDRE-DE-KAMOURASKA": "SNT8-M",
    "SAINT-ALEXIS": "SNT9-M",
    "SAINT-ALFRED": "SNT10-M",
    "SAINT-ALPHONSE": "SNT11-M",
    "SAINT-ALPHONSE-DE-GRANBY": "SNT12-M",
    "SAINT-ALPHONSE-RODRIGUEZ": "SNT13-M",
    "SAINT-AMABLE": "SNT14-M",
    "SAINT-AMBROISE": "SNT15-M",
    "SAINT-AMBROISE-DE-KILDARE": "SNT16-M",
    "SAINT-ANDRÉ": "SNTN-M",
    "SAINT-ANDRÉ-AVELLIN": "SNT17-M",
    "SAINT-ANDRÉ-D'ARGENTEUIL": "SNT18-M",
    "SAINT-ANDRÉ-DE-RESTIGOUCHE": "SNT19-M",
    "SAINT-ANICET": "SNT20-M",
    "SAINT-ANSELME": "SNT21-M",
    "SAINT-ANTOINE-DE-TILLY": "SNT22-M",
    "SAINT-ANTOINE-SUR-RICHELIEU": "SNT23-M",
    "SAINT-ANTONIN": "SNT24-M",
    "SAINT-APOLLINAIRE": "SNT25-M",
    "SAINT-ARMAND": "SNTR-M",
    "SAINT-ATHANASE": "SNTT-M",
    "SAINT-AUBERT": "SNT26-M",
    "SAINT-AUGUSTIN": "SNT27-M",
    "SAINT-BARNABÉ-SUD": "SNT28-M",
    "SAINT-BENJAMIN": "SNT29-M",
    "SAINT-BENOÎT-DU-LAC": "SNT30-M",
    "SAINT-BENOÎT-LABRE": "SNT31-M",
    "SAINT-BERNARD": "SNT32-M",
    "SAINT-BERNARD-DE-LACOLLE": "SNT33-M",
    "SAINT-BERNARD-DE-MICHAUDVILLE": "SNT34-M",
    "SAINT-BLAISE-SUR-RICHELIEU": "SNT35-M",
    "SAINT-BONAVENTURE": "SNT36-M",
    "SAINT-BONIFACE": "SNT37-M",
    "SAINT-BRUNO": "SNT38-M",
    "SAINT-BRUNO-DE-GUIGUES": "SNT39-M",
    "SAINT-BRUNO-DE-KAMOURASKA": "SNT40-M",
    "SAINT-CALIXTE": "SNTC-M",
    "SAINT-CASIMIR": "SNT41-M",
    "SAINT-CÉLESTIN": "SNT459-V",
    "SAINT-CHARLES-BORROMÉE": "SNT43-M",
    "SAINT-CHARLES-DE-BELLECHASSE": "SNT44-M",
    "SAINT-CHARLES-DE-BOURGET": "SNT45-M",
    "SAINT-CHARLES-SUR-RICHELIEU": "SNT46-M",
    "SAINT-CHRYSOSTOME": "SNT47-M",
    "SAINT-CLAUDE": "SNT48-M",
    "SAINT-CLÉMENT": "SNT49-M",
    "SAINT-CLÉOPHAS-DE-BRANDON": "SNT50-M",
    "SAINT-CLET": "SNT51-M",
    "SAINT-CÔME": "SNT52-M",
    "SAINT-CÔME-LINIÈRE": "SNT53-M",
    "SAINT-CUTHBERT": "SNT54-M",
    "SAINT-CYPRIEN": "SNT55-M",
    "SAINT-CYPRIEN-DE-NAPIERVILLE": "SNT56-M",
    "SAINT-CYRILLE-DE-WENDOVER": "SNT57-M",
    "SAINT-DAMASE": "SNT58-M",
    "SAINT-DAMASE-DE-L'ISLET": "SNT59-M",
    "SAINT-DAVID": "SNT60-M",
    "SAINT-DAVID-DE-FALARDEAU": "SNT61-M",
    "SAINT-DENIS-DE-BROMPTON": "SNT62-M",
    "SAINT-DENIS-DE-LA-BOUTEILLERIE": "SNT63-M",
    "SAINT-DENIS-SUR-RICHELIEU": "SNT64-M",
    "SAINT-DOMINIQUE": "SNT65-M",
    "SAINT-DOMINIQUE-DU-ROSAIRE": "SNT66-M",
    "SAINT-DONAT": "SNT67-M",
    "SAINT-EDMOND-LES-PLAINES": "SNT68-M",
    "SAINT-ÉDOUARD": "SNT69-M",
    "SAINT-ÉDOUARD-DE-MASKINONGÉ": "SNT70-M",
    "SAINT-ÉLIE-DE-CAXTON": "SNT71-M",
    "SAINT-ELZÉAR": "SNT72-M",
    "SAINT-ELZÉAR-DE-TÉMISCOUATA": "SNT73-M",
    "SAINT-ÉMILE-DE-SUFFOLK": "SNT74-M",
    "SAINT-ÉPHREM-DE-BEAUCE": "SNT75-M",
    "SAINT-ÉPIPHANE": "SNT76-M",
    "SAINT-ESPRIT": "SNTS-M",
    "SAINT-ÉTIENNE-DE-BEAUHARNOIS": "SNT77-M",
    "SAINT-ÉTIENNE-DE-BOLTON": "SNT78-M",
    "SAINT-EUGÈNE": "SNT79-M",
    "SAINT-EUGÈNE-D'ARGENTENAY": "SNT80-M",
    "SAINT-EUGÈNE-DE-GUIGUES": "SNT81-M",
    "SAINT-ÉVARISTE-DE-FORSYTH": "SNTV-M",
    "SAINT-FAUSTIN--LAC-CARRÉ": "SNTF-M",
    "SAINT-FÉLIX-D'OTIS": "SNT82-M",
    "SAINT-FÉLIX-DE-DALQUIER": "SNT83-M",
    "SAINT-FÉLIX-DE-KINGSEY": "SNT84-M",
    "SAINT-FÉLIX-DE-VALOIS": "SNT85-M",
    "SAINT-FERDINAND": "SNT86-M",
    "SAINT-FERRÉOL-LES-NEIGES": "SNT87-M",
    "SAINT-FLAVIEN": "SNT88-M",
    "SAINT-FORTUNAT": "SNT89-M",
    "SAINT-FRANÇOIS-D'ASSISE": "SNT90-M",
    "SAINT-FRANÇOIS-DAVIER-DE-BROMPTON": "SNT91-M",
    "SAINT-FRANÇOIS-DAVIER-DE-VIGER": "SNT92-M",
    "SAINT-FRANÇOIS-DE-L'ÎLE-D'ORLÉANS": "SNT93-M",
    "SAINT-FRANÇOIS-DE-LA-RIVIÈRE-DU-SUD": "SNT94-M",
    "SAINT-FRANÇOIS-DE-SALES": "SNT95-M",
    "SAINT-FRANÇOIS-DU-LAC": "SNT96-M",
    "SAINT-FULGENCE": "SNT97-M",
    "SAINT-GABRIEL-DE-BRANDON": "SNT98-M",
    "SAINT-GABRIEL-DE-RIMOUSKI": "SNT99-M",
    "SAINT-GABRIEL-DE-VALCARTIER": "SNT100-M",
    "SAINT-GABRIEL-LALEMANT": "SNT101-M",
    "SAINT-GÉDÉON": "SNT102-M",
    "SAINT-GÉDÉON-DE-BEAUCE": "SNT103-M",
    "SAINT-GEORGES-DE-CLARENCEVILLE": "SNT104-M",
    "SAINT-GEORGES-DE-WINDSOR": "SNT105-M",
    "SAINT-GERMAIN-DE-GRANTHAM": "SNT106-M",
    "SAINT-GERVAIS": "SNT107-M",
    "SAINT-GILLES": "SNT108-M",
    "SAINT-GUILLAUME": "SNT109-M",
    "SAINT-GUY": "SNT110-M",
    "SAINT-HENRI": "SNT111-M",
    "SAINT-HENRI-DE-TAILLON": "SNT112-M",
    "SAINT-HERMÉNÉGILDE": "SNT113-M",
    "SAINT-HIPPOLYTE": "SNT114-M",
    "SAINT-HONORÉ-DE-SHENLEY": "SNT115-M",
    "SAINT-HONORÉ-DE-TÉMISCOUATA": "SNT116-M",
    "SAINT-HUBERT-DE-RIVIÈRE-DU-LOUP": "SNT117-M",
    "SAINT-HUGUES": "SNT118-M",
    "SAINT-IGNACE-DE-LOYOLA": "SNT119-M",
    "SAINT-IGNACE-DE-STANBRIDGE": "SNT120-M",
    "SAINT-ISIDORE": "SNT121-M",
    "SAINT-ISIDORE-DE-CLIFTON": "SNT122-M",
    "SAINT-JACQUES": "SNTJ-M",
    "SAINT-JACQUES-DE-LEEDS": "SNT123-M",
    "SAINT-JACQUES-LE-MINEUR": "SNT124-M",
    "SAINT-JANVIER-DE-JOLY": "SNT125-M",
    "SAINT-JEAN-BAPTISTE": "SNT126-M",
    "SAINT-JEAN-DE-BRÉBEUF": "SNT127-M",
    "SAINT-JEAN-DE-DIEU": "SNT128-M",
    "SAINT-JEAN-DE-L'ÎLE-D'ORLÉANS": "SNT129-M",
    "SAINT-JEAN-DE-LA-LANDE": "SNT130-M",
    "SAINT-JEAN-DE-MATHA": "SNT131-M",
    "SAINT-JEAN-PORT-JOLI": "SNT132-M",
    "SAINT-JOACHIM-DE-SHEFFORD": "SNT133-M",
    "SAINT-JOSEPH-DE-COLERAINE": "SNT134-M",
    "SAINT-JOSEPH-DES-ÉRABLES": "SNT135-M",
    "SAINT-JOSEPH-DU-LAC": "SNT136-M",
    "SAINT-JUDE": "SNT137-M",
    "SAINT-JULIEN": "SNT138-M",
    "SAINT-JUST-DE-BRETENIÈRES": "SNT139-M",
    "SAINT-JUSTE-DU-LAC": "SNT140-M",
    "SAINT-JUSTIN": "SNT141-M",
    "SAINT-LAMBERT-DE-LAUZON": "SNT142-M",
    "SAINT-LAURENT-DE-L'ÎLE-D'ORLÉANS": "SNT143-M",
    "SAINT-LAZARE-DE-BELLECHASSE": "SNT144-M",
    "SAINT-LÉONARD-D'ASTON": "SNT145-M",
    "SAINT-LÉONARD-DE-PORTNEUF": "SNT146-M",
    "SAINT-LIBOIRE": "SNT147-M",
    "SAINT-LIGUORI": "SNT148-M",
    "SAINT-LOUIS": "SNT149-M",
    "SAINT-LOUIS-DE-BLANDFORD": "SNT150-M",
    "SAINT-LOUIS-DE-GONZAGUE": "SNT151-M",
    "SAINT-LUC-DE-BELLECHASSE": "SNT152-M",
    "SAINT-LUC-DE-VINCENNES": "SNT153-M",
    "SAINT-LUCIEN": "SNT154-M",
    "SAINT-LUDGER": "SNT155-M",
    "SAINT-LUDGER-DE-MILOT": "SNT156-M",
    "SAINT-MAGLOIRE": "SNT157-M",
    "SAINT-MALO": "SNT158-M",
    "SAINT-MARC-SUR-RICHELIEU": "SNT159-M",
    "SAINT-MARCEL": "SNT160-M",
    "SAINT-MARCEL-DE-RICHELIEU": "SNT161-M",
    "SAINT-MATHIAS-SUR-RICHELIEU": "SNT162-M",
    "SAINT-MATHIEU": "SNT163-M",
    "SAINT-MATHIEU-D'HARRICANA": "SNT164-M",
    "SAINT-MATHIEU-DE-BELOEIL": "SNT165-M",
    "SAINT-MATHIEU-DU-PARC": "SNT166-M",
    "SAINT-MAXIME-DU-MONT-LOUIS": "SNT167-M",
    "SAINT-MÉDARD": "SNT168-M",
    "SAINT-MICHEL": "SNT169-M",
    "SAINT-MICHEL-DE-BELLECHASSE": "SNT170-M",
    "SAINT-MICHEL-DES-SAINTS": "SNT171-M",
    "SAINT-MICHEL-DU-SQUATEC": "SNT172-M",
    "SAINT-MODESTE": "SNT173-M",
    "SAINT-NAZAIRE": "SNT174-M",
    "SAINT-NÉRÉE-DE-BELLECHASSE": "SNT175-M",
    "SAINT-NORBERT-D'ARTHABASKA": "SNT176-M",
    "SAINT-OMER": "SNT177-M",
    "SAINT-ONÉSIME-D'IXWORTH": "SNT178-M",
    "SAINT-PACÔME": "SNT179-M",
    "SAINT-PATRICE-DE-BEAURIVAGE": "SNT180-M",
    "SAINT-PATRICE-DE-SHERRINGTON": "SNT181-M",
    "SAINT-PAUL": "SNT182-M",
    "SAINT-PAUL-D'ABBOTSFORD": "SNT183-M",
    "SAINT-PAUL-DE-L'ÎLE-AUX-NOIX": "SNT184-M",
    "SAINT-PAUL-DE-MONTMINY": "SNT185-M",
    "SAINT-PAULIN": "SNT186-M",
    "SAINT-PHILIBERT": "SNT187-M",
    "SAINT-PIERRE-DE-BROUGHTON": "SNT188-M",
    "SAINT-PIERRE-DE-L'ÎLE-D'ORLÉANS": "SNT189-M",
    "SAINT-PIERRE-DE-LAMY": "SNT190-M",
    "SAINT-PIERRE-LES-BECQUETS": "SNT191-M",
    "SAINT-PLACIDE": "SNT192-M",
    "SAINT-POLYCARPE": "SNT193-M",
    "SAINT-PRIME": "SNT194-M",
    "SAINT-PROSPER": "SNT195-M",
    "SAINT-PROSPER-DE-CHAMPLAIN": "SNT196-M",
    "SAINT-RAPHAËL": "SNT197-M",
    "SAINT-RÉMI-DE-TINGWICK": "SNT198-M",
    "SAINT-RENÉ-DE-MATANE": "SNT199-M",
    "SAINT-ROBERT": "SNT200-M",
    "SAINT-ROBERT-BELLARMIN": "SNT201-M",
    "SAINT-ROCH-DE-L'ACHIGAN": "SNT202-M",
    "SAINT-ROCH-DE-RICHELIEU": "SNT203-M",
    "SAINT-ROCH-OUEST": "SNT204-M",
    "SAINT-ROMAIN": "SNT205-M",
    "SAINT-SAMUEL": "SNT206-M",
    "SAINT-SÉBASTIEN": "SNT207-M",
    "SAINT-SIMÉON": "SNT208-M",
    "SAINT-SIMON": "SNT209-M",
    "SAINT-SIMON-LES-MINES": "SNT210-M",
    "SAINT-SIXTE": "SNT211-M",
    "SAINT-STANISLAS": "SNT212-M",
    "SAINT-STANISLAS-DE-KOSTKA": "SNT213-M",
    "SAINT-SYLVÈRE": "SNT214-M",
    "SAINT-SYLVESTRE": "SNT215-M",
    "SAINT-TÉLESPHORE": "SNT216-M",
    "SAINT-THÉODORE-D'ACTON": "SNT217-M",
    "SAINT-THÉOPHILE": "SNT218-M",
    "SAINT-THOMAS": "SNT219-M",
    "SAINT-THOMAS-DIDYME": "SNT220-M",
    "SAINT-TITE-DES-CAPS": "SNT221-M",
    "SAINT-UBALDE": "SNT222-M",
    "SAINT-ULRIC": "SNT223-M",
    "SAINT-URBAIN-PREMIER": "SNT224-M",
    "SAINT-VALENTIN": "SNT225-M",
    "SAINT-VALÈRE": "SNT226-M",
    "SAINT-VALÉRIEN-DE-MILTON": "SNT227-M",
    "SAINT-VALLIER": "SNT228-M",
    "SAINT-VENANT-DE-PAQUETTE": "SNT229-M",
    "SAINT-VIANNEY": "SNT230-M",
    "SAINT-VICTOR": "SNT231-M",
    "SAINT-WENCESLAS": "SNTW-M",
    "SAINT-ZACHARIE": "SNTZ-M",
    "SAINT-ZÉNON": "SNT232-M",
    "SAINT-ZOTIQUE": "SNT233-M",
    "SAINTE-AGATHE-DE-LOTBINIÈRE": "SNT234-M",
    "SAINTE-ANGÈLE-DE-MÉRICI": "SNT235-M",
    "SAINTE-ANGÈLE-DE-MONNOIR": "SNT236-M",
    "SAINTE-ANGÈLE-DE-PRÉMONT": "SNT237-M",
    "SAINTE-ANNE-DE-LA-PÉRADE": "SNT238-M",
    "SAINTE-ANNE-DE-LA-ROCHELLE": "SNT239-M",
    "SAINTE-ANNE-DE-SOREL": "SNT240-M",
    "SAINTE-ANNE-DU-LAC": "SNT241-M",
    "SAINTE-ANNE-DU-SAULT": "SNT242-M",
    "SAINTE-AURÉLIE": "SNT243-M",
    "SAINTE-BARBE": "SNT244-M",
    "SAINTE-BÉATRIX": "SNT245-M",
    "SAINTE-BRIGIDE-D'IBERVILLE": "SNT246-M",
    "SAINTE-CATHERINE-DE-HATLEY": "SNT247-M",
    "SAINTE-CÉCILE-DE-MILTON": "SNT248-M",
    "SAINTE-CÉCILE-DE-WHITTON": "SNT249-M",
    "SAINTE-CHRISTINE-D'AUVERGNE": "SNT250-M",
    "SAINTE-CLAIRE": "SNT251-M",
    "SAINTE-CLOTILDE": "SNT252-M",
    "SAINTE-CLOTILDE-DE-BEAUCE": "SNT253-M",
    "SAINTE-CLOTILDE-DE-HORTON": "SNT254-M",
    "SAINTE-CROIX": "SNT255-M",
    "SAINTE-ÉLISABETH": "SNT256-M",
    "SAINTE-ÉLIZABETH-DE-WARWICK": "SNT257-M",
    "SAINTE-ÉMÉLIE-DE-L'ÉNERGIE": "SNT258-M",
    "SAINTE-EULALIE": "SNT259-M",
    "SAINTE-EUPHÉMIE-SUR-RIVIÈRE-DU-SUD": "SNT260-M",
    "SAINTE-FAMILLE-DE-L'ÎLE-D'ORLÉANS": "SNT261-M",
    "SAINTE-FÉLICITÉ": "SNT262-M",
    "SAINTE-FLORENCE": "SNT263-M",
    "SAINTE-GENEVIÈVE-DE-BERTHIER": "SNT264-M",
    "SAINTE-GERMAINE-BOULÉ": "SNT265-M",
    "SAINTE-GERTRUDE-MANNEVILLE": "SNT266-M",
    "SAINTE-HEDWIDGE": "SNT267-M",
    "SAINTE-HÉLÈNE-DE KAMOURASKA": "SNT268-M",
    "SAINTE-HÉLÈNE-DE-BAGOT": "SNT269-M",
    "SAINTE-HÉLÈNE-DE-CHESTER": "SNT270-M",
    "SAINTE-JULIENNE": "SNT271-M",
    "SAINTE-JUSTINE": "SNT272-M",
    "SAINTE-JUSTINE-DE-NEWTON": "SNT273-M",
    "SAINTE-LUCE": "SNT274-M",
    "SAINTE-LUCIE-DE-BEAUREGARD": "SNT275-M",
    "SAINTE-LUCIE-DES-LAURENTIDES": "SNT276-M",
    "SAINTE-MADELEINE-DE-LA-RIVIÈRE-MADELEINE": "SNT277-M",
    "SAINTE-MARCELLINE-DE-KILDARE": "SNT278-M",
    "SAINTE-MARGUERITE-MARIE": "SNT279-M",
    "SAINTE-MARIE-DE-BLANDFORD": "SNT280-M",
    "SAINTE-MARIE-SALOMÉ": "SNT281-M",
    "SAINTE-MARTHE": "SNT282-M",
    "SAINTE-MARTINE": "SNT283-M",
    "SAINTE-MÉLANIE": "SNT284-M",
    "SAINTE-MONIQUE": "SNT285-M",
    "SAINTE-PAULE": "SNT286-M",
    "SAINTE-PERPÉTUE": "SNT287-M",
    "SAINTE-RITA": "SNT288-M",
    "SAINTE-ROSE-DE-WATFORD": "SNT289-M",
    "SAINTE-SABINE": "SNT290-M",
    "SAINTE-SOPHIE": "SNT291-M",
    "SAINTE-SOPHIE-D'HALIFAX": "SNT292-M",
    "SAINTE-THÈCLE": "SNT293-M",
    "SAINTE-THÉRÈSE-DE-GASPÉ": "SNT294-M",
    "SAINTE-THÉRÈSE-DE-LA-GATINEAU": "SNT295-M",
    "SAINTE-URSULE": "SNT296-M",
    "SAINTE-VICTOIRE-DE-SOREL": "SNT297-M",
    "SAYABEC": "SYBC-M",
    "SCOTT": "SCTT-T",
    "SHAWVILLE": "SHWV-M",
    "SHEENBORO": "SHNB-M",
    "SHIGAWAKE": "SHGW-M",
    "STANBRIDGE EAST": "STNB-M",
    "STANBRIDGE STATION": "STN1-M",
    "STANSTEAD-EST": "STNS-M",
    "STOKE": "STK-M",
    "STORNOWAY": "STRN-M",
    "TASCHEREAU": "TSCH-M",
    "TERRASSE-VAUDREUIL": "TRRS-M",
    "THORNE": "THRN-M",
    "TINGWICK": "TNGW-M",
    "TOURVILLE": "TRVL-M",
    "TRÈS-SAINT-RÉDEMPTEUR": "TRSS-M",
    "TROIS-RIVES": "TRSR-M",
    "ULVERTON": "ULVR-M",
    "UPTON": "UPTN-M",
    "VAL-ALAIN": "VLLN-M",
    "VAL-BRILLANT": "VLBR-M",
    "VAL-DES-BOIS": "VLDS-M",
    "VAL-DES-LACS": "VLD1-M",
    "VAL-DES-MONTS": "VLD2-M",
    "VAL-JOLI": "VLJL-M",
    "VAL-MORIN": "VLMR-M",
    "VAL-RACINE": "VLRC-M",
    "VAL-SAINT-GILLES": "VLSN-M",
    "VALLÉE-JONCTION": "VLLJ-M",
    "VENISE-EN-QUÉBEC": "VNSN-M",
    "VERCHÈRES": "VRCH-M",
    "VILLEROY": "VLLR-M",
    "WALTHAM": "WLTH-M",
    "WEEDON": "WDN-M",
    "WENTWORTH-NORD": "WNTW-M",
    "WICKHAM": "WCKH-M",
    "WOTTON": "WTTN-M",
    "YAMACHICHE": "YMCH-M",
    "YAMASKA": "YMSK-M",
    "PARISH OF BRÉBEUF": "BRBF-P",
    "PARISH OF DISRAELI": "DSRL-P",
    "PARISH OF HÉROUXVILLE": "HRXV-P",
    "PARISH OF L'ASCENSION-DE-NOTRE-SEIGNEUR": "LSC2-P",
    "PARISH OF LA DORÉ": "LDR-P",
    "PARISH OF LA DURANTAYE": "LDRN-P",
    "PARISH OF LA RÉDEMPTION": "LRDM-P",
    "PARISH OF LA TRINITÉ-DES-MONTS": "LTRN-P",
    "PARISH OF LAC-AUX-SABLES": "LCXS-P",
    "PARISH OF NOTRE-DAME-AUXILIATRICE-DE-BUCKLAND": "NTR17-P",
    "PARISH OF NOTRE-DAME-DE-LOURDES": "NTR18-P",
    "PARISH OF NOTRE-DAME-DES-ANGES": "NTR19-P",
    "PARISH OF NOTRE-DAME-DES-PINS": "NTR20-P",
    "PARISH OF NOTRE-DAME-DES-SEPT-DOULEURS": "NTR21-P",
    "PARISH OF NOTRE-DAME-DU-BON-CONSEIL": "NTR22-P",
    "PARISH OF NOTRE-DAME-DU-MONT-CARMEL": "NTR23-P",
    "PARISH OF NOTRE-DAME-DU-SACRÉ-CŒUR-D'ISSOUDUN": "NTR24-P",
    "PARISH OF PACKINGTON": "PCKN-P",
    "PARISH OF RAGUENEAU": "RGN-P",
    "PARISH OF SACRÉ-CŒUR-DE-JÉSUS": "SCR1-P",
    "PARISH OF SAINT-ADELME": "SNT298-P",
    "PARISH OF SAINT-ADELPHE": "SNT299-P",
    "PARISH OF SAINT-ALEXANDRE-DES-LACS": "SNT300-P",
    "PARISH OF SAINT-ALEXIS-DES-MONTS": "SNT301-P",
    "PARISH OF SAINT-ANACLET-DE-LESSARD": "SNT302-P",
    "PARISH OF SAINT-ANTOINE-DE-L'ISLE-AUX-GRUES": "SNT303-P",
    "PARISH OF SAINT-ARSÈNE": "SNT304-P",
    "PARISH OF SAINT-AUGUSTIN": "SNT305-P",
    "PARISH OF SAINT-AUGUSTIN-DE-WOBURN": "SNT306-P",
    "PARISH OF SAINT-BARNABÉ": "SNT307-P",
    "PARISH OF SAINT-BARTHÉLEMY": "SNT308-P",
    "PARISH OF SAINT-CAMILLE-DE-LELLIS": "SNT309-P",
    "PARISH OF SAINT-CHARLES-GARNIER": "SNT310-P",
    "PARISH OF SAINT-CHRISTOPHE-D'ARTHABASKA": "SNT311-P",
    "PARISH OF SAINT-CLÉOPHAS": "SNT312-P",
    "PARISH OF SAINT-CYPRIEN": "SNT313-P",
    "PARISH OF SAINT-CYRILLE-DE-LESSARD": "SNT314-P",
    "PARISH OF SAINT-DAMASE": "SNT315-P",
    "PARISH OF SAINT-DAMIEN": "SNT316-P",
    "PARISH OF SAINT-DAMIEN-DE-BUCKLAND": "SNT317-P",
    "PARISH OF SAINT-DIDACE": "SNT318-P",
    "PARISH OF SAINT-DONAT": "SNT319-P",
    "PARISH OF SAINT-EDMOND-DE-GRANTHAM": "SNT320-P",
    "PARISH OF SAINT-ÉDOUARD-DE-FABRE": "SNT321-P",
    "PARISH OF SAINT-ÉDOUARD-DE-LOTBINIÈRE": "SNT322-P",
    "PARISH OF SAINT-ÉLOI": "SNT323-P",
    "PARISH OF SAINT-ELPHÈGE": "SNT324-P",
    "PARISH OF SAINT-ÉTIENNE-DES-GRÈS": "SNT325-P",
    "PARISH OF SAINT-EUGÈNE-DE-LADRIÈRE": "SNT326-P",
    "PARISH OF SAINT-EUSÈBE": "SNT327-P",
    "PARISH OF SAINT-FABIEN": "SNT328-P",
    "PARISH OF SAINT-FABIEN-DE-PANET": "SNT329-P",
    "PARISH OF SAINT-FRÉDÉRIC": "SNT330-P",
    "PARISH OF SAINT-GÉRARD-MAJELLA": "SNT331-P",
    "PARISH OF SAINT-GERMAIN": "SNT332-P",
    "PARISH OF SAINT-GILBERT": "SNT333-P",
    "PARISH OF SAINT-HILAIRE-DE-DORSET": "SNT334-P",
    "PARISH OF SAINT-HILARION": "SNT335-P",
    "PARISH OF SAINT-IRÉNÉE": "SNT336-P",
    "PARISH OF SAINT-ISIDORE": "SNT337-P",
    "PARISH OF SAINT-JACQUES-LE-MAJEUR-DE-WOLFESTOWN": "SNT338-P",
    "PARISH OF SAINT-JEAN-DE-CHERBOURG": "SNT339-P",
    "PARISH OF SAINT-JOACHIM": "SNT340-P",
    "PARISH OF SAINT-JOSEPH-DE-KAMOURASKA": "SNT341-P",
    "PARISH OF SAINT-JOSEPH-DE-LEPAGE": "SNT342-P",
    "PARISH OF SAINT-JULES": "SNT343-P",
    "PARISH OF SAINT-LAMBERT": "SNT344-P",
    "PARISH OF SAINT-LÉANDRE": "SNT345-P",
    "PARISH OF SAINT-LÉON-DE-STANDON": "SNT346-P",
    "PARISH OF SAINT-LÉON-LE-GRAND": "SNT347-P",
    "PARISH OF SAINT-LOUIS-DE-GONZAGUE": "SNT348-P",
    "PARISH OF SAINT-LOUIS-DE-GONZAGUE-DU-CAP-TOURMENTE": "SNT349-P",
    "PARISH OF SAINT-LOUIS-DU-HA! HA!": "SNT350-P",
    "PARISH OF SAINT-MAJORIQUE-DE-GRANTHAM": "SNT351-P",
    "PARISH OF SAINT-MALACHIE": "SNT352-P",
    "PARISH OF SAINT-MARC-DE-FIGUERY": "SNT353-P",
    "PARISH OF SAINT-MARC-DU-LAC-LONG": "SNT354-P",
    "PARISH OF SAINT-MARCELLIN": "SNT355-P",
    "PARISH OF SAINT-MARTIN": "SNT356-P",
    "PARISH OF SAINT-MATHIEU-DE-RIOUX": "SNT357-P",
    "PARISH OF SAINT-MAURICE": "SNT358-P",
    "PARISH OF SAINT-MOÏSE": "SNT359-P",
    "PARISH OF SAINT-NARCISSE": "SNT360-P",
    "PARISH OF SAINT-NARCISSE-DE-BEAURIVAGE": "SNT361-P",
    "PARISH OF SAINT-NARCISSE-DE-RIMOUSKI": "SNT362-P",
    "PARISH OF SAINT-NAZAIRE-D'ACTON": "SNT363-P",
    "PARISH OF SAINT-NAZAIRE-DE-DORCHESTER": "SNT364-P",
    "PARISH OF SAINT-NORBERT": "SNT365-P",
    "PARISH OF SAINT-OCTAVE-DE-MÉTIS": "SNT366-P",
    "PARISH OF SAINT-ODILON-DE-CRANBOURNE": "SNT367-P",
    "PARISH OF SAINT-PAUL-DE-LA-CROIX": "SNT368-P",
    "PARISH OF SAINT-PHILÉMON": "SNT369-P",
    "PARISH OF SAINT-PHILIPPE-DE-NÉRI": "SNT370-P",
    "PARISH OF SAINT-PIE-DE-GUIRE": "SNT371-P",
    "PARISH OF SAINT-PIERRE-BAPTISTE": "SNT372-P",
    "PARISH OF SAINT-PIERRE-DE-LA-RIVIÈRE-DU-SUD": "SNT373-P",
    "PARISH OF SAINT-RENÉ": "SNT374-P",
    "PARISH OF SAINT-ROCH-DE-MÉKINAC": "SNT375-P",
    "PARISH OF SAINT-ROCH-DES-AULNAIES": "SNT376-P",
    "PARISH OF SAINT-ROSAIRE": "SNT377-P",
    "PARISH OF SAINT-SÉVÈRE": "SNT378-P",
    "PARISH OF SAINT-SÉVERIN": "SNT379-P",
    "PARISH OF SAINT-SIMÉON": "SNT380-P",
    "PARISH OF SAINT-SIMON": "SNT381-P",
    "PARISH OF SAINT-SULPICE": "SNT382-P",
    "PARISH OF SAINT-THARCISIUS": "SNT383-P",
    "PARISH OF SAINT-THURIBE": "SNT384-P",
    "PARISH OF SAINT-URBAIN": "SNT385-P",
    "PARISH OF SAINT-VALÉRIEN": "SNT386-P",
    "PARISH OF SAINT-ZÉNON-DU-LAC-HUMQUI": "SNT387-P",
    "PARISH OF SAINT-ZÉPHIRIN-DE-COURVAL": "SNT388-P",
    "PARISH OF SAINTE-ANNE-DE-LA-POCATIÈRE": "SNT389-P",
    "PARISH OF SAINTE-ANNE-DE-SABREVOIS": "SNT390-P",
    "PARISH OF SAINTE-ANNE-DES-LACS": "SNT391-P",
    "PARISH OF SAINTE-APOLLINE-DE-PATTON": "SNT392-P",
    "PARISH OF SAINTE-BRIGITTE-DES-SAULTS": "SNT393-P",
    "PARISH OF SAINTE-CÉCILE-DE-LÉVRARD": "SNT394-P",
    "PARISH OF SAINTE-CHRISTINE": "SNT395-P",
    "PARISH OF SAINTE-FLAVIE": "SNT396-P",
    "PARISH OF SAINTE-FRANÇOISE": "SNT397-P",
    "PARISH OF SAINTE-GENEVIÈVE-DE-BATISCAN": "SNT398-P",
    "PARISH OF SAINTE-HÉLÈNE-DE-MANCEBOURG": "SNT399-P",
    "PARISH OF SAINTE-HÉNÉDINE": "SNT400-P",
    "PARISH OF SAINTE-IRÈNE": "SNT401-P",
    "PARISH OF SAINTE-JEANNE-D'ARC": "SNT402-P",
    "PARISH OF SAINTE-LOUISE": "SNT403-P",
    "PARISH OF SAINTE-MARGUERITE": "SNT404-P",
    "PARISH OF SAINTE-MARIE-MADELEINE": "SNT405-P",
    "PARISH OF SAINTE-PERPÉTUE": "SNT406-P",
    "PARISH OF SAINTE-PRAXÈDE": "SNT407-P",
    "PARISH OF SAINTE-ROSE-DU-NORD": "SNT408-P",
    "PARISH OF SAINTE-SABINE": "SNT409-P",
    "PARISH OF SAINTE-SÉRAPHINE": "SNT410-P",
    "PARISH OF SAINTE-SOPHIE-DE-LÉVRARD": "SNT411-P",
    "PARISH OF SAINTS-ANGES": "SNT412-P",
    "PARISH OF SAINTS-MARTYRS-CANADIENS": "SNT413-P",
    "PARISH OF SENNETERRE": "SNNT-P",
    "PARISH OF TRÈS-SAINT-SACREMENT": "TRS1-P",
    "RESORT COUNTY MUNICIPALITY ABITIBI": "ABTB-RC",
    "RESORT COUNTY MUNICIPALITY ABITIBI-OUEST": "ACTN-RC",
    "RESORT COUNTY MUNICIPALITY ACTON": "ANTL-RC",
    "RESORT COUNTY MUNICIPALITY ANTOINE-LABELLE": "ARGT-Rc",
    "RESORT COUNTY MUNICIPALITY ARGENTEUIL": "ARTB-RC",
    "RESORT COUNTY MUNICIPALITY ARTHABASKA": "AVGN-RC",
    "RESORT COUNTY MUNICIPALITY AVIGNON": "BCST-RC",
    "RESORT COUNTY MUNICIPALITY BEAUCE-SARTIGAN": "BHRN-RC",
    "RESORT COUNTY MUNICIPALITY BEAUHARNOIS-SALABERRY": "BHSB-RC",
    "RESORT COUNTY MUNICIPALITY BÉCANCOUR": "BCNC-RC",
    "RESORT COUNTY MUNICIPALITY BELLECHASSE": "BLCS-RC",
    "RESORT COUNTY MUNICIPALITY BONAVENTURE": "BNVT-RC",
    "RESORT COUNTY MUNICIPALITY BROME-MISSISQUOI": "BRMM-RC",
    "RESORT COUNTY MUNICIPALITY CANIAPISCAU": "CNPC-RC",
    "RESORT COUNTY MUNICIPALITY CHARLEVOIX": "CHLX-RC",
    "RESORT COUNTY MUNICIPALITY CHARLEVOIX-EST": "CHLV-RC",
    "RESORT COUNTY MUNICIPALITY COATICOOK": "CTCK-RC",
    "RESORT COUNTY MUNICIPALITY D'AUTRAY": "DATR-RC",
    "RESORT COUNTY MUNICIPALITY DEUX-MONTAGNES": "DMTG-RC",
    "RESORT COUNTY MUNICIPALITY DRUMMOND": "DRMM-RC",
    "RESORT COUNTY MUNICIPALITY JOLIETTE": "JLTT-RC",
    "RESORT COUNTY MUNICIPALITY KAMOURASKA": "KMRS-RC",
    "RESORT COUNTY MUNICIPALITY L'ASSOMPTION": "LSSP-RC",
    "RESORT COUNTY MUNICIPALITY L'ÉRABLE": "LRBL-RC",
    "RESORT COUNTY MUNICIPALITY L'ÎLE-D'ORLÉANS": "LDOR-RC",
    "RESORT COUNTY MUNICIPALITY L'ISLET": "LISL-RC",
    "RESORT COUNTY MUNICIPALITY LA CÔTE-DE-BEAUPRÉ": "LCDB-RC",
    "RESORT COUNTY MUNICIPALITY LA CÔTE-DE-GASPÉ": "LCDG-RC",
    "RESORT COUNTY MUNICIPALITY LA HAUTE-CÔTE-NORD": "LHCN-RC",
    "RESORT COUNTY MUNICIPALITY LA HAUTE-GASPÉSIE": "LHGS-RC",
    "RESORT COUNTY MUNICIPALITY LA HAUTE-YAMASKA": "LHYM-RC",
    "RESORT COUNTY MUNICIPALITY LA JACQUES-CARTIER": "LJQC-RC",
    "RESORT COUNTY MUNICIPALITY LA MATANIE": "LMTN-RC",
    "RESORT COUNTY MUNICIPALITY LA MATAPÉDIA": "LMTA-RC",
    "RESORT COUNTY MUNICIPALITY LA MITIS": "LMTS-RC",
    "RESORT COUNTY MUNICIPALITY LA NOUVELLE-BEAUCE": "LNVB-RC",
    "RESORT COUNTY MUNICIPALITY LA RIVIÈRE-DU-NORD": "LRDN-RC",
    "RESORT COUNTY MUNICIPALITY LA VALLÉE-DE-L'OR": "LVDL-RC",
    "RESORT COUNTY MUNICIPALITY LA VALLÉE-DE-LA-GATINEAU": "LVDG-RC",
    "RESORT COUNTY MUNICIPALITY LA VALLÉE-DU-RICHELIEU": "LVDR-RC",
    "RESORT COUNTY MUNICIPALITY LAC-SAINT-JEAN-EST": "LSJE-RC",
    "RESORT COUNTY MUNICIPALITY LE DOMAINE-DU-ROY": "LDDR-RC",
    "RESORT COUNTY MUNICIPALITY LE FJORD-DU-SAGUENAY": "LJDS-RC",
    "RESORT COUNTY MUNICIPALITY LE GOLFE-DU-SAINT-LAURENT": "LGSL-RC",
    "RESORT COUNTY MUNICIPALITY LE GRANIT": "LGRT-RC",
    "RESORT COUNTY MUNICIPALITY LE HAUT-RICHELIEU": "LHRC-RC",
    "RESORT COUNTY MUNICIPALITY LE HAUT-SAINT-FRANÇOIS": "LHSF-RC",
    "RESORT COUNTY MUNICIPALITY LE HAUT-SAINT-LAURENT": "LHSL-RC",
    "RESORT COUNTY MUNICIPALITY LE ROCHER-PERCÉ": "LRPR-RC",
    "RESORT COUNTY MUNICIPALITY LE VAL-SAINT-FRANÇOIS": "LVSF-RC",
    "RESORT COUNTY MUNICIPALITY LES APPALACHES": "LAPP-RC",
    "RESORT COUNTY MUNICIPALITY LES BASQUES": "LBAS-RC",
    "RESORT COUNTY MUNICIPALITY LES CHENAUX": "LCHN-RC",
    "RESORT COUNTY MUNICIPALITY LES COLLINES-DE-L'OUTAOUAIS": "LCLL-RC",
    "RESORT COUNTY MUNICIPALITY LES ETCHEMINS": "LETC-RC",
    "RESORT COUNTY MUNICIPALITY LES JARDINS-DE-NAPIERVILLE": "LJDE-RC",
    "RESORT COUNTY MUNICIPALITY LES LAURENTIDES": "LLRD-RC",
    "RESORT COUNTY MUNICIPALITY LES MASKOUTAINS": "LMKT-RC",
    "RESORT COUNTY MUNICIPALITY LES MOULINS": "LMNS-RC",
    "RESORT COUNTY MUNICIPALITY LES PAYS-D'EN-HAUT": "LPDN-RC",
    "RESORT COUNTY MUNICIPALITY LES SOURCES": "LSRC-RC",
    "RESORT COUNTY MUNICIPALITY LOTBINIÈRE": "LTBN-RC",
    "RESORT COUNTY MUNICIPALITY MANICOUAGAN": "MNCG-RC",
    "RESORT COUNTY MUNICIPALITY MARGUERITE-D'YOUVILLE": "MGDY-RC",
    "RESORT COUNTY MUNICIPALITY MARIA-CHAPDELAINE": "MCPD-RC",
    "RESORT COUNTY MUNICIPALITY MASKINONGÉ": "MSKN-RG",
    "RESORT COUNTY MUNICIPALITY MATAWINIE": "MTWN-RG",
    "RESORT COUNTY MUNICIPALITY MÉKINAC": "MKNC-RG",
    "RESORT COUNTY MUNICIPALITY MEMPHRÉMAGOG": "MMPM-RG",
    "RESORT COUNTY MUNICIPALITY MINGANIE": "MNGN-RG",
    "RESORT COUNTY MUNICIPALITY MONTCALM": "MNTL-RG",
    "RESORT COUNTY MUNICIPALITY MONTMAGNY": "MTMG-RG",
    "RESORT COUNTY MUNICIPALITY NICOLET-YAMASKA": "NCYM-RG",
    "RESORT COUNTY MUNICIPALITY PAPINEAU": "PPNU-RG",
    "RESORT COUNTY MUNICIPALITY PIERRE-DE SAUREL": "PDSR-RG",
    "RESORT COUNTY MUNICIPALITY PONTIAC": "PNTC-RG",
    "RESORT COUNTY MUNICIPALITY PORTNEUF": "PNTF-RG",
    "RESORT COUNTY MUNICIPALITY RIMOUSKI-NEIGETTE": "RMNG-RG",
    "RESORT COUNTY MUNICIPALITY RIVIÈRE-DU-LOUP": "RVDL-RG",
    "RESORT COUNTY MUNICIPALITY ROBERT-CLICHE": "RBCL-RG",
    "RESORT COUNTY MUNICIPALITY ROUSSILLON": "RSSL-RG",
    "RESORT COUNTY MUNICIPALITY ROUVILLE": "RVLL-RG",
    "RESORT COUNTY MUNICIPALITY SEPT-RIVIÈRES": "SPRV-RG",
    "RESORT COUNTY MUNICIPALITY TÉMISCAMINGUE": "TMSC-RG",
    "RESORT COUNTY MUNICIPALITY TÉMISCOUATA": "TMST-RC",
    "RESORT COUNTY MUNICIPALITY THÉRÈSE-DE BLAINVILLE": "THDB-RC",
    "RESORT COUNTY MUNICIPALITY VAUDREUIL-SOULANGES": "VDSL-RC",
    "ACTON VALE": "ACTN-T",
    "ALMA": "ALM-T",
    "AMOS": "AMS-T",
    "AMQUI": "AMQ-T",
    "ASBESTOS": "ASBS-T",
    "BAIE-COMEAU": "BCM-T",
    "BAIE-D'URFÉ": "BDRF-T",
    "BAIE-SAINT-PAUL": "BSN1-T",
    "BARKMERE": "BRKM-T",
    "BEACONSFIELD": "BCNS-T",
    "BEAUCEVILLE": "BCVL-T",
    "BEAUHARNOIS": "BHRN-T",
    "BEAUPRÉ": "BPR-T",
    "BÉCANCOUR": "BCNC-T",
    "BEDFORD": "BDF1-TS",
    "BELLETERRE": "BLLT-T",
    "BELOEIL": "BLL-T",
    "BERTHIERVILLE": "BRT1-T",
    "BLAINVILLE": "BLNV-T",
    "BOIS-DES-FILION": "BSDS-T",
    "BOISBRIAND": "BSBR-T",
    "BONAVENTURE": "BNVN-T",
    "BOUCHERVILLE": "BCHR-T",
    "BROMONT": "BRMN-T",
    "BROSSARD": "BRSS-T",
    "BROWNSBURG-CHATHAM": "BRWN-T",
    "CANDIAC": "CNDC-H",
    "CAP-CHAT": "CPCH-T",
    "CAP-SANTÉ": "CPS1-T",
    "CARIGNAN": "CRGN-T",
    "CARLETON-SUR-MER": "CRLT-T",
    "CAUSAPSCAL": "CSPS-T",
    "CHAMBLY": "CHM2-T",
    "CHANDLER": "CHND-T",
    "CHAPAIS": "CHPS-T",
    "CHARLEMAGNE": "CHRL-T",
    "CHÂTEAU-RICHER": "CHTR-T",
    "CHÂTEAUGUAY": "CHTG-T",
    "CHIBOUGAMAU": "CHBG-T",
    "CLERMONT": "CLR1-TS",
    "COATICOOK": "CTCK-T",
    "CONTRECŒUR": "CNTR-T",
    "COOKSHIRE-EATON": "CKSH-T",
    "CÔTE-SAINT-LUC": "CTSN-T",
    "COTEAU-DU-LAC": "CTDL-T",
    "COWANSVILLE": "CWNS-T",
    "DANVILLE": "DNVL-T",
    "DAVELUYVILLE": "DVLY-T",
    "DÉGELIS": "DGLS-T",
    "DELSON": "DLSN-T",
    "DESBIENS": "DSBN-T",
    "DEUX-MONTAGNES": "DXMN-T",
    "DISRAELI": "DSR1-T",
    "DOLBEAU-MISTASSINI": "DLBM-T",
    "DOLLARD-DES ORMEAUX": "DLLR-T",
    "DONNACONA": "DNNC-T",
    "DORVAL": "DRVL-T",
    "DRUMMONDVILLE": "DRMM-T",
    "DUNHAM": "DNHM-T",
    "DUPARQUET": "DPRQ-T",
    "EAST ANGUS": "ESTN-T",
    "ESTÉREL": "ESTR-T",
    "FARNHAM": "FRNH-T",
    "FERMONT": "FRM1-T",
    "FORESTVILLE": "FRST-T",
    "FOSSAMBAULT-SUR-LE-LAC": "FSSM-T",
    "GASPÉ": "GSP-T",
    "GATINEAU": "GTN-T",
    "GRACEFIELD": "GRCF-T",
    "GRANBY": "GRNB-T",
    "GRANDE-RIVIÈRE": "GRN4-T",
    "HAMPSTEAD": "HMPS-T",
    "HUNTINGDON": "HNTN-T",
    "JOLIETTE": "JLTT-T",
    "KINGSEY FALLS": "KNGS-T",
    "KIRKLAND": "KRKL-T",
    "L'ANCIENNE-LORETTE": "LNCN-T",
    "L'ASSOMPTION": "LSSM-T",
    "L'ÉPIPHANIE": "LPPH-T",
    "L'ÎLE-CADIEUX": "LLCD-T",
    "L'ÎLE-DORVAL": "LLDR-T",
    "L'ÎLE-PERROT": "LLPR-T",
    "LA MALBAIE": "LMLB-T",
    "LA POCATIÈRE": "LPCT-T",
    "LA PRAIRIE": "LPRR-T",
    "LA SARRE": "LSRR-T",
    "LA TUQUE": "LTQ-T",
    "LAC-BROME": "LCBR-T",
    "LAC-DELAGE": "LCDL-T",
    "LAC-MÉGANTIC": "LCMG-T",
    "LAC-SAINT-JOSEPH": "LCS3-T",
    "LAC-SERGENT": "LCSR-T",
    "LACHUTE": "LCHT-T",
    "LAVAL": "LVL-T",
    "LAVALTRIE": "LVLT-T",
    "LEBEL-SUR-QUÉVILLON": "LBLS-T",
    "LÉRY": "LRY-T",
    "LONGUEUIL": "LNGL-T",
    "LORRAINE": "LRR1-T",
    "LOUISEVILLE": "LSVL-T",
    "MACAMIC": "MCMC-T",
    "MAGOG": "MGG-T",
    "MALARTIC": "MLRT-T",
    "MANIWAKI": "MNWK-T",
    "MARIEVILLE": "MRVL-T",
    "MASCOUCHE": "MSCC-T",
    "MATAGAMI": "MTGM-T",
    "MATANE": "MTN-T",
    "MERCIER": "MRC1-T",
    "MÉTABETCHOUAN--LAC-À-LA-CROIX": "MTBT-T",
    "MÉTIS-SUR-MER": "MTSS-T",
    "MIRABEL": "MRBL-T",
    "MONT-JOLI": "MNTJ-T",
    "MONT-LAURIER": "MNTL-T",
    "MONT-ROYAL": "MNT6-T",
    "MONT-SAINT-HILAIRE": "MNT7-T",
    "MONT-TREMBLANT": "MNTT-T",
    "MONTMAGNY": "MNTM-T",
    "MURDOCHVILLE": "MRDC-T",
    "NEUVILLE": "NVL1-T",
    "NEW RICHMOND": "NWRC-T",
    "NICOLET": "NCLT-T",
    "NORMANDIN": "NRMN-T",
    "NOTRE-DAME-DE-L'ÎLE-PERROT": "NTR25-T",
    "NOTRE-DAME-DES-PRAIRIES": "NTR26-T",
    "OTTERBURN PARK": "OTT1-T",
    "PASPÉBIAC": "PSPB-T",
    "PERCÉ": "PRC-T",
    "PINCOURT": "PNCR-T",
    "PLESSISVILLE": "PLSS-T",
    "POHÉNÉGAMOOK": "PHNG-T",
    "POINTE-CLAIRE": "PNT2-T",
    "PONT-ROUGE": "PNTR-T",
    "PORT-CARTIER": "PRTC-T",
    "PORTNEUF": "PRT1-T",
    "PRÉVOST": "PRVS-T",
    "PRINCEVILLE": "PRNC-T",
    "QUÉBEC": "QBC-T",
    "REPENTIGNY": "RPNT-T",
    "RICHELIEU": "RCHL-T",
    "RIMOUSKI": "RMSK-T",
    "RIVIÈRE-DU-LOUP": "RVRD-T",
    "RIVIÈRE-ROUGE": "RVRR-T",
    "ROBERVAL": "RBRV-T",
    "ROSEMÈRE": "RSMR-T",
    "ROUYN-NORANDA": "RYNN-T",
    "SAGUENAY": "SGNY-T",
    "SAINT-AUGUSTIN-DE-DESMAURES": "SNT414-T",
    "SAINT-BASILE": "SNT415-T",
    "SAINT-BASILE-LE-GRAND": "SNT416-T",
    "SAINT-BRUNO-DE-MONTARVILLE": "SNT417-T",
    "SAINT-CÉSAIRE": "SNT418-T",
    "SAINT-COLOMBAN": "SNT419-T",
    "SAINT-CONSTANT": "SNT420-T",
    "SAINT-EUSTACHE": "SNT421-T",
    "SAINT-FÉLICIEN": "SNT422-T",
    "SAINT-GABRIEL": "SNT423-T",
    "SAINT-GEORGES": "SNT424-T",
    "SAINT-HYACINTHE": "SNT425-T",
    "SAINT-JEAN-SUR-RICHELIEU": "SNT426-T",
    "SAINT-JÉRÔME": "SNT427-T",
    "SAINT-JOSEPH-DE-BEAUCE": "SNT428-T",
    "SAINT-JOSEPH-DE-SOREL": "SNT429-T",
    "SAINT-LAMBERT": "SNT430-T",
    "SAINT-LAZARE": "SNT431-T",
    "SAINT-LIN--LAURENTIDES": "SNT432-T",
    "SAINT-MARC-DES-CARRIÈRES": "SNT433-T",
    "SAINT-OURS": "SNT434-T",
    "SAINT-PAMPHILE": "SNT435-T",
    "SAINT-PASCAL": "SNT436-T",
    "SAINT-PIE": "SNT437-T",
    "SAINT-RAYMOND": "SNT438-T",
    "SAINT-RÉMI": "SNT439-T",
    "SAINT-SAUVEUR": "SNT440-T",
    "SAINT-TITE": "SNT441-T",
    "SAINTE-ADÈLE": "SNT442-T",
    "SAINTE-AGATHE-DES-MONTS": "SNT443-T",
    "SAINTE-ANNE-DE-BEAUPRÉ": "SNT444-T",
    "SAINTE-ANNE-DE-BELLEVUE": "SNT445-T",
    "SAINTE-ANNE-DES-MONTS": "SNT446-T",
    "SAINTE-ANNE-DES-PLAINES": "SNT447-T",
    "SAINTE-CATHERINE": "SNT448-T",
    "SAINTE-CATHERINE-DE-LA-JACQUES-CARTIER": "SNT449-T",
    "SAINTE-JULIE": "SNT450-T",
    "SAINTE-MARGUERITE-DU-LAC-MASSON": "SNT451-T",
    "SAINTE-MARIE": "SNT452-T",
    "SAINTE-MARTHE-SUR-LE-LAC": "SNT453-T",
    "SAINTE-THÉRÈSE": "SNT454-T",
    "SALABERRY-DE-VALLEYFIELD": "SLBR-T",
    "SCHEFFERVILLE": "SCHF-T",
    "SCOTSTOWN": "SCTS-T",
    "SENNETERRE": "SNN1-T",
    "SEPT-ÎLES": "SPTL-T",
    "SHAWINIGAN": "SHWN-T",
    "SOREL-TRACY": "SRLT-T",
    "STANSTEAD": "STN3-TS",
    "SUTTON": "STTN-T",
    "TÉMISCAMING": "TMSC-T",
    "TÉMISCOUATA-SUR-LE-LAC": "TMS1-T",
    "TERREBONNE": "TRRB-T",
    "THETFORD MINES": "THTF-T",
    "THURSO": "THRS-T",
    "TROIS-PISTOLES": "TRSP-T",
    "TROIS-RIVIÈRES": "TRS2-T",
    "VAL-D'OR": "VLDR-T",
    "VALCOURT": "VLC1-TS",
    "VARENNES": "VRNN-T",
    "VAUDREUIL-DORION": "VDRL-T",
    "VICTORIAVILLE": "VCTR-T",
    "VILLE-MARIE": "VLLM-T",
    "WATERVILLE": "WTRV-T",
    "WESTMOUNT": "WSTM-T",
    "ARUNDEL": "ARND-TS",
    "AUMOND": "AMND-TS",
    "CHICHESTER": "CHCH-TS",
    "CLEVELAND": "CLVL-TS",
    "CLORIDORME": "CLRD-TS",
    "GODMANCHESTER": "GDMN-TS",
    "GORE": "GR-TS",
    "GUÉRIN": "GRN-TS",
    "HAM-NORD": "HMNR-TS",
    "HARRINGTON": "HRRN-TS",
    "HEMMINGFORD": "HMM1-V",
    "LANDRIENNE": "LNDR-TS",
    "LAUNAY": "LNY-TS",
    "LINGWICK": "LNGW-TS",
    "LOCHABER": "LCHB-TS",
    "LOCHABER-PARTIE-OUEST": "LCH1-TS",
    "LOW": "LW-TS",
    "MARSTON": "MRST-TS",
    "MELBOURNE": "MLBR-TS",
    "NÉDÉLEC": "NDLC-TS",
    "ORFORD": "ORFR-TS",
    "POTTON": "PTTN-TS",
    "RISTIGOUCHE-PARTIE-SUD-EST": "RSTG-TS",
    "ROXTON": "RXT1-TS",
    "SAINT-CAMILLE": "SNT455-TS",
    "SAINT-GODEFROI": "SNT456-TS",
    "SAINTE-EDWIDGE-DE-CLIFTON": "SNT457-TS",
    "SHEFFORD": "SHFF-TS",
    "TRÉCESSON": "TRCS-TS",
    "WENTWORTH": "WNT1-TS",
    "WESTBURY": "WSTB-TS",
    "UNITED TOWNSHIP OF LATULIPE-ET-GABOURY": "LTLP-UT",
    "UNITED TOWNSHIP OF STONEHAM-ET-TEWKESBURY": "STNH-UT",
    "ABERCORN": "ABRC-V",
    "ANGLIERS": "ANGL-V",
    "AYER'S CLIFF": "AYRS-V",
    "BAIE-TRINITÉ": "BTRN-V",
    "BROME": "BRM-V",
    "CHUTE-AUX-OUTARDES": "CHTX-V",
    "FORT-COULONGE": "FRTC-V",
    "GODBOUT": "GDBT-V",
    "GRANDES-PILES": "GRN5-V",
    "GRENVILLE": "GRN6-V",
    "HÉBERTVILLE-STATION": "HBR1-V",
    "KINGSBURY": "KNG1-V",
    "LA GUADELOUPE": "LGDL-V",
    "LAC-POULIN": "LCPL-V",
    "LAC-SAGUAY": "LCSG-V",
    "LAURIER-STATION": "LRRS-V",
    "LAWRENCEVILLE": "LWRN-V",
    "MARSOUI": "MRS-V",
    "MASSUEVILLE": "MSSV-V",
    "MONT-SAINT-PIERRE": "MNT8-V",
    "NORTH HATLEY": "NRTH-V",
    "NOTRE-DAME-DU-BON-CONSEIL": "NTR27-V",
    "POINTE-AUX-OUTARDES": "PNTX-V",
    "POINTE-DES-CASCADES": "PNTD-V",
    "POINTE-FORTUNE": "PNTF-V",
    "POINTE-LEBEL": "PNT3-V",
    "PORTAGE-DU-FORT": "PRTG-V",
    "PRICE": "PRC1-V",
    "ROXTON FALLS": "RXT2-V",
    "SAINT-ANDRÉ-DU-LAC-SAINT-JEAN": "SNT458-V",
    "SAINT-NOËL": "SNT460-V",
    "SAINT-PIERRE": "SNT461-V",
    "SAINTE-JEANNE-D'ARC": "SNT462-V",
    "SAINTE-MADELEINE": "SNT463-V",
    "SAINTE-PÉTRONILLE": "SNT464-V",
    "SENNEVILLE": "SNNV-V",
    "STUKELY-SUD": "STKL-V",
    "TADOUSSAC": "TDSS-V",
    "TRING-JONCTION": "TRNG-V",
    "VAL-DAVID": "VLDV-V",
    "VAUDREUIL-SUR-LE-LAC": "VDR1-V",
    "WARDEN": "WRDN-V",
    "AHUNTSIC, MONTREAL": "MON-AHNT-N",
    "BAIE-D'URFÉ, MONTREAL": "MON-BDRF-N",
    "BAS-ANJOU, MONTREAL": "MON-BSNJ-N",
    "BEACONSFIELD, MONTREAL": "MON-BCNS-N",
    "BEAURIVAGE, MONTREAL": "MON-BRVG-N",
    "BOIS-DES-FILION, MONTREAL": "MON-BSDS-N",
    "BOIS-FRANC, MONTREAL": "MON-BSFR-N",
    "CANDIAC, MONTREAL": "MON-CNDC-N",
    "CARTIERVILLE, MONTREAL": "MON-CRTR-N",
    "CECILE-P-NEWMAN, MONTREAL": "MON-CCLP-N",
    "CHAMERAN, MONTREAL": "MON-CHMR-N",
    "CITÉ DU HAVRE, MONTREAL": "MON-CTDH-N",
    "CITÉ DU MULTIMÉDIA, MONTREAL": "MON-CTDM-N",
    "COSMOS, MONTREAL": "MON-CSMS-N",
    "CÔTE-DES-NEIGES, MONTREAL": "MON-CTDS-N",
    "CÔTE-SAINT-LUC, MONTREAL": "MON-CTSN-N",
    "CÔTE-SAINT-PAUL, MONTREAL": "MON-CTS1-N",
    "CRÉMAZIE, MONTREAL": "MON-CRMZ-N",
    "DELORIMIER, MONTREAL": "MON-DLRM-N",
    "DELSON, MONTREAL": "MON-DLSN-N",
    "DESMARCHAIS-CRAWFORD, MONTREAL": "MON-DSMR-N",
    "DEUX-MONTAGNES, MONTREAL": "MON-DXMN-N",
    "DU COLLÈGE, MONTREAL": "MON-DCLL-N",
    "DUPÉRÉ, MONTREAL": "MON-DPRM-N",
    "FRANÇOIS-PERRAULT, MONTREAL": "MON-FRNS-N",
    "GABRIEL-SAGARD, MONTREAL": "MON-GBRL-N",
    "GALERIES D'ANJOU, MONTREAL": "MON-GLRS-N",
    "GRAND PRAIRIE, MONTREAL": "MON-GRND-N",
    "GRENET, MONTREAL": "MON-GRNT-N",
    "GRIFFINTOWN, MONTREAL": "MON-GRFF-N",
    "GUYBOURG, MONTREAL": "MON-GYBR-N",
    "HAMPSTEAD, MONTREAL": "MON-HMPS-N",
    "HAUT LACHINE, MONTREAL": "MON-HTLC-N",
    "HAUT-ANJOU, MONTREAL": "MON-HTNJ-N",
    "HOCHELAGA, MONTREAL": "MON-HCHL-N",
    "ÎLE MERCIER, MONTREAL": "MON-LMRC-N",
    "ÎLE-DES-SOEURS, MONTREAL": "MON-LDSS-N",
    "JACQUES-BIZARD, MONTREAL": "MON-JCQS-N",
    "KANESATAKE, MONTREAL": "MON-KNST-N",
    "L'ÎLE-CADIEUX, MONTREAL": "MON-LLCD-N",
    "L'ÎLE-DORVAL, MONTREAL": "MON-LLDR-N",
    "L'ÎLE-PERROT, MONTREAL": "MON-LLPR-N",
    "LA PETITE-ITALIE, MONTREAL": "MON-LPTT-N",
    "LA POINTE-AUX-PRAIRIES, MONTREAL": "MON-LPNT-N",
    "LA PRAIRIE, MONTREAL": "MON-LPRR-N",
    "LA VISITATION, MONTREAL": "MON-LVST-N",
    "LACHINE, MONTREAL": "MON-LCHN-N",
    "LACHINE-OUEST, MONTREAL": "MON-LCH1-N",
    "BASSE - VILLE, QUÉBEC CITY": "QUE-BSSV-N",
    "CAP-ROUGE, QUÉBEC CITY": "QUE-CPRG-N",
    "CENTRE-VILLE QUÉBEC CITY, QUÉBEC CITY": "QUE-CNTR-N",
    "CHUTES-MONTMORENCY, QUÉBEC CITY": "QUE-CHTS-N",
    "CITÉ-UNIVERSITAIRE, QUÉBEC CITY": "QUE-CTNV-N",
    "DES CHÂTELS, QUÉBEC CITY": "QUE-DSCH-N",
    "DUBERGER-LES SAULES, QUÉBEC CITY": "QUE-DBRG-N",
    "HAUTE - VILLE, QUÉBEC CITY": "QUE-HTVL-N",
    "JEAN-LESAGE AEROPORT, QUÉBEC CITY": "QUE-JNLS-N",
    "JÉSUITES, QUÉBEC CITY": "QUE-JSTS-N",
    "L'AÉROPORT, QUÉBEC CITY": "QUE-LRPR-N",
    "L'ANGE-GARDIEN, QUÉBEC CITY": "QUE-LNGG-N",
    "LAC-SAINT-CHARLES, QUÉBEC CITY": "QUE-LCSN-N",
    "LAIRET, QUÉBEC CITY": "QUE-LRTQ-N",
    "LE QUARTIER PETIT CHAMPLAIN, QUÉBEC CITY": "QUE-LQRT-N",
    "LORETTEVILLE, QUÉBEC CITY": "QUE-LRTT-N",
    "MAIZERETS, QUÉBEC CITY": "QUE-MZRT-N",
    "MONTCALM, QUÉBEC CITY": "QUE-MNTC-N",
    "NEUFCHÂTEL EST-LEBOURGNEUF, QUÉBEC CITY": "QUE-NFCH-N",
    "NOTRE-DAME-DES-LAURENTIDES, QUÉBEC CITY": "QUE-NTRD-N",
    "PLATEAU, QUÉBEC CITY": "QUE-PLTQ-N",
    "POINTE-DE-SAINTE-FOY, QUÉBEC CITY": "QUE-PNTD-N",
    "QUARTIER 4-2, QUÉBEC CITY": "QUE-QRTR-N",
    "QUARTIER 4-3, QUÉBEC CITY": "QUE-QRT1-N",
    "QUARTIER 4-5, QUÉBEC CITY": "QUE-QRT2-N",
    "QUARTIER 4-6, QUÉBEC CITY": "QUE-QRT3-N",
    "QUARTIER 5-1, QUÉBEC CITY": "QUE-QRT4-N",
    "QUARTIER 5-2, QUÉBEC CITY": "QUE-QRT5-N",
    "QUARTIER 5-4, QUÉBEC CITY": "QUE-QRT6-N",
    "SAINT LOUIS, QUÉBEC CITY": "QUE-SNTL-N",
    "SAINT-AUGUSTIN-DE-DESMAURES, QUÉBEC CITY": "QUE-SNTG-N",
    "SAINT-ÉMILE, QUÉBEC CITY": "QUE-SNTM-N",
    "SAINT-JEAN-BAPTISTE, QUÉBEC CITY": "QUE-SNTJ-N",
    "SAINT-ROCH, QUÉBEC CITY": "QUE-SNTR-N",
    "SAINT-SACREMENT, QUÉBEC CITY": "QUE-SNTS-N",
    "SAINT-SAUVEUR, QUÉBEC CITY": "QUE-SNT1-N",
    "SILLERY, QUÉBEC CITY": "QUE-SLLR-N",
    "VAL-BÉLAIR, QUÉBEC CITY": "QUE-VLBL-N",
    "VANIER, QUÉBEC CITY": "QUE-VNRQ-N",
    "VIEUX-LIMOILOU, QUÉBEC CITY": "QUE-VXLM-N",
    "VIEUX-MOULIN, QUÉBEC CITY": "QUE-VXML-N",
    "AUTEUIL, LAVAL": "LAV-ATLL-N",
    "CHOMEDEY, LAVAL": "LAV-CHMD-N",
    "DUVERNAY, LAVAL": "LAV-DVRN-N",
    "FABREVILLE, LAVAL": "LAV-FBRV-N",
    "LAVAL-DES-RAPIDES, LAVAL": "LAV-LVLD-N",
    "LAVAL-OUEST, LAVAL": "LAV-LVLS-N",
    "LAVAL-SUR-LE-LAC, LAVAL": "LAV-LVL1-N",
    "PONT-VIAU, LAVAL": "LAV-PNTV-N",
    "SAINT DOROTHÉE, LAVAL": "LAV-SNTD-N",
    "SAINT-FRANÇOIS, LAVAL": "LAV-SNTF-N",
    "SAINT-VINCENT-DE-PAUL, LAVAL": "LAV-SNTV-N",
    "SAINTE-ROSE, LAVAL": "LAV-SNT2-N",
    "VILLE DE SAINT-FRANÇOIS, LAVAL": "LAV-VLLD-N",
    "VIMONT, LAVAL": "LAV-VMNT-N",
    "ACHBAR, GATINEAU": "GAT-ACHB-N",
    "ANGERS, GATINEAU": "GAT-ANGR-N",
    "BASSIN-DE-LA-LIÈVRE, GATINEAU": "GAT-BSSN-N",
    "CARREFOUR-DE-L'HÔPITAL DISTRICT, GATINEAU": "GAT-CRRF-N",
    "CENTRE-VILLE, GATINEAU": "GAT-CNT1-N",
    "CHAMPLAIN PARK, GATINEAU": "GAT-CHMP-N",
    "CÔTE D'AZUR, GATINEAU": "GAT-CTDZ-N",
    "CÔTE-DES-NEIGES, GATINEAU": "GAT-CTD1-N",
    "COTEVILLE, GATINEAU": "GAT-CTVL-N",
    "DES CEDRES, GATINEAU": "GAT-DSCD-N",
    "DES EXPLORATEURS, GATINEAU": "GAT-DSXP-N",
    "DES PIONNIERS, GATINEAU": "GAT-DSPN-N",
    "DESCHENES, GATINEAU": "GAT-DSC1-N",
    "DISTRICT DE BELLEVUE, GATINEAU": "GAT-DSTR-N",
    "DOMAINE DE LA VÉRENDRYE, GATINEAU": "GAT-DMND-N",
    "DOMAINE-GLENWOOD, GATINEAU": "GAT-DMNG-N",
    "DOWNTOWN GATINEAU, GATINEAU": "GAT-DWNT-N",
    "DU MOULIN, GATINEAU": "GAT-DMLN-N",
    "DU PARC, GATINEAU": "GAT-DPRC-N",
    "DU PLATEAU, GATINEAU": "GAT-DPLT-N",
    "HAUTES-PLAINES, GATINEAU": "GAT-HTSP-N",
    "ÎLE DE HULL, GATINEAU": "GAT-LDHL-N",
    "JARDINS LAVIGNE, GATINEAU": "GAT-JRDN-N",
    "LA CITÉ, GATINEAU": "GAT-LCTG-N",
    "LA SEIGNEURIE, GATINEAU": "GAT-LSGN-N",
    "LAC-DES-FÉES, GATINEAU": "GAT-LCDS-N",
    "LAC-DESCHÊNES, GATINEAU": "GAT-LCD1-N",
    "LAKEVIEW TERRACE, GATINEAU": "GAT-LKVW-N",
    "LE BARON, GATINEAU": "GAT-LBRN-N",
    "LE CARREFOUR, GATINEAU": "GAT-LCRR-N",
    "LES GOLFS, GATINEAU": "GAT-LSGL-N",
    "LES RAPIDES, GATINEAU": "GAT-LSRP-N",
    "LIMBOUR, GATINEAU": "GAT-LMBR-N",
    "LUCERNE NORD, GATINEAU": "GAT-LCRN-N",
    "MANOIR DES TREMBLES, GATINEAU": "GAT-MNRD-N",
    "MASSON, GATINEAU": "GAT-MSSN-N",
    "MONT-BLEU, GATINEAU": "GAT-MNTB-N",
    "MONT-LUC, GATINEAU": "GAT-MNTL-N",
    "NOTRE-DAME, GATINEAU": "GAT-NTR1-N",
    "PARC AYLMER, GATINEAU": "GAT-PRCY-N",
    "PARC DE LA MONTAGNE, GATINEAU": "GAT-PRCD-N",
    "QUEENS'S PARK, GATINEAU": "GAT-QNSS-N",
    "RIVIERA, GATINEAU": "GAT-RVRG-N",
    "RIVIÈRE-BLANCHE, GATINEAU": "GAT-RVRB-N",
    "RIVIÈRE-GATINEAU, GATINEAU": "GAT-RVR1-N",
    "ST JEAN BOSCO, GATINEAU": "GAT-STJN-N",
    "TERRASSES-PAIEMENT, GATINEAU": "GAT-TRRS-N",
    "VAL-TETRAULT, GATINEAU": "GAT-VLTT-N",
    "BRENTWOOD, LONGUEUIL": "LON-BRNT-N",
    "BROOKLINE, LONGUEUIL": "LON-BRKL-N",
    "CARILLON - SAINT-PIE-D, LONGUEUIL": "LON-CRLL-N",
    "CASTLE GARDENS, LONGUEUIL": "LON-CSTL-N",
    "CROYDON, LONGUEUIL": "LON-CRYD-N",
    "DU BOISÉ DU TREMBLAY, LONGUEUIL": "LON-DBSD-N",
    "EAST GREENFIELD, LONGUEUIL": "LON-ESTG-N",
    "FATIMA-PARCOURS-DU-CERF, LONGUEUIL": "LON-FTMP-N",
    "GREENFIELD PARK, LONGUEUIL": "LON-GRNF-N",
    "IBERVILLE, LONGUEUIL": "LON-IBRV-N",
    "LAFLÈCHE, LONGUEUIL": "LON-LFLC-N",
    "LEMOYNE, LONGUEUIL": "LON-LMYN-N",
    "MARAÎCHERS, LONGUEUIL": "LON-MRCH-N",
    "NEW GREENFIELD PARK, LONGUEUIL": "LON-NWGR-N",
    "NOTRE-DAME-DE-GRÂCES, LONGUEUIL": "LON-NTR2-N",
    "NOTRE-DAME-DE-LA-GARDE, LONGUEUIL": "LON-NTR3-N",
    "PARC-DE-LA-CITÉ, LONGUEUIL": "LON-PRC1-N",
    "PARC-MICHEL-CHARTRAND, LONGUEUIL": "LON-PRCM-N",
    "PARCOURS DU CERF, LONGUEUIL": "LON-PRCR-N",
    "PINEHURST, LONGUEUIL": "LON-PNHR-N",
    "PLACE LONGUEUIL, LONGUEUIL": "LON-PLCL-N",
    "QUARTIER SAINT-VINCENT-DE-PAUL, LONGUEUIL": "LON-QRT7-N",
    "QUARTIER VIEUX LONGUEUIL, LONGUEUIL": "LON-QRT8-N",
    "SACRÉ-COEUR, LONGUEUIL": "LON-SCRC-N",
    "SAINT ROBERT, LONGUEUIL": "LON-SNT3-N",
    "SAINT-JEAN-VIANNEY, LONGUEUIL": "LON-SNT4-N",
    "SPRINGFIELD PARK, LONGUEUIL": "LON-SPRN-N",
    "VIEUX-SAINT-HUBERT-LA-SAVANNE, LONGUEUIL": "LON-VXSN-N",
    "CENTRE-VILLE, SHERBROOKE": "SHE-CNT2-N",
    "D'ASCOT, SHERBROOKE": "SHE-DSCT-N",
    "D'UPLANDS, SHERBROOKE": "SHE-DPLN-N",
    "DE BEAUVOIR, SHERBROOKE": "SHE-DBVR-N",
    "DE BECKETT, SHERBROOKE": "SHE-DBCK-N",
    "DE DEAUVILLE, SHERBROOKE": "SHE-DDVL-N",
    "DE DESRANLEAU, SHERBROOKE": "SHE-DDSR-N",
    "DE FAIRVIEW, SHERBROOKE": "SHE-DFRV-N",
    "DE L'HOTEL - DIEU, SHERBROOKE": "SHE-DLHT-N",
    "DE L'UNIVERSITÉ, SHERBROOKE": "SHE-DLNV-N",
    "DE LA CROIX-LUMINEUSE, SHERBROOKE": "SHE-DLCR-N",
    "DE MARIE-RIVIER, SHERBROOKE": "SHE-DMRR-N",
    "DE ROCK FOREST, SHERBROOKE": "SHE-DRCK-N",
    "DE SAINT-ÉLIE, SHERBROOKE": "SHE-DSNT-N",
    "DES CHÂTEAUX-D'EAU, SHERBROOKE": "SHE-DSC2-N",
    "DES MOULINS, SHERBROOKE": "SHE-DSML-N",
    "DES QUATRE-SAISONS, SHERBROOKE": "SHE-DSQT-N",
    "DU CARREFOUR, SHERBROOKE": "SHE-DCRR-N",
    "DU CENTRE-SUD, SHERBROOKE": "SHE-DCNT-N",
    "DU GOLF, SHERBROOKE": "SHE-DGLF-N",
    "DU LAC-DES-NATIONS, SHERBROOKE": "SHE-DLCD-N",
    "DU PIN-SOLITAIRE, SHERBROOKE": "SHE-DPNS-N",
    "LE VIEUX NORD, SHERBROOKE": "SHE-LVXN-N",
    "BERNIERES-SAINT-NICOLAS, LEVIS": "LEV-BRNR-N",
    "CHARNY, LEVIS": "LEV-CHRN-N",
    "PINTENDRE, LEVIS": "LEV-PNTN-N",
    "SAINT-ETIENNE-DE-LAUZON, LEVIS": "LEV-SNTT-N",
    "SAINT-JEAN-CHRYSOSTOME, LEVIS": "LEV-SNT5-N",
    "SAINT-JOSEPH-DE-LA-POINTE-DE-LEVY, LEVIS": "LEV-SNT6-N",
    "SAINT-REDEMPTEUR, LEVIS": "LEV-SNT7-N",
    "SAINT-ROMUALD, LEVIS": "LEV-SNT8-N",
    "SAINTE-HELENE-DE-BREAKEYVILLE, LEVIS": "LEV-SNTH-N",
    "ARVIDA, SAGUENAY": "SAG-ARVD-N",
    "BRISSON, SAGUENAY": "SAG-BRSS-N",
    "CENTRE-VILLE SAGUENAY, SAGUENAY": "SAG-CNT3-N",
    "CHICOUTIMI-NORD, SAGUENAY": "SAG-CHCT-N",
    "DES ANGLAIS, SAGUENAY": "SAG-DSNG-N",
    "DES ECRIVAINS, SAGUENAY": "SAG-DSCR-N",
    "DES OISEAUX, SAGUENAY": "SAG-DSSX-N",
    "DES ORCHIDÉES EST, SAGUENAY": "SAG-DSRC-N",
    "DES ORCHIDÉES OUEST, SAGUENAY": "SAG-DSR1-N",
    "DES PEINTRES, SAGUENAY": "SAG-DSP1-N",
    "DOMAINE DU ROI, SAGUENAY": "SAG-DMN1-N",
    "DUBOSE, SAGUENAY": "SAG-DBSS-N",
    "FAY, SAGUENAY": "SAG-FYSG-N",
    "FLAMAND, SAGUENAY": "SAG-FLMN-N",
    "LA BAIE, SAGUENAY": "SAG-LBSG-N",
    "LANGELIER, SAGUENAY": "SAG-LNGL-N",
    "LEGARDEUR, SAGUENAY": "SAG-LGRD-N",
    "MANOIR, SAGUENAY": "SAG-MNRS-N",
    "NOTRE DAME, SAGUENAY": "SAG-NTR4-N",
    "PETIT MATHIAS, SAGUENAY": "SAG-PTTM-N",
    "PLACE DES COPAINS, SAGUENAY": "SAG-PLCD-N",
    "PLATEAU DES SAGUENÉENS, SAGUENAY": "SAG-PLTD-N",
    "POLYCLINIQUE, SAGUENAY": "SAG-PLYC-N",
    "SAINT PIERRE, SAGUENAY": "SAG-SNTP-N",
    "SHIPSHAW, SAGUENAY": "SAG-SHPS-N",
    "ST PHILIPPE, SAGUENAY": "SAG-STPH-N",
    "TREMBLAY, SAGUENAY": "SAG-TRMB-N",
    "VANIER, SAGUENAY": "SAG-VNRS-N",
    "BAIE-JOLIE, TROY-RIVIERES": "TRO-BJLT-N",
    "CAP-DE-LA-MADELEINE, TROY-RIVIERES": "TRO-CPDL-N",
    "DE NORMANVILLE, TROY-RIVIERES": "TRO-DNRM-N",
    "DEMONTIGNY, TROY-RIVIERES": "TRO-DMNT-N",
    "LES VIEILLES-FORGES, TROY-RIVIERES": "TRO-LSVL-N",
    "PARC-ISABEAU, TROY-RIVIERES": "TRO-PRCS-N",
    "POINTE-DU-LAC, TROY-RIVIERES": "TRO-PNT1-N",
    "SAINT-LOUIS-DE-CHAMPLAIN, TROY-RIVIERES": "TRO-SNT9-N",
    "SAINT-LOUIS-DE-FRANCE, TROY-RIVIERES": "TRO-SNT10-N",
    "SAINT-PATRICK, TROY-RIVIERES": "TRO-SNT11-N",
    "SAINTE-CATHERINE, TROY-RIVIERES": "TRO-SNTC-N",
    "SAINTE-MARGUERITE, TROY-RIVIERES": "TRO-SNT12-N",
    "SECTEUR-LAMBERT, TROY-RIVIERES": "TRO-SCTR-N",
    "SECTEUR-LAURENTIEN, TROY-RIVIERES": "TRO-SCT1-N",
    "TERRASSE-DUVERNAY, TROY-RIVIERES": "TRO-TRR1-N",
    "TROIS-RIVIÈRES CENTRE VILLE, TROY-RIVIERES": "TRO-TRSR-N",
    "TROIS-RIVIÈRES-OUEST, TROY-RIVIERES": "TRO-TRS1-N",
    "VAL-MAURICIE, TROY-RIVIERES": "TRO-VLMR-N",
    "VILLAGE-DES-CRÊTE, TROY-RIVIERES": "TRO-VLLG-N",
    "BOIS DE LAPINI, TERREBONNE": "TER-BSDL-N",
    "CHEMIN COMTOIS, TERREBONNE": "TER-CHMN-N",
    "CITÉ INDUSTRIELLE INTERNATIONALE, TERREBONNE": "TER-CTND-N",
    "CÔTE DU TERREBONNE, TERREBONNE": "TER-CTDT-N",
    "DOMAINE SAINT-CHARLES, TERREBONNE": "TER-DMNS-N",
    "GOLF LE BOISE, TERREBONNE": "TER-GLFL-N",
    "ÎLE ST JEAN, TERREBONNE": "TER-LSTJ-N",
    "LA PLAINE, TERREBONNE": "TER-LPLN-N",
    "LAC-ANDRE, TERREBONNE": "TER-LCND-N",
    "LACHENAIE, TERREBONNE": "TER-LCH2-N",
    "SAINT LOUIS HAUTEVILLE, TERREBONNE": "TER-SNT13-N",
    "SAINT-LOUIS-DE-TERREBONNE, TERREBONNE": "TER-SNT14-N",
    "SECTEUR ANGORA, TERREBONNE": "TER-SCT2-N",
    "SECTEUR GEORGES VI, TERREBONNE": "TER-SCT3-N",
    "SECTEUR LACHENAIE, TERREBONNE": "TER-SCT4-N",
    "SECTEUR LEVEILLE, TERREBONNE": "TER-SCT5-N",
    "TERREBONNE CENTRE, TERREBONNE": "TER-TRRB-N",
    "VIEUX-TERREBONNE, TERREBONNE": "TER-VXTR-N",
    "VILLAGE DE LA PLAINE, TERREBONNE": "TER-VLL1-N",
    "ESTEVAN": "ESTV-C",
    "HUMBOLDT": "HMBL-C",
    "MARTENSVILLE": "MRTN-C",
    "MEADOW LAKE": "MDWL-C",
    "MELFORT": "MLFR-C",
    "MELVILLE": "MLVL-C",
    "MOOSE JAW": "MSJW-C",
    "NORTH BATTLEFORD": "NRTH-C",
    "PRINCE ALBERT": "PRNC-C",
    "REGINA": "RGN-C",
    "SASKATOON": "SSKT-C",
    "SWIFT CURRENT": "SWFT-C",
    "WARMAN": "WRMN-C",
    "WEYBURN": "WYBR-C",
    "YORKTON": "YRKT-C",
    "ABERDEEN": "ABRD-T",
    "ALAMEDA": "ALMD-T",
    "ALLAN": "ALLN-T",
    "ARBORFIELD": "ARBR-T",
    "ARCOLA": "ARCL-T",
    "ASQUITH": "ASQT-T",
    "ASSINIBOIA": "ASSN-T",
    "BALCARRES": "BLCR-T",
    "BALGONIE": "BLGN-T",
    "BATTLEFORD": "BTTL-T",
    "BENGOUGH": "BNGG-T",
    "BIENFAIT": "BNFT-T",
    "BIG RIVER": "BGRV-T",
    "BIGGAR": "BGGR-T",
    "BLAINE LAKE": "BLNL-T",
    "BREDENBURY": "BRDN-T",
    "BROADVIEW": "BRDV-T",
    "BRUNO": "BRN-T",
    "BURSTALL": "BRST-T",
    "CABRI": "CBR-T",
    "CANORA": "CNR-T",
    "CARLYLE": "CRLY-T",
    "CARNDUFF": "CRND-T",
    "CARROT RIVER": "CRRT-T",
    "CENTRAL BUTTE": "CNTR-T",
    "CHOICELAND": "CHCL-T",
    "CHURCHBRIDGE": "CHRC-T",
    "COLONSAY": "CLNS-T",
    "CORONACH": "CRNC-T",
    "CRAIK": "CRK-T",
    "CUDWORTH": "CDWR-T",
    "CUPAR": "CPR-T",
    "CUT KNIFE": "CTKN-T",
    "DALMENY": "DLMN-T",
    "DAVIDSON": "DVDS-T",
    "DELISLE": "DLSL-T",
    "DUCK LAKE": "DCKL-T",
    "DUNDURN": "DNDR-T",
    "EASTEND": "ESTN-T",
    "EATONIA": "ETN-T",
    "ELROSE": "ELRS-T",
    "ESTERHAZY": "ESTR-T",
    "ESTON": "EST1-T",
    "FLEMING": "FLMN-T",
    "FOAM LAKE": "FMLK-T",
    "FORT QU'APELLE": "FRTQ-T",
    "FRANCIS": "FRNC-T",
    "GOVAN": "GVN-T",
    "GRAND COULEE": "GRND-T",
    "GRAVELBOURG": "GRVL-T",
    "GRENFELL": "GRNF-T",
    "HAFFORD": "HFFR-T",
    "HAGUE": "HG-T",
    "HANLEY": "HNLY-T",
    "HEPBURN": "HPBR-T",
    "HERBERT": "HRBR-T",
    "HUDSON BAY": "HDSN-T",
    "IMPERIAL": "IMPR-T",
    "INDIAN HEAD": "INDN-T",
    "ITUNA": "ITN-T",
    "KAMSACK": "KMSC-T",
    "KELVINGTON": "KLVN-T",
    "KERROBERT": "KRRB-T",
    "KINDERSLEY": "KNDR-T",
    "KINISTINO": "KNST-T",
    "KIPLING": "KPLN-T",
    "KYLE": "KYL-T",
    "LAFLECHE": "LFLC-T",
    "LAMPMAN": "LMPM-T",
    "LANGENBURG": "LNGN-T",
    "LANGHAM": "LNGH-T",
    "LANIGAN": "LNG1-T",
    "LASHBURN": "LSHB-T",
    "LEADER": "LDR-T",
    "LEMBERG": "LMBR-T",
    "LEROY": "LRY-T",
    "LUSELAND": "LSLN-T",
    "MACKLIN": "MCKL-T",
    "MAIDSTONE": "MDST-T",
    "MAPLE CREEK": "MPLC-T",
    "MARSHALL": "MRSH-T",
    "MIDALE": "MDL-T",
    "MILESTONE": "MLST-T",
    "MOOSOMIN": "MSMN-T",
    "MORSE": "MRS-T",
    "MOSSBANK": "MSSB-T",
    "NAICAM": "NCM-T",
    "NIPAWIN": "NPWN-T",
    "NOKOMIS": "NKMS-T",
    "NORQUAY": "NRQY-T",
    "OGEMA": "OGM-T",
    "OSLER": "OSLR-T",
    "OUTLOOK": "OTLK-T",
    "OXBOW": "OXBW-T",
    "PENSE": "PNS-T",
    "PILOT BUTTE": "PLTB-T",
    "PONTEIX": "PNTX-T",
    "PORCUPINE PLAIN": "PRCP-T",
    "PREECEVILLE": "PRCV-T",
    "QU'APELLE": "QPLL-T",
    "RADISSON": "RDSS-T",
    "RADVILLE": "RDVL-T",
    "RAYMORE": "RYMR-T",
    "REDVERS": "RDVR-T",
    "REGINA BEACH": "RGNB-T",
    "ROCANVILLE": "RCNV-T",
    "ROCKGLEN": "RCKG-T",
    "ROSE VALLEY": "RSVL-T",
    "ROSETOWN": "RSTW-T",
    "ROSTHERN": "RSTH-T",
    "ROULEAU": "RL-T",
    "SALTCOATS": "SLTC-T",
    "SHAUNAVON": "SHNV-T",
    "SHELLBROOK": "SHLL-T",
    "SINTALUTA": "SNTL-T",
    "SOUTHEY": "STHY-T",
    "SPIRITWOOD": "SPRT-T",
    "SPRINGSIDE": "SPRN-T",
    "ST BRIEUX": "STBR-T",
    "ST WALBURG": "STWL-T",
    "STAR CITY": "STRC-T",
    "STOUGHTON": "STGH-T",
    "STRASBOURG": "STRS-T",
    "STURGIS": "STRG-T",
    "TISDALE": "TSDL-T",
    "TURTLEFORD": "TRTL-T",
    "UNITY": "UNTY-T",
    "VONDA": "VND-T",
    "WADENA": "WDN-T",
    "WAKAW": "WKW-T",
    "WALDHEIM": "WLDH-T",
    "WAPELLA": "WPLL-T",
    "WATROUS": "WTRS-T",
    "WATSON": "WTSN-T",
    "WAWOTA": "WWT-T",
    "WHITE CITY": "WHTC-T",
    "WHITEWOOD": "WHTW-T",
    "WILKIE": "WLK-T",
    "WILLOW BUNCH": "WLLW-T",
    "WOLSELEY": "WLSL-T",
    "WYNYARD": "WYNY-T",
    "YELLOW GRASS": "YLLW-T",
    "ZEALANDIA": "ZLND-T",
    "ALTA VISTA": "ALTV-H",
    "AMSTERDAM": "AMST-H",
    "ARLINGTON BEACH": "ARLN-H",
    "BALONE BEACH": "BLNB-H",
    "BARRIER FORD": "BRRR-H",
    "BAYARD": "BYRD-H",
    "BAYVIEW HEIGHTS": "BYVW-H",
    "BEAUBIER": "BBR-H",
    "BEAVER CREEK": "BVRC-H",
    "BELLEGARDE": "BLLG-H",
    "BIG BEAVER": "BGBV-H",
    "BLUMENTHAL": "BLMN-H",
    "BRANCEPETH": "BRNC-H",
    "BURGIS BEACH": "BRGS-H",
    "CANNINGTON LAKE": "CNNN-H",
    "CARON": "CRN-H",
    "CASA RIO": "CSR-H",
    "CATHEDRAL BLUFFS": "CTHD-H",
    "CEDAR VILLA ESTATES": "CDRV-H",
    "CHELAN": "CHLN-H",
    "CLAYBANK": "CLYB-H",
    "COLESDALE PARK": "CLSD-H",
    "COLLINGWOOD LAKESHORE ESTATES": "CLLN-H",
    "CONGRESS": "CNGR-H",
    "CORNING": "CRNN-H",
    "CRAWFORD ESTATES": "CRWF-H",
    "CRUTWELL": "CRTW-H",
    "CRYSTAL BAY-SUNSET": "CRYS-H",
    "CRYSTAL LAKE": "CRY1-H",
    "CUDSASKWA BEACH": "CDSS-H",
    "DARLINGS BEACH": "DRLN-H",
    "DAVIN": "DVN-H",
    "DAY'S BEACH": "DYSB-H",
    "DEER VALLEY": "DRVL-H",
    "DELMAS": "DLMS-H",
    "DEMAINE": "DMN-H",
    "DISCOVERY RIDGE": "DSCV-H",
    "EAGLE RIDGE COUNTRY ESTATES": "EGLR-H",
    "EDGELEY": "EDGL-H",
    "ELBOW LAKE": "ELBW-H",
    "ELK RIDGE": "ELKR-H",
    "ERWOOD": "ERWD-H",
    "EVERGREEN ACRES": "EVRG-H",
    "EVERGREEN BEACH": "EVR1-H",
    "EXNER'S TWIN BAYS": "EXNR-H",
    "FAIRHOLME": "FRHL-H",
    "FAIRY GLEN": "FRYG-H",
    "FISKE": "FSK-H",
    "FRENCHMAN BUTTE": "FRN1-H",
    "FURDALE": "SAS-FRDL",
    "GARRICK": "GRRC-H",
    "GOOD SPIRIT ACRES": "GDSP-H",
    "GRAY": "GRY-H",
    "GREENSPOT": "GRNS-H",
    "GRONLID": "GRNL-H",
    "GUERNSEY": "GRN1-H",
    "HAGEN": "HGN-H",
    "HAZEL DELL": "HZLD-H",
    "HENDON": "HNDN-H",
    "HITCHCOCK BAY": "HTCH-H",
    "HOEY": "HY-H",
    "HOLBEIN": "HLBN-H",
    "KANDAHAR": "KNDH-H",
    "KETCHEN": "KTCH-H",
    "KOPP'S KOVE": "KPPS-H",
    "KRONAU": "KRN-H",
    "KUROKI": "KRK-H",
    "LANZ POINT": "LNZP-H",
    "LITTLE FISHING LAKE": "LTTL-H",
    "LITTLE SWAN RIVER": "LTT1-H",
    "LIVELONG": "LVLN-H",
    "LONE ROCK": "LNRC-H",
    "MACDOWALL": "MCDW-H",
    "MACPHEAT PARK": "MCPH-H",
    "MARTINSON'S BEACH": "MRT1-H",
    "MAYFAIR": "SAS-MYFR",
    "MAYMONT BEACH": "MYMN-H",
    "MCCORD": "MCCR-H",
    "MERRILL HILLS": "MRRL-H",
    "MESKANAW": "MSKN-H",
    "MOHR'S BEACH": "MHRS-H",
    "MOOSE BAY": "MSBY-H",
    "MOWREY BEACH": "MWRY-H",
    "MOZART": "MZRT-H",
    "MULLINGAR": "MLLN-H",
    "NESSLIN LAKE": "NSSL-H",
    "NEUANLAGE": "NNLG-H",
    "NEUHORST": "NHRS-H",
    "NORTH COLESDALE PARK": "NRT1-H",
    "NORTH SHORE FISHING LAKE": "NRT2-H",
    "NORTH WEYBURN": "NRT3-H",
    "NORTHSIDE": "NRT4-H",
    "OKLA": "OKL-H",
    "ORMISTON": "ORMS-H",
    "OTTMAN-MURRAY BEACH": "OTTM-H",
    "PARKVIEW": "PRKV-H",
    "PARRY": "PRRY-H",
    "PASQUA LAKE": "PSQL-H",
    "PEEBLES": "PBLS-H",
    "PELICAN COVE": "PLCN-H",
    "PELICAN SHORES": "PLC2-H",
    "PHILLIPS GROVE": "PHLL-H",
    "POWM BEACH": "PWMB-H",
    "PRAIRIE RIVER": "PRRR-H",
    "RICETON": "RCTN-H",
    "RIVER'S EDGE": "RVRS-H",
    "RIVERSIDE ESTATES": "RVR1-H",
    "RUNNYMEDE": "RNNY-H",
    "SARNIA BEACH": "SRNB-H",
    "SCOUT LAKE": "SCTL-H",
    "SLEEPY HOLLOW": "SLPY-H",
    "SNOWDEN": "SNWD-H",
    "SORENSEN BEACH": "SRNS-H",
    "SOUTH WATERHEN LAKE": "STHW-H",
    "SPRING BAY": "SPR1-H",
    "SPRUCE BAY": "SPRC-H",
    "SPRUCE LAKE": "SPR2-H",
    "ST ISIDORE-DE-BELLEVUE": "STSD-H",
    "ST JOSEPH'S": "STJS-H",
    "SUMMERFIELD BEACH": "SMMR-H",
    "SUNSET VIEW BEACH": "SNS1-H",
    "SWAN PLAIN": "SWNP-H",
    "SYLVANIA": "SYLV-H",
    "TADMORE": "TDMR-H",
    "TAYLOR BEACH": "TYLR-H",
    "TREVESSA BEACH": "TRVS-H",
    "TROSSACHS": "TRSS-H",
    "TUFFNELL": "TFFN-H",
    "TURTLE LAKE SOUTH BAY": "TRT1-H",
    "TWAY": "TWY-H",
    "UHL'S BAY": "UHLS-H",
    "USHERVILLE": "USHR-H",
    "WEST CHATFIELD BEACH": "WSTC-H",
    "WESTVIEW": "SAS-WETV",
    "WISHART": "WSHR-H",
    "WYMARK": "WYMR-H",
    "ARDILL": "ARDL-H",
    "CACTUS LAKE": "CCTS-H",
    "CLEMENCEAU": "CLMN-H",
    "CRANE VALLEY": "CRNV-H",
    "ELDERSLEY": "ELDR-H",
    "FIFE LAKE": "FFLK-H",
    "JASMIN": "JSMN-H",
    "KAYVILLE": "KYVL-H",
    "LADY LAKE": "LDYL-H",
    "LANGBANK": "LNGB-H",
    "LAPORTE": "LPRT-H",
    "MAIN CENTRE": "MNCN-H",
    "MIKADO": "MKD-H",
    "OUNGRE": "ONGR-H",
    "PERCIVAL": "PRC1-H",
    "PIAPOT": "PPT-H",
    "SHIPMAN": "SHPM-H",
    "SIMMIE": "SMM-H",
    "SPRING VALLEY": "SPR3-H",
    "VANTAGE": "VNTG-H",
    "VICEROY": "VCRY-H",
    "ABBEY": "ABBY-V",
    "ABERNETHY": "ABRN-V",
    "ALIDA": "ALD-V",
    "ALVENA": "ALVN-V",
    "ANNAHEIM": "ANNH-V",
    "ANTLER": "ANTL-V",
    "ARCHERWILL": "ARCH-V",
    "ARRAN": "ARRN-V",
    "ATWATER": "ATWT-V",
    "AVONLEA": "AVNL-V",
    "AYLESBURY": "AYLS-V",
    "AYLSHAM": "AYL1-V",
    "BANGOR": "BNGR-V",
    "BEATTY": "BTTY-V",
    "BEECHY": "BCHY-V",
    "BELLE PLAINE": "BLLP-V",
    "BETHUNE": "BTHN-V",
    "BJORKDALE": "BJRK-V",
    "BLADWORTH": "BLDW-V",
    "BORDEN": "BRD1-V",
    "BRACKEN": "BRCK-V",
    "BRADWELL": "BRDW-V",
    "BRIERCREST": "BRRC-V",
    "BRODERICK": "BRDR-V",
    "BROWNLEE": "BRWN-V",
    "BUCHANAN": "BCHN-V",
    "BUENA VISTA": "SAS-BNVS",
    "BULYEA": "BLY-V",
    "CADILLAC": "CDLL-V",
    "CALDER": "CLDR-V",
    "CANWOOD": "CNWD-V",
    "CARIEVALE": "CRVL-V",
    "CARMICHAEL": "CRMC-V",
    "CARONPORT": "CRNP-V",
    "CEYLON": "CYLN-V",
    "CHAPLIN": "CHPL-V",
    "CHRISTOPHER LAKE": "CHRS-V",
    "CLAVET": "CLVT-V",
    "CLIMAX": "CLMX-V",
    "CODERRE": "CDRR-V",
    "CODETTE": "CDTT-V",
    "COLEVILLE": "CLVL-V",
    "CONQUEST": "CNQS-V",
    "CONSUL": "CNSL-V",
    "CRAVEN": "CRVN-V",
    "CREELMAN": "CRLM-V",
    "DAFOE": "DF-V",
    "DEBDEN": "DBDN-V",
    "DENZIL": "DNZL-V",
    "DILKE": "DLK-V",
    "DINSMORE": "DNSM-V",
    "DISLEY": "DSLY-V",
    "DODSLAND": "DDSL-V",
    "DORINTOSH": "DRNT-V",
    "DRAKE": "DRK-V",
    "DRINKWATER": "DRNK-V",
    "DUBUC": "DBC-V",
    "DUFF": "DFF-V",
    "DUVAL": "DVL-V",
    "EARL GREY": "ERLG-V",
    "EBENEZER": "EBNZ-V",
    "EDAM": "EDM-V",
    "EDENWOLD": "EDNW-V",
    "ELBOW": "ELB1-V",
    "ELFROS": "ELFR-V",
    "ELSTOW": "ELST-V",
    "ENDEAVOUR": "ENDV-V",
    "ENGLEFELD": "ENGL-V",
    "ERNFOLD": "ERNF-V",
    "EYEBROW": "EYBR-V",
    "FAIRLIGHT": "FRLG-V",
    "FENWOOD": "FNWD-V",
    "FILLMORE": "FLLM-V",
    "FINDLATER": "FNDL-V",
    "FLAXCOMBE": "FLXC-V",
    "FORGET": "FRGT-V",
    "FOSSTON": "FSST-V",
    "FOX VALLEY": "FXVL-V",
    "FROBISHER": "FRBS-V",
    "FRONTIER": "FRNT-V",
    "GAINSBOROUGH": "GNSB-V",
    "GERALD": "GRLD-V",
    "GLADMAR": "GLDM-V",
    "GLASLYN": "GLSL-V",
    "GLEN EWEN": "GLNW-V",
    "GLENAVON": "GLNV-V",
    "GLENSIDE": "GLNS-V",
    "GOLDEN PRAIRIE": "GLDN-V",
    "GOODEVE": "GDV-V",
    "GOODSOIL": "GDSL-V",
    "GOODWATER": "GDWT-V",
    "GRAYSON": "GRYS-V",
    "HALBRITE": "HLBR-V",
    "HAWARDEN": "HWRD-V",
    "HAZENMORE": "HZNM-V",
    "HAZLET": "HZLT-V",
    "HEWARD": "HWR1-V",
    "HODGEVILLE": "HDGV-V",
    "HOLDFAST": "HLDF-V",
    "HUBBARD": "HBBR-V",
    "HYAS": "HYS-V",
    "INVERMAY": "INVR-V",
    "JANSEN": "JNSN-V",
    "KEELER": "KLR-V",
    "KELLIHER": "KLLH-V",
    "KENASTON": "KNS1-V",
    "KENDAL": "KNDL-V",
    "KENNEDY": "KNND-V",
    "KENOSEE LAKE": "KNSL-V",
    "KILLALY": "KLLL-V",
    "KINCAID": "KNCD-V",
    "KINLEY": "KNLY-V",
    "KISBEY": "KSBY-V",
    "KRYDOR": "KRYD-V",
    "LAKE ALMA": "LKLM-V",
    "LAKE LENORE": "LKLN-V",
    "LANCER": "LNCR-V",
    "LANDIS": "LNDS-V",
    "LANG": "LNG-V",
    "LEASK": "LSK-V",
    "LEBRET": "LBRT-V",
    "LEOVILLE": "LVLL-V",
    "LEROSS": "LRSS-V",
    "LESTOCK": "LSTC-V",
    "LIBERTY": "LBR1-V",
    "LINTLAW": "LNTL-V",
    "LIPTON": "LPTN-V",
    "LOON LAKE": "LNLK-V",
    "LOREBURN": "LRBR-V",
    "LOVE": "LV-V",
    "LUCKY LAKE": "LCKY-V",
    "MACNUTT": "MCNT-V",
    "MACOUN": "MCN-V",
    "MACRORIE": "MCRR-V",
    "MAJOR": "MJR-V",
    "MAKWA": "MKW-V",
    "MANKOTA": "MNKT-V",
    "MANOR": "MNR-V",
    "MARCELIN": "MRCL-V",
    "MARENGO": "MRNG-V",
    "MARGO": "MRG-V",
    "MARKINCH": "MRKN-V",
    "MARQUIS": "MRQS-V",
    "MARSDEN": "MRSD-V",
    "MARYFIELD": "MRYF-V",
    "MAYMONT": "MYM1-V",
    "MCLEAN": "MCLN-V",
    "MCTAGGART": "MCTG-V",
    "MEACHAM": "MCHM-V",
    "MEATH PARK": "MTHP-V",
    "MEDSTEAD": "MDS1-V",
    "MENDHAM": "MNDH-V",
    "MEOTA": "MT-V",
    "MERVIN": "MRVN-V",
    "MIDDLE LAKE": "MDDL-V",
    "MILDEN": "MLDN-V",
    "MINTON": "MNTN-V",
    "MISTATIM": "MSTT-V",
    "MONTMARTRE": "MNTM-V",
    "MORTLACH": "MRTL-V",
    "MUENSTER": "MNST-V",
    "NEILBURG": "NLBR-V",
    "NETHERHILL": "NTHR-V",
    "NEUDORF": "NDRF-V",
    "NEVILLE": "NVLL-V",
    "NORTH PORTAL": "NRT5-V",
    "ODESSA": "ODSS-V",
    "OSAGE": "OSG-V",
    "PADDOCKWOOD": "PDDC-V",
    "PANGMAN": "PNGM-V",
    "PARADISE HILL": "PRDS-V",
    "PARKSIDE": "PRKS-V",
    "PAYNTON": "PYNT-V",
    "PELLY": "PLLY-V",
    "PENNANT": "PNNN-V",
    "PERDUE": "PRD-V",
    "PIERCELAND": "PRCL-V",
    "PILGER": "PLGR-V",
    "PLEASANTDALE": "PLSN-V",
    "PLENTY": "PLNT-V",
    "PLUNKETT": "PLNK-V",
    "PRELATE": "PRLT-V",
    "PRIMATE": "PRMT-V",
    "PRUD'HOMME": "PRDH-V",
    "PUNNICHY": "PNNC-V",
    "QUILL LAKE": "QLLL-V",
    "QUINTON": "QNTN-V",
    "RABBIT LAKE": "RBBT-V",
    "RAMA": "RM-V",
    "RESORT VILLAGE OF METINOTA": "RSRT-V",
    "RHEIN": "RHN-V",
    "RICHARD": "RCHR-V",
    "RICHMOUND": "RCHM-V",
    "RIDGEDALE": "RDGD-V",
    "RIVERHURST": "RVRH-V",
    "ROCHE PERCEE": "RCHP-V",
    "RUDDELL": "RDDL-V",
    "RUSH LAKE": "RSHL-V",
    "RUTHILDA": "RTHL-V",
    "SCEPTRE": "SCPT-V",
    "SEDLEY": "SDLY-V",
    "SEMANS": "SMNS-V",
    "SENLAC": "SNLC-V",
    "SHACKLETON": "SHCK-V",
    "SHAMROCK": "SHMR-V",
    "SHEHO": "SHH-V",
    "SHELL LAKE": "SHL1-V",
    "SILTON": "SLTN-V",
    "SIMPSON": "SMPS-V",
    "SMEATON": "SMTN-V",
    "SMILEY": "SMLY-V",
    "SPALDING": "SPLD-V",
    "SPEERS": "SPRS-V",
    "SPY HILL": "SPYH-V",
    "ST BENEDICT": "STBN-V",
    "ST GREGOR": "STGR-V",
    "STENEN": "STNN-V",
    "STEWART VALLEY": "STWR-V",
    "STOCKHOLM": "STCK-V",
    "STORTHOAKS": "STRT-V",
    "STRONGFIELD": "STRN-V",
    "SUCCESS": "SCCS-V",
    "TANTALLON": "TNTL-V",
    "TESSIER": "TSSR-V",
    "THEODORE": "THDR-V",
    "TOGO": "TG-V",
    "TOMPKINS": "TMPK-V",
    "TORQUAY": "TRQY-V",
    "TRAMPING LAKE": "TRMP-V",
    "TRIBUNE": "TRBN-V",
    "TUGASKE": "TGSK-V",
    "TUXFORD": "TXFR-V",
    "VAL MARIE": "VLMR-V",
    "VALPARAISO": "VLPR-V",
    "VANGUARD": "VNGR-V",
    "VANSCOY": "VNSC-V",
    "VIBANK": "VBNK-V",
    "VISCOUNT": "VSCN-V",
    "WALDECK": "WLDC-V",
    "WALDRON": "WLDR-V",
    "WASECA": "WSC-V",
    "WEBB": "WBB-V",
    "WEEKES": "WKS-V",
    "WEIRDALE": "WRDL-V",
    "WELDON": "WLDN-V",
    "WELWYN": "WLWY-V",
    "WHITE FOX": "WHTF-V",
    "WILCOX": "WLCX-V",
    "WINDTHORST": "WNDT-V",
    "WISETON": "WSTN-V",
    "WOOD MOUNTAIN": "WDMN-V",
    "YARBO": "YRB-V",
    "YOUNG": "YNG-V",
    "ZELMA": "ZLM-V",
    "ZENON PARK": "ZNNP-V",
    "NORTHERN HAMLET BLACK POINT": "BLPT-NH",
    "NORTHERN HAMLET COLE BAY": "CLBY-NH",
    "NORTHERN HAMLET DORE LAKE": "DRLK-NH",
    "NORTHERN HAMLET JANS BAY": "JNBY-NH",
    "NORTHERN HAMLET MICHEL VILLAGE": "MCVL-NH",
    "NORTHERN HAMLET PATUANAK": "PTNK-NH",
    "NORTHERN HAMLET ST GEORGE'S HILL": "STGG-NH",
    "NORTHERN HAMLET STONY RAPIDS": "STRP-NH",
    "NORTHERN HAMLET TIMBER BAY": "TMBY-NH",
    "NORTHERN HAMLET TURNOR LAKE": "TRNL-NH",
    "NORTHERN HAMLET WEYAKWIN": "WYKW-NH",
    "NORTHERN TOWN CREIGHTON": "CRGT-NH",
    "NORTHERN TOWN LA RONGE": "LRNG-NH",
    "NORTHERN VILLAGE AIR RONGE": "ARNG-NV",
    "NORTHERN VILLAGE BEAUVAL": "BVAL-NV",
    "NORTHERN VILLAGE BUFFALO NARROWS": "BFFN-NV",
    "NORTHERN VILLAGE CUMBERLAND HOUSE": "CMBR-NV",
    "NORTHERN VILLAGE DENARE BEACH": "DNRB-NV",
    "NORTHERN VILLAGE GREEN LAKE": "GRLK-NV",
    "NORTHERN VILLAGE ILE A LA CROSSE": "LCRS-NV",
    "NORTHERN VILLAGE LA LOCHE": "LLOC-NV",
    "NORTHERN VILLAGE PELICAN NARROWS": "PLCN-NV",
    "NORTHERN VILLAGE PINEHOUSE": "PNHS-NV",
    "NORTHERN VILLAGE SANDY BAY": "SDBY-NV",
    "RESORT VILLAGE ALICE BEACH": "ALBC-RV",
    "RESORT VILLAGE AQUADEO": "AQDE-RV",
    "RESORT VILLAGE B-SAY-TAH": "BSTH-RV",
    "RESORT VILLAGE BEAVER FLAT": "BVFL-RV",
    "RESORT VILLAGE BIG SHELL": "BGSH-RV",
    "RESORT VILLAGE BIRD'S POINT": "BRPT-RV",
    "RESORT VILLAGE CANDLE LAKE": "CNDL-RV",
    "RESORT VILLAGE CHITEK LAKE": "CHLK-RV",
    "RESORT VILLAGE CHORNEY BEACH": "CHBC-RV",
    "RESORT VILLAGE COCHIN": "CCHN-RV",
    "RESORT VILLAGE COTEAU BEACH": "CTBC-RV",
    "RESORT VILLAGE DISTRICT OF KETEPWA": "DTKT-RV",
    "RESORT VILLAGE ECHO BAY": "ECBY-RV",
    "RESORT VILLAGE ELK RIDGE": "ELRD-RV",
    "RESORT VILLAGE ETTERS BEACH": "ETBC-RV",
    "RESORT VILLAGE FORT SAN": "FRSN-RV",
    "RESORT VILLAGE GLEN HARBOUR": "SLHB-RV",
    "RESORT VILLAGE GRANDVIEW BEACH": "GRVB-RV",
    "RESORT VILLAGE GREIG LAKE": "GGLK-RV",
    "RESORT VILLAGE ISLAND VIEW": "ISVW-RV",
    "RESORT VILLAGE KANNATA VALLEY": "KNVL-RV",
    "RESORT VILLAGE KIVIMAA-MONNLIGHT BAY": "KVM-RV",
    "RESORT VILLAGE LESLIE BEACH": "LSBC-RV",
    "RESORT VILLAGE LUMSDEN BEACH": "LSDB-RV",
    "RESORT VILLAGE MANITOU BEACH": "MNBC-RV",
    "RESORT VILLAGE MELVILLE BEACH": "MVBC-RV",
    "RESORT VILLAGE MISTUSINNE": "MSTS-RV",
    "RESORT VILLAGE NORTH GROVE": "NRGR-RV",
    "RESORT VILLAGE PEBBLE BAYE": "PBBL-RV",
    "RESORT VILLAGE PELICAN POINTE": "PLCP-RV",
    "RESORT VILLAGE SASKATCHEWAN BEACH": "SKWN-RV",
    "RESORT VILLAGE SHIELDS": "SHLD-RV",
    "RESORT VILLAGE SOUTH LAKE": "STLK-RV",
    "RESORT VILLAGE SUN VALLEY": "SVLL-RV",
    "RESORT VILLAGE SUNSET COVE": "SSCV-RV",
    "RESORT VILLAGE THODE": "THDE-RV",
    "RESORT VILLAGE TOBIN LAKE": "TBLK-RV",
    "RESORT VILLAGE TURTLE VIEW": "TTVW-RV",
    "RESORT VILLAGE WAKAW LAKE": "WKLE-RV",
    "RESORT VILLAGE WEE TOO BEACH": "WTBC-RV",
    "RESORT VILLAGE WEST END": "WSED-RV",
    "ABERDEEN NO 373": "ABR1-RM",
    "ABERNETHY NO 186": "ABR2-RM",
    "ANTELOPE PARK NO 322": "ANT1-RM",
    "ANTLER NO 61": "ANT2-RM",
    "ARBORFIELD NO 456": "ARB1-RM",
    "ARGYLE NO 1": "ARGY-RM",
    "ARLINGTON NO 79": "ARL1-RM",
    "ARM RIVER NO 252": "ARMR-RM",
    "AUVERGNE NO 76": "AVRG-RM",
    "BAILDON NO 131": "BLDN-RM",
    "BARRIER VALLEY NO 397": "BRR1-RM",
    "BATTLE RIVER NO 438": "BTT1-RM",
    "BAYNE NO 371": "BYNN-RM",
    "BEAVER RIDGE NO 622": "BVRR-RM",
    "BENGOUGH NO 40": "BNG1-RM",
    "BENSON NO 35": "BNSN-RM",
    "BIG ARM NO 251": "BGRM-RM",
    "BIG QUILL NO 308": "BGQL-RM",
    "BIG RIVER NO 555": "BGR1-RM",
    "BIG STICK NO 141": "BGST-RM",
    "BIGGAR NO 347": "BGG1-RM",
    "BIRCH HILLS NO 460": "BRC2-RM",
    "BJORKDALE NO 426": "BJR1-RM",
    "BLAINE LAKE NO, 434": "BLN1-RM",
    "BLUCHER NO 343": "BLCH-RM",
    "BONE CREEK NO 108": "BNCR-RM",
    "BRATT'S LAKE NO 129": "BRTT-RM",
    "BRITANNIA NO 502": "BRTN-RM",
    "BROCK NO 64": "BRC3-RM",
    "BROKENSHELL NO 68": "BRKN-RM",
    "BROWNING NO 34": "BRW1-RM",
    "BUCHANAN NO 304": "BCH1-RM",
    "BUCKLAND NO 491": "BCKL-RM",
    "BUFFALO NO 409": "BFFL-RM",
    "CALDER NO 241": "CLD1-RM",
    "CALEDONIA NO 99": "CLDN-RM",
    "CAMBRIA NO 6": "CMBR-RM",
    "CANA NO 214": "CNN-RM",
    "CANAAN NO 225": "CNN1-RM",
    "CANWOOD NO 494": "CNW1-RM",
    "CARMICHAEL NO 109": "CRM1-RM",
    "CARON NO 162": "CRN1-RM",
    "CHAPLIN NO 164": "CHP1-RM",
    "CHESTER NO 125": "CHST-RM",
    "CHESTERFIELD NO 261": "CHS1-RM",
    "CHURCHBRIDGE NO 211": "CHR1-RM",
    "CLAYTON NO 333": "CLYT-RM",
    "CLINWORTH NO 230": "CLNW-RM",
    "COALFIELDS NO 4": "CLFL-RM",
    "COLONSAY NO 342": "CLN1-RM",
    "CONNAUGHT NO 457": "CNNG-RM",
    "CORMAN PARK NO 344": "CRMN-RM",
    "COTE NO 271": "CTN-RM",
    "COTEAU NO 255": "CTN1-RM",
    "COULEE NO 136": "CLN-RM",
    "CRAIK NO 222": "CRKN-RM",
    "CUPAR NO 218": "CPRN-RM",
    "CUT KNIFE NO 439": "CTK1-RM",
    "CYMRI NO 36": "CYMR-RM",
    "DEER FORKS NO 232": "DRFR-RM",
    "DOUGLAS NO 436": "DGLS-RM",
    "DUCK LAKE NO 463": "DCK1-RM",
    "DUFFERIN NO 190": "DFFR-RM",
    "DUNDURN NO 314": "DND1-RM",
    "EAGLE CREEK NO 376": "EGLC-RM",
    "EDENWOLD NO 158": "EDN1-RM",
    "ELCAPO NO 154": "ELCP-RM",
    "ELDON NO 471": "ELDN-RM",
    "ELFROS NO 307": "ELF1-RM",
    "ELMSTHORPE NO 100": "ELMS-RM",
    "EMERALD NO 277": "EMRL-RM",
    "ENFIELD NO 194": "ENFL-RM",
    "ENNISKILLEN NO 3": "ENNS-RM",
    "ENTERPRISE NO 142": "ENTR-RM",
    "ESTEVAN NO 5": "EST2-RM",
    "EXCEL NO 71": "EXCL-RM",
    "EXCELSIOR NO 166": "EXC1-RM",
    "EYE HILL NO 382": "EYHL-RM",
    "EYEBROW NO 193": "EYB1-RM",
    "FERTILE BELT NO 183": "FRTL-RM",
    "FERTILE VALLEY NO 285": "FRT1-RM",
    "FILLMORE NO 96": "FLL1-RM",
    "FISH CREEK NO 402": "FSHC-RM",
    "FLETT'S SPRINGS NO 429": "FLTT-RM",
    "FOAM LAKE NO 276": "FML1-RM",
    "FOX VALLEY NO 171": "FXV1-RM",
    "FRANCIS NO 127": "FRN2-RM",
    "FRENCHMAN BUTTE NO 501": "FRN3-RM",
    "FRONTIER NO 19": "FRN4-RM",
    "GARDEN RIVER NO 490": "GRDN-RM",
    "GARRY NO 245": "GRRY-RM",
    "GLEN BAIN NO 105": "GLNB-RM",
    "GLEN MCPHERSON NO 46": "GLNM-RM",
    "GLENSIDE NO 377": "GLN1-RM",
    "GOLDEN WEST NO 95": "GLD1-RM",
    "GOOD LAKE NO 274": "GDLK-RM",
    "GRANDVIEW NO 349": "GRN2-RM",
    "GRANT NO 372": "GRNT-RM",
    "GRASS LAKE NO 381": "GRSS-RM",
    "GRASSY CREEK NO 78": "GRS1-RM",
    "GRAVELBOURG NO 104": "GRV1-RM",
    "GRAYSON NO 184": "GRY1-RM",
    "GREAT BEND NO 405": "GRTB-RM",
    "GRIFFIN NO 66": "GRFF-RM",
    "GULL LAKE NO 139": "GLL1-RM",
    "HAPPY VALLEY NO 10": "HPPY-RM",
    "HAPPYLAND NO 231": "HPP1-RM",
    "HARRIS NO 316": "HRRS-RM",
    "HART BUTTE NO 11": "HRTB-RM",
    "HAZEL DELL NO 335": "HZL1-RM",
    "HAZELWOOD NO 94": "HZLW-RM",
    "HEART'S HILL NO 352": "HRTS-RM",
    "HILLSBOROUGH NO 132": "HLLS-RM",
    "HILLSDALE NO 440": "HLL1-RM",
    "HOODOO NO 401": "HDN-RM",
    "HUDSON BAY NO 394": "HDS1-RM",
    "HUMBOLDT NO 370": "HMB1-RM",
    "HURON NO 223": "HRNN-RM",
    "INDIAN HEAD NO 156": "IND1-RM",
    "INSINGER NO 275": "INSN-RM",
    "INVERGORDON NO 430": "INV1-RM",
    "INVERMAY NO 305": "INV2-RM",
    "ITUNA BON ACCORD NO 246": "ITNB-RM",
    "KELLROSS NO 247": "KLLR-RM",
    "KELVINGTON NO 366": "KLV1-RM",
    "KEY WEST NO 70": "KYWS-RM",
    "KEYS NO 303": "KYSN-RM",
    "KINDERSLEY NO 290": "KND1-RM",
    "KING GEORGE NO 256": "KNGG-RM",
    "KINGSLEY NO 124": "KNGS-RM",
    "KINISTINO NO 459": "KNS2-RM",
    "KLAKE JOHNSTON NO 102": "KLKJ-RM",
    "LAC PELLETIER NO 107": "LCPL-RM",
    "LACADENA NO 228": "LCDN-RM",
    "LAIRD NO 404": "LRDN-RM",
    "LAJORD NO 128": "LJRD-RM",
    "LAKE ALMA NO 8": "LKL1-RM",
    "LAKE LENORE NO 399": "LKL2-RM",
    "LAKELAND NO 521": "LKL3-RM",
    "LAKESIDE NO 338": "LKSD-RM",
    "LAKEVIEW NO 337": "LKV1-RM",
    "LANGENBURG NO 181": "LNG2-RM",
    "LAST MOUNTAIN VALLEY NO 250": "LSTM-RM",
    "LAURIER NO 38": "LRRN-RM",
    "LAWTONIA NO 135": "LWTN-RM",
    "LEASK NO 464": "LSKN-RM",
    "LEROY NO 339": "LRYN-RM",
    "LIPTON NO 217": "LPT1-RM",
    "LIVINGSTON NO 331": "LVNG-RM",
    "LOMOND NO 37": "LMND-RM",
    "LONE TREE NO 18": "LNTR-RM",
    "LONGLAKETON NO 219": "LNGL-RM",
    "LOON LAKE NO 561": "LNL1-RM",
    "LOREBURN NO 254": "LRB1-RM",
    "LOST RIVER NO 313": "LSTR-RM",
    "LUMSDEN NO 189": "LMS1-RM",
    "MANITOU LAKE NO 442": "MNTL-RM",
    "MANKOTA NO 45": "MNK1-RM",
    "MAPLE BUSH NO 224": "MPLB-RM",
    "MAPLE CREEK NO 111": "MPL1-RM",
    "MARIPOSA NO 350": "MRPS-RM",
    "MARQUIS NO 191": "MRQ1-RM",
    "MARRIOTT NO 317": "MRRT-RM",
    "MARTIN NO 122": "MRT2-RM",
    "MARYFIELD NO 91": "MRY1-RM",
    "MAYFIELD NO 406": "MYFL-RM",
    "MCCRANEY NO 282": "MCC1-RM",
    "MCLEOD NO 185": "MCLD-RM",
    "MCKILLOP NO 220": "MCK1-RM",
    "MEADOW LAKE NO 588": "MDW1-RM",
    "MEDSTEAD NO 497": "MDS2-RM",
    "MEETING LAKE NO 466": "MTNG-RM",
    "MEOTA NO 468": "MTN-RM",
    "MERVIN NO 499": "MRV1-RM",
    "MILDEN NO 286": "MLD1-RM",
    "MILTON NO 292": "MLTN-RM",
    "MIRY CREEK NO 229": "MRYC-RM",
    "MONET NO 257": "MNT1-RM",
    "MONTMARTRE NO 126": "MNT2-RM",
    "MONTROSE NO 315": "MNTR-RM",
    "MOOSE CREAKK NO 33": "MSCR-RM",
    "MOOSE JAW NO 161": "MSJ1-RM",
    "MOOSE MOUNTAIN NO 63": "MSM1-RM",
    "MOOSE RANGE NO 486": "MSRN-RM",
    "MOOSOMIN NO 121": "MSM2-RM",
    "MORRIS NO 312": "MRRS-RM",
    "MORSE NO 165": "MRSN-RM",
    "MOUNT HOPE NO 279": "MNTH-RM",
    "MOUNT PLEASANT NO 2": "MNTP-RM",
    "MOUNTAIN VIEW NO 318": "MNT3-RM",
    "NEWCOMBE NO 260": "NWCM-RM",
    "NIPAWIN NO 487": "NPW1-RM",
    "NORTH BATTLEFORD NO 437": "NRT6-RM",
    "NORTH QU'APELLE NO 187": "NRT7-RM",
    "NORTON NO 69": "NRTN-RM",
    "OAKDALE NO 320": "OKDL-RM",
    "OLD POST NO 43": "OLDP-RM",
    "ORKNEY NO 244": "ORKN-RM",
    "PADDOCKWOOD NO 520": "PDD1-RM",
    "PARKDALE NO 498": "PRKD-RM",
    "PAYNTON NO 470": "PYN1-RM",
    "PENSE NO 160": "PNSN-RM",
    "PERDUE NO 346": "PRDN-RM",
    "PIAPOT NO 110": "PPTN-RM",
    "PINTO CREEK NO 75": "PNTC-RM",
    "PITTVILLE NO 169": "PTTV-RM",
    "PLEASANT VALLEY NO 288": "PLS1-RM",
    "PLEASANTDALE NO 398": "PLS2-RM",
    "PONASS LAKE NO 367": "PNSS-RM",
    "POPLAR VALLEY NO 12": "PPLR-RM",
    "PORCUPINE NO 395": "PRC2-RM",
    "PRAIRIE ROSDEN NO 309": "PRR1-RM",
    "PRAIRIEDALE NO 321": "PRRD-RM",
    "PREECEVILLE NO 334": "PRC3-RM",
    "PRINCE ALBERT NO 461": "PRN2-RM",
    "PROGRESS NO 351": "PRGR-RM",
    "RECIPROCITY NO 32": "RCPR-RM",
    "REDBERRY NO 435": "RDBR-RM",
    "REDBURN NO 130": "RDB1-RM",
    "REFORD NO 379": "RFRD-RM",
    "RENO NO 51": "RNN-RM",
    "RIVERSIDE NO 168": "RVR2-RM",
    "ROCANVILLE NO 151": "RCN1-RM",
    "RODGERS NO 133": "RDGR-RM",
    "ROSEDALE NO 283": "RSDL-RM",
    "ROSEMOUNT NO 378": "RSMN-RM",
    "ROSTHERN NO 402": "RST1-RM",
    "ROUND HILL NO 467": "RNDH-RM",
    "ROUND VALLEY NO 410": "RNDV-RM",
    "RUDY NO 284": "RDYN-RM",
    "SALTCOATS NO 213": "SLT1-RM",
    "SARNIA NO 221": "SRNN-RM",
    "SASKATCHEWAN LANDING NO 167": "SSK1-RM",
    "SASMAN NO 336": "SSMN-RM",
    "SCOTT NO 98": "SCT1-RM",
    "SENLAC NO 411": "SNL1-RM",
    "SHAMROCK NO 134": "SHM1-RM",
    "SHELLBROOK NO 493": "SHL2-RM",
    "SHERWOOD NO 159": "SHRW-RM",
    "SILVERWOOD NO 123": "SLVR-RM",
    "SLIDING HILLS NO 273": "SLDN-RM",
    "SNIPE LAKE NO 259": "SNPL-RM",
    "SOURIS VALLEY NO 7": "SRSV-RM",
    "SOUTH QU'APELLE NO 157": "STHQ-RM",
    "SPALDING NO 368": "SPL1-RM",
    "SPIRITWOOD NO 496": "SPR4-RM",
    "SPY HILL NO 152": "SPY1-RM",
    "ST ANDREWS NO 287": "STND-RM",
    "ST LOUIS NO 431": "STL1-RM",
    "ST PETER NO 369": "STPT-RM",
    "ST PHILIPS NO 301": "STPH-RM",
    "STANLEY NO 215": "STNL-RM",
    "STAR CITY NO 428": "STR1-RM",
    "STONEHENGE NO 73": "STNH-RM",
    "STORTHOAKS NO 31": "STR2-RM",
    "SURPRISE VALLEY NO 9": "SRPR-RM",
    "SUTTON NO 103": "STTN-RM",
    "SWIFT CURRENT NO 137": "SWF1-RM",
    "TECUMSEH NO 65": "TCMS-RM",
    "TERRELL NO 101": "TRRL-RM",
    "THE GAP NO 39": "THGP-RM",
    "THREE LAKES NO 400": "THRL-RM",
    "TISDALE NO 427": "TSD1-RM",
    "TORCH RIVER NO 488": "TRCH-RM",
    "TOUCHWOOD NO 248": "TCHW-RM",
    "TRAMPING LAKE NO 380": "TRM1-RM",
    "TULLYMET NO 216": "TLLY-RM",
    "TURTLE RIVER NO 469": "TRT2-RM",
    "USBORNE NO 310": "USBR-RM",
    "VAL MARIE NO 17": "VLM1-RM",
    "VANSCOY NO 345": "VNS1-RM",
    "VICTORY NO 226": "VCTR-RM",
    "VISCOUNT NO 341": "VSC1-RM",
    "WALLACE NO 243": "WLLC-RM",
    "WALPOLE NO 92": "WLPL-RM",
    "WAVERLEY NO 44": "WVRL-RM",
    "WAWKEN NO 93": "WWKN-RM",
    "WEBB NO 138": "WBBN-RM",
    "WELLINGTON NO 97": "WLLN-RM",
    "WEYBURN NO 67": "WYB1-RM",
    "WHEATLANDS NO 163": "WHTL-RM",
    "WHISKA CREEK NO 106": "WHSK-RM",
    "WHITE VALLEY NO 49": "WHTV-RM",
    "WILLNER NO 253": "WLL1-RM",
    "WILLOW BUNCH NO 42": "WLL2-RM",
    "WILLOW CREEK NO 458": "WLL3-RM",
    "WILLOWDALE NO 153": "WLL4-RM",
    "WILTON NO 472": "WLTN-RM",
    "WINSLOW NO 319": "WNSL-RM",
    "WISE CREEK NO 77": "WSCR-RM",
    "WOLSELEY NO 155": "WLS1-RM",
    "WOLVERINE NO 340": "WLVR-RM",
    "WOOD CREEK NO 281": "WDCR-RM",
    "WOOD RIVER NO 74": "WDRV-RM",
    "WREFORD NO 280": "WRFR-RM",
    "ARGYLE PARK - ENGLEWOOD, REGINA": "REG-ARG1",
    "CORONATION PARK, REGINA": "REG-CRN1",
    "NORTHEAST, REGINA": "REG-NRTH",
    "UPLANDS, REGINA": "REG-UPLN",
    "EAST ZONE, REGINA": "REG-ESTZ",
    "ARCOLA EAST, REGINA": "REG-ARC1",
    "BOOTHILL, REGINA": "REG-BTH1",
    "DEWDNEY EAST , REGINA": "REG-DWDN",
    "CENTRAL ZONE, REGINA": "REG-CNTR",
    "AL RITCHIE, REGINA": "REG-ALR1",
    "CATHEDRAL, REGINA": "REG-CTH1",
    "CENTRE SQUARE, REGINA": "REG-CNT2",
    "DOWNTOWN, REGINA": "REG-DWNT",
    "EASTVIEW, REGINA": "REG-EST1",
    "GLADMER PARK, REGINA": "REG-GLD1",
    "HERITAGE, REGINA": "REG-HRT1",
    "NORTH CENTRAL, REGINA": "REG-NRT2",
    "WAREHOUSE, REGINA": "REG-WRHS",
    "ALBERT PARK, REGINA": "REG-ALB1",
    "HARBOUR LANDING, REGINA": "REG-HRB1",
    "HILLSDALE, REGINA": "REG-HLL1",
    "LAKEVIEW, REGINA": "REG-LKV1",
    "WHITMORE PARK, REGINA": "REG-WHTM",
    "WEST ZONE, REGINA": "REG-WSTZ",
    "DIEPPE WESTERRA, REGINA": "REG-DPPW",
    "MCNAB, REGINA": "REG-MCN1",
    "NORMANVIEW, REGINA": "REG-NRM2",
    "NORMANVIEW WEST, REGINA": "REG-NRM3",
    "PRAIRIE VIEW, REGINA": "REG-PRR1",
    "REGENT PARK, REGINA": "REG-RGN1",
    "ROSEMONT/MOUNT ROYAL, REGINA": "REG-RSMN",
    "SHERWOOD/MCCARTHY, REGINA": "REG-SHRW",
    "TWIN LAKES, REGINA": "REG-TWNL",
    "WALSH ACRES/LAKERIDGE, REGINA": "REG-WLSH",
    "ABBEY PLACE, REGINA": "REG-ABBY",
    "BLACKBURNE COURT, REGINA": "REG-BLCK",
    "COOPERTOWN, REGINA": "REG-CPRT",
    "DEWDNEY EAST, REGINA": "REG-DWD1",
    "DIEPPE, REGINA": "REG-DPPR",
    "DOWNTOWN REGINA, REGINA": "REG-DWN1",
    "FAIRWAYS WEST, REGINA": "REG-FRWY",
    "GARDEN RIDGE, REGINA": "REG-GRDN",
    "GERMANTOWN, REGINA": "REG-GRMN",
    "GLENCAIRN, REGINA": "REG-GLNC",
    "GLENELM PARK, REGINA": "REG-GLNL",
    "HAWKSTONE, REGINA": "REG-HWKS",
    "HIGHLAND GREENS, REGINA": "REG-HGHL",
    "HUNTINGTON TERRACE, REGINA": "REG-HNTN",
    "KENSINGTON GREENS, REGINA": "REG-KNSN",
    "LAKERIDGE, REGINA": "REG-LKRD",
    "MAPLE RIDGE, REGINA": "REG-MPLR",
    "NORTHEAST REGINA, REGINA": "REG-NRT3",
    "ROSEMONT - MOUNT ROYAL, REGINA": "REG-RSM1",
    "SHERWOOD - MCCARTHY, REGINA": "REG-SHR1",
    "SKYVIEW, REGINA": "REG-SKYV",
    "SOVANNA POINTE, REGINA": "REG-SVNN",
    "STERLING MANOR, REGINA": "REG-STRL",
    "THE CREEKS, REGINA": "REG-THCR",
    "THE CRESCENTS, REGINA": "REG-THC1",
    "THE GREENS ON GARDINER, REGINA": "REG-THGR",
    "THE TOWNS, REGINA": "REG-THTW",
    "TUXEDO PARK, REGINA": "REG-TXDP",
    "ADELAIDE - CHURCHHILL": "SAS-ADLD",
    "AIRPORT BUSINESS AREA": "SAS-ARPR",
    "AROBOR CREEK": "SAS-ARBR",
    "ASPEN RIDGE": "SAS-ASPN",
    "AVALON": "SAS-AVLN",
    "BLAIRMORE SUBURBAN CENTRE": "SAS-BLRM",
    "BREVOORT PARK": "SAS-BRVR",
    "BRIARWOOD": "SAS-BRRW",
    "BROADWAY": "SAS-BRDW",
    "CASWELL HILL": "SAS-CSWL",
    "CENTRAL BUSINESS DISTRICT": "SAS-CNT3",
    "CENTRAL INDUSTRIAL": "SAS-CNT4",
    "CITY PARK": "SAS-CTYP",
    "CITY PARK SOUTH": "SAS-CTY1",
    "COLLEGE PARK": "SAS-CLLG",
    "COLLEGE PARK EAST": "SAS-CLL1",
    "CONFEDERATION PARK": "SAS-CNFD",
    "CONFEDERATION SUBURBAN CENTRE": "SAS-CNF1",
    "DUNDONALD": "SAS-DNDN",
    "EASTVIEW": "SAS-EST2",
    "ERINDALE": "SAS-ERND",
    "EVERGREEN": "SAS-EVRG",
    "EXHIBITION": "SAS-EXHB",
    "FAIRHAVEN": "SAS-FRHV",
    "FOREST GROVE": "SAS-FRST",
    "GORDIE HOWE MANAGEMENT AREA": "SAS-GRDH",
    "GREYSTONE HEIGHTS": "SAS-GRYS",
    "GROSVENOR PARK": "SAS-GRSV",
    "HAMPTON VILLAGE": "SAS-HMPT",
    "HAULTAIN": "SAS-HLTN",
    "HILLCREST MANAGEMENT AREA": "SAS-HLLC",
    "HOLIDAY PARK": "SAS-HLDY",
    "HOLLISTON": "SAS-HLL2",
    "HUDSON BAY INDUSTRIAL": "SAS-HDSN",
    "HUDSON BAY PARK": "SAS-HDS1",
    "KELSEY - WOODLAWN": "SAS-KLSY",
    "KING GEORGE": "SAS-KNGG",
    "KINSMAN": "SAS-KNSM",
    "LAKERIDGE": "SAS-LKR1",
    "LAKEWOOD SUBURBAN CENTRE": "SAS-LKWD",
    "LAWSON HEIGHTS": "SAS-LWSN",
    "LAWSON HEIGHTS SUBURBAN CENTRE": "SAS-LWS1",
    "MASSEY PLACE": "SAS-MSSY",
    "MEADOW GREEN": "SAS-MDWG",
    "MONTGOMERY PLACE": "SAS-MNTG",
    "NORTH DEVELOPMENT AREA": "SAS-NRT4",
    "NORTH INDUSTRIAL": "SAS-NRT5",
    "NORTH NUTANA": "SAS-NRT6",
    "NORTH PARK": "SAS-NRT7",
    "NORTH WEST DEVELOPMENT AREA": "SAS-NRT8",
    "NUTANA PARK": "SAS-NTNP",
    "NUTANA SUBURBAN CENTRE": "SAS-NTNS",
    "PACIFIC HEIGHTS": "SAS-PCFC",
    "PARK RIDGE": "SAS-PRKR",
    "PLEASANT HILL": "SAS-PLSN",
    "PLEASANT HILL VILLAGE": "SAS-PLS1",
    "QUEEN ELIZABETH": "SAS-QNLZ",
    "RICHMOND HEIGHTS": "SAS-RCHM",
    "RIVER HEIGHTS": "SAS-RVRH",
    "RIVERSDALE": "SAS-RVRS",
    "SUTHERLAND INDUSTRIAL": "SAS-RSWD",
    "THE WILLOWS": "SAS-WLLS",
    "UNIVERSITY HEIGHTS DEVELOPMENT AREA": "SAS-UHDA",
    "UNIVERSITY HEIGHTS SUBURAN CENTRE": "SAS-UHSC",
    "UNIVERSITY OF SASKATCHEWAN LANDS - SOUTH MANAGEMENT AREA": "SAS-USLN",
    "UNIVERSITY OF SASKATCHEWAN MANAGEMENT AREA": "SAS-USKW",
    "VARSITY VIEW": "SAS-VSTY",
    "WEST DOWNTOWN": "SAS-WSDT",
    "WEST INDUSTRIAL": "SAS-WSIN",
    "WESTMONT": "SAS-WETM",
    "WILLOW GROVE": "SAS-WLLG",
    "ROSEWOOD": "SAS-WSTD",
    "SILVERSPRING": "SAS-WSTN",
    "SILVERWOOD HEIGHTS": "SAS-WSTM",
    "SOUTH CASWELL": "SAS-WSTV",
    "SOUTH DOWNTOWN": "SAS-WLDW",
    "SOUTH WEST INDUSTRIAL": "SAS-WLLW",
    "STONEBRIDGE": "SAS-STBR",
    "SUTHERLAND": "SAS-STHL",
    "WHITEHORSE": "SAS-WHTH-C",
    "DAWSON CITY": "SAS-DWSN-T",
    "FARO": "SAS-FARO-T",
    "WATSON LAKE": "SAS-WTSN-T",
    "CARMACKS": "SAS-CRMC-V",
    "HAINES JUNCTION": "SAS-HNJN-V",
    "TESLIN": "SAS-TSLN-V",
    "COMMUNITIES OF BANGS FALLS": "BNGS-CM",
    "COMMUNITIES OF BEACH MEADOWS": "BCH1-CM",
    "COMMUNITIES OF BEN EOIN": "BNN-CM",
    "COMMUNITIES OF BENACADIE": "BNCD-CM",
    "COMMUNITIES OF BIG BEACH": "BGBC-CM",
    "COMMUNITIES OF BIG POND": "BGP1-CM",
    "COMMUNITIES OF BIG POND CENTRE": "BGPN-CM",
    "COMMUNITIES OF BIG RIDGE": "BGRD-CM",
    "COMMUNITIES OF BIRCH GROVE": "BRC1-CM",
    "COMMUNITIES OF BLACK BROOK": "BLC1-CM",
    "COMMUNITIES OF BLACKETTS LAKE": "BLC2-CM",
    "COMMUNITIES OF BOISDALE": "BSDL-CM",
    "COMMUNITIES OF BRAS DOR": "BRSD-CM",
    "COMMUNITIES OF BRINGHOUT": "BRGH-CM",
    "COMMUNITIES OF BROOKLYN QUEENS": "BRKL-CM",
    "COMMUNITIES OF BROOKFIELD MINES": "BRKF-CM",
    "COMMUNITIES OF BROUGHTON": "BRGH-CM",
    "COMMUNITIES OF BUCKFIELD": "BCKF-CM",
    "COMMUNITIES OF CALEDONIA": "CLDN-CM",
    "COMMUNITIES OF CARIBOU MARSH": "CRB1-CM",
    "COMMUNITIES OF CASTLE BAY": "CSTL-CM",
    "COMMUNITIES OF CATALONE": "CTLN-CM",
    "COMMUNITIES OF CATALONE GUT": "CTL1-CM",
    "COMMUNITIES OF CHARLESTON": "CHRL-CM",
    "COMMUNITIES OF CHELSEA": "CHLS-CM",
    "COMMUNITIES OF CHRISTMAS ISLAND": "CHRS-CM",
    "COMMUNITIES OF COXHEATH": "CXHT-CM",
    "COMMUNITIES OF DALEM LAKE": "DLML-CM",
    "COMMUNITIES OF DOMINION": "DMNN-CM",
    "COMMUNITIES OF DONKIN": "DNKN-CM",
    "COMMUNITIES OF DUTCH BROOK": "DTC1-CM",
    "COMMUNITIES OF EAGLE HEAD": "EGLH-CM",
    "COMMUNITIES OF EAST BAY": "ESTB-CM",
    "COMMUNITIES OF EAST BERLIN": "EST4-CM",
    "COMMUNITIES OF EAST PORT MEDWAY": "EST5-CM",
    "COMMUNITIES OF EAST SIDE PORT LHEBERT": "EST6-CM",
    "COMMUNITIES OF EDWARDSVILLE": "EDWR-CM",
    "COMMUNITIES OF FRENCH ROAD": "FRNC-CM",
    "COMMUNITIES OF FRENCHVALE": "FRNC-CM",
    "COMMUNITIES OF GABARUS": "GBRS-CM",
    "COMMUNITIES OF GABARUS LAKE": "GBR1-CM",
    "COMMUNITIES OF GARDINER MINES": "GRDN-CM",
    "COMMUNITIES OF GEORGES RIVER": "GRGR-CM",
    "COMMUNITIES OF GILLIS LAKE": "GLLS-CM",
    "COMMUNITIES OF GLACE BAY": "GLCE-CM",
    "COMMUNITIES OF GRAND LAKE ROAD": "GRN2-CM",
    "COMMUNITIES OF GRAND MIRA NORTH": "GRN3-CM",
    "COMMUNITIES OF GRAND MIRA SOUTH": "GRN4-CM",
    "COMMUNITIES OF GRAND NARROWS": "GRN5-CM",
    "COMMUNITIES OF GREENFIELD": "GRNF-CM",
    "COMMUNITIES OF GROVES POINT": "GRVP-CM",
    "COMMUNITIES OF HARMONY MILLS": "HRMN-CM",
    "COMMUNITIES OF HIBERNIA": "HBRN-CM",
    "COMMUNITIES OF HIGGINSVILLE": "HGGN-CM",
    "COMMUNITIES OF HILLSIDE BOULARDERIE": "HLSB-CM",
    "COMMUNITIES OF HOMEVILLE": "HMVL-CM",
    "COMMUNITIES OF HORNES ROAD": "HRNS-CM",
    "COMMUNITIES OF HOWIE CENTRE": "HWCT-CM",
    "COMMUNITIES OF HUBBARDS": "HBBD-CM",
    "COMMUNITIES OF HUBLEY": "HBLY-CM",
    "COMMUNITIES OF HUNTINGTON": "HNTN-CM",
    "COMMUNITIES OF HUNTS POINT": "HNTP-CM",
    "COMMUNITIES OF INDIAN HARBOUR": "INHN-CM",
    "COMMUNITIES OF INGRAMPORT": "INGP-CM",
    "COMMUNITIES OF IRISH COVE": "IRSH-CM",
    "COMMUNITIES OF IRISHVALE": "IRSV-CM",
    "COMMUNITIES OF IRONVILLE": "IRNV-CM",
    "COMMUNITIES OF ISLAND VIEW": "ISLV-CM",
    "COMMUNITIES OF JACKET LAKE": "JCKL-CM",
    "COMMUNITIES OF JEDDORE OYSTER POND": "JDOP-CM",
    "COMMUNITIES OF JUNIPER MOUNTAIN": "JNPR-CM",
    "COMMUNITIES OF KEMPT": "KMPT-CM",
    "COMMUNITIES OF KETCH HARBOUR": "KTCH-CM",
    "COMMUNITIES OF LABELLE": "LBL-CM",
    "COMMUNITIES OF LAKE CHARLOTTE": "LKCH-CM",
    "COMMUNITIES OF LAKE EGMONT": "LKEG-CM",
    "COMMUNITIES OF LAKE MAJOR": "LKMJ-CM",
    "COMMUNITIES OF LAWRENCETOWN": "LWRCT-CM",
    "COMMUNITIES OF LEITCHES CREEK": "LTCH-CM",
    "COMMUNITIES OF LEITCHES CREEK STATION": "LTC1-CM",
    "COMMUNITIES OF LEWIS LAKE": "LWLK-CM",
    "COMMUNITIES OF LINDSEY LAKE": "LNDS-CM",
    "COMMUNITIES OF LINGAN": "LNGN-CM",
    "COMMUNITIES OF LINGAN ROAD": "LNGR-CM",
    "COMMUNITIES OF LISCOMB SANCTUARY": "LSCB-CM",
    "COMMUNITIES OF LITTLE BRAS DOR": "LTBD-CM",
    "COMMUNITIES OF LITTLE HARBOUR": "LTHB-CM",
    "COMMUNITIES OF LITTLE LORRAINE": "LTLR-CM",
    "COMMUNITIES OF LITTLE POND": "LTPD-CM",
    "COMMUNITIES OF LIVERPOOL": "LVRP-CM",
    "COMMUNITIES OF LOCHABER MINES": "LCHB-CM",
    "COMMUNITIES OF LONG ISLAND MAIN": "LNGI-CM",
    "COMMUNITIES OF LONG LAKE": "LNGL-CM",
    "COMMUNITIES OF LOUISBOURG": "LUSB-CM",
    "COMMUNITIES OF LOW LANDING": "LWLN-CM",
    "COMMUNITIES OF LUCASVILLE": "LCSV-CM",
    "COMMUNITIES OF MAIN A DIEU": "MNDU-CM",
    "COMMUNITIES OF MARION BRIDGE": "MRNB-CM",
    "COMMUNITIES OF MCADAMS LAKE": "MCDM-CM",
    "COMMUNITIES OF MILL CREEK": "MLCK-CM",
    "COMMUNITIES OF MILL LAKE": "MLLL-CM",
    "COMMUNITIES OF MILL VILLAGE": "MLVL-CM",
    "COMMUNITIES OF MILLVILLE BOULARDERIE": "MLVB-CM",
    "COMMUNITIES OF MILTON": "MLTN-CM",
    "COMMUNITIES OF MINEVILLE": "MNVL-CM",
    "COMMUNITIES OF MIRA GUT": "MRGT-CM",
    "COMMUNITIES OF MIRA ROAD": "MRRD-CM",
    "COMMUNITIES OF MITCHELL BAY": "MTCH-CM",
    "COMMUNITIES OF MOLEGA": "MLGA-CM",
    "COMMUNITIES OF MOUNT PLEASANT": "MNTP-CM",
    "COMMUNITIES OF MURCHYVILLE": "MRCH-CM",
    "COMMUNITIES OF MURPHY COVE": "MRPH-CM",
    "COMMUNITIES OF MUSHABOOM": "MSHB-CM",
    "COMMUNITIES OF MUSQUODOBOIT HARBOUR": "MSQD-CM",
    "COMMUNITIES OF MYERS POINT": "MYRS-CM",
    "COMMUNITIES OF NECUM TEUCH": "NCMT-CM",
    "COMMUNITIES OF NEW ABERDEEN": "NWAB-CM",
    "COMMUNITIES OF NEW GRAFTON": "NWGF-CM",
    "COMMUNITIES OF NEW VICTORIA": "NWVC-CM",
    "COMMUNITIES OF NEW WATERFORD": "NWWD-CM",
    "COMMUNITIES OF NEWCOMB CORNER": "NWCM-CM",
    "COMMUNITIES OF NORTH BEAVER BANK": "NRT1-CM",
    "COMMUNITIES OF NORTH BROOKFIELD": "NRT2-CM",
    "COMMUNITIES OF NORTH SYDNEY": "NRT3-CM",
    "COMMUNITIES OF NORTH WEST ARM": "NRT4-CM",
    "COMMUNITIES OF NORTHFIELD QUEENS": "NRT5-CM",
    "COMMUNITIES OF NORTHSIDE EAST BAY": "NRT6-CM",
    "COMMUNITIES OF OAKFIELD": "OKFL-CM",
    "COMMUNITIES OF OLDHAM": "OLDH-CM",
    "COMMUNITIES OF OSTREA LAKE": "OSTR-CM",
    "COMMUNITIES OF OTTER LAKE": "OTTR-CM",
    "COMMUNITIES OF OWLS HEAD": "OWLS-CM",
    "COMMUNITIES OF OYSTER POND": "OYST-CM",
    "COMMUNITIES OF PACE SETTLEMENT": "PCST-CM",
    "COMMUNITIES OF PEGGYS COVE": "PGGY-CM",
    "COMMUNITIES OF PEGGYS COVE PRESERVATION AREA": "PGG1-CM",
    "COMMUNITIES OF PENNANT POINT": "PNNN-CM",
    "COMMUNITIES OF PIPERS COVE": "PPRS-CM",
    "COMMUNITIES OF PLEASANT HARBOUR": "PLSN-CM",
    "COMMUNITIES OF PLEASANT POINT": "PLS2-CM",
    "COMMUNITIES OF PLEASANT VALLEY": "PLS1-CM",
    "COMMUNITIES OF PLEASANTFIELD": "PLSF-CM",
    "COMMUNITIES OF POINT ACONI": "PNTA-CM",
    "COMMUNITIES OF POINT EDWARD": "PNTE-CM",
    "COMMUNITIES OF POPES HARBOUR": "PPSH-CM",
    "COMMUNITIES OF PORT CALEDONIA": "PRTC-CM",
    "COMMUNITIES OF PORT DUFFERIN": "PRTD-CM",
    "COMMUNITIES OF PORT JOLI": "PRTJ-CM",
    "COMMUNITIES OF PORT MEDWAY": "PRTM-CM",
    "COMMUNITIES OF PORT MORIEN": "PRTM-CM",
    "COMMUNITIES OF PORT MOUTON": "PRTM-CM",
    "COMMUNITIES OF PORTAGE": "PRTG-CM",
    "COMMUNITIES OF PORTERS LAKE": "PRTR-CM",
    "COMMUNITIES OF PORTUGUESE COVE": "PRTG-CM",
    "COMMUNITIES OF PRIME BROOK": "PRMB-CM",
    "COMMUNITIES OF PROSPECT": "PRSP-CM",
    "COMMUNITIES OF PROSPECT BAY": "PRS1-CM",
    "COMMUNITIES OF PURCELLS COVE": "PRCL-CM",
    "COMMUNITIES OF QUEENSLAND": "QNSL-CM",
    "COMMUNITIES OF RESERVE MINES": "RSRV-CM",
    "COMMUNITIES OF RIVER LAKE": "RVRL-CM",
    "COMMUNITIES OF RIVER RYAN": "RVRY-CM",
    "COMMUNITIES OF RIVERSDALE": "RVRS-CM",
    "COMMUNITIES OF ROCK ELM": "RCKM-CM",
    "COMMUNITIES OF ROUND ISLAND": "RNDI-CM",
    "COMMUNITIES OF SABLE ISLAND": "SBLS-CM",
    "COMMUNITIES OF SAINT MARGARETS BAY": "SNTM-CM",
    "COMMUNITIES OF SALEM ROAD": "SLMR-CM",
    "COMMUNITIES OF SALMON RIVER BRIDGE": "SLMN-CM",
    "COMMUNITIES OF SALMON RIVER ROAD": "SLM1-CM",
    "COMMUNITIES OF SAMBRO": "SMBR-CM",
    "COMMUNITIES OF SAMBRO CREEK": "SMB1-CM",
    "COMMUNITIES OF SAMBRO HEAD": "SMB2-CM",
    "COMMUNITIES OF SANDFIELD": "SNDF-CM",
    "COMMUNITIES OF SANDY COVE": "SNDY-CM",
    "COMMUNITIES OF SCOTCH LAKE": "SCTL-CM",
    "COMMUNITIES OF SCOTCHTOWN": "SCTT-CM",
    "COMMUNITIES OF SEABRIGHT": "SBRG-CM",
    "COMMUNITIES OF SEAFORTH": "SFRT-CM",
    "COMMUNITIES OF SHAD BAY": "SHDB-CM",
    "COMMUNITIES OF SHEARWATER": "SHRW-CM",
    "COMMUNITIES OF SHEET HARBOUR": "SHTH-CM",
    "COMMUNITIES OF SHEET HARBOUR PASSAGE": "SHT1-CM",
    "COMMUNITIES OF SHIP HARBOUR": "SHPH-CM",
    "COMMUNITIES OF SHUNACADIE": "SHNC-CM",
    "COMMUNITIES OF SIMMS SETTLEMENT": "SMMS-CM",
    "COMMUNITIES OF SMITHS SETTLEMENT": "SMTH-CM",
    "COMMUNITIES OF SOBER ISLAND": "SBRS-CM",
    "COMMUNITIES OF SOUTH BAR": "STHB-CM",
    "COMMUNITIES OF SOUTH BROOKFIELD": "STHB-CM",
    "COMMUNITIES OF SOUTH SECTION": "STHS-CM",
    "COMMUNITIES OF SOUTH SIDE OF BOULARDERIE": "STSB-CM",
    "COMMUNITIES OF SOUTH WEST PORT MOUTON": "STWP-CM",
    "COMMUNITIES OF SPRY BAY": "SPR1-CM",
    "COMMUNITIES OF SPRY HARBOUR": "SPR2-CM",
    "COMMUNITIES OF ST ANDREWS CHANNEL": "STAC-CM",
    "COMMUNITIES OF SUMMERVILLE BEACH": "SMRB-CM",
    "COMMUNITIES OF SUMMERVILLE CENTRE": "SMRC-CM",
    "COMMUNITIES OF SYDNEY": "SYDN-CM",
    "COMMUNITIES OF SYDNEY FORKS": "SYDF-CM",
    "COMMUNITIES OF SYDNEY MINES": "SYDM-CM",
    "COMMUNITIES OF SYDNEY RIVER": "SYDR-CM",
    "COMMUNITIES OF TANGIER": "TNGR-CM",
    "COMMUNITIES OF TAYLORS HEAD": "TYLR-CM",
    "COMMUNITIES OF TEN MILE LAKE": "TNML-CM",
    "COMMUNITIES OF TERENCE BAY": "TRNC-CM",
    "COMMUNITIES OF THIRD LAKE": "THRD-CM",
    "COMMUNITIES OF THREE FATHOM HARBOUR": "THRF-CM",
    "COMMUNITIES OF TIMBERLEA": "TMBR-CM",
    "COMMUNITIES OF TRAFALGAR": "TRFL-CM",
    "COMMUNITIES OF TROUT BROOK": "TRTB-CM",
    "COMMUNITIES OF UPPER GRAND MIRA": "UPP3-CM",
    "COMMUNITIES OF UPPER HAMMONDS PLAINS": "UPPR-CM",
    "COMMUNITIES OF UPPER LAKEVILLE": "UPP3-CM",
    "COMMUNITIES OF UPPER LAWRENCETOWN": "UPP4-CM",
    "COMMUNITIES OF UPPER LEITCHES CREEK": "UPP5-CM",
    "COMMUNITIES OF UPPER MUSQUODOBOIT": "UPP5-CM",
    "COMMUNITIES OF UPPER NORTH SYDNEY": "UPP6-CM",
    "COMMUNITIES OF UPPER SACKVILLE": "UPP1-CM",
    "COMMUNITIES OF UPPER TANTALLON": "UPP2-CM",
    "COMMUNITIES OF VICTORIA MINES": "VCTM-CM",
    "COMMUNITIES OF WATT SECTION": "WTTS-CM",
    "COMMUNITIES OF WAVERLEY": "WVRL-CM",
    "COMMUNITIES OF WELLINGTON": "WLL1-CM",
    "COMMUNITIES OF WEST BERLIN": "WSTB-CM",
    "COMMUNITIES OF WEST CHEZZETCOOK": "WSTC-CM",
    "COMMUNITIES OF WEST DOVER": "WSTD-CM",
    "COMMUNITIES OF WEST JEDDORE": "WSTJ-CM",
    "COMMUNITIES OF WEST LAWRENCETOWN": "WSTL-CM",
    "COMMUNITIES OF WEST PENNANT": "WSTP-CM",
    "COMMUNITIES OF WEST PETPESWICK": "WST1-CM",
    "COMMUNITIES OF WEST PORTERS LAKE": "WST2-CM",
    "COMMUNITIES OF WEST QUODDY": "WSTQ-CM",
    "COMMUNITIES OF WESTERN HEAD": "WSTH-CM",
    "COMMUNITIES OF WESTFIELD": "WSTF-CM",
    "COMMUNITIES OF WESTMOUNT": "WSTM-CM",
    "COMMUNITIES OF WHITEBURN MINES": "WTBM-CM",
    "COMMUNITIES OF WHITES LAKE": "WHTS-CM",
    "COMMUNITIES OF WILLIAMSWOOD": "WLLM-CM",
    "COMMUNITIES OF WINDSOR JUNCTION": "WNDS-CM",
    "COMMUNITIES OF WOODSIDE": "WDSD-CM",
    "COMMUNITIES OF WYSES CORNER": "WYSS-CM",
    "COMMUNITIES OF YANKEETOWN": "YNKT-CM",
    
    // Alberta Municipal Districts
    "MUNICIPAL DISTRICT OF ACADIA NO. 34": "ACDN",
    "MUNICIPAL DISTRICT OF ATHABASCA": "ATH1",
    "MUNICIPAL DISTRICT OF BARRHEAD NO. 11": "BRR1",
    "MUNICIPAL DISTRICT OF BEAVER": "BVR",
    "MUNICIPAL DISTRICT OF BIG LAKES": "BGLK",
    "MUNICIPAL DISTRICT OF BIGHORN NO. 8": "BGHR",
    "MUNICIPAL DISTRICT OF BIRCH HILLS": "BRC3",
    "MUNICIPAL DISTRICT OF BONNYVILLE NO. 87": "BNN2",
    "MUNICIPAL DISTRICT OF BRAZEAU": "BRZ",
    "MUNICIPAL DISTRICT OF CAMROSE": "CMR1",
    "MUNICIPAL DISTRICT OF CARDSTON": "CRD1",
    "MUNICIPAL DISTRICT OF CLEAR HILLS": "CLRH",
    "MUNICIPAL DISTRICT OF CLEARWATER": "CLRW",
    "MUNICIPAL DISTRICT OF CYPRESS": "CYPR",
    "MUNICIPAL DISTRICT OF FAIRVIEW NO. 136": "FRV2",
    "MUNICIPAL DISTRICT OF FLAGSTAFF": "FLGS",
    "MUNICIPAL DISTRICT OF FOOTHILLS NO. 31": "FTHL",
    "MUNICIPAL DISTRICT OF FORTY MILE NO. 8": "FRTY",
    "MUNICIPAL DISTRICT OF GRANDE PRAIRIE NO. 1": "GRN4",
    "MUNICIPAL DISTRICT OF GREENVIEW NO. 16": "GRNV",
    "MUNICIPAL DISTRICT OF KNEEHILL": "KNHL",
    "MUNICIPAL DISTRICT OF LAC LA BICHE": "LCL1",
    "MUNICIPAL DISTRICT OF LAC STE ANNE": "LCST",
    "MUNICIPAL DISTRICT OF LACOMBE": "LCM1",
    "MUNICIPAL DISTRICT OF LAMONT": "LMN1",
    "MUNICIPAL DISTRICT OF LEDUC": "LDC1",
    "MUNICIPAL DISTRICT OF LESSER SLAVE RIVER NO. 124": "LSSR",
    "MUNICIPAL DISTRICT OF LETHBRIDGE": "LTH1",
    "MUNICIPAL DISTRICT OF MINBURN NO. 27": "MNB1",
    "MUNICIPAL DISTRICT OF MOUNTAIN VIEW": "MNT1",
    "MUNICIPAL DISTRICT OF NEWELL NO. 4": "NWLL",
    "MUNICIPAL DISTRICT OF NORTHERN LIGHTS": "NRT2",
    "MUNICIPAL DISTRICT OF NORTHERN SUNRISE": "NRT3",
    "MUNICIPAL DISTRICT OF OPPORTUNITY NO. 17": "OPPR",
    "MUNICIPAL DISTRICT OF PAINTEARTH NO. 18": "PNTR",
    "MUNICIPAL DISTRICT OF PARKLAND": "PRK2",
    "MUNICIPAL DISTRICT OF PEACE NO. 135": "PCN",
    "MUNICIPAL DISTRICT OF PINCHER CREEK NO. 9": "PNC2",
    "MUNICIPAL DISTRICT OF PONOKA": "PNK1",
    "MUNICIPAL DISTRICT OF PROVOST NO. 52": "PRV1",
    "MUNICIPAL DISTRICT OF RANCHLAND NO. 66": "RNCH",
    "MUNICIPAL DISTRICT OF RED DEER": "RDD1",
    "MUNICIPAL DISTRICT OF ROCKY VIEW": "RCK3",
    "MUNICIPAL DISTRICT OF SADDLE HILLS": "SDDL",
    "MUNICIPAL DISTRICT OF SMOKY LAKE": "SMK2",
    "MUNICIPAL DISTRICT OF SMOKY RIVER NO. 130": "SMK1",
    "MUNICIPAL DISTRICT OF SPIRIT RIVER NO. 133": "SPR5",
    "MUNICIPAL DISTRICT OF ST PAUL NO. 19": "STP1",
    "MUNICIPAL DISTRICT OF STARLAND": "STR2",
    "MUNICIPAL DISTRICT OF STETTLER NO. 6": "STT1",
    "MUNICIPAL DISTRICT OF STURGEON": "STRG",
    "MUNICIPAL DISTRICT OF TABER": "TBR1",
    "MUNICIPAL DISTRICT OF THORHILD NO. 7": "THR3",
    "MUNICIPAL DISTRICT OF TWO HILLS NO. 21": "TWH1",
    "MUNICIPAL DISTRICT OF VERMILION RIVER": "VRM1",
    "MUNICIPAL DISTRICT OF VULCAN": "VLC1",
    "MUNICIPAL DISTRICT OF WAINWRIGHT NO. 61": "WNW1",
    "MUNICIPAL DISTRICT OF WARNER NO. 5": "WRN1",
    "MUNICIPAL DISTRICT OF WESTLOCK": "WST1",
    "MUNICIPAL DISTRICT OF WETASKIWIN NO. 10": "WTS1",
    "MUNICIPAL DISTRICT OF WHEATLAND": "WHT2",
    "MUNICIPAL DISTRICT OF WILLOW CREEK NO. 26": "WLLW",
    "MUNICIPAL DISTRICT OF WOODLANDS": "WDLN",
    "MUNICIPAL DISTRICT OF YELLOWHEAD": "YLL1",
};;